export const VALID_GUESSES = [
  'ああああ',
  'あーあー',
  'あーーー',
  'ああいう',
  'あーがる',
  'あーきー',
  'あーくろ',
  'あーごん',
  'あーしー',
  'ああした',
  'ああして',
  'あーしゃ',
  'あーしん',
  'あーすり',
  'あーすん',
  'あーせん',
  'あーだー',
  'あーちー',
  'あーちゃ',
  'あーちん',
  'あーとー',
  'あーとし',
  'あーにか',
  'あーにす',
  'あーぱー',
  'あーばん',
  'あーびた',
  'あーふた',
  'あーべる',
  'あーまー',
  'あーみぃ',
  'あーみー',
  'あーみん',
  'あーめん',
  'ああゆう',
  'あーゆー',
  'あーらん',
  'あーりー',
  'あーれふ',
  'あーんと',
  'あいあい',
  'あいあう',
  'あいあし',
  'あいあん',
  'あいいー',
  'あいいく',
  'あいいろ',
  'あいいん',
  'あいうち',
  'あいえき',
  'あいえす',
  'あいえつ',
  'あいえむ',
  'あいえん',
  'あいおい',
  'あいおー',
  'あいおり',
  'あいおわ',
  'あいおん',
  'あいかぎ',
  'あいがき',
  'あいかた',
  'あいがた',
  'あいがみ',
  'あいがめ',
  'あいがも',
  'あいかわ',
  'あいかん',
  'あいがん',
  'あいぎん',
  'あいくぎ',
  'あいぐす',
  'あいくち',
  'あいぐま',
  'あいけあ',
  'あいけい',
  'あいけん',
  'あいこう',
  'あいごう',
  'あいごー',
  'あいごか',
  'あいこく',
  'あいごし',
  'あいごま',
  'あいこら',
  'あいこん',
  'あいさい',
  'あいさく',
  'あいさつ',
  'あいさぴ',
  'あいさむ',
  'あいざめ',
  'あいさん',
  'あいしー',
  'あいじつ',
  'あいしゃ',
  'あいしゅ',
  'あいしょ',
  'あいしる',
  'あいじろ',
  'あいしん',
  'あいじん',
  'あいずち',
  'あいずみ',
  'あいすむ',
  'あいずり',
  'あいする',
  'あいせい',
  'あいせき',
  'あいせつ',
  'あいぜつ',
  'あいせん',
  'あいぜん',
  'あいそう',
  'あいぞう',
  'あいそく',
  'あいぞめ',
  'あいそん',
  'あいたい',
  'あいたけ',
  'あいたた',
  'あいたっ',
  'あいたで',
  'あいだな',
  'あいだほ',
  'あいだま',
  'あいたむ',
  'あいだる',
  'あいつう',
  'あいつぐ',
  'あいった',
  'あいづち',
  'あいつら',
  'あいであ',
  'あいでし',
  'あいてつ',
  'あいてむ',
  'あいでん',
  'あいとう',
  'あいとく',
  'あいどく',
  'あいどし',
  'あいどの',
  'あいどり',
  'あいどる',
  'あいなか',
  'あいなめ',
  'あいなる',
  'あいにく',
  'あいにる',
  'あいぬご',
  'あいねず',
  'あいねん',
  'あいのこ',
  'あいのす',
  'あいのて',
  'あいのと',
  'あいのま',
  'あいのり',
  'あいばな',
  'あいはむ',
  'あいはん',
  'あいばん',
  'あいびー',
  'あいぴー',
  'あいびき',
  'あいびす',
  'あいびん',
  'あいふく',
  'あいふだ',
  'あいぶり',
  'あいべつ',
  'あいべや',
  'あいぼう',
  'あいぼし',
  'あいぼり',
  'あいぼれ',
  'あいまい',
  'あいます',
  'あいまつ',
  'あいまる',
  'あいみつ',
  'あいみる',
  'あいみん',
  'あいむこ',
  'あいめい',
  'あいもち',
  'あいもの',
  'あいやく',
  'あいやど',
  'あいよう',
  'あいよく',
  'あいらく',
  'あいらぐ',
  'あいりす',
  'あいれん',
  'あいろう',
  'あいろん',
  'あいわす',
  'あうあず',
  'あゔぁん',
  'あうぇあ',
  'あうえあ',
  'あうぇい',
  'あうえい',
  'あうぇー',
  'あうえー',
  'あうすと',
  'あうたー',
  'あうとろ',
  'あうらる',
  'あえない',
  'あえなく',
  'あえもの',
  'あえんか',
  'あおあお',
  'あおあざ',
  'あおあし',
  'あおいか',
  'あおいき',
  'あおいし',
  'あおいろ',
  'あおうお',
  'あおうま',
  'あおうめ',
  'あおおに',
  'あおがい',
  'あおかげ',
  'あおかち',
  'あおがね',
  'あおかび',
  'あおがら',
  'あおかん',
  'あおぎす',
  'あおきり',
  'あおぎり',
  'あおきん',
  'あおくさ',
  'あおぐみ',
  'あおげら',
  'あおごけ',
  'あおざい',
  'あおさぎ',
  'あおさば',
  'あおざめ',
  'あおじく',
  'あおじそ',
  'あおじる',
  'あおじろ',
  'あおすじ',
  'あおせぱ',
  'あおせん',
  'あおぞら',
  'あおだけ',
  'あおだち',
  'あおだも',
  'あおたん',
  'あおなぎ',
  'あおなし',
  'あおにく',
  'あおにび',
  'あおぬた',
  'あおねぎ',
  'あおねろ',
  'あおのく',
  'あおのり',
  'あおばえ',
  'あおはだ',
  'あおばと',
  'あおばな',
  'あおひげ',
  'あおぶさ',
  'あおふだ',
  'あおぼし',
  'あおまめ',
  'あおむき',
  'あおむく',
  'あおむけ',
  'あおむし',
  'あおめん',
  'あおもじ',
  'あおもの',
  'あおもり',
  'あおやき',
  'あおやぎ',
  'あおやま',
  'あかあか',
  'あかあざ',
  'あかあり',
  'あかいか',
  'あかいろ',
  'あかうお',
  'あかうそ',
  'あかうま',
  'あかうり',
  'あかえい',
  'あかえび',
  'あかおに',
  'あかおび',
  'あかがい',
  'あかかき',
  'あかがし',
  'あかがね',
  'あかかぶ',
  'あかがみ',
  'あかがり',
  'あかがわ',
  'あかぎれ',
  'あかきん',
  'あかぐつ',
  'あかぐま',
  'あかぐみ',
  'あかげら',
  'あかごめ',
  'あかざか',
  'あかさび',
  'あかしあ',
  'あかしお',
  'あかしか',
  'あかじそ',
  'あかしで',
  'あかしや',
  'あかすぎ',
  'あかすし',
  'あかずし',
  'あかずの',
  'あかずみ',
  'あかすり',
  'あかせる',
  'あかせん',
  'あかだい',
  'あかだし',
  'あかだに',
  'あかだま',
  'あかたん',
  'あがちす',
  'あかちゃ',
  'あかちん',
  'あかつき',
  'あかつち',
  'あかつら',
  'あかづら',
  'あかてい',
  'あかてん',
  'あかどう',
  'あかとき',
  'あかとび',
  'あかどら',
  'あかとり',
  'あがない',
  'あがなう',
  'あかなす',
  'あかなべ',
  'あかなめ',
  'あかにく',
  'あかにし',
  'あかぬけ',
  'あかはじ',
  'あかはた',
  'あかはだ',
  'あかはな',
  'あかばな',
  'あかはら',
  'あかばん',
  'あかひげ',
  'あかびし',
  'あかひれ',
  'あかぶさ',
  'あかふじ',
  'あかふだ',
  'あかぷり',
  'あがぺー',
  'あかべこ',
  'あかべに',
  'あかぺら',
  'あかへん',
  'あかぼう',
  'あかほん',
  'あかぼん',
  'あかまい',
  'あがまう',
  'あかまた',
  'あかまち',
  'あかまつ',
  'あかみそ',
  'あかみち',
  'あかむけ',
  'あかむし',
  'あかむつ',
  'あかむま',
  'あかめる',
  'あがめる',
  'あかもく',
  'あかもつ',
  'あかもの',
  'あかもん',
  'あかゆき',
  'あからむ',
  'あがりば',
  'あがりめ',
  'あがりゆ',
  'あかるい',
  'あかるさ',
  'あかるみ',
  'あかるむ',
  'あかんべ',
  'あかんぼ',
  'あきあき',
  'あきあげ',
  'あきあじ',
  'あきうど',
  'あきおち',
  'あきかぜ',
  'あきがら',
  'あきかん',
  'あきくさ',
  'あきぐち',
  'あきぐみ',
  'あきさく',
  'あきさば',
  'あきさむ',
  'あきさめ',
  'あきしつ',
  'あきしょ',
  'あきぜみ',
  'あきぞら',
  'あきだか',
  'あきだな',
  'あきたる',
  'あきだる',
  'あきない',
  'あきなう',
  'あきなす',
  'あきにれ',
  'あきのひ',
  'あきはぎ',
  'あきばこ',
  'あきばれ',
  'あきびと',
  'あきびん',
  'あきふく',
  'あきふゆ',
  'あきべや',
  'あきまき',
  'あきみせ',
  'あきめく',
  'あきょう',
  'あぎょう',
  'あきらか',
  'あきらめ',
  'あきれあ',
  'あきれす',
  'あきれる',
  'あきわく',
  'あきんど',
  'あくあく',
  'あくいろ',
  'あくいん',
  'あぐーち',
  'あくうま',
  'あくうん',
  'あくえき',
  'あくえん',
  'あくがた',
  'あくかん',
  'あくきん',
  'あくけい',
  'あくげん',
  'あくこう',
  'あくごう',
  'あくごん',
  'あくさい',
  'あくさく',
  'あくさん',
  'あくじき',
  'あくしす',
  'あくした',
  'あくしつ',
  'あくしゃ',
  'あくしゅ',
  'あくしょ',
  'あくじょ',
  'あくしん',
  'あくじん',
  'あくすい',
  'あくする',
  'あくせい',
  'あくぜい',
  'あくせく',
  'あくせさ',
  'あくせす',
  'あくぜつ',
  'あくせる',
  'あくせん',
  'あくぜん',
  'あくそう',
  'あくたー',
  'あくたい',
  'あくたま',
  'あくだま',
  'あくたれ',
  'あくちぶ',
  'あくちん',
  'あくてん',
  'あくどい',
  'あくとう',
  'あくどう',
  'あくとく',
  'あくなき',
  'あくにち',
  'あくにん',
  'あくぬき',
  'あくぬけ',
  'あぐねる',
  'あくねん',
  'あくのて',
  'あくひつ',
  'あくふう',
  'あくぶん',
  'あくへい',
  'あくへき',
  'あくへん',
  'あくほう',
  'あくまで',
  'あくまは',
  'あくめい',
  'あくやく',
  'あくゆう',
  'あくよう',
  'あくらつ',
  'あぐりー',
  'あくりる',
  'あくるひ',
  'あくれい',
  'あくろす',
  'あぐろめ',
  'あげあげ',
  'あげあし',
  'あげいし',
  'あげいた',
  'あげいん',
  'あげーん',
  'あけおめ',
  'あげかす',
  'あけがた',
  'あげくび',
  'あけくれ',
  'あけげー',
  'あけこん',
  'あげさげ',
  'あげしお',
  'あけしめ',
  'あけすけ',
  'あげせん',
  'あげぜん',
  'あげそこ',
  'あげぞこ',
  'あげだい',
  'あけたか',
  'あげだし',
  'あけたて',
  'あげだま',
  'あげちん',
  'あげどき',
  'あげどこ',
  'あげなべ',
  'あげはま',
  'あけばん',
  'あげぱん',
  'あけびか',
  'あげぶた',
  'あけへん',
  'あけぼの',
  'あげまき',
  'あげまく',
  'あげまん',
  'あけむつ',
  'あげもの',
  'あげやき',
  'あげゆか',
  'あげゆみ',
  'あこーど',
  'あこがれ',
  'あごくい',
  'あごはぜ',
  'あごひげ',
  'あごひも',
  'あごぼね',
  'あごわれ',
  'あさあけ',
  'あざーす',
  'あさーと',
  'あざーん',
  'あさいー',
  'あさいち',
  'あさいと',
  'あさいど',
  'あさいり',
  'あさいん',
  'あさうら',
  'あさおき',
  'あさおり',
  'あさかい',
  'あさがお',
  'あさがく',
  'あさがけ',
  'あさかぜ',
  'あさがた',
  'あさかつ',
  'あさがゆ',
  'あさぎり',
  'あさくず',
  'あさぐつ',
  'あさぐも',
  'あざけり',
  'あざける',
  'あさこん',
  'あさざけ',
  'あささむ',
  'あさじう',
  'あさじえ',
  'あさしお',
  'あさしも',
  'あさじも',
  'あさしん',
  'あさすず',
  'あさぞら',
  'あさだち',
  'あさぢえ',
  'あさっき',
  'あさつき',
  'あさづけ',
  'あざっす',
  'あさって',
  'あさづな',
  'あさつゆ',
  'あざとい',
  'あさどら',
  'あざなう',
  'あさなぎ',
  'あさなわ',
  'あさにじ',
  'あさぬの',
  'あさのは',
  'あさのみ',
  'あさはか',
  'あさばち',
  'あさはら',
  'あさはん',
  'あさばん',
  'あさひも',
  'あさひる',
  'あさぶろ',
  'あさまら',
  'あざまる',
  'あさみゆ',
  'あざむく',
  'あさめし',
  'あさもや',
  'あざやか',
  'あさやけ',
  'あさゆう',
  'あざらし',
  'あさると',
  'あざれあ',
  'あされん',
  'あざわど',
  'あさんぽ',
  'あじあい',
  'あじあう',
  'あしあと',
  'あじあん',
  'あじーる',
  'あしいれ',
  'あしうら',
  'あしおき',
  'あしおと',
  'あしかか',
  'あしかけ',
  'あしかせ',
  'あしがた',
  'あしがら',
  'あしがる',
  'あじきき',
  'あしきり',
  'あしくせ',
  'あしくび',
  'あしぐり',
  'あしくん',
  'あしげい',
  'あしげり',
  'あしこき',
  'あしこし',
  'あじさい',
  'あしさき',
  'あじざけ',
  'あじさし',
  'あじしお',
  'あしすと',
  'あしずり',
  'あしだい',
  'あしたず',
  'あしたば',
  'あじたま',
  'あしつき',
  'あしつぎ',
  'あじつけ',
  'あしっど',
  'あしどめ',
  'あしとり',
  'あしどり',
  'あしなえ',
  'あしなか',
  'あしなが',
  'あしなみ',
  'あしぬき',
  'あしぬけ',
  'あしのせ',
  'あじのり',
  'あしばや',
  'あしはら',
  'あじびら',
  'あしひれ',
  'あしぶえ',
  'あしふき',
  'あしぶね',
  'あしぶみ',
  'あしへん',
  'あしぼそ',
  'あしぼね',
  'あじまさ',
  'あしまね',
  'あしまめ',
  'あしもと',
  'あしもの',
  'あじゃた',
  'あじゃら',
  'あじゃり',
  'あじゃれ',
  'あしゅあ',
  'あしゅう',
  'あしゅく',
  'あしゆび',
  'あしゅら',
  'あしよわ',
  'あしらい',
  'あしらう',
  'あしるき',
  'あじわい',
  'あじわう',
  'あしわざ',
  'あしわら',
  'あずかり',
  'あずかる',
  'あすきー',
  'あすくる',
  'あずける',
  'あすこん',
  'あすたー',
  'あすたな',
  'あすてか',
  'あすてり',
  'あすなろ',
  'あすぱら',
  'あすぴー',
  'あすぺん',
  'あずまや',
  'あすまら',
  'あすろん',
  'あせかき',
  'あぜくら',
  'あせする',
  'あせだく',
  'あせちる',
  'あせっと',
  'あせどめ',
  'あせとり',
  'あせとん',
  'あせばむ',
  'あせびえ',
  'あせふき',
  'あせみず',
  'あぜみち',
  'あせろら',
  'あそうぎ',
  'あそうは',
  'あそーと',
  'あそばす',
  'あそびぎ',
  'あそびげ',
  'あそびば',
  'あそびめ',
  'あそぼう',
  'あたいえ',
  'あだうち',
  'あたえる',
  'あたおか',
  'あたかも',
  'あだかも',
  'あたくし',
  'あだごと',
  'あだじお',
  'あたする',
  'あだする',
  'あたたか',
  'あだちる',
  'あたっか',
  'あたっく',
  'あたっち',
  'あだなす',
  'あだばな',
  'あたぴー',
  'あだびと',
  'あたふた',
  'あだぷた',
  'あだぷと',
  'あたぼう',
  'あだめく',
  'あだもの',
  'あたりび',
  'あたりめ',
  'あたりや',
  'あだると',
  'あたわず',
  'あちーゔ',
  'あちーぶ',
  'あちこち',
  'あちさん',
  'あちちち',
  'あちゃー',
  'あちゃあ',
  'あつあげ',
  'あつあつ',
  'あついた',
  'あつうす',
  'あつえん',
  'あっかい',
  'あつかい',
  'あつかう',
  'あっかく',
  'あつがみ',
  'あつがり',
  'あつがる',
  'あつかわ',
  'あっかん',
  'あつかん',
  'あつぎり',
  'あっくす',
  'あつぐち',
  'あっけい',
  'あっこう',
  'あっこん',
  'あっさい',
  'あっさく',
  'あっさつ',
  'あっさり',
  'あっしー',
  'あつしぼ',
  'あっしゅ',
  'あっしん',
  'あっする',
  'あっせい',
  'あっせつ',
  'あっせん',
  'あつぞこ',
  'あっそん',
  'あったか',
  'あったら',
  'あっちい',
  'あっちち',
  'あっちゃ',
  'あっつう',
  'あっての',
  'あってん',
  'あつでん',
  'あっとう',
  'あつぬり',
  'あっぱー',
  'あっぱい',
  'あっぱく',
  'あっぱれ',
  'あっぷく',
  'あっぷる',
  'あつまり',
  'あつまる',
  'あつみつ',
  'あつめる',
  'あつもの',
  'あつもり',
  'あつやき',
  'あつよう',
  'あつよく',
  'あっらー',
  'あつらえ',
  'あつれき',
  'あつろき',
  'あていた',
  'あてうま',
  'あてがい',
  'あてがう',
  'あてがき',
  'あてこと',
  'あてごと',
  'あてこむ',
  'あてさき',
  'あてしょ',
  'あてすと',
  'あてつけ',
  'あてっこ',
  'あてない',
  'あてにげ',
  'あでにん',
  'あてびと',
  'あでぷと',
  'あてもの',
  'あてやか',
  'あでやか',
  'あでゅー',
  'あてれこ',
  'あてわざ',
  'あてんど',
  'あてんぽ',
  'あとあし',
  'あとあじ',
  'あとあと',
  'あどいん',
  'あとおい',
  'あとおし',
  'あどーび',
  'あどおん',
  'あとがき',
  'あとかた',
  'あとかぶ',
  'あとがま',
  'あとから',
  'あときん',
  'あとくち',
  'あとげつ',
  'あとさき',
  'あとさく',
  'あとざん',
  'あとずり',
  'あとぜめ',
  'あとだし',
  'あとぢえ',
  'あとつぎ',
  'あとづけ',
  'あととり',
  'あとにー',
  'あとはく',
  'あとはら',
  'あとばら',
  'あとぴー',
  'あとぴん',
  'あどぷと',
  'あとへん',
  'あとぼう',
  'あどまん',
  'あどみん',
  'あとやく',
  'あとやま',
  'あとらく',
  'あとらす',
  'あとりえ',
  'あどりぶ',
  'あどれす',
  'あなあき',
  'あなあけ',
  'あないち',
  'あなうま',
  'あなうめ',
  'あなうら',
  'あながち',
  'あながま',
  'あなかん',
  'あなくま',
  'あなぐま',
  'あなぐら',
  'あなぐり',
  'あなくろ',
  'あなこん',
  'あなざー',
  'あなずる',
  'あなせん',
  'あなたこ',
  'あなづり',
  'あなでじ',
  'あなてま',
  'あなとー',
  'あなどり',
  'あなどる',
  'あななす',
  'あなばち',
  'あなぷろ',
  'あなぼこ',
  'あなほり',
  'あなもん',
  'あなろぐ',
  'あにーる',
  'あにうえ',
  'あにおた',
  'あにおん',
  'あにから',
  'あにこう',
  'あにさん',
  'あにじゃ',
  'あにそん',
  'あにでし',
  'あにぶん',
  'あにまる',
  'あにめか',
  'あによめ',
  'あにりん',
  'あにをた',
  'あねうえ',
  'あねぎみ',
  'あねさん',
  'あねじゃ',
  'あねぶん',
  'あねむこ',
  'あねもね',
  'あのーど',
  'あのーる',
  'あのかた',
  'あのころ',
  'あのさあ',
  'あのさん',
  'あのにむ',
  'あのねえ',
  'あのひと',
  'あのみー',
  'あのよう',
  'あぱーと',
  'あはあは',
  'あばうと',
  'あばかす',
  'あばくす',
  'あぱこん',
  'あぱしー',
  'あばずれ',
  'あばたー',
  'あぱっち',
  'あははは',
  'あばらや',
  'あばれる',
  'あぱれる',
  'あびーむ',
  'あぴーる',
  'あひさん',
  'あびせる',
  'あふぃり',
  'あふぃん',
  'あふぇあ',
  'あふがん',
  'あぶぎだ',
  'あぷこん',
  'あぶさん',
  'あぶじゃ',
  'あぶすと',
  'あふたー',
  'あぶだび',
  'あぶない',
  'あぶなえ',
  'あぶなく',
  'あぶなげ',
  'あぶはち',
  'あぷらい',
  'あぶらえ',
  'あぶらけ',
  'あぶらげ',
  'あぶらこ',
  'あぶらざ',
  'あぶらな',
  'あぶらび',
  'あぶらみ',
  'あぶらめ',
  'あぶらや',
  'あふりか',
  'あぷりけ',
  'あふるる',
  'あふれこ',
  'あふれる',
  'あぶれる',
  'あへかお',
  'あへがお',
  'あべこべ',
  'あべっく',
  'あへっど',
  'あべはぜ',
  'あべまき',
  'あべりあ',
  'あべんど',
  'あぺんど',
  'あぼーと',
  'あぽーと',
  'あぼおん',
  'あぼーん',
  'あぼかど',
  'あぼがど',
  'あほくさ',
  'あほぐち',
  'あぽじー',
  'あほだら',
  'あほたれ',
  'あほづら',
  'あぽでん',
  'あぽとり',
  'あぽなし',
  'あぽりあ',
  'あぽろん',
  'あぼ〜ん',
  'あまあい',
  'あまあし',
  'あまあま',
  'あまいと',
  'あまいろ',
  'あまうけ',
  'あまえび',
  'あまえる',
  'あまおう',
  'あまおけ',
  'あまおち',
  'あまおと',
  'あまがき',
  'あまがさ',
  'あまかす',
  'あまかぜ',
  'あまかつ',
  'あまがつ',
  'あまかみ',
  'あまがみ',
  'あまから',
  'あまかわ',
  'あまくち',
  'あまぐつ',
  'あまくも',
  'あまぐも',
  'あまぐり',
  'あまごい',
  'あまこう',
  'あまさぎ',
  'あまざけ',
  'あまじお',
  'あまずら',
  'あませい',
  'あまぞら',
  'あまぞん',
  'あまだい',
  'あまだれ',
  'あまちゃ',
  'あまっこ',
  'あまつぶ',
  'あまつゆ',
  'あまでら',
  'あまどい',
  'あまとう',
  'あまどり',
  'あまなつ',
  'あまにゆ',
  'あまぬの',
  'あまねく',
  'あまのり',
  'あまはだ',
  'あまびえ',
  'あまびと',
  'あまぼし',
  'あまみず',
  'あまみそ',
  'あまもや',
  'あまもり',
  'あまやか',
  'あまやみ',
  'あまゆき',
  'あまよけ',
  'あまりに',
  'あまれす',
  'あまろり',
  'あまんど',
  'あみあげ',
  'あみーが',
  'あみーご',
  'あみいし',
  'あみーば',
  'あみーる',
  'あみうち',
  'あみかけ',
  'あみかご',
  'あみがさ',
  'あみこむ',
  'あみしろ',
  'あみだす',
  'あみだな',
  'あみだま',
  'あみてぃ',
  'あみてん',
  'あみどり',
  'あみのき',
  'あみのめ',
  'あみばり',
  'あみはん',
  'あみぼう',
  'あみぼし',
  'あみもと',
  'あみもの',
  'あみやき',
  'あむーる',
  'あむはら',
  'あむらー',
  'あめあし',
  'あめいろ',
  'あめうし',
  'あめうじ',
  'あめうり',
  'あめーば',
  'あめおち',
  'あめかじ',
  'あめかす',
  'あめかぜ',
  'あめがち',
  'あめこう',
  'あめこみ',
  'あめしゃ',
  'あめしょ',
  'あめじょ',
  'あめすく',
  'あめだす',
  'あめだま',
  'あめつち',
  'あめつぶ',
  'あめつゆ',
  'あめひと',
  'あめふだ',
  'あめふと',
  'あめふり',
  'あめます',
  'あめやま',
  'あめゆき',
  'あめらぐ',
  'あめりか',
  'あめんど',
  'あめんぼ',
  'あもーれ',
  'あもしし',
  'あもとじ',
  'あもろそ',
  'あもんど',
  'あやいと',
  'あやうい',
  'あやうく',
  'あやうじ',
  'あやおり',
  'あやかし',
  'あやかる',
  'あやぎぬ',
  'あやしい',
  'あやしげ',
  'あやしむ',
  'あやだけ',
  'あやつり',
  'あやつる',
  'あやとら',
  'あやとり',
  'あやなす',
  'あやぬの',
  'あやひと',
  'あやぶむ',
  'あやふや',
  'あやまち',
  'あやまつ',
  'あやまり',
  'あやまる',
  'あやめか',
  'あやめる',
  'あゆかけ',
  'あゆずし',
  'あゆつり',
  'あゆづり',
  'あらーと',
  'あらーむ',
  'あらあら',
  'あらいこ',
  'あらいし',
  'あらいず',
  'あらいそ',
  'あらいば',
  'あらいぶ',
  'あらいや',
  'あらうま',
  'あらうみ',
  'あらがう',
  'あらかし',
  'あらかす',
  'あらかた',
  'あらかね',
  'あらがね',
  'あらかべ',
  'あらがみ',
  'あらかわ',
  'あらかん',
  'あらぎも',
  'あらぎり',
  'あらくれ',
  'あらげる',
  'あらごし',
  'あらごと',
  'あらごま',
  'あらこも',
  'あらごも',
  'あらさー',
  'あらざん',
  'あらしお',
  'あらじお',
  'あらじる',
  'あらすか',
  'あらすじ',
  'あらそい',
  'あらそう',
  'あらそば',
  'あらぞめ',
  'あらたか',
  'あらだき',
  'あらだつ',
  'あらたま',
  'あらたむ',
  'あらため',
  'あらちゃ',
  'あらっく',
  'あらとぎ',
  'あらない',
  'あらなみ',
  'あらなわ',
  'あらにん',
  'あらぬり',
  'あらねつ',
  'あらはだ',
  'あらばま',
  'あらびあ',
  'あらびか',
  'あらびき',
  'あらびる',
  'あらぶご',
  'あらぶし',
  'あらぶる',
  'あらへん',
  'あらぼん',
  'あらまあ',
  'あらまき',
  'あらまし',
  'あらむご',
  'あらもの',
  'あらもん',
  'あらやだ',
  'あらゆる',
  'あららぎ',
  'あらりつ',
  'あらわざ',
  'あらわす',
  'あらわる',
  'あらわれ',
  'ありあう',
  'ありあけ',
  'ありあり',
  'ありーな',
  'ありうる',
  'ありえる',
  'ありがく',
  'ありかた',
  'ありがち',
  'ありがと',
  'ありがね',
  'ありぎれ',
  'ありくい',
  'ありぐも',
  'ありける',
  'ありごて',
  'ありさま',
  'ありしひ',
  'ありじゅ',
  'ありすい',
  'ありそう',
  'ありぞく',
  'ありぞな',
  'ありだか',
  'ありたけ',
  'ありだけ',
  'ありづか',
  'ありつぎ',
  'ありつく',
  'ありっぐ',
  'ありてい',
  'ありなし',
  'ありのみ',
  'ありばい',
  'ありばち',
  'ありほぞ',
  'ありまい',
  'ありまき',
  'ありゃー',
  'ありゃあ',
  'ありやー',
  'ありゅう',
  'ありよう',
  'ありんこ',
  'ありんす',
  'あるある',
  'あるいは',
  'あるいみ',
  'あるかり',
  'あるかん',
  'あるきる',
  'あるきん',
  'あるけー',
  'あるけん',
  'あるごる',
  'あるごん',
  'あるさろ',
  'あるじぇ',
  'あるしゅ',
  'あるしん',
  'あるたけ',
  'あるだけ',
  'あるとき',
  'あるなし',
  'あるにか',
  'あるにこ',
  'あるばー',
  'あるぱか',
  'あるばむ',
  'あるはら',
  'あるひと',
  'あるびの',
  'あるふぁ',
  'あるぷす',
  'あるべき',
  'あるべど',
  'あるぺん',
  'あるみな',
  'あれあれ',
  'あれうと',
  'あれーす',
  'あれーと',
  'あれから',
  'あれきり',
  'あれぐろ',
  'あれこれ',
  'あれしき',
  'あれだけ',
  'あれだま',
  'あれでら',
  'あれどめ',
  'あれはだ',
  'あれぱち',
  'あれびは',
  'あれへん',
  'あれほど',
  'あれまあ',
  'あれるや',
  'あれんじ',
  'あろーん',
  'あろわな',
  'あわーど',
  'あわさる',
  'あわせず',
  'あわせて',
  'あわせど',
  'あわせめ',
  'あわせる',
  'あわだち',
  'あわだつ',
  'あわつぶ',
  'あわてる',
  'あわばこ',
  'あわひめ',
  'あわぶき',
  'あわぶく',
  'あわぶろ',
  'あわめし',
  'あわもち',
  'あわもり',
  'あわゆき',
  'あわよい',
  'あわれげ',
  'あわれみ',
  'あわれむ',
  'あんあん',
  'あんいつ',
  'あんうつ',
  'あんうん',
  'あんえい',
  'あんおん',
  'あんかー',
  'あんがい',
  'あんかけ',
  'あんがと',
  'あんがど',
  'あんから',
  'あんかん',
  'あんぎな',
  'あんきも',
  'あんぎゃ',
  'あんきょ',
  'あんぐう',
  'あんぐら',
  'あんぐり',
  'あんくる',
  'あんぐる',
  'あんぐろ',
  'あんくん',
  'あんけつ',
  'あんけん',
  'あんげん',
  'あんこう',
  'あんごう',
  'あんこー',
  'あんこく',
  'あんごら',
  'あんころ',
  'あんこん',
  'あんさー',
  'あんざす',
  'あんさつ',
  'あんさん',
  'あんざん',
  'あんしつ',
  'あんじつ',
  'あんしゃ',
  'あんじゃ',
  'あんしゅ',
  'あんじゅ',
  'あんしょ',
  'あんじょ',
  'あんじる',
  'あんしん',
  'あんじん',
  'あんすう',
  'あんずる',
  'あんせい',
  'あんせむ',
  'あんせん',
  'あんぜん',
  'あんそく',
  'あんそろ',
  'あんだー',
  'あんたい',
  'あんだけ',
  'あんたら',
  'あんたん',
  'あんてい',
  'あんてな',
  'あんてん',
  'あんとう',
  'あんどぅ',
  'あんどう',
  'あんどら',
  'あんとれ',
  'あんどん',
  'あんなあ',
  'あんなー',
  'あんない',
  'あんなに',
  'あんなん',
  'あんにん',
  'あんねい',
  'あんのん',
  'あんばー',
  'あんばい',
  'あんぱい',
  'あんばこ',
  'あんぱん',
  'あんびり',
  'あんびる',
  'あんぴん',
  'あんぷく',
  'あんぷす',
  'あんぷる',
  'あんぶん',
  'あんぺあ',
  'あんべし',
  'あんぺら',
  'あんぽう',
  'あんぽり',
  'あんまき',
  'あんまく',
  'あんまし',
  'あんまり',
  'あんまん',
  'あんみつ',
  'あんみん',
  'あんもく',
  'あんもち',
  'あんもん',
  'あんやく',
  'あんらく',
  'あんるい',
  'いあんふ',
  'いいあい',
  'いいあう',
  'いーえす',
  'いいおく',
  'いーおん',
  'いいかい',
  'いいがい',
  'いいかえ',
  'いいかお',
  'いいかた',
  'いいかも',
  'いいから',
  'いいきび',
  'いいきみ',
  'いいきり',
  'いいぎり',
  'いいきる',
  'いいぐさ',
  'いーぐる',
  'いいこと',
  'いいころ',
  'いいさす',
  'いいざま',
  'いーしー',
  'いーじー',
  'いーじす',
  'いいすぎ',
  'いいすす',
  'いーすと',
  'いいずな',
  'いーぜる',
  'いいせん',
  'いーそう',
  'いいたげ',
  'いいだこ',
  'いいだし',
  'いいたす',
  'いいだす',
  'いいつぐ',
  'いいつけ',
  'いいづな',
  'いいとこ',
  'いいとし',
  'いいとも',
  'いいなか',
  'いいなす',
  'いいなり',
  'いいぬけ',
  'いいはる',
  'いーびー',
  'いーぴー',
  'いいびつ',
  'いいひと',
  'いーびる',
  'いーぶい',
  'いいぶり',
  'いーぶる',
  'いいぶん',
  'いーぶん',
  'いーぺー',
  'いいむし',
  'いいやる',
  'いーゆー',
  'いいよう',
  'いいよる',
  'いーるど',
  'いいわけ',
  'いうちー',
  'いうとも',
  'いうなり',
  'いえいえ',
  'いえいぬ',
  'いえかぜ',
  'いえがら',
  'いえぎみ',
  'いえごと',
  'いえすじ',
  'いえずす',
  'いえだに',
  'いえつき',
  'いえてぃ',
  'いえてる',
  'いえでん',
  'いえども',
  'いえなみ',
  'いえぬし',
  'いえねこ',
  'いえのみ',
  'いえばえ',
  'いえばと',
  'いえめん',
  'いえもち',
  'いえもと',
  'いぇろう',
  'いぇろー',
  'いえろー',
  'いおうか',
  'いおぐし',
  'いおつり',
  'いおとす',
  'いおんか',
  'いかいか',
  'いがいが',
  'いかえす',
  'いかがく',
  'いがくし',
  'いがくぶ',
  'いがぐり',
  'いかげそ',
  'いかけや',
  'いかける',
  'いかけん',
  'いかごろ',
  'いかさま',
  'いかしか',
  'いかすい',
  'いかずち',
  'いかすみ',
  'いかぞく',
  'いかたま',
  'いかたる',
  'いかつい',
  'いかづち',
  'いかなご',
  'いかなる',
  'いかにも',
  'いかほど',
  'いかめら',
  'いがめる',
  'いかもの',
  'いかよう',
  'いがらい',
  'いからす',
  'いかるが',
  'いかれる',
  'いかんで',
  'いきあう',
  'いぎあり',
  'いきいき',
  'いきうお',
  'いきうま',
  'いきうめ',
  'いきおい',
  'いきかい',
  'いきがい',
  'いきかう',
  'いきがお',
  'いきがけ',
  'いきかた',
  'いきがた',
  'いきがみ',
  'いきがる',
  'いきぎも',
  'いきぎれ',
  'いきぐみ',
  'いきごみ',
  'いきごむ',
  'いきざい',
  'いきさき',
  'いきさつ',
  'いきざま',
  'いきしあ',
  'いきしな',
  'いきしに',
  'いきしめ',
  'いきじめ',
  'いきしゅ',
  'いきすぎ',
  'いきすじ',
  'いきずり',
  'いきせき',
  'いきたい',
  'いきだす',
  'いきちか',
  'いきつぎ',
  'いきつく',
  'いきづく',
  'いきつけ',
  'いきない',
  'いぎなく',
  'いきなり',
  'いきぬき',
  'いきぬく',
  'いきのお',
  'いきのね',
  'いきはじ',
  'いきばる',
  'いきぶる',
  'いぎぼそ',
  'いきまく',
  'いきもの',
  'いきよい',
  'いきょう',
  'いぎょう',
  'いきょく',
  'いぎりす',
  'いくあて',
  'いぐあな',
  'いくいく',
  'いくえい',
  'いくさい',
  'いぐさか',
  'いくさき',
  'いくさば',
  'いくじご',
  'いくしゅ',
  'いくすう',
  'いぐすり',
  'いくせい',
  'いくせん',
  'いくたち',
  'いくたび',
  'いくたま',
  'いくたり',
  'いくちよ',
  'いくつか',
  'いくつき',
  'いくつも',
  'いくとし',
  'いくとせ',
  'いくども',
  'いくない',
  'いくにち',
  'いくにん',
  'いくねん',
  'いくばく',
  'いくぶん',
  'いぐぼご',
  'いくぼす',
  'いくほど',
  'いくめん',
  'いくもう',
  'いくやく',
  'いくよも',
  'いくらか',
  'いくらも',
  'いくりん',
  'いぐるー',
  'いけいけ',
  'いけうお',
  'いけおじ',
  'いけがき',
  'いけかた',
  'いけこむ',
  'いけしめ',
  'いけじめ',
  'いけずみ',
  'いけてる',
  'いけどし',
  'いけどり',
  'いけどる',
  'いけない',
  'いけにえ',
  'いけばな',
  'いけめん',
  'いげんご',
  'いこうき',
  'いこーる',
  'いごこち',
  'いこみき',
  'いころす',
  'いさかい',
  'いさかう',
  'いざかや',
  'いざこざ',
  'いさごじ',
  'いささか',
  'いざない',
  'いざなう',
  'いざなき',
  'いざなぎ',
  'いざなみ',
  'いさめる',
  'いざよい',
  'いさらい',
  'いさりび',
  'いしいし',
  'いじいじ',
  'いしうす',
  'いしうち',
  'いしかい',
  'いしがい',
  'いしがき',
  'いしがけ',
  'いしがに',
  'いしかべ',
  'いしがま',
  'いしがみ',
  'いしがめ',
  'いしかわ',
  'いしきか',
  'いしきり',
  'いしぐみ',
  'いじくる',
  'いしくれ',
  'いしけり',
  'いじける',
  'いじげん',
  'いしころ',
  'いしさじ',
  'いしじき',
  'いしずえ',
  'いじずく',
  'いしずみ',
  'いしずり',
  'いしせい',
  'いしだい',
  'いしだき',
  'いしだん',
  'いしづき',
  'いじづく',
  'いしづち',
  'いしつつ',
  'いしづみ',
  'いしてき',
  'いじでも',
  'いしなぎ',
  'いしなげ',
  'いしなご',
  'いしばい',
  'いしばし',
  'いしばは',
  'いしばり',
  'いじはる',
  'いじばる',
  'いしびつ',
  'いしひと',
  'いしびや',
  'いしぶた',
  'いしぶみ',
  'いしぶろ',
  'いしべい',
  'いしへん',
  'いしほう',
  'いじほう',
  'いしみち',
  'いしむろ',
  'いじめる',
  'いしもち',
  'いしやき',
  'いしやく',
  'いじゃく',
  'いしやま',
  'いしゅう',
  'いじゅう',
  'いしゅく',
  'いしゅつ',
  'いじゅつ',
  'いしゆみ',
  'いしょう',
  'いじょう',
  'いしょく',
  'いじょく',
  'いしるい',
  'いしろう',
  'いしわた',
  'いじわる',
  'いずかた',
  'いすずみ',
  'いすせき',
  'いすのき',
  'いずまい',
  'いすらむ',
  'いずれか',
  'いずれも',
  'いすわり',
  'いすわる',
  'いせいか',
  'いせえび',
  'いせかい',
  'いせごい',
  'いせこう',
  'いせこみ',
  'いせだい',
  'いそいそ',
  'いそいで',
  'いそうお',
  'いそうご',
  'いそうさ',
  'いそがす',
  'いそがに',
  'いそしぎ',
  'いそしむ',
  'いそじる',
  'いそずり',
  'いそたい',
  'いそづり',
  'いそなで',
  'いそなみ',
  'いそはぜ',
  'いそはま',
  'いそぶえ',
  'いそやけ',
  'いぞんど',
  'いたあつ',
  'いたいけ',
  'いたいし',
  'いたいじ',
  'いたいめ',
  'いたかじ',
  'いたかす',
  'いたがね',
  'いたかべ',
  'いたがみ',
  'いたがる',
  'いたきれ',
  'いたこう',
  'いたざい',
  'いたさん',
  'いたじい',
  'いたじき',
  'いたじめ',
  'いたしゃ',
  'いたずき',
  'いたずら',
  'いたずり',
  'いただき',
  'いたたく',
  'いただく',
  'いたちか',
  'いたつき',
  'いたづき',
  'いたって',
  'いたづら',
  'いたでん',
  'いだてん',
  'いたどり',
  'いたのま',
  'いたばし',
  'いたばね',
  'いたばり',
  'いたぶき',
  'いたふね',
  'いたぶね',
  'いたぶる',
  'いたべい',
  'いたまえ',
  'いたまる',
  'いためし',
  'いために',
  'いためる',
  'いたやき',
  'いたやね',
  'いたよせ',
  'いたらぬ',
  'いたりあ',
  'いたりー',
  'いたりや',
  'いたわり',
  'いたわる',
  'いたんし',
  'いたんじ',
  'いちあく',
  'いちあん',
  'いちいか',
  'いちいち',
  'いちいん',
  'いちえき',
  'いちえん',
  'いちおう',
  'いちおく',
  'いちおし',
  'いちおん',
  'いちがつ',
  'いちがみ',
  'いちから',
  'いちがん',
  'いちぎめ',
  'いちぐう',
  'いちくみ',
  'いちぐん',
  'いちげい',
  'いちげき',
  'いちげつ',
  'いちげん',
  'いちごう',
  'いちこつ',
  'いちこめ',
  'いちころ',
  'いちごん',
  'いちざい',
  'いちざら',
  'いちじき',
  'いちじく',
  'いちじつ',
  'いちじに',
  'いちじゅ',
  'いちじょ',
  'いちじん',
  'いちずに',
  'いちぜん',
  'いちぞく',
  'いちぞん',
  'いちだい',
  'いちだく',
  'いちだま',
  'いちだん',
  'いちぢく',
  'いちつけ',
  'いちづけ',
  'いちどう',
  'いちどく',
  'いちどに',
  'いちども',
  'いちどり',
  'いちなか',
  'いちなん',
  'いちにし',
  'いちにち',
  'いちにょ',
  'いちにん',
  'いちねん',
  'いちばい',
  'いちはつ',
  'いちばん',
  'いちびと',
  'いちひめ',
  'いちびり',
  'いちびる',
  'いちぶつ',
  'いちぶん',
  'いちべつ',
  'いちぼう',
  'いちぼく',
  'いちまい',
  'いちまき',
  'いちまつ',
  'いちまん',
  'いちみり',
  'いちみん',
  'いちめい',
  'いちめん',
  'いちもう',
  'いちもく',
  'いちもち',
  'いちもつ',
  'いちもん',
  'いちゃく',
  'いちやく',
  'いちゅう',
  'いちょう',
  'いちよう',
  'いちょく',
  'いちよく',
  'いちらく',
  'いちらん',
  'いちりつ',
  'いちりん',
  'いちるい',
  'いちれい',
  'いちれつ',
  'いちれん',
  'いちろう',
  'いちろく',
  'いちわり',
  'いついつ',
  'いっかい',
  'いつがい',
  'いっかく',
  'いっかつ',
  'いっかど',
  'いっかな',
  'いつかは',
  'いつから',
  'いっかん',
  'いっきく',
  'いっきに',
  'いっきょ',
  'いっきん',
  'いっけい',
  'いっけつ',
  'いっけん',
  'いつげん',
  'いっこう',
  'いっこく',
  'いつごろ',
  'いっこん',
  'いっさい',
  'いつざい',
  'いっさく',
  'いっさつ',
  'いっさん',
  'いっしー',
  'いつしか',
  'いっしき',
  'いっしご',
  'いっしつ',
  'いっしゅ',
  'いっしょ',
  'いっしん',
  'いっすい',
  'いっする',
  'いっすん',
  'いっせい',
  'いっせき',
  'いっせつ',
  'いっせん',
  'いっそう',
  'いっそく',
  'いつぞや',
  'いっそん',
  'いったい',
  'いったく',
  'いつだつ',
  'いったん',
  'いっつい',
  'いっつう',
  'いつつご',
  'いってい',
  'いってき',
  'いってつ',
  'いってに',
  'いつでも',
  'いってら',
  'いってん',
  'いっとう',
  'いっとき',
  'いっとく',
  'いっぱい',
  'いっぱく',
  'いっぱこ',
  'いっぱし',
  'いっぱつ',
  'いっぱん',
  'いっぴー',
  'いっぴき',
  'いっぴつ',
  'いっぴん',
  'いっぷう',
  'いっぷく',
  'いつぶす',
  'いっぷす',
  'いつぶつ',
  'いつぶん',
  'いっぷん',
  'いっぺい',
  'いっぺー',
  'いっぺん',
  'いつぼう',
  'いっぽう',
  'いっぽん',
  'いつまで',
  'いつみん',
  'いつめん',
  'いつもじ',
  'いつもつ',
  'いつゆう',
  'いづらい',
  'いつらく',
  'いつわり',
  'いつわる',
  'いである',
  'いでおむ',
  'いでたち',
  'いでたつ',
  'いてつく',
  'いてどけ',
  'いでんし',
  'いといぼ',
  'いといり',
  'いどうど',
  'いとおす',
  'いとおり',
  'いどがえ',
  'いとかけ',
  'いどがわ',
  'いとくず',
  'いとぐち',
  'いとぐら',
  'いとくり',
  'いとこに',
  'いどころ',
  'いとさま',
  'いとさめ',
  'いとさん',
  'いとしい',
  'いとしき',
  'いとしご',
  'いとしの',
  'いとしむ',
  'いとじり',
  'いとすぎ',
  'いとぞこ',
  'いとたけ',
  'いとだま',
  'いどづな',
  'いとづめ',
  'いとてき',
  'いととり',
  'いとなみ',
  'いとなむ',
  'いとのこ',
  'いどばた',
  'いとはん',
  'いとひき',
  'いとひめ',
  'いとびん',
  'いとへん',
  'いどほり',
  'いとまき',
  'いどみず',
  'いとみち',
  'いとめる',
  'いとゆう',
  'いとらん',
  'いとわく',
  'いなおし',
  'いなおす',
  'いなおる',
  'いなかま',
  'いなかや',
  'いながら',
  'いなげな',
  'いなさく',
  'いなずま',
  'いなづか',
  'いなづま',
  'いななき',
  'いななく',
  'いなびる',
  'いなむし',
  'いなむら',
  'いならぶ',
  'いなわら',
  'いにしえ',
  'いにっと',
  'いにゅう',
  'いにょう',
  'いにんぐ',
  'いぬがお',
  'いぬかき',
  'いぬがみ',
  'いぬがや',
  'いぬくい',
  'いぬぐい',
  'いぬくぎ',
  'いぬくぐ',
  'いぬぐす',
  'いぬごや',
  'いぬころ',
  'いぬざめ',
  'いぬしで',
  'いぬじに',
  'いぬぞく',
  'いぬぞり',
  'いぬつき',
  'いぬつげ',
  'いぬづれ',
  'いぬどし',
  'いぬにく',
  'いぬねこ',
  'いぬのひ',
  'いぬはぎ',
  'いぬびわ',
  'いぬぶえ',
  'いぬふく',
  'いぬぶな',
  'いぬまき',
  'いぬりん',
  'いぬわし',
  'いねかけ',
  'いねかり',
  'いねこき',
  'いねむり',
  'いねむる',
  'いねわら',
  'いのこく',
  'いのこり',
  'いのこる',
  'いのしし',
  'いのぶた',
  'いのんど',
  'いばしょ',
  'いばやし',
  'いばらき',
  'いばらぎ',
  'いばらも',
  'いばりや',
  'いびしゃ',
  'いびせい',
  'いひょう',
  'いびょう',
  'いひろう',
  'いぶかる',
  'いぶきは',
  'いぶくろ',
  'いふごう',
  'いふしゃ',
  'いぶんか',
  'いぶんし',
  'いべこん',
  'いべさー',
  'いべんと',
  'いぼあし',
  'いぼいぼ',
  'いぼだい',
  'いぼにし',
  'いぼまい',
  'いまーご',
  'いまーむ',
  'いまいち',
  'いまいま',
  'いまがた',
  'いまかの',
  'いまから',
  'いまかれ',
  'いまこそ',
  'いまごろ',
  'いまさら',
  'いましき',
  'いましめ',
  'いましも',
  'いまじん',
  'いますぐ',
  'いまだし',
  'いまだに',
  'いまでき',
  'いまでは',
  'いまでも',
  'いまどき',
  'いまなお',
  'いまにも',
  'いまふう',
  'いまほど',
  'いままで',
  'いまみや',
  'いまよう',
  'いまわり',
  'いまわる',
  'いみあい',
  'いみあけ',
  'いみがき',
  'いみかず',
  'いみぐれ',
  'いみしん',
  'いみない',
  'いみばし',
  'いみぶか',
  'いみょう',
  'いみろん',
  'いむかん',
  'いむしつ',
  'いむべき',
  'いめーじ',
  'いめくら',
  'いめとれ',
  'いめれす',
  'いもうと',
  'いもがい',
  'いもかさ',
  'いもがさ',
  'いもがゆ',
  'いもがら',
  'いもぎみ',
  'いもじり',
  'いもすけ',
  'いもたれ',
  'いもづる',
  'いもとご',
  'いものこ',
  'いものし',
  'いもばん',
  'いもほり',
  'いもむし',
  'いやーん',
  'いやいや',
  'いやおい',
  'いやおう',
  'いやがる',
  'いやこと',
  'いやごと',
  'いやさか',
  'いやしい',
  'いやしみ',
  'いやしむ',
  'いやちこ',
  'いやでも',
  'いやはや',
  'いやほん',
  'いやます',
  'いやみす',
  'いやもう',
  'いやもに',
  'いややか',
  'いよいよ',
  'いよかん',
  'いよだつ',
  'いよべん',
  'いよやか',
  'いらいと',
  'いらいら',
  'いらくさ',
  'いらした',
  'いらして',
  'いらすと',
  'いらだち',
  'いらだつ',
  'いらつく',
  'いらつこ',
  'いらっと',
  'いらつめ',
  'いらどる',
  'いられる',
  'いらんご',
  'いらんど',
  'いりあい',
  'いりうみ',
  'いりかた',
  'いりがた',
  'いりくち',
  'いりぐち',
  'いりくむ',
  'いりごま',
  'いりごみ',
  'いりこむ',
  'いりごめ',
  'いりすう',
  'いりすみ',
  'いりたて',
  'いりちー',
  'いりつく',
  'いりなべ',
  'いりなみ',
  'いりのい',
  'いりはま',
  'いりふね',
  'いりまち',
  'いりまめ',
  'いりむこ',
  'いりもや',
  'いりやね',
  'いりゅう',
  'いりょう',
  'いりよう',
  'いりょく',
  'いるかざ',
  'いるかせ',
  'いるこん',
  'いるまん',
  'いれいひ',
  'いれうす',
  'いれゔん',
  'いれかえ',
  'いれかけ',
  'いれがみ',
  'いれぐい',
  'いれくと',
  'いれこむ',
  'いれしち',
  'いれじち',
  'いれずみ',
  'いれぢえ',
  'いれふだ',
  'いれぶる',
  'いれぶん',
  'いれもの',
  'いれわた',
  'いろあい',
  'いろあく',
  'いろあげ',
  'いろいし',
  'いろいと',
  'いろいろ',
  'いろおち',
  'いろおに',
  'いろかず',
  'いろがみ',
  'いろがら',
  'いろぎめ',
  'いろぐろ',
  'いろけし',
  'いろこい',
  'いろこう',
  'いろごと',
  'いろざと',
  'いろじろ',
  'いろすな',
  'いろずり',
  'いろずれ',
  'いろぞめ',
  'いろだし',
  'いろだま',
  'いろつき',
  'いろづく',
  'いろつけ',
  'いろづけ',
  'いろつや',
  'いろとび',
  'いろどめ',
  'いろどり',
  'いろどる',
  'いろにー',
  'いろぬき',
  'いろぬり',
  'いろはく',
  'いろぶみ',
  'いろぼけ',
  'いろまち',
  'いろみず',
  'いろむじ',
  'いろむら',
  'いろめく',
  'いろもの',
  'いろやけ',
  'いろよい',
  'いろわけ',
  'いろんな',
  'いわあな',
  'いわいぎ',
  'いわうめ',
  'いわかき',
  'いわがき',
  'いわかげ',
  'いわかど',
  'いわがに',
  'いわかん',
  'いわぐみ',
  'いわくら',
  'いわさか',
  'いわざる',
  'いわしお',
  'いわしゆ',
  'いわしろ',
  'いわたけ',
  'いわたな',
  'いわだな',
  'いわでも',
  'いわなし',
  'いわのり',
  'いわはだ',
  'いわひば',
  'いわぶろ',
  'いわまつ',
  'いわむし',
  'いわむら',
  'いわむろ',
  'いわやま',
  'いわゆる',
  'いわんや',
  'いをえる',
  'いをくむ',
  'いんあい',
  'いんあつ',
  'いんいつ',
  'いんいん',
  'いんうつ',
  'いんうん',
  'いんえい',
  'いんえん',
  'いんおう',
  'いんがい',
  'いんかく',
  'いんがし',
  'いんかむ',
  'いんかめ',
  'いんかれ',
  'いんかん',
  'いんきー',
  'いんきゃ',
  'いんきょ',
  'いんきん',
  'いんぎん',
  'いんけい',
  'いんげい',
  'いんけん',
  'いんげん',
  'いんこう',
  'いんごう',
  'いんこく',
  'いんごと',
  'いんざい',
  'いんさつ',
  'いんさん',
  'いんじき',
  'いんじご',
  'いんしつ',
  'いんじゃ',
  'いんしゅ',
  'いんじゅ',
  'いんしょ',
  'いんじょ',
  'いんしん',
  'いんすい',
  'いんすう',
  'いんずう',
  'いんすこ',
  'いんすた',
  'いんすと',
  'いんすら',
  'いんする',
  'いんせい',
  'いんぜい',
  'いんせき',
  'いんせつ',
  'いんせる',
  'いんせん',
  'いんぜん',
  'いんそう',
  'いんぞう',
  'いんぞく',
  'いんそつ',
  'いんたー',
  'いんたい',
  'いんたく',
  'いんちき',
  'いんてい',
  'いんてき',
  'いんてつ',
  'いんてり',
  'いんてる',
  'いんどあ',
  'いんとう',
  'いんどう',
  'いんとく',
  'いんとら',
  'いんどり',
  'いんとろ',
  'いんとん',
  'いんなー',
  'いんない',
  'いんにく',
  'いんにょ',
  'いんにん',
  'いんねん',
  'いんのう',
  'いんのこ',
  'いんばー',
  'いんはい',
  'いんばい',
  'いんばこ',
  'いんぱね',
  'いんぱら',
  'いんばん',
  'いんぱん',
  'いんびぼ',
  'いんぷう',
  'いんふぉ',
  'いんぷく',
  'いんぶつ',
  'いんふら',
  'いんふる',
  'いんふれ',
  'いんぷれ',
  'いんぷろ',
  'いんぶん',
  'いんぺい',
  'いんぺら',
  'いんぺる',
  'いんぼう',
  'いんぼら',
  'いんぽん',
  'いんめい',
  'いんめつ',
  'いんめん',
  'いんもう',
  'いんもつ',
  'いんもん',
  'いんよう',
  'いんよく',
  'いんらん',
  'いんりつ',
  'いんりん',
  'いんれい',
  'いんれー',
  'いんれき',
  'いんれつ',
  'いんろう',
  'いんろー',
  'いんわい',
  'ゔぁいす',
  'ゔぁいぶ',
  'ゔぁぎな',
  'ゔぁにら',
  'ゔぁるゔ',
  'ゔぁるな',
  'ゔぁんぷ',
  'うぃーく',
  'ういーく',
  'うぃーす',
  'うぃーど',
  'うぃーん',
  'ゔぃおら',
  'ゔぃおる',
  'うぃきる',
  'ういぐる',
  'ういごと',
  'うぃざー',
  'ういざん',
  'ういじん',
  'うぃすき',
  'ういすき',
  'うぃっか',
  'ういっく',
  'うぃっぐ',
  'ういっぐ',
  'うぃっす',
  'ういっす',
  'うぃっち',
  'ういっち',
  'うぃっと',
  'ういっと',
  'ゔぃっぷ',
  'ゔぃでお',
  'うぃどう',
  'ういどう',
  'うぃどー',
  'ういどー',
  'ういなー',
  'ういばな',
  'ういまご',
  'うぃめん',
  'うぃりー',
  'ういりー',
  'うぃるす',
  'ういるす',
  'うぃるむ',
  'ういろう',
  'うぃんか',
  'ういんか',
  'うぃんく',
  'ういんく',
  'うぃんぐ',
  'ういんぐ',
  'うぃんず',
  'うぃんた',
  'うぃんち',
  'ういんち',
  'うぃんど',
  'ういんど',
  'うぃんな',
  'ういんな',
  'うーはー',
  'うーはい',
  'うーまん',
  'うーめら',
  'ううめん',
  'うーめん',
  'うーろん',
  'うぇあー',
  'うえあー',
  'うぇいゔ',
  'うぇいじ',
  'うぇいず',
  'うぇいた',
  'うぇいと',
  'うえいと',
  'うぇいぶ',
  'うえいぶ',
  'うぇいん',
  'うぇーい',
  'うぇーゔ',
  'ゔぇーだ',
  'うぇーと',
  'うえーと',
  'うぇーば',
  'うぇーぶ',
  'うえーぶ',
  'ゔぇーる',
  'うえかえ',
  'うえきや',
  'うえこみ',
  'うえこむ',
  'うぇざー',
  'うえざー',
  'うえさま',
  'うえざま',
  'うえした',
  'うえじに',
  'うぇすた',
  'うぇすと',
  'うえすと',
  'ゔぇすと',
  'うぇせく',
  'うえつけ',
  'うぇっじ',
  'うえっじ',
  'うぇっと',
  'うえっと',
  'うぇっぶ',
  'うえでは',
  'うぇぬす',
  'うえのこ',
  'うぇはー',
  'うえはー',
  'うぇふぁ',
  'うえぶれ',
  'うぇぽん',
  'うえぽん',
  'うえみぎ',
  'うえむき',
  'うえむく',
  'うぇるぷ',
  'ゔぉいす',
  'うぉーく',
  'うおーく',
  'うぉーさ',
  'うぉーず',
  'うぉーた',
  'うぉーむ',
  'うぉーる',
  'うおーる',
  'うおがし',
  'うおかす',
  'うおくし',
  'うおぐし',
  'うおすき',
  'うぉっか',
  'うぉつか',
  'うおっか',
  'うおつか',
  'うぉっち',
  'うおっち',
  'うおつり',
  'うぉとか',
  'ゔぉどか',
  'うおのめ',
  'うおへん',
  'うおみそ',
  'ゔぉると',
  'うぉるふ',
  'うぉんつ',
  'うぉんど',
  'うかいろ',
  'うかうか',
  'うかがい',
  'うかがう',
  'うかじん',
  'うがじん',
  'うかせる',
  'うかたま',
  'うがった',
  'うかぶせ',
  'うかべる',
  'うかれお',
  'うかれめ',
  'うかれる',
  'うがんだ',
  'うきあし',
  'うきいし',
  'うきいわ',
  'うきうお',
  'うきうき',
  'うきおり',
  'うきがし',
  'うききそ',
  'うきくさ',
  'うきくも',
  'うきぐも',
  'うきごし',
  'うきごり',
  'うきしま',
  'うきじま',
  'うきだす',
  'うきたつ',
  'うきでる',
  'うきはし',
  'うきふね',
  'うきぼり',
  'うきゃく',
  'うきゅう',
  'うきよえ',
  'うきょく',
  'うぐいす',
  'うくれれ',
  'うけあい',
  'うけあう',
  'うけいか',
  'うけいれ',
  'うけうり',
  'うけおい',
  'うけおう',
  'うけくち',
  'うけぐち',
  'うけごし',
  'うけざら',
  'うけしょ',
  'うけだす',
  'うけだち',
  'うけつぐ',
  'うけつけ',
  'うけつぼ',
  'うけとり',
  'うけとる',
  'うけにん',
  'うけばこ',
  'うけばな',
  'うけはん',
  'うけもち',
  'うけもつ',
  'うけやど',
  'うごかす',
  'うこぎか',
  'うごめく',
  'うざがる',
  'うさぎか',
  'うさぎざ',
  'うさせつ',
  'うさみみ',
  'うしあぶ',
  'うじうじ',
  'うじうど',
  'うしえび',
  'うしおい',
  'うしおに',
  'うしかい',
  'うじがみ',
  'うしがら',
  'うしがわ',
  'うしごや',
  'うしざき',
  'うしざめ',
  'うしぞく',
  'うじちゃ',
  'うじでら',
  'うしどし',
  'うしとら',
  'うしなう',
  'うしのひ',
  'うしばえ',
  'うじひと',
  'うじびと',
  'うじぶみ',
  'うしへん',
  'うじむし',
  'うしもく',
  'うしゃく',
  'うじゃく',
  'うしやみ',
  'うしょう',
  'うじょう',
  'うしょく',
  'うしろで',
  'うすあお',
  'うすあけ',
  'うすあげ',
  'うすあじ',
  'うすいた',
  'うずいと',
  'うすいろ',
  'うすうす',
  'うずうず',
  'うすがた',
  'うすがみ',
  'うすかわ',
  'うすぎぬ',
  'うすぎり',
  'うすくち',
  'うすぐも',
  'うすぐれ',
  'うすしお',
  'うすじお',
  'うずしお',
  'うすずみ',
  'うすたけ',
  'うすちゃ',
  'うすつく',
  'うすづく',
  'うすにく',
  'うすぬり',
  'うすのろ',
  'うすばか',
  'うずべく',
  'うすべに',
  'うすべり',
  'うずまき',
  'うすまく',
  'うずまく',
  'うすまる',
  'うずまる',
  'うずみび',
  'うすめる',
  'うずめる',
  'うすもの',
  'うすもや',
  'うすやき',
  'うすやみ',
  'うすゆき',
  'うすよう',
  'うすらい',
  'うすらぐ',
  'うすらひ',
  'うすらび',
  'うすれる',
  'うせさる',
  'うせもの',
  'うそうそ',
  'うぞうぞ',
  'うそかえ',
  'うそつき',
  'うそつけ',
  'うそっこ',
  'うそなき',
  'うそぶく',
  'うそやん',
  'うたいて',
  'うたいめ',
  'うだうだ',
  'うたかい',
  'うたがい',
  'うたがう',
  'うたがき',
  'うたかた',
  'うたがた',
  'うたがみ',
  'うたぐち',
  'うたぐり',
  'うたぐる',
  'うたごえ',
  'うたざわ',
  'うたせゆ',
  'うたたね',
  'うたびと',
  'うたひめ',
  'うたもの',
  'うたよみ',
  'うたれる',
  'うちあい',
  'うちあう',
  'うちあげ',
  'うちいけ',
  'うちいり',
  'うちいる',
  'うちうち',
  'うちうみ',
  'うちかい',
  'うちがい',
  'うちかぎ',
  'うちかく',
  'うちかけ',
  'うちがけ',
  'うちがし',
  'うちかた',
  'うちかつ',
  'うちがね',
  'うちがま',
  'うちがみ',
  'うちがり',
  'うちがわ',
  'うちきず',
  'うちきり',
  'うちきる',
  'うちきん',
  'うちくび',
  'うちくら',
  'うちぐら',
  'うちけし',
  'うちけす',
  'うちげば',
  'うちこみ',
  'うちこむ',
  'うちざた',
  'うちしき',
  'うちじに',
  'うちすう',
  'うちすじ',
  'うちぜい',
  'うちそと',
  'うちたけ',
  'うちだし',
  'うちだす',
  'うちづら',
  'うちでき',
  'うちでし',
  'うちどめ',
  'うちとる',
  'うちなる',
  'うちにわ',
  'うちぬき',
  'うちぬく',
  'うちねこ',
  'うちのみ',
  'うちのり',
  'うちばり',
  'うちひも',
  'うちふす',
  'うちぶた',
  'うちふる',
  'うちぶろ',
  'うちぼう',
  'うちぼり',
  'うちまき',
  'うちまく',
  'うちまご',
  'うちまた',
  'うちみず',
  'うちみる',
  'うちむき',
  'うちもの',
  'うちもも',
  'うちやる',
  'うちゅう',
  'うちろじ',
  'うちわえ',
  'うちわく',
  'うちわけ',
  'うちわに',
  'うちわる',
  'うちんち',
  'うつうつ',
  'うっかり',
  'うっがん',
  'うっきー',
  'うっくつ',
  'うづくり',
  'うっけつ',
  'うつける',
  'うっさい',
  'うつしえ',
  'うつしよ',
  'うっすら',
  'うっせえ',
  'うっせー',
  'うっせき',
  'うつせみ',
  'うつぜん',
  'うっそう',
  'うっそり',
  'うったい',
  'うったえ',
  'うっつい',
  'うっとい',
  'うっとり',
  'うつばり',
  'うつぶす',
  'うっぷす',
  'うつぶせ',
  'うっぷん',
  'うつぼつ',
  'うつむき',
  'うつむく',
  'うつむけ',
  'うつりが',
  'うつりぎ',
  'うつりん',
  'うつろい',
  'うつろう',
  'うできき',
  'うでくび',
  'うでぐみ',
  'うでこき',
  'うでさき',
  'うでずく',
  'うでたて',
  'うでだて',
  'うでづく',
  'うでぬき',
  'うでまえ',
  'うとうと',
  'うとっと',
  'うどんげ',
  'うどんこ',
  'うどんや',
  'うながす',
  'うなぎや',
  'うなさか',
  'うなずき',
  'うなずく',
  'うなぞこ',
  'うなつき',
  'うなづく',
  'うなでん',
  'うなどん',
  'うなばら',
  'うにどん',
  'うにふら',
  'うぬぼれ',
  'うねうね',
  'うねおり',
  'うねたて',
  'うねだて',
  'うねみぞ',
  'うねめし',
  'うのこく',
  'うのはな',
  'うばーれ',
  'うばうお',
  'うはうは',
  'うばがい',
  'うばざめ',
  'うばすて',
  'うばそく',
  'うばたま',
  'うひょう',
  'うふーん',
  'うぷおつ',
  'うぶがみ',
  'うぶぎぬ',
  'うぶごえ',
  'うぶだし',
  'うぷぬし',
  'うぶめし',
  'うべなう',
  'うまあぶ',
  'うまーん',
  'うまいち',
  'うまいな',
  'うまうま',
  'うまおい',
  'うまがお',
  'うまかた',
  'うまから',
  'うまがる',
  'うまくさ',
  'うまぐし',
  'うまぐわ',
  'うまげた',
  'うまごや',
  'うまさけ',
  'うまざけ',
  'うましお',
  'うまじお',
  'うまずめ',
  'うまづら',
  'うまどし',
  'うまとび',
  'うまとり',
  'うまなみ',
  'うまぬし',
  'うまのせ',
  'うまのひ',
  'うまのり',
  'うまばえ',
  'うまひと',
  'うまびる',
  'うまぶね',
  'うまへん',
  'うまみち',
  'うまれび',
  'うまれる',
  'うみうし',
  'うみうそ',
  'うみうま',
  'うみえら',
  'うみおそ',
  'うみかぜ',
  'うみがめ',
  'うみがわ',
  'うみぎり',
  'うみくさ',
  'うみぐさ',
  'うみぐも',
  'うみさち',
  'うみしだ',
  'うみしる',
  'うみじる',
  'うみすな',
  'うみずな',
  'うみぞい',
  'うみたけ',
  'うみだす',
  'うみづき',
  'うみづり',
  'うみどり',
  'うみなり',
  'うみにな',
  'うみねぎ',
  'うみねこ',
  'うみのこ',
  'うみのひ',
  'うみばと',
  'うみへび',
  'うみます',
  'うみやま',
  'うみゆり',
  'うみわけ',
  'うみわた',
  'うみわに',
  'うめいろ',
  'うめくさ',
  'うめこみ',
  'うめこむ',
  'うめしゅ',
  'うめぞの',
  'うめたて',
  'うめづけ',
  'うめねず',
  'うめのみ',
  'うめばか',
  'うめぼし',
  'うもれぎ',
  'うもれる',
  'うやまい',
  'うやまう',
  'うやむや',
  'うようよ',
  'うよさよ',
  'うらあか',
  'うらあて',
  'うらあみ',
  'うらいた',
  'うらうち',
  'うらうら',
  'うらえり',
  'うらがき',
  'うらかく',
  'うらかぜ',
  'うらかた',
  'うらがね',
  'うらがみ',
  'うらがれ',
  'うらかわ',
  'うらがわ',
  'うらぎく',
  'うらきど',
  'うらぎり',
  'うらぎる',
  'うらくぎ',
  'うらぐち',
  'うらげい',
  'うらけん',
  'うらごえ',
  'うらごし',
  'うらごめ',
  'うらさく',
  'うらざと',
  'うらさん',
  'うらしる',
  'うらじろ',
  'うらすじ',
  'うらせど',
  'うらだな',
  'うらつき',
  'うらづけ',
  'うらどう',
  'うらどし',
  'うらどら',
  'うらとり',
  'うらない',
  'うらなう',
  'うらなげ',
  'うらなみ',
  'うらなり',
  'うらにわ',
  'うらぬす',
  'うらのす',
  'うらばな',
  'うらはら',
  'うらばり',
  'うらばん',
  'うらびと',
  'うらぶた',
  'うらぶみ',
  'うらぼん',
  'うらまー',
  'うらまき',
  'うらまち',
  'うらまど',
  'うらみち',
  'うらむき',
  'うらめる',
  'うらめん',
  'うらもん',
  'うらやま',
  'うらやみ',
  'うらやむ',
  'うららか',
  'うらろく',
  'うらわざ',
  'うりあげ',
  'うりいえ',
  'うりおぺ',
  'うりかい',
  'うりかけ',
  'うりかた',
  'うりきり',
  'うりきる',
  'うりきれ',
  'うりぐい',
  'うりけん',
  'うりごえ',
  'うりこし',
  'うりこみ',
  'うりこむ',
  'うりごめ',
  'うりじん',
  'うりずん',
  'うりせん',
  'うりだか',
  'うりだし',
  'うりだす',
  'うりたて',
  'うりだて',
  'うりつけ',
  'うりどき',
  'うりなら',
  'うりにげ',
  'うりぬく',
  'うりぬけ',
  'うりぬし',
  'うりのき',
  'うりばえ',
  'うりぼう',
  'うりもち',
  'うりもの',
  'うりょう',
  'うりるい',
  'うるあわ',
  'うるーこ',
  'ゔるーて',
  'うるうび',
  'うるうる',
  'うるおい',
  'うるおう',
  'うるおす',
  'うるかす',
  'うるがた',
  'ゔるがた',
  'うるごめ',
  'うるさい',
  'うるしえ',
  'うるしか',
  'うるしや',
  'ゔるすと',
  'うるせぇ',
  'うるせえ',
  'うるせー',
  'うるとら',
  'うるむち',
  'うれあし',
  'うれえる',
  'うれくち',
  'うれしい',
  'うれしげ',
  'うれすじ',
  'うれせん',
  'うれだか',
  'うれたん',
  'うれっこ',
  'うれゆき',
  'うろうろ',
  'うろつく',
  'うろぬく',
  'うろはぜ',
  'うわあご',
  'うわあん',
  'うわーん',
  'うわいし',
  'うわうす',
  'うわえだ',
  'うわおび',
  'うわがき',
  'うわかけ',
  'うわがけ',
  'うわがみ',
  'うわかわ',
  'うわがわ',
  'うわぐつ',
  'うわぐむ',
  'うわごと',
  'うわしき',
  'うわじき',
  'うわしる',
  'うわずみ',
  'うわずる',
  'うわぜい',
  'うわだい',
  'うわつき',
  'うわつく',
  'うわづみ',
  'うわつら',
  'うわなみ',
  'うわなり',
  'うわぬり',
  'うわのせ',
  'うわのり',
  'うわばき',
  'うわばこ',
  'うわばみ',
  'うわばり',
  'うわばん',
  'うわひも',
  'うわふく',
  'うわぶれ',
  'うわまい',
  'うわまえ',
  'うわむき',
  'うわむく',
  'うわもり',
  'うわやく',
  'うんうん',
  'うんえい',
  'うんえき',
  'うんえん',
  'うんおう',
  'うんかい',
  'うんかく',
  'うんけい',
  'うんげー',
  'うんげん',
  'うんこう',
  'うんざり',
  'うんさん',
  'うんざん',
  'うんしん',
  'うんすい',
  'うんせい',
  'うんそう',
  'うんそん',
  'うんたい',
  'うんだい',
  'うんたら',
  'うんちく',
  'うんちゃ',
  'うんちん',
  'うんてい',
  'うんでい',
  'うんてん',
  'うんどう',
  'うんとこ',
  'うんどん',
  'うんぬん',
  'うんのう',
  'うんぱん',
  'うんぴつ',
  'うんむん',
  'うんめい',
  'うんめん',
  'うんよう',
  'うんよく',
  'うんらん',
  'えあがん',
  'えあこん',
  'えあさす',
  'えあどあ',
  'えあばす',
  'えあまね',
  'えあもに',
  'えありあ',
  'えあろび',
  'えあわせ',
  'えいいん',
  'えいえい',
  'えいえん',
  'えいおう',
  'えいおん',
  'えいかー',
  'えいがか',
  'えいかく',
  'えいがく',
  'えいかん',
  'えいきょ',
  'えいきん',
  'えいぎん',
  'えいけい',
  'えいけつ',
  'えいけん',
  'えいこう',
  'えいごう',
  'えいこく',
  'えいこん',
  'えいさあ',
  'えいさー',
  'えいさい',
  'えいさく',
  'えいしき',
  'えいじす',
  'えいじつ',
  'えいしゃ',
  'えいしゅ',
  'えいじゅ',
  'えいしょ',
  'えいじる',
  'えいしん',
  'えいじん',
  'えいすう',
  'えいずる',
  'えいせい',
  'えいせん',
  'えいぜん',
  'えいそう',
  'えいぞう',
  'えいぞく',
  'えいそん',
  'えいぞん',
  'えいたい',
  'えいだい',
  'えいたつ',
  'えいだつ',
  'えいたん',
  'えいだん',
  'えいてい',
  'えいてん',
  'えいとう',
  'えいどう',
  'えいとく',
  'えいどく',
  'えいどす',
  'えいとん',
  'えいにち',
  'えいにん',
  'えいねん',
  'えいのう',
  'えいはい',
  'えいはら',
  'えいびん',
  'えいふつ',
  'えいぶん',
  'えいへい',
  'えいべい',
  'えいべつ',
  'えいほう',
  'えいまい',
  'えいまん',
  'えいみん',
  'えいめい',
  'えいめん',
  'えいもじ',
  'えいやく',
  'えいやっ',
  'えいゆう',
  'えいよう',
  'えいらく',
  'えいらん',
  'えいりょ',
  'えいりん',
  'えいれい',
  'えいろう',
  'えいろく',
  'えうちわ',
  'えうろぱ',
  'えーあい',
  'えーえふ',
  'えーおー',
  'えーかー',
  'えーがた',
  'えーけい',
  'えーこす',
  'えーしー',
  'ええっと',
  'えーっと',
  'えーてる',
  'えーとす',
  'えーぶい',
  'えーめん',
  'えーわん',
  'えおうぎ',
  'えおしん',
  'えかがみ',
  'えがきて',
  'えがたい',
  'えがらい',
  'えがわる',
  'えきあん',
  'えぎーゆ',
  'えきいん',
  'えきうむ',
  'えきうり',
  'えきえき',
  'えきがく',
  'えききん',
  'えきざい',
  'えきさく',
  'えきしま',
  'えきしゃ',
  'えきしゅ',
  'えきしん',
  'えきじん',
  'えきすぽ',
  'えきする',
  'えきせい',
  'えきぜい',
  'えきそう',
  'えきぞち',
  'えきそん',
  'えきたい',
  'えきたぶ',
  'えきだめ',
  'えきだん',
  'えきちか',
  'えきちく',
  'えきてい',
  'えきてき',
  'えきでん',
  'えきとう',
  'えきどめ',
  'えきなか',
  'えきぱい',
  'えきびる',
  'えきふう',
  'えきべん',
  'えきほう',
  'えきまえ',
  'えきまに',
  'えきめい',
  'えきめろ',
  'えきめん',
  'えきゅー',
  'えきゆう',
  'えきらん',
  'えきれい',
  'えくすて',
  'えくすぽ',
  'えくせる',
  'えくそあ',
  'えくそん',
  'えぐらふ',
  'えくらん',
  'えくれあ',
  'えぐれる',
  'えげれす',
  'えこうげ',
  'えこーる',
  'えこかー',
  'えごころ',
  'えごのき',
  'えこのみ',
  'えごのり',
  'えごまぞ',
  'えごまゆ',
  'えごよみ',
  'えころじ',
  'えこんて',
  'えさがし',
  'えさばこ',
  'えさやり',
  'えしかる',
  'えじぷと',
  'えしゃく',
  'えじりん',
  'えすあい',
  'えすいー',
  'えすえー',
  'えすえす',
  'えすえふ',
  'えすえむ',
  'えすえる',
  'えすかー',
  'えすがた',
  'えすきす',
  'えすじす',
  'えすぞう',
  'えすてる',
  'えすぱー',
  'えすびー',
  'えすぴー',
  'えすぷり',
  'えずめん',
  'えずらき',
  'えすらむ',
  'えせおや',
  'えせごと',
  'えせもの',
  'えぞうし',
  'えぞぎく',
  'えぞしか',
  'えぞぜみ',
  'えぞねぎ',
  'えぞばい',
  'えぞぼら',
  'えぞまつ',
  'えぞりす',
  'えだがみ',
  'えだかり',
  'えだきり',
  'えだくみ',
  'えだせん',
  'えだつぎ',
  'えだつの',
  'えだづの',
  'えだにく',
  'えだぶり',
  'えだまめ',
  'えだみち',
  'えだみや',
  'えだむち',
  'えたろん',
  'えちえち',
  'えちぜん',
  'えちれん',
  'えっくす',
  'えっけん',
  'えっさい',
  'えっじー',
  'えっする',
  'えっせぃ',
  'えっせい',
  'えっせー',
  'えっせん',
  'えっちい',
  'えっとう',
  'えつどく',
  'えつなん',
  'えつねん',
  'えっぺい',
  'えっへん',
  'えつらく',
  'えつらん',
  'えつれき',
  'えでぃた',
  'えでぃと',
  'えてがみ',
  'えてこう',
  'えてして',
  'えどえず',
  'えどぎく',
  'えどっこ',
  'えどべん',
  'えどまえ',
  'えどみそ',
  'えどもの',
  'えとわす',
  'えどわん',
  'えなじー',
  'えなみん',
  'えなめる',
  'えなんじ',
  'えにぐま',
  'えにしだ',
  'えにっき',
  'えになる',
  'えぬこく',
  'えぬさぴ',
  'えぬしー',
  'えぬじー',
  'えぬれん',
  'えねみー',
  'えねるぎ',
  'えのころ',
  'えばおり',
  'えはがき',
  'えびいも',
  'えびいろ',
  'えひがさ',
  'えびがに',
  'えびごし',
  'えびぜめ',
  'えびぞり',
  'えぴたふ',
  'えびちゃ',
  'えびちり',
  'えぴっく',
  'えびづる',
  'えぴぺん',
  'えびまよ',
  'えふえー',
  'えふえむ',
  'えぶくろ',
  'えふそう',
  'えふびー',
  'えふぴー',
  'えぷろん',
  'えふわん',
  'えべんき',
  'えべんと',
  'えぽきし',
  'えぼしな',
  'えぼだい',
  'えぽっく',
  'えぼにー',
  'えぽにむ',
  'えぽわす',
  'えまでん',
  'えまどう',
  'えみぐれ',
  'えみゅー',
  'えむえす',
  'えむえふ',
  'えむおー',
  'えむびー',
  'えむぺぐ',
  'えめちん',
  'えめりー',
  'えもよう',
  'えやこん',
  'えらあな',
  'えらがる',
  'えらそう',
  'えらばり',
  'えらぶた',
  'えらぶつ',
  'えらぶる',
  'えらぼね',
  'えらむご',
  'えらもの',
  'えらんど',
  'えりあし',
  'えりーと',
  'えりうら',
  'えりがえ',
  'えりがみ',
  'えりくず',
  'えりくび',
  'えりぐり',
  'えりこし',
  'えりさき',
  'えりさん',
  'えりした',
  'えりしん',
  'えりだす',
  'えりつき',
  'えりどり',
  'えりぬき',
  'えりぬく',
  'えりまき',
  'えりもと',
  'えりんぎ',
  'えりんと',
  'えるーど',
  'えるゔん',
  'えるえる',
  'えるぴー',
  'えるぼー',
  'えるみん',
  'えるろん',
  'えれあこ',
  'えれくと',
  'えれじー',
  'えれっく',
  'えればん',
  'えろーす',
  'えろかわ',
  'えろぐろ',
  'えろげー',
  'えろこい',
  'えろちか',
  'えろびで',
  'えろぷり',
  'えろほん',
  'えをかく',
  'えんあい',
  'えんあん',
  'えんいき',
  'えんいん',
  'えんえい',
  'えんえき',
  'えんえん',
  'えんおう',
  'えんかい',
  'えんがい',
  'えんかく',
  'えんがく',
  'えんかこ',
  'えんかつ',
  'えんがわ',
  'えんかん',
  'えんがん',
  'えんきど',
  'えんぎは',
  'えんきり',
  'えんきん',
  'えんぐみ',
  'えんぐん',
  'えんけい',
  'えんげい',
  'えんげき',
  'えんげつ',
  'えんけん',
  'えんげん',
  'えんこい',
  'えんこう',
  'えんごう',
  'えんごく',
  'えんこつ',
  'えんこん',
  'えんざい',
  'えんさき',
  'えんさく',
  'えんさん',
  'えんざん',
  'えんしゃ',
  'えんじゃ',
  'えんじゅ',
  'えんしょ',
  'えんじょ',
  'えんじる',
  'えんしん',
  'えんじん',
  'えんすい',
  'えんずい',
  'えんすう',
  'えんすー',
  'えんすと',
  'えんずる',
  'えんせい',
  'えんぜい',
  'えんせき',
  'えんぜつ',
  'えんぜる',
  'えんせん',
  'えんぜん',
  'えんそう',
  'えんぞう',
  'えんそく',
  'えんたー',
  'えんたい',
  'えんだい',
  'えんだか',
  'えんたく',
  'えんだて',
  'えんため',
  'えんたん',
  'えんだん',
  'えんちん',
  'えんづき',
  'えんづく',
  'えんてい',
  'えんてん',
  'えんでん',
  'えんとう',
  'えんどう',
  'えんとく',
  'えんどく',
  'えんとつ',
  'えんとり',
  'えんない',
  'えんにち',
  'えんねつ',
  'えんねん',
  'えんのう',
  'えんばい',
  'えんばく',
  'えんぱく',
  'えんぱす',
  'えんぱつ',
  'えんばん',
  'えんぴつ',
  'えんぷく',
  'えんぷら',
  'えんふん',
  'えんぶん',
  'えんぷん',
  'えんぺい',
  'えんぺら',
  'えんぺん',
  'えんぼう',
  'えんぽう',
  'えんぼす',
  'えんぽん',
  'えんまく',
  'えんまん',
  'えんめい',
  'えんめつ',
  'えんもく',
  'えんもん',
  'えんやす',
  'えんゆう',
  'えんよう',
  'えんよく',
  'えんらい',
  'えんらく',
  'えんりょ',
  'えんりん',
  'えんるい',
  'えんれい',
  'えんれん',
  'おあいこ',
  'おあいそ',
  'おあしす',
  'おあずけ',
  'おあつい',
  'おいうち',
  'おいおい',
  'おいかぜ',
  'おいかわ',
  'おいきた',
  'おいごえ',
  'おいこし',
  'おいこす',
  'おいこみ',
  'おいこむ',
  'おいこん',
  'おいさき',
  'おいしい',
  'おいずり',
  'おいずる',
  'おいせん',
  'おいだき',
  'おいだし',
  'おいだす',
  'おいたち',
  'おいたつ',
  'おいたて',
  'おいちい',
  'おいちー',
  'おいちょ',
  'おいつく',
  'おいっこ',
  'おいっす',
  'おいとま',
  'おいどん',
  'おいない',
  'おいぬき',
  'おいぬく',
  'おいのり',
  'おいはぎ',
  'おいばね',
  'おいばら',
  'おいばん',
  'おいぼれ',
  'おいまつ',
  'おいめい',
  'おいやる',
  'おいらく',
  'おいらと',
  'おいらる',
  'おいらん',
  'おいりー',
  'おいるご',
  'おいわい',
  'おいわけ',
  'おうあん',
  'おういつ',
  'おういん',
  'おううつ',
  'おうえい',
  'おうえん',
  'おうおう',
  'おうおん',
  'おうかく',
  'おうがた',
  'おうかん',
  'おうがん',
  'おうけい',
  'おうけつ',
  'おうけん',
  'おうげん',
  'おうこう',
  'おうこく',
  'おうごん',
  'おうさつ',
  'おうさま',
  'おうしき',
  'おうしざ',
  'おうしつ',
  'おうじつ',
  'おうじて',
  'おうしゃ',
  'おうじゃ',
  'おうしゅ',
  'おうじゅ',
  'おうしょ',
  'おうじょ',
  'おうじる',
  'おうしん',
  'おうじん',
  'おうすい',
  'おうずる',
  'おうせい',
  'おうせき',
  'おうせつ',
  'おうせん',
  'おうぜん',
  'おうそう',
  'おうぞく',
  'おうそん',
  'おうたい',
  'おうだい',
  'おうだく',
  'おうだつ',
  'おうだん',
  'おうてい',
  'おうてき',
  'おうてん',
  'おうとう',
  'おうどう',
  'おうとく',
  'おうとつ',
  'おうなつ',
  'おうにょ',
  'おうにん',
  'おうねつ',
  'おうねん',
  'おうのう',
  'おうはい',
  'おうばい',
  'おうばく',
  'おうはん',
  'おうばん',
  'おうふう',
  'おうふく',
  'おうぶん',
  'おうへい',
  'おうべい',
  'おうへん',
  'おうほう',
  'おうぼう',
  'おうまふ',
  'おうめん',
  'おうもの',
  'おうよう',
  'おうらい',
  'おうりつ',
  'おうりん',
  'おうれつ',
  'おうれん',
  'おうろう',
  'おうわく',
  'おえかき',
  'おえしき',
  'おおあえ',
  'おおあさ',
  'おおあざ',
  'おおあし',
  'おおあじ',
  'おおあせ',
  'おおあな',
  'おおあね',
  'おおあま',
  'おおあめ',
  'おおあり',
  'おおあれ',
  'おおいご',
  'おおいし',
  'おおいた',
  'おおいに',
  'おおいり',
  'おおうけ',
  'おおうそ',
  'おおうた',
  'おおうみ',
  'おーゔん',
  'おーえー',
  'おーえす',
  'おおえだ',
  'おおえび',
  'おーえる',
  'おおおく',
  'おおおじ',
  'おおおば',
  'おーかー',
  'おーがー',
  'おおがい',
  'おおがき',
  'おおかじ',
  'おおかぜ',
  'おおかた',
  'おおがた',
  'おーがた',
  'おおかち',
  'おおがち',
  'おおがね',
  'おおかべ',
  'おおがま',
  'おおかみ',
  'おおがみ',
  'おおかめ',
  'おおから',
  'おおがら',
  'おおかわ',
  'おおきい',
  'おおきく',
  'おおきさ',
  'おおきな',
  'おおきに',
  'おおきみ',
  'おおぎみ',
  'おおきめ',
  'おおぎり',
  'おおぐい',
  'おーくす',
  'おおくち',
  'おおぐち',
  'おおくび',
  'おおぐみ',
  'おおくら',
  'おーくる',
  'おーけー',
  'おおけが',
  'おおげさ',
  'おおごえ',
  'おおこけ',
  'おおごと',
  'おおごま',
  'おーさー',
  'おおさか',
  'おおさが',
  'おおざけ',
  'おおさじ',
  'おおざと',
  'おおざら',
  'おおざる',
  'おおしい',
  'おーじー',
  'おおしお',
  'おおじか',
  'おおしけ',
  'おおすじ',
  'おおすず',
  'おおすみ',
  'おおぜい',
  'おおせか',
  'おおぜき',
  'おおせる',
  'おおそと',
  'おおぞら',
  'おおぞん',
  'おーだー',
  'おおだい',
  'おおたか',
  'おおだこ',
  'おおたち',
  'おおだち',
  'おおだな',
  'おおだま',
  'おーたむ',
  'おおだる',
  'おおつえ',
  'おおづつ',
  'おおづな',
  'おおつぶ',
  'おおづめ',
  'おおでき',
  'おおてし',
  'おおどこ',
  'おおとし',
  'おおどし',
  'おおとの',
  'おーどび',
  'おおどぶ',
  'おーとま',
  'おーとめ',
  'おおとら',
  'おおとり',
  'おおとろ',
  'おーなー',
  'おおなき',
  'おおなた',
  'おおなべ',
  'おおなみ',
  'おおぬさ',
  'おおのり',
  'おーばー',
  'おおばか',
  'おおばけ',
  'おおばこ',
  'おおはし',
  'おおはじ',
  'おーぱす',
  'おおばね',
  'おおはば',
  'おーばる',
  'おおばん',
  'おーびー',
  'おーぴー',
  'おおびき',
  'おおひげ',
  'おおびけ',
  'おーびす',
  'おおびん',
  'おーぶい',
  'おおふう',
  'おおぶく',
  'おおふね',
  'おおぶね',
  'おおぶり',
  'おーぶん',
  'おーぷん',
  'おーぺあ',
  'おおへい',
  'おおべや',
  'おーぼえ',
  'おーぼー',
  'おおぼけ',
  'おおぼね',
  'おおぼら',
  'おおまえ',
  'おおまか',
  'おおまけ',
  'おおまた',
  'おおみえ',
  'おおみず',
  'おおみみ',
  'おおみや',
  'おおみよ',
  'おおむぎ',
  'おおむね',
  'おおめし',
  'おーめん',
  'おおもじ',
  'おおもず',
  'おおもて',
  'おおもと',
  'おおもの',
  'おおもり',
  'おおもん',
  'おおやけ',
  'おおやね',
  'おおやま',
  'おおゆき',
  'おおゆみ',
  'おおゆや',
  'おおゆれ',
  'おおよう',
  'おおよせ',
  'おおよそ',
  'おーらい',
  'おおらか',
  'おーらす',
  'おーらる',
  'おーるご',
  'おーるど',
  'おおるり',
  'おーろら',
  'おーろん',
  'おおわく',
  'おおわざ',
  'おおわし',
  'おおわた',
  'おおわれ',
  'おかえし',
  'おかえり',
  'おかかえ',
  'おがくず',
  'おかくれ',
  'おかげで',
  'おかざり',
  'おかしい',
  'おかしな',
  'おかしみ',
  'おかしも',
  'おかたい',
  'おかちん',
  'おかっぱ',
  'おかづり',
  'おかひき',
  'おかぼれ',
  'おかまい',
  'おかもち',
  'おかやき',
  'おかやま',
  'おからだ',
  'おかりな',
  'おかると',
  'おがわら',
  'おかわり',
  'おきあい',
  'おきあみ',
  'おきいし',
  'おきえそ',
  'おきかえ',
  'おきがけ',
  'おきがさ',
  'おきかた',
  'おきざり',
  'おきさる',
  'おきしど',
  'おきだす',
  'おきだな',
  'おきづけ',
  'おきつち',
  'おきっぱ',
  'おきづり',
  'おきどこ',
  'おぎない',
  'おぎなう',
  'おきなみ',
  'おきなわ',
  'おきにし',
  'おきぬけ',
  'おきはい',
  'おきびき',
  'おきふし',
  'おきべん',
  'おきまり',
  'おきもの',
  'おぎゃあ',
  'おぎゃる',
  'おきゃん',
  'おきょう',
  'おぎょう',
  'おくいし',
  'おくいん',
  'おくがい',
  'おくがき',
  'おくがた',
  'おくこう',
  'おくさま',
  'おくさん',
  'おくしゃ',
  'おくする',
  'おくせつ',
  'おくそく',
  'おくそこ',
  'おくたく',
  'おくたぼ',
  'おくたん',
  'おくだん',
  'おくつき',
  'おくづけ',
  'おくでん',
  'おくない',
  'おくにわ',
  'おくねん',
  'おくのて',
  'おくのま',
  'おくへき',
  'おくまる',
  'おくまん',
  'おくみや',
  'おくむき',
  'おくめん',
  'おくやま',
  'おくやみ',
  'おくゆき',
  'おぐらい',
  'おくらす',
  'おくりじ',
  'おくりて',
  'おくりな',
  'おくりび',
  'おぐるま',
  'おくるみ',
  'おくれげ',
  'おくれる',
  'おけいこ',
  'おこごと',
  'おごころ',
  'おこさま',
  'おこさん',
  'おこじょ',
  'おごじょ',
  'おごそか',
  'おこたり',
  'おこたる',
  'おことば',
  'おこない',
  'おこなう',
  'おこのみ',
  'おごのり',
  'おごぽご',
  'おこぼれ',
  'おさうち',
  'おさえる',
  'おさおさ',
  'おさがめ',
  'おさがり',
  'おさきに',
  'おさけび',
  'おざしき',
  'おさしだ',
  'おさない',
  'おさなき',
  'おさなご',
  'おさなな',
  'おざなり',
  'おさまり',
  'おさまる',
  'おさむい',
  'おさむし',
  'おさめる',
  'おさらい',
  'おさらば',
  'おさんじ',
  'おしあい',
  'おしあう',
  'おしあげ',
  'おしいし',
  'おしいり',
  'おしいる',
  'おしいれ',
  'おしうり',
  'おしえご',
  'おしえる',
  'おしおき',
  'おしかけ',
  'おしがし',
  'おしかつ',
  'おしがみ',
  'おしかり',
  'おしがり',
  'おしがる',
  'おじかん',
  'おしきず',
  'おしきせ',
  'おしきり',
  'おしきる',
  'おしくも',
  'おしくら',
  'おじける',
  'おしごと',
  'おしこみ',
  'おしこむ',
  'おしざめ',
  'おじさん',
  'おしずし',
  'おしぜみ',
  'おじせん',
  'おしたし',
  'おしたじ',
  'おしだし',
  'おしだす',
  'おしちや',
  'おしつけ',
  'おしっこ',
  'おしどり',
  'おしなみ',
  'おしのび',
  'おしばな',
  'おしぴん',
  'おしふね',
  'おしぶね',
  'おしぼり',
  'おしまい',
  'おしむぎ',
  'おしめん',
  'おしゃか',
  'おしゃく',
  'おしゃま',
  'おじゃま',
  'おしやる',
  'おじゃる',
  'おしゃれ',
  'おじゃん',
  'おしゅう',
  'おじゅう',
  'おしょう',
  'おじょう',
  'おしょく',
  'おじょく',
  'おしらす',
  'おしらせ',
  'おしるこ',
  'おしるし',
  'おしろい',
  'おしんこ',
  'おすいぬ',
  'おすうま',
  'おずおず',
  'おすかー',
  'おすざる',
  'おすすめ',
  'おすちや',
  'おすねこ',
  'おすねじ',
  'おすぱー',
  'おすまし',
  'おすもじ',
  'おすわり',
  'おせいじ',
  'おせいぼ',
  'おせおせ',
  'おぜそう',
  'おせっせ',
  'おせんち',
  'おぞうに',
  'おそごと',
  'おそざき',
  'おそじも',
  'おそぢえ',
  'おそなえ',
  'おそばん',
  'おそまき',
  'おそまつ',
  'おそらく',
  'おそれげ',
  'おそれす',
  'おそれる',
  'おそろい',
  'おそわる',
  'おたいこ',
  'おだいば',
  'おたおた',
  'おたおめ',
  'おたかい',
  'おたがい',
  'おたから',
  'おたげい',
  'おたけび',
  'おたさー',
  'おたしゃ',
  'おたずね',
  'おだちん',
  'おたつく',
  'おたっし',
  'おだてる',
  'おたふく',
  'おだぶつ',
  'おだまき',
  'おたまや',
  'おだやか',
  'おたりあ',
  'おだんぎ',
  'おちあう',
  'おちあゆ',
  'おちいる',
  'おちうお',
  'おちうど',
  'おちおち',
  'おちかた',
  'おちぐち',
  'おちけん',
  'おちこち',
  'おちこみ',
  'おちこむ',
  'おちつき',
  'おちつく',
  'おちふだ',
  'おちみず',
  'おちゃこ',
  'おちゃめ',
  'おちゃや',
  'おちゆく',
  'おちょこ',
  'おつうじ',
  'おつかい',
  'おつがい',
  'おっかけ',
  'おつかれ',
  'おっきい',
  'おっくう',
  'おっくご',
  'おつくり',
  'おっけー',
  'おっけん',
  'おっこう',
  'おっこる',
  'おっさん',
  'おつしゅ',
  'おっずひ',
  'おったつ',
  'おっちぬ',
  'おっちん',
  'おっつく',
  'おっつけ',
  'おつとめ',
  'おっとり',
  'おつなか',
  'おつねん',
  'おっぱい',
  'おっぱぶ',
  'おっぴら',
  'おつぼう',
  'おつぼね',
  'おっほん',
  'おつまみ',
  'おつもり',
  'おつゆう',
  'おてあげ',
  'おでかけ',
  'おてかず',
  'おてしょ',
  'おてすう',
  'おてだま',
  'おてつき',
  'おででこ',
  'おてほん',
  'おてまえ',
  'おでまし',
  'おてもと',
  'おてもり',
  'おてんき',
  'おてんば',
  'おでんや',
  'おでんわ',
  'おとあな',
  'おとうと',
  'おとおし',
  'おとおじ',
  'おどおど',
  'おとがい',
  'おどかし',
  'おどかす',
  'おとぎれ',
  'おとげー',
  'おどける',
  'おとこぎ',
  'おとこけ',
  'おとこげ',
  'おとこし',
  'おとこで',
  'おとこな',
  'おとこゆ',
  'おところ',
  'おとさた',
  'おとしご',
  'おとしと',
  'おとずれ',
  'おとつい',
  'おとづき',
  'おととい',
  'おとどけ',
  'おととし',
  'おととび',
  'おとどり',
  'おとなう',
  'おとなげ',
  'おとなご',
  'おとなし',
  'おとひめ',
  'おとぼけ',
  'おとまり',
  'おとめげ',
  'おとめご',
  'おとめざ',
  'おともれ',
  'おとよめ',
  'おとらず',
  'おどらす',
  'おどりこ',
  'おどりじ',
  'おどりて',
  'おどりば',
  'おとろえ',
  'おどろき',
  'おどろく',
  'おとわれ',
  'おながれ',
  'おなきん',
  'おなくら',
  'おなさけ',
  'おなじく',
  'おなじみ',
  'おなどる',
  'おなにー',
  'おなぬー',
  'おなもみ',
  'おにあい',
  'おにいた',
  'おにおん',
  'おにがみ',
  'おにかわ',
  'おにきす',
  'おにぎり',
  'おにくさ',
  'おにぐも',
  'おにっこ',
  'おにでん',
  'おにばす',
  'おにばば',
  'おにびし',
  'おにふだ',
  'おにぼし',
  'おにみそ',
  'おにもつ',
  'おにゅー',
  'おにゆり',
  'おによめ',
  'おねがい',
  'おねしょ',
  'おねすじ',
  'おねだり',
  'おねんね',
  'おのおの',
  'おのかみ',
  'おのこで',
  'おのずと',
  'おののき',
  'おののく',
  'おのれと',
  'おぱーる',
  'おはいお',
  'おはぐろ',
  'おばさん',
  'おはじき',
  'おばしま',
  'おはなし',
  'おばはん',
  'おはよう',
  'おはらい',
  'おはらめ',
  'おはりこ',
  'おびあげ',
  'おびいた',
  'おぴうむ',
  'おびえる',
  'おびがね',
  'おびがみ',
  'おびかわ',
  'おびきん',
  'おひさま',
  'おひしば',
  'おびしめ',
  'おびじめ',
  'おびしん',
  'おひたき',
  'おひたし',
  'おひつじ',
  'おびどめ',
  'おひねり',
  'おびのこ',
  'おびひも',
  'おびふう',
  'おひょう',
  'おひらき',
  'おひるぎ',
  'おひろい',
  'おひろめ',
  'おふぁー',
  'おふぃす',
  'おふかい',
  'おふくろ',
  'おふこん',
  'おふざけ',
  'おぶさる',
  'おぶじぇ',
  'おふぱこ',
  'おふれこ',
  'おふろや',
  'おぺーく',
  'おぺかん',
  'おぺこど',
  'おぺしつ',
  'おべっか',
  'おぺらざ',
  'おぺろん',
  'おへんじ',
  'おぼえず',
  'おぼえる',
  'おぼこい',
  'おぽさむ',
  'おぼしい',
  'おぼしき',
  'おほたき',
  'おぼらす',
  'おぼれる',
  'おぼろげ',
  'おぼろよ',
  'おまーる',
  'おまーん',
  'おまいつ',
  'おまいり',
  'おまえら',
  'おまかせ',
  'おまくに',
  'おまけに',
  'おまこく',
  'おまつり',
  'おまもり',
  'おまわり',
  'おまんこ',
  'おまんま',
  'おみあい',
  'おみあげ',
  'おみあし',
  'おみくじ',
  'おみこし',
  'おみごと',
  'おみそれ',
  'おみっと',
  'おみなご',
  'おみまい',
  'おみやげ',
  'おむかい',
  'おむかえ',
  'おむすび',
  'おむそば',
  'おむれつ',
  'おむろは',
  'おめおめ',
  'おめかし',
  'おめがね',
  'おめぐり',
  'おめだま',
  'おめつけ',
  'おめでた',
  'おめみえ',
  'おめもじ',
  'おもあど',
  'おもいで',
  'おもうに',
  'おもえる',
  'おもがい',
  'おもかげ',
  'おもかじ',
  'おもがし',
  'おもざし',
  'おもしい',
  'おもしろ',
  'おもたい',
  'おもだか',
  'おもたげ',
  'おもたせ',
  'おもだち',
  'おもだつ',
  'おもちち',
  'おもちゃ',
  'おもづな',
  'おもてじ',
  'おもてど',
  'おもてめ',
  'おもとじ',
  'おもなが',
  'おもなる',
  'おもねる',
  'おものい',
  'おもばば',
  'おもぶく',
  'おもむき',
  'おもむく',
  'おももち',
  'おもやく',
  'おもらし',
  'おもろい',
  'おもわく',
  'おもわず',
  'おもわぬ',
  'おもんね',
  'おやいし',
  'おやいぬ',
  'おやいも',
  'おやおや',
  'おやかた',
  'おやがた',
  'おやかぶ',
  'おやきめ',
  'おやくめ',
  'おやけん',
  'おやざと',
  'おやしお',
  'おやじか',
  'おやすい',
  'おやすみ',
  'おやだま',
  'おやちゃ',
  'おやづき',
  'おやとも',
  'おやどり',
  'おやなし',
  'おやねこ',
  'おやばか',
  'おやぶね',
  'おやふら',
  'おやぶん',
  'おやぼね',
  'おやまあ',
  'おやもじ',
  'おやもと',
  'おやゆび',
  'およがす',
  'およぎて',
  'およばれ',
  'およぼす',
  'おらおら',
  'おらくる',
  'おらしょ',
  'おらんだ',
  'おりあい',
  'おりあう',
  'おりーゔ',
  'おりいと',
  'おりーぶ',
  'おりいろ',
  'おりえり',
  'おりおり',
  'おりおん',
  'おりかさ',
  'おりかた',
  'おりがた',
  'おりがみ',
  'おりから',
  'おりがら',
  'おりぐけ',
  'おりくち',
  'おりぐち',
  'おりけい',
  'おりこう',
  'おりこみ',
  'おりこむ',
  'おりこん',
  'おりしき',
  'おりしも',
  'おりじん',
  'おりすけ',
  'おりせん',
  'おりそう',
  'おりだす',
  'おりたつ',
  'おりちん',
  'おりづめ',
  'おりづる',
  'おりなす',
  'おりばこ',
  'おりぱら',
  'おりひめ',
  'おりふし',
  'おりふら',
  'おりほん',
  'おりもと',
  'おりもの',
  'おりやま',
  'おりゃる',
  'おりよく',
  'おるがん',
  'おるごん',
  'おるぞー',
  'おるてが',
  'おれあう',
  'おれがの',
  'おれくぎ',
  'おれくち',
  'おれこむ',
  'おれごん',
  'おれさま',
  'おれせん',
  'おれたち',
  'おれっこ',
  'おれっち',
  'おれてき',
  'おれんじ',
  'おれんち',
  'おろいど',
  'おろいゆ',
  'おろおろ',
  'おろしき',
  'おろしず',
  'おろしね',
  'おろしや',
  'おろそか',
  'おろもご',
  'おわいや',
  'おわかれ',
  'おわこん',
  'おわらい',
  'おわりね',
  'おをひく',
  'おんあい',
  'おんあつ',
  'おんいい',
  'おんいき',
  'おんいん',
  'おんえあ',
  'おんえき',
  'おんおふ',
  'おんおん',
  'おんかい',
  'おんがい',
  'おんかく',
  'おんがく',
  'おんかつ',
  'おんがな',
  'おんかん',
  'おんがん',
  'おんくん',
  'おんけい',
  'おんげー',
  'おんけん',
  'おんげん',
  'おんこう',
  'おんごく',
  'おんさき',
  'おんじき',
  'おんしつ',
  'おんしゃ',
  'おんしゅ',
  'おんじゅ',
  'おんしん',
  'おんじん',
  'おんすい',
  'おんすう',
  'おんせい',
  'おんせつ',
  'おんせん',
  'おんぞう',
  'おんそく',
  'おんぞん',
  'おんたい',
  'おんだい',
  'おんたく',
  'おんだく',
  'おんだす',
  'おんたま',
  'おんだん',
  'おんてい',
  'おんてき',
  'おんでこ',
  'おんでる',
  'おんてん',
  'おんとう',
  'おんとく',
  'おんどく',
  'おんどさ',
  'おんとし',
  'おんどり',
  'おんどる',
  'おんどれ',
  'おんない',
  'おんなぎ',
  'おんなけ',
  'おんなし',
  'おんなじ',
  'おんなで',
  'おんなめ',
  'おんなゆ',
  'おんにん',
  'おんねつ',
  'おんねん',
  'おんのじ',
  'おんのみ',
  'おんばこ',
  'おんばん',
  'おんびき',
  'おんびん',
  'おんぷう',
  'おんぶる',
  'おんべい',
  'おんぼう',
  'おんぼろ',
  'おんまえ',
  'おんみつ',
  'おんめい',
  'おんもん',
  'おんやく',
  'おんよう',
  'おんよく',
  'おんよみ',
  'おんりー',
  'おんりつ',
  'おんれい',
  'おんれこ',
  'かーえれ',
  'かあかあ',
  'かーかー',
  'があがあ',
  'がーがー',
  'かーかす',
  'かーきー',
  'かーきち',
  'かーぎや',
  'かあさま',
  'かあさん',
  'かーすて',
  'かーすと',
  'かーそる',
  'がーたー',
  'がーだー',
  'があたろ',
  'かあつき',
  'があっと',
  'がーっと',
  'かーてし',
  'かーてん',
  'がーでん',
  'かーどる',
  'がーどる',
  'かーとん',
  'かーなび',
  'かーねる',
  'かーびん',
  'かーぶる',
  'がーべら',
  'かーぼん',
  'かーみん',
  'がーやう',
  'かーらー',
  'がーりー',
  'がーるず',
  'かいあく',
  'がいあく',
  'かいあげ',
  'がいあつ',
  'がいあな',
  'かいあん',
  'がいあん',
  'かいいき',
  'かいいぬ',
  'かいいれ',
  'かいいん',
  'がいいん',
  'かいうん',
  'かいえい',
  'かいえき',
  'かいえん',
  'がいえん',
  'かいおい',
  'かいおき',
  'かいおけ',
  'かいおぺ',
  'かいおん',
  'かいかい',
  'かいがい',
  'がいかい',
  'かいかえ',
  'かいかき',
  'かいかく',
  'かいがく',
  'がいかく',
  'かいかけ',
  'かいかた',
  'かいかつ',
  'がいかつ',
  'かいがね',
  'かいかび',
  'がいかひ',
  'かいがら',
  'かいかん',
  'かいがん',
  'がいかん',
  'かいきは',
  'かいぎは',
  'かいきょ',
  'かいぎょ',
  'がいぎょ',
  'かいきり',
  'かいきる',
  'かいきん',
  'かいぎん',
  'がいきん',
  'がいぎん',
  'かいぐい',
  'かいぐう',
  'かいくる',
  'かいぐる',
  'かいくれ',
  'かいくん',
  'かいぐん',
  'がいぐん',
  'かいけい',
  'がいけい',
  'かいけつ',
  'がいげつ',
  'かいけん',
  'かいげん',
  'がいけん',
  'がいげん',
  'かいこう',
  'かいごう',
  'がいこう',
  'がいごう',
  'かいこが',
  'かいこく',
  'がいこく',
  'かいこし',
  'かいごし',
  'かいこつ',
  'がいこつ',
  'かいこみ',
  'かいこむ',
  'かいこん',
  'がいこん',
  'かいざー',
  'かいさい',
  'かいざい',
  'がいさい',
  'がいざい',
  'かいさき',
  'かいさく',
  'かいさつ',
  'かいさま',
  'かいさん',
  'かいざん',
  'がいさん',
  'がいじか',
  'かいしき',
  'がいじし',
  'かいしつ',
  'かいじつ',
  'かいして',
  'がいして',
  'かいしび',
  'かいしめ',
  'かいしゃ',
  'かいじゃ',
  'がいしゃ',
  'かいしゅ',
  'かいじゅ',
  'がいじゅ',
  'かいしょ',
  'かいじょ',
  'がいしょ',
  'がいじょ',
  'かいしん',
  'かいじん',
  'がいしん',
  'がいじん',
  'かいすい',
  'かいすう',
  'がいすう',
  'かいずか',
  'がいすと',
  'かいする',
  'がいする',
  'がいすん',
  'かいせい',
  'がいせい',
  'かいせき',
  'がいせき',
  'かいせつ',
  'かいぜつ',
  'がいせつ',
  'かいぜる',
  'かいせん',
  'かいぜん',
  'がいせん',
  'がいぜん',
  'かいそう',
  'かいぞう',
  'がいそう',
  'かいぞえ',
  'かいそく',
  'かいぞく',
  'がいそく',
  'がいそふ',
  'がいそぼ',
  'かいぞめ',
  'かいそん',
  'がいそん',
  'かいたい',
  'かいだい',
  'がいたい',
  'がいだい',
  'かいだか',
  'かいたく',
  'かいだく',
  'かいだこ',
  'かいだし',
  'かいたす',
  'かいだす',
  'かいたて',
  'かいだて',
  'かいだめ',
  'がいため',
  'がいたれ',
  'かいたん',
  'かいだん',
  'がいたん',
  'かいちく',
  'かいちん',
  'かいつう',
  'かいづか',
  'かいつけ',
  'かいてい',
  'がいてい',
  'かいてき',
  'がいてき',
  'かいてん',
  'かいでん',
  'がいてん',
  'がいでん',
  'かいとう',
  'かいどう',
  'がいとう',
  'かいどき',
  'かいとく',
  'かいどく',
  'がいどく',
  'かいとり',
  'かいどり',
  'かいとる',
  'かいない',
  'かいなか',
  'かいなし',
  'かいなで',
  'かいなん',
  'かいにく',
  'かいにん',
  'かいぬし',
  'かいねこ',
  'がいねん',
  'かいのう',
  'かいのき',
  'かいはい',
  'かいはく',
  'がいはく',
  'かいはつ',
  'かいばつ',
  'かいばと',
  'かいはん',
  'かいぱん',
  'がいはん',
  'かいひん',
  'がいひん',
  'かいふう',
  'がいふう',
  'かいふく',
  'かいぶし',
  'かいぶつ',
  'がいぶつ',
  'かいぶん',
  'がいぶん',
  'かいへい',
  'かいへき',
  'がいへき',
  'かいへん',
  'かいべん',
  'がいへん',
  'かいほう',
  'かいぼう',
  'がいほう',
  'がいぼう',
  'かいぼく',
  'かいほつ',
  'かいぼり',
  'かいぼん',
  'がいまい',
  'かいまき',
  'かいまく',
  'かいまん',
  'かいみん',
  'かいめい',
  'がいめい',
  'かいめつ',
  'かいめん',
  'がいめん',
  'かいもく',
  'かいもち',
  'かいもの',
  'かいもん',
  'かいやき',
  'かいやく',
  'かいやん',
  'かいゆう',
  'がいゆう',
  'かいよう',
  'がいよう',
  'かいよく',
  'かいよせ',
  'かいらい',
  'がいらい',
  'かいらぎ',
  'かいらく',
  'かいらん',
  'がいらん',
  'かいりき',
  'かいりく',
  'かいりつ',
  'かいりん',
  'がいりん',
  'かいるい',
  'かいれい',
  'かいれき',
  'かいれつ',
  'かいろう',
  'がいろく',
  'かいろず',
  'がいろん',
  'かいわい',
  'かいわご',
  'かいわり',
  'かいわん',
  'かいんぎ',
  'かゔぁー',
  'がうちょ',
  'かうぶり',
  'かうべる',
  'かうんた',
  'かうんと',
  'かえうた',
  'かえさる',
  'かえしん',
  'かえだま',
  'かえって',
  'かえでか',
  'かえもん',
  'かえりち',
  'かえりみ',
  'かえるで',
  'かおいろ',
  'かおきき',
  'かおげい',
  'かおだし',
  'かおだち',
  'かおだて',
  'かおつき',
  'かおぱす',
  'かおばせ',
  'かおはめ',
  'かおばれ',
  'かおぶれ',
  'かおぼん',
  'かおまけ',
  'かおみせ',
  'かおむけ',
  'かおもじ',
  'かおやく',
  'かおりん',
  'ががいも',
  'かかえて',
  'かかえる',
  'かかくさ',
  'かがくし',
  'ががくし',
  'かかげる',
  'かかさず',
  'かかさん',
  'かがふり',
  'かがまる',
  'かがめる',
  'かがもん',
  'かがやき',
  'かがやく',
  'かがよう',
  'かがりび',
  'かかりゆ',
  'かかわり',
  'かかわる',
  'かがんぼ',
  'ががんぼ',
  'かぎあか',
  'かきあげ',
  'かぎあけ',
  'かきあじ',
  'かぎあな',
  'かきいれ',
  'かきいろ',
  'かきおき',
  'かきかえ',
  'かきかけ',
  'かぎかけ',
  'かきかた',
  'かぎがた',
  'かききず',
  'かききる',
  'かきけす',
  'かきこみ',
  'かきこむ',
  'かぎざき',
  'かきさん',
  'かきしぶ',
  'かきぞめ',
  'かきだし',
  'かきたす',
  'かきだす',
  'かぎだす',
  'かぎたば',
  'かきたま',
  'かきたれ',
  'かぎちゃ',
  'かきつく',
  'かきつけ',
  'かぎっこ',
  'かぎつめ',
  'かぎづめ',
  'かきどう',
  'がきどう',
  'かきとめ',
  'がきども',
  'かきとり',
  'かきとる',
  'かぎとる',
  'かぎなわ',
  'かきぬき',
  'かきぬく',
  'かきねつ',
  'かきのき',
  'かぎのて',
  'かぎはな',
  'かぎばな',
  'かぎばり',
  'かきはん',
  'かきぱん',
  'かきぴー',
  'かきびと',
  'かきぶり',
  'かきまゆ',
  'かぎむし',
  'かきめし',
  'かきもじ',
  'かきもち',
  'かきもの',
  'かぎやー',
  'かきゃく',
  'かきやく',
  'かぎゃく',
  'かきゅう',
  'かぎゅう',
  'がきゅう',
  'かきょう',
  'かぎょう',
  'がきょう',
  'がぎょう',
  'かきょく',
  'かきわり',
  'かくあげ',
  'かくいう',
  'がくいき',
  'かくいつ',
  'がくいり',
  'かくいん',
  'がくいん',
  'かくうえ',
  'かくうち',
  'かくうん',
  'かくえき',
  'がくえん',
  'かくおち',
  'かくおび',
  'がくおん',
  'かくかい',
  'かくがい',
  'がくがい',
  'かくかく',
  'がくがく',
  'かくがた',
  'かくがり',
  'かくかん',
  'かくがん',
  'がくぎょ',
  'かくぎり',
  'かくくぎ',
  'かくけい',
  'がくげい',
  'かくげー',
  'がくげき',
  'かくげつ',
  'かくけん',
  'かくげん',
  'かくこう',
  'かくこく',
  'がくこつ',
  'かくざい',
  'がくさい',
  'かくさく',
  'かくさげ',
  'かくさつ',
  'かくざら',
  'かくさん',
  'がくさん',
  'かくしき',
  'がくしき',
  'かくしご',
  'かくじし',
  'かくした',
  'かくしだ',
  'かくしつ',
  'かくじつ',
  'かくして',
  'かくしめ',
  'かくしゃ',
  'がくしゃ',
  'かくしゅ',
  'かくしょ',
  'かくじょ',
  'がくしょ',
  'かくしん',
  'かくじん',
  'がくじん',
  'かくすい',
  'かくすう',
  'かくずけ',
  'かくする',
  'かくせい',
  'がくせい',
  'がくせき',
  'かくせつ',
  'かくぜつ',
  'がくせつ',
  'かくせん',
  'かくぜん',
  'がくぜん',
  'かくそう',
  'がくそう',
  'がくそく',
  'がくそつ',
  'かくそで',
  'かくたい',
  'かくだい',
  'がくたい',
  'かくたす',
  'かくたる',
  'かくたん',
  'かくだん',
  'がくだん',
  'かくちく',
  'かくつう',
  'かくつき',
  'かぐつき',
  'がぐつき',
  'かくづけ',
  'かぐつち',
  'かくてい',
  'かくてき',
  'がくてき',
  'かくてる',
  'かくてろ',
  'かくてん',
  'がくてん',
  'かくとう',
  'がくどう',
  'かくとく',
  'がくとく',
  'かくとり',
  'かくない',
  'がくない',
  'かくにち',
  'かくにん',
  'かくねん',
  'がくねん',
  'かくのう',
  'がくばつ',
  'かくばる',
  'かくはん',
  'かくびき',
  'かくひつ',
  'がくびわ',
  'かくびん',
  'がくふう',
  'かくふく',
  'がくぶち',
  'かくぶつ',
  'がくぶる',
  'かくぶん',
  'かくへき',
  'かくべち',
  'かくべつ',
  'かくへん',
  'がくへん',
  'かくほう',
  'かくぼう',
  'がくほう',
  'がくぼう',
  'がくぼく',
  'かくぼん',
  'かくまう',
  'かくまき',
  'かくまく',
  'がくむか',
  'かくめい',
  'がくめい',
  'かくめん',
  'がくめん',
  'がくもん',
  'かくやく',
  'かくやす',
  'がくゆう',
  'かくよう',
  'かくらん',
  'がくらん',
  'かくりつ',
  'がくりつ',
  'かくりよ',
  'かくりん',
  'かくれい',
  'がくれい',
  'かくれが',
  'がくれき',
  'かくれば',
  'かくれみ',
  'かくれや',
  'かくれる',
  'かぐろい',
  'がくろく',
  'かくろん',
  'がくわり',
  'がくんと',
  'かけあい',
  'かけあう',
  'かけあし',
  'かげあな',
  'かけいず',
  'かけいひ',
  'かけいぼ',
  'がけうえ',
  'かげうた',
  'かげうら',
  'かけうり',
  'かけえり',
  'かけおち',
  'かけがい',
  'かけかえ',
  'かけがえ',
  'かけがね',
  'かけがみ',
  'かげきは',
  'かけきん',
  'かけくぎ',
  'かげぐち',
  'かけくら',
  'かけごえ',
  'かけごと',
  'かげごと',
  'かけこみ',
  'かけこむ',
  'かけごや',
  'かけさる',
  'かけざん',
  'かけじく',
  'がけした',
  'かけじる',
  'かけすて',
  'かけずて',
  'かげぜん',
  'かけそば',
  'かけぞり',
  'かけだし',
  'かけだす',
  'かけっこ',
  'かけとり',
  'かけなげ',
  'かげなれ',
  'かけはぎ',
  'かけはし',
  'かげばら',
  'かけひき',
  'かげふじ',
  'かけふだ',
  'がけぶち',
  'がけぷち',
  'かげぼし',
  'かけまい',
  'がけみち',
  'かけもち',
  'かけもつ',
  'かけもの',
  'かけよる',
  'かけりつ',
  'かげろう',
  'かけわざ',
  'かげんず',
  'かげんみ',
  'かこいめ',
  'かこうき',
  'かこうこ',
  'かこうし',
  'かこうひ',
  'かこうろ',
  'かごおち',
  'かごかき',
  'かこくご',
  'かこけい',
  'かこさく',
  'かごしま',
  'かごしゅ',
  'かこせい',
  'かこつけ',
  'かごぬけ',
  'かごのき',
  'かごみみ',
  'かこもん',
  'かさあげ',
  'かざあし',
  'かさーた',
  'かざあな',
  'かさいし',
  'かざいれ',
  'がさいれ',
  'かざおと',
  'かざおれ',
  'かさがい',
  'かさかき',
  'かさかけ',
  'かさがけ',
  'かさかさ',
  'がさがさ',
  'かさがみ',
  'かざかみ',
  'かざきり',
  'かざくち',
  'かざぐち',
  'かさぐも',
  'かざぐも',
  'かざごえ',
  'かさこそ',
  'がさごそ',
  'かささぎ',
  'かざしも',
  'かさだか',
  'かさたて',
  'がざちく',
  'かさなり',
  'かさなる',
  'がざにあ',
  'かざぬき',
  'かさねぎ',
  'かさねて',
  'かさねる',
  'かざはな',
  'かざばな',
  'かさはり',
  'かさばる',
  'かざふご',
  'かさぶた',
  'かさぼこ',
  'かざぼし',
  'かざまち',
  'かざまど',
  'かざむき',
  'かさもち',
  'かざよけ',
  'かざりけ',
  'かさんき',
  'かざんこ',
  'かざんさ',
  'かしいえ',
  'かしうり',
  'かしぇる',
  'かしおり',
  'がしかし',
  'がしがし',
  'がじがじ',
  'かしかた',
  'かしかぶ',
  'かじかむ',
  'かしかり',
  'かしかん',
  'かじきざ',
  'かしきず',
  'かしきり',
  'かしきる',
  'かしきん',
  'かしげる',
  'かしこい',
  'かしこし',
  'かしざら',
  'かししつ',
  'かじしん',
  'かしずく',
  'かしせき',
  'かしたい',
  'かしだし',
  'かしだす',
  'かしちん',
  'かじづか',
  'かしつき',
  'かじつき',
  'かしづく',
  'かしつけ',
  'かじつす',
  'がしっと',
  'かしてん',
  'かじとり',
  'かじどろ',
  'かじなし',
  'かしぬし',
  'かじのき',
  'かしばこ',
  'かしばち',
  'かしぱん',
  'かしびる',
  'かしふだ',
  'かじぼう',
  'かしほん',
  'かしぼん',
  'かしみあ',
  'かしみや',
  'かしめる',
  'かしもと',
  'かしもの',
  'かしゃく',
  'かしゃっ',
  'がしゃっ',
  'かしゃり',
  'がしゃん',
  'かしゅー',
  'かしゅう',
  'かじゅう',
  'がしゅう',
  'かじゅく',
  'がじゅく',
  'かしゅひ',
  'がしゅん',
  'がじゅん',
  'かしょう',
  'かじょう',
  'がしょう',
  'がじょう',
  'かしょく',
  'かしらじ',
  'かしらん',
  'かしわぎ',
  'かしわで',
  'かずある',
  'がすいと',
  'がすいり',
  'かすうぶ',
  'かすーれ',
  'がすうん',
  'がすえき',
  'がすえそ',
  'かすがい',
  'かすかす',
  'かずかず',
  'がすかん',
  'がすきぐ',
  'がすくろ',
  'がすけつ',
  'かずける',
  'かすごみ',
  'かすざめ',
  'がすしつ',
  'かすじる',
  'がすすた',
  'がすせい',
  'がすせん',
  'かすたー',
  'がすたい',
  'がすだい',
  'かすたま',
  'かすたむ',
  'がすだん',
  'かすづけ',
  'かずてき',
  'かすてら',
  'かすてん',
  'がすでん',
  'がすとう',
  'かすとり',
  'かずとり',
  'かすとる',
  'がすとろ',
  'がすぬき',
  'がすのお',
  'かずのこ',
  'かすはら',
  'かすふだ',
  'かずふだ',
  'かすみめ',
  'かすめる',
  'がすもれ',
  'かすれー',
  'かすれる',
  'かずわる',
  'かぜあな',
  'かせいか',
  'かせいと',
  'かせいふ',
  'かぜいん',
  'がぜーぼ',
  'かぜおと',
  'かせきこ',
  'かせぎて',
  'かぜぎみ',
  'かぜくさ',
  'かぜくも',
  'かせげる',
  'かぜごえ',
  'かぜたつ',
  'かぜだつ',
  'かせづえ',
  'かせっと',
  'がぜっと',
  'かぜぬき',
  'がせねた',
  'かぜのこ',
  'かぜはい',
  'かぜひき',
  'かぜひく',
  'かぜまち',
  'かぜむき',
  'かぜよけ',
  'がせんし',
  'かせんぶ',
  'かぞいろ',
  'かそうか',
  'かそうど',
  'かそうば',
  'かぞえる',
  'かそーど',
  'がそーる',
  'がそかけ',
  'かそくき',
  'かそくど',
  'かそけき',
  'かそけし',
  'かそこら',
  'かそさい',
  'かそざい',
  'がそすた',
  'かそすれ',
  'かそせい',
  'かそぶつ',
  'がそりん',
  'かたあげ',
  'かたあし',
  'かたあて',
  'かたーる',
  'かたいき',
  'かたいじ',
  'かだいし',
  'かだいふ',
  'かたいれ',
  'かたうた',
  'かたうで',
  'かたおし',
  'かたおち',
  'がたおち',
  'かたおや',
  'かたがき',
  'かたかけ',
  'かたかげ',
  'かたかた',
  'かたがた',
  'がたがた',
  'かたかな',
  'かたがみ',
  'かたがわ',
  'かたきし',
  'かたぎし',
  'かたぎぬ',
  'かたくせ',
  'かたくち',
  'かたぐち',
  'かたくな',
  'かたくり',
  'かたげる',
  'かたこい',
  'かたごし',
  'かたこと',
  'がたごと',
  'かたこり',
  'かたさき',
  'かたしき',
  'かたしろ',
  'かたじん',
  'かたすみ',
  'かたずみ',
  'かたそで',
  'かたぞめ',
  'かただい',
  'かたちち',
  'かたつき',
  'かたづく',
  'がたつく',
  'かたつけ',
  'かたづけ',
  'かたっと',
  'がたっと',
  'かたっぽ',
  'かたてま',
  'かたとき',
  'かたどる',
  'かたなし',
  'かたぬき',
  'かたねり',
  'かたはい',
  'かたはし',
  'かたはだ',
  'かたはば',
  'かたばみ',
  'かたはら',
  'かたばら',
  'かたばん',
  'かたぱん',
  'かたひざ',
  'かたひじ',
  'がたぴし',
  'かたひも',
  'かたびら',
  'かたぴら',
  'かたぶく',
  'かたぶつ',
  'かたぶり',
  'かたへん',
  'かたほう',
  'かたぼう',
  'かたまえ',
  'かたまひ',
  'かたまゆ',
  'かたまり',
  'かたまる',
  'かたみち',
  'かたみに',
  'かたみみ',
  'かたむき',
  'かたむく',
  'かためる',
  'かためん',
  'かたもじ',
  'かたもち',
  'かたもの',
  'かたもみ',
  'かたやき',
  'かだやし',
  'かたやま',
  'かたゆき',
  'かたゆで',
  'かたよく',
  'かたより',
  'かたよる',
  'かたらい',
  'かたらう',
  'かたりく',
  'かたりて',
  'かたりは',
  'かたりべ',
  'かたれぬ',
  'がたろう',
  'かたろぐ',
  'かたわく',
  'かたわら',
  'かたわれ',
  'かちあう',
  'かちある',
  'かちいろ',
  'かちうま',
  'かちえる',
  'がちおた',
  'かちおん',
  'かちかく',
  'かちかち',
  'がちがち',
  'かちかん',
  'かちくか',
  'かちぐみ',
  'かちぐり',
  'がちこい',
  'かちこし',
  'かちこす',
  'かちこち',
  'かちこみ',
  'かちすじ',
  'がちぜい',
  'かちつぎ',
  'かちっと',
  'がちっと',
  'かちどき',
  'かちどく',
  'かちとる',
  'かちにげ',
  'かちぬく',
  'かちびと',
  'かちぼし',
  'がちほも',
  'がちまい',
  'かちまけ',
  'かちむし',
  'がちむち',
  'がちゃめ',
  'かちゃり',
  'がちゃん',
  'かちゅう',
  'かちょう',
  'がちょう',
  'がちりん',
  'かちろん',
  'かちわり',
  'かちわる',
  'がちをた',
  'かちんこ',
  'かちんご',
  'がちんこ',
  'かつあい',
  'かつあげ',
  'かついろ',
  'かつえき',
  'かつえる',
  'かつおぎ',
  'かっかい',
  'がっかい',
  'かっかく',
  'がっかく',
  'かつかつ',
  'がっかつ',
  'がつがつ',
  'がっかり',
  'かっかん',
  'かつがん',
  'がっかん',
  'かつぎや',
  'かっきょ',
  'かつぎょ',
  'かっきり',
  'かっきる',
  'かっくう',
  'がっくう',
  'がっくり',
  'かっけい',
  'がっけい',
  'かっけー',
  'かつげき',
  'かっけつ',
  'かづける',
  'かっこう',
  'かつごう',
  'がっこう',
  'かっこー',
  'かっこく',
  'がっこつ',
  'かっこむ',
  'かっこん',
  'かっさい',
  'かつざい',
  'がっさい',
  'がっさく',
  'かっさつ',
  'がっさつ',
  'がっさん',
  'かつじか',
  'かっしき',
  'かつじき',
  'がっしき',
  'かつじく',
  'かっしゃ',
  'がっしゅ',
  'がっしり',
  'かっすい',
  'かっする',
  'がっする',
  'かっせい',
  'かっせき',
  'かつぜつ',
  'かっせん',
  'かつぜん',
  'かっそう',
  'がっそう',
  'かったー',
  'かったい',
  'がったい',
  'かったつ',
  'かつだつ',
  'がったり',
  'かったん',
  'がっちゃ',
  'がっちょ',
  'かっちり',
  'がっちり',
  'がっつく',
  'がっつり',
  'かってに',
  'がっでむ',
  'がってん',
  'かっとう',
  'かつどう',
  'かっとし',
  'かつとじ',
  'かつどん',
  'かっぱー',
  'かっぱつ',
  'かっぱん',
  'かっぴつ',
  'がっぴつ',
  'かっふぇ',
  'かっぷく',
  'かつぶし',
  'かつぶつ',
  'かっぷら',
  'がっぷり',
  'かっぷる',
  'がっぺい',
  'かっぺき',
  'がっぺき',
  'かつべん',
  'かっぺん',
  'がつへん',
  'かつぼう',
  'かっぽう',
  'がっぽう',
  'がっぽり',
  'かっぽれ',
  'がっぽん',
  'かつまた',
  'かつめし',
  'かつもく',
  'かつやく',
  'かつやま',
  'かつよう',
  'かつらお',
  'かつらか',
  'かつらく',
  'がつりん',
  'かつれい',
  'かつれき',
  'かつれつ',
  'かていい',
  'かていか',
  'かていぎ',
  'かでぃま',
  'かてきょ',
  'かてきん',
  'かてごり',
  'かでんし',
  'かでんつ',
  'かどいで',
  'かどうか',
  'かどかど',
  'かどぐち',
  'かとする',
  'かどだつ',
  'かどつけ',
  'かどづけ',
  'かどっこ',
  'かとてき',
  'かどなみ',
  'かどばる',
  'かどばん',
  'かどふだ',
  'かどべや',
  'かどまつ',
  'かどまる',
  'かどみせ',
  'かともじ',
  'かどりゆ',
  'かとれあ',
  'かとれや',
  'かどわす',
  'かとんぼ',
  'かなあじ',
  'かなーと',
  'かなあみ',
  'かなえる',
  'かながき',
  'かながた',
  'かながち',
  'かなかな',
  'かながわ',
  'かなきん',
  'かなくぎ',
  'かなぐし',
  'かなくず',
  'かなくそ',
  'かなぐつ',
  'かなぐる',
  'かなさび',
  'かなざわ',
  'かなしい',
  'かなしき',
  'かなしげ',
  'かなしさ',
  'かなしぶ',
  'かなしみ',
  'かなしむ',
  'かなすた',
  'かなだも',
  'かなづち',
  'かなっぺ',
  'かなつぼ',
  'かなてこ',
  'かなでる',
  'かなとこ',
  'かなにか',
  'かなばち',
  'かなぶつ',
  'かなぶみ',
  'かなぶん',
  'かなへび',
  'かなぼう',
  'かなぼん',
  'かなまた',
  'かなまり',
  'かなめん',
  'かなもじ',
  'かなもの',
  'かなやま',
  'かならご',
  'かならず',
  'かなりあ',
  'かなりや',
  'かなわぬ',
  'かなわん',
  'かなんが',
  'かにかま',
  'かにがら',
  'かにかん',
  'かにくさ',
  'かにくそ',
  'かにぐも',
  'かにここ',
  'かにさし',
  'かにぞく',
  'かにたま',
  'かにのめ',
  'かにはた',
  'かにばば',
  'かにばる',
  'がにまた',
  'かにみそ',
  'かにむし',
  'かにめし',
  'がにめで',
  'かにゅう',
  'かねあい',
  'かねいれ',
  'かねかし',
  'かねがた',
  'かねがね',
  'かねくい',
  'かねぐら',
  'かねぐり',
  'かねごえ',
  'かねごと',
  'かねざし',
  'かねずく',
  'かねつき',
  'かねづく',
  'かねづる',
  'かねつろ',
  'かねない',
  'かねのね',
  'かねばこ',
  'かねひら',
  'かねびら',
  'かねへん',
  'かねもち',
  'かねやく',
  'かねろに',
  'かねんど',
  'かのうは',
  'かのえね',
  'かのーら',
  'かのーり',
  'かのきし',
  'かのくつ',
  'かのくに',
  'かのしし',
  'かのじょ',
  'かのちえ',
  'かのとう',
  'かのとみ',
  'かばーと',
  'かばーん',
  'かばいて',
  'かばいろ',
  'がばがば',
  'かばしら',
  'がばっと',
  'かばでぃ',
  'がばなー',
  'かばのき',
  'かばやき',
  'かはらい',
  'かばらい',
  'かばりえ',
  'がばりと',
  'かはんき',
  'かばんご',
  'がびある',
  'がびーん',
  'かぴかぴ',
  'がびがび',
  'かぴたる',
  'かぴたん',
  'かびどめ',
  'かぴばら',
  'かびぱん',
  'かひへん',
  'かひょう',
  'がひょう',
  'がびょう',
  'かふぃえ',
  'かぶーる',
  'かふぇー',
  'かふぇる',
  'がぶがぶ',
  'かぶきざ',
  'かふきん',
  'かぶきん',
  'かふくぶ',
  'かぶけん',
  'かぶさる',
  'かぶしき',
  'かぶじる',
  'かぶせる',
  'かぷせる',
  'かふそく',
  'かぶそく',
  'かぶだか',
  'かふたん',
  'がぶっと',
  'がぷっと',
  'かぶぬし',
  'がぶのみ',
  'かぶふだ',
  'かぶもと',
  'かぶやす',
  'かぷらー',
  'かぶらな',
  'かぶらや',
  'かぶれる',
  'かぶわけ',
  'かぺいか',
  'かべいた',
  'かべうち',
  'かべがき',
  'かべかけ',
  'かべがみ',
  'かべぎわ',
  'かべくさ',
  'かべごし',
  'かべざい',
  'かべしろ',
  'かべぞい',
  'かべつち',
  'かべどん',
  'かべぬり',
  'かべぱす',
  'かべぱん',
  'かべやく',
  'かぺりん',
  'かへんぶ',
  'かほうに',
  'かほうわ',
  'かぽえら',
  'かほーん',
  'がぼがぼ',
  'かぼそい',
  'かぼちゃ',
  'かぽっく',
  'がぼっと',
  'かほんか',
  'かまあし',
  'かまいて',
  'かまいり',
  'かまいれ',
  'かまうで',
  'かまえる',
  'かまおね',
  'かまかぜ',
  'かまがた',
  'かまきり',
  'がまぐち',
  'かまくび',
  'かまくら',
  'かまける',
  'かましあ',
  'がましい',
  'かましき',
  'がましゅ',
  'がまずみ',
  'かませる',
  'かまたき',
  'かまだし',
  'かまちょ',
  'かまつか',
  'かまつぎ',
  'がまっと',
  'かまとと',
  'かまどめ',
  'かまとろ',
  'かまひげ',
  'かまぶろ',
  'かまへん',
  'かまぼこ',
  'かまめし',
  'かまもと',
  'かまやり',
  'かまゆで',
  'かみあう',
  'かみあげ',
  'かみいち',
  'かみいれ',
  'かみおき',
  'かみかい',
  'かみかぜ',
  'かみがた',
  'かみかみ',
  'かみがみ',
  'がみがみ',
  'かみきず',
  'かみぎぬ',
  'かみきり',
  'かみきる',
  'かみきれ',
  'かみぎれ',
  'かみくず',
  'かみごと',
  'かみこま',
  'かみごま',
  'かみごむ',
  'かみさび',
  'かみさま',
  'かみざら',
  'かみさん',
  'かみしつ',
  'かみしで',
  'かみしも',
  'かみすき',
  'かみすり',
  'かみせい',
  'かみせん',
  'かみそり',
  'かみたい',
  'かみだな',
  'かみちゃ',
  'かみつく',
  'かみつち',
  'かみつつ',
  'かみづつ',
  'かみづな',
  'かみつよ',
  'かみつれ',
  'かみてん',
  'かみどこ',
  'かみどめ',
  'かみなび',
  'かみなべ',
  'かみなり',
  'かみのく',
  'かみのけ',
  'かみのこ',
  'かみのし',
  'かみのて',
  'かみばこ',
  'かみばな',
  'かみばん',
  'かみふり',
  'かみまき',
  'かみみせ',
  'かみやき',
  'かみゆい',
  'かみより',
  'かみるれ',
  'かみわざ',
  'かむかぜ',
  'がむぐつ',
  'かむこと',
  'かむさび',
  'がむしか',
  'がむしろ',
  'かむだち',
  'かむなび',
  'かむぬし',
  'がむらん',
  'かむわざ',
  'かめあな',
  'かめあや',
  'かめうら',
  'かめかん',
  'がめつい',
  'かめのこ',
  'かめのて',
  'かめばら',
  'かめへん',
  'かめむし',
  'かめもく',
  'かめらや',
  'がめらん',
  'かめりあ',
  'かめりは',
  'かめれす',
  'かもうち',
  'かもうり',
  'かもーん',
  'かもがや',
  'かもくど',
  'かもしか',
  'かもつき',
  'がもっと',
  'かもなす',
  'かもなべ',
  'かもにく',
  'かもねぎ',
  'かもふれ',
  'かもみる',
  'かももく',
  'かやかや',
  'がやがや',
  'かやきん',
  'かやくこ',
  'かやぐむ',
  'かやっく',
  'かやぶき',
  'かやみそ',
  'かやもん',
  'かやらん',
  'かやりき',
  'かやりび',
  'かゆうら',
  'かゆがる',
  'かゆづえ',
  'かゆばら',
  'かゆぷて',
  'かよいじ',
  'がようし',
  'かようび',
  'かよわい',
  'からーか',
  'がらあき',
  'からあげ',
  'からーど',
  'からーむ',
  'からいと',
  'からいぬ',
  'からいも',
  'からうす',
  'からうた',
  'からうま',
  'からうめ',
  'からうり',
  'からおけ',
  'からおし',
  'がらおち',
  'からおり',
  'からかい',
  'からがい',
  'からかう',
  'からかさ',
  'からがし',
  'からかす',
  'からかぜ',
  'からかね',
  'からかぶ',
  'からかみ',
  'からから',
  'からがら',
  'がらがら',
  'からかる',
  'からきし',
  'からぎぬ',
  'からきり',
  'からくさ',
  'からくじ',
  'がらくた',
  'からくち',
  'からくに',
  'からくも',
  'からくら',
  'からぐら',
  'からくり',
  'がらけい',
  'がらけー',
  'からけし',
  'からけつ',
  'からげる',
  'からこそ',
  'からころ',
  'からこん',
  'からざえ',
  'からさお',
  'からざお',
  'からさけ',
  'からざけ',
  'からしお',
  'からしし',
  'からじし',
  'からして',
  'からしな',
  'からしゆ',
  'がらすえ',
  'からすか',
  'がらすか',
  'からすき',
  'がらすき',
  'からすざ',
  'がらすど',
  'からすみ',
  'がらすや',
  'からせき',
  'からぜき',
  'からせじ',
  'からだき',
  'からたけ',
  'からたち',
  'からちゃ',
  'からって',
  'からっと',
  'がらっと',
  'からっぽ',
  'からつゆ',
  'からづり',
  'からてか',
  'からてぎ',
  'からてん',
  'からとう',
  'からとて',
  'からなし',
  'からなる',
  'からには',
  'からねこ',
  'からばお',
  'からばこ',
  'からはし',
  'からはふ',
  'からばら',
  'からばり',
  'からびつ',
  'からびと',
  'からびな',
  'からびる',
  'からびん',
  'からふう',
  'からぶき',
  'からふと',
  'からぶり',
  'からふる',
  'からぶる',
  'からぶろ',
  'からへた',
  'からぼけ',
  'からぼし',
  'からぼり',
  'がらぽん',
  'からます',
  'からまつ',
  'からまり',
  'からまる',
  'からみそ',
  'からみん',
  'からむき',
  'からむし',
  'からめて',
  'からめで',
  'からめる',
  'からもじ',
  'からもの',
  'がらもの',
  'からもも',
  'からもん',
  'からゆき',
  'からよう',
  'かられる',
  'からんつ',
  'からんど',
  'かりあげ',
  'かりあと',
  'かりいえ',
  'かりいぬ',
  'かりいれ',
  'かりうえ',
  'かりうど',
  'かりうむ',
  'がりうむ',
  'かりうめ',
  'かりえす',
  'かりおき',
  'かりおや',
  'かりかえ',
  'かりかし',
  'かりかた',
  'かりがね',
  'かりかぶ',
  'かりかり',
  'がりがり',
  'かりぎぬ',
  'かりきり',
  'かりきる',
  'かりくび',
  'かりくら',
  'かりこし',
  'かりこす',
  'かりこみ',
  'かりこむ',
  'かりごや',
  'かりじめ',
  'かりすう',
  'かりすと',
  'かりすま',
  'かりずり',
  'がりせん',
  'かりそめ',
  'かりたく',
  'かりたす',
  'かりだす',
  'かりたて',
  'かりだな',
  'かりちん',
  'かりっと',
  'がりっと',
  'かりとじ',
  'かりどの',
  'かりどめ',
  'かりとり',
  'かりどり',
  'かりとる',
  'かりなん',
  'かりにげ',
  'かりにも',
  'かりにん',
  'かりぬい',
  'かりぬし',
  'かりのな',
  'かりのよ',
  'かりぱー',
  'がりばー',
  'かりぱく',
  'かりばし',
  'かりぱす',
  'かりばち',
  'かりぱち',
  'かりばり',
  'がりばん',
  'かりびと',
  'かりぶー',
  'かりぶき',
  'かりふく',
  'かりぷそ',
  'がりべん',
  'かりほす',
  'かりまた',
  'かりみや',
  'かりめん',
  'かりもの',
  'かりゃく',
  'かりやく',
  'がりゃく',
  'かりゅう',
  'がりゅう',
  'かりゆし',
  'かりょう',
  'がりょう',
  'かりょく',
  'がりょく',
  'かりよん',
  'がりれお',
  'かりろん',
  'かりんば',
  'かるいし',
  'かるーあ',
  'かるうえ',
  'かるがも',
  'かるかや',
  'かるがる',
  'かるかん',
  'かるくち',
  'かるさん',
  'かるすと',
  'かるそん',
  'がるそん',
  'かるたや',
  'かるでら',
  'かるてる',
  'かるとん',
  'かるぱす',
  'かるべん',
  'かるぼい',
  'かるみあ',
  'かるみん',
  'かるめら',
  'かるめる',
  'かるやか',
  'かるやき',
  'かるわざ',
  'かれあし',
  'かれいい',
  'かれーこ',
  'がれーじ',
  'かれえだ',
  'がれおん',
  'かれかの',
  'かれがれ',
  'かれがわ',
  'かれぎく',
  'かれくさ',
  'かれごえ',
  'かれこれ',
  'かれせん',
  'かれたき',
  'かれっじ',
  'かれっと',
  'がれっと',
  'かれなり',
  'かればむ',
  'かれぶし',
  'がれりー',
  'かれんず',
  'かれんだ',
  'かれんつ',
  'かれんと',
  'かろうし',
  'かろーら',
  'かろがろ',
  'かろちん',
  'がろっぷ',
  'かろてん',
  'かろめる',
  'かろやか',
  'かろりー',
  'かわいい',
  'かわいげ',
  'かわいた',
  'がわいた',
  'かわうお',
  'かわうそ',
  'かわうま',
  'かわえび',
  'かわおび',
  'かわかす',
  'かわかぜ',
  'かわかみ',
  'かわがめ',
  'かわぎし',
  'かわぎぬ',
  'かわきり',
  'かわぎり',
  'かわぐち',
  'かわぐつ',
  'かわげた',
  'がわげた',
  'かわげら',
  'かわごえ',
  'かわごし',
  'かわごと',
  'かわさき',
  'かわしき',
  'かわしも',
  'かわじり',
  'かわすじ',
  'かわせい',
  'かわせみ',
  'かわぞい',
  'かわそう',
  'かわぞこ',
  'かわたけ',
  'かわたで',
  'かわたび',
  'かわつき',
  'かわった',
  'かわっぱ',
  'かわづら',
  'かわづり',
  'かわどこ',
  'かわとじ',
  'かわどめ',
  'かわなみ',
  'かわのじ',
  'かわはぎ',
  'かわばた',
  'かわはば',
  'かわばり',
  'かわひも',
  'かわぶち',
  'かわぶね',
  'かわへび',
  'かわべり',
  'かわへん',
  'かわほね',
  'かわほり',
  'かわます',
  'かわむし',
  'かわむつ',
  'かわやぎ',
  'かわゆい',
  'かわゆか',
  'かわゆす',
  'かわよい',
  'かわらか',
  'かわらけ',
  'かわらげ',
  'かわらぬ',
  'かわらや',
  'かわりえ',
  'かわりに',
  'かわりみ',
  'かわりめ',
  'かわりゆ',
  'かわろう',
  'がをおる',
  'がをだす',
  'がをはる',
  'かんあく',
  'かんあけ',
  'かんあつ',
  'がんあつ',
  'かんあん',
  'かんいか',
  'かんいり',
  'かんいん',
  'かんうき',
  'かんうん',
  'かんえい',
  'かんえつ',
  'かんえん',
  'がんえん',
  'かんおう',
  'かんおけ',
  'かんおん',
  'かんかい',
  'かんがい',
  'がんかい',
  'かんがえ',
  'かんかく',
  'かんがく',
  'がんかけ',
  'がんがけ',
  'かんかじ',
  'がんがぜ',
  'かんかつ',
  'かんかん',
  'かんがん',
  'がんがん',
  'かんきく',
  'かんぎく',
  'かんきし',
  'かんきつ',
  'かんきょ',
  'かんぎょ',
  'かんきり',
  'がんぎれ',
  'かんきん',
  'かんぎん',
  'がんきん',
  'かんくう',
  'がんくつ',
  'がんくび',
  'がんぐや',
  'かんぐり',
  'かんぐる',
  'がんぐろ',
  'かんぐん',
  'かんけい',
  'かんげい',
  'かんげき',
  'かんけつ',
  'かんげつ',
  'かんけり',
  'かんけん',
  'かんげん',
  'がんけん',
  'かんごい',
  'かんこう',
  'かんごう',
  'がんこう',
  'かんごえ',
  'かんこく',
  'かんごく',
  'かんごし',
  'かんこつ',
  'かんこぴ',
  'かんごふ',
  'かんごり',
  'かんこる',
  'かんさい',
  'かんざい',
  'がんざい',
  'かんさく',
  'かんざく',
  'がんさく',
  'かんざけ',
  'かんざし',
  'かんざす',
  'かんさつ',
  'がんさつ',
  'かんさび',
  'かんさん',
  'かんざん',
  'がんさん',
  'がんざん',
  'かんしか',
  'かんしき',
  'かんじき',
  'がんしき',
  'かんじく',
  'がんじく',
  'かんじた',
  'かんじだ',
  'かんしつ',
  'がんしつ',
  'がんじつ',
  'かんして',
  'かんしゃ',
  'かんじゃ',
  'がんしゃ',
  'がんじゃ',
  'かんしゅ',
  'かんじゅ',
  'がんしゅ',
  'かんしょ',
  'かんじょ',
  'がんしょ',
  'かんじる',
  'かんしん',
  'かんじん',
  'がんしん',
  'かんすい',
  'がんすい',
  'かんすう',
  'かんすげ',
  'かんすと',
  'かんする',
  'かんずる',
  'かんせい',
  'かんぜい',
  'かんせき',
  'がんせき',
  'かんせつ',
  'かんぜつ',
  'がんせつ',
  'かんぜみ',
  'かんせん',
  'かんぜん',
  'がんせん',
  'がんぜん',
  'かんそう',
  'かんぞう',
  'がんそう',
  'がんぞう',
  'かんそか',
  'かんそく',
  'かんぞく',
  'がんそく',
  'かんぞこ',
  'かんそん',
  'かんたー',
  'かんたい',
  'かんだい',
  'がんたい',
  'かんたく',
  'がんだて',
  'かんたる',
  'がんだれ',
  'かんたん',
  'かんだん',
  'がんたん',
  'かんちき',
  'かんちく',
  'がんちく',
  'かんちつ',
  'かんつい',
  'かんつう',
  'かんづく',
  'かんづめ',
  'がんづめ',
  'かんてい',
  'がんてい',
  'かんてき',
  'かんてつ',
  'かんてら',
  'かんでら',
  'かんてん',
  'かんでん',
  'がんてん',
  'かんとう',
  'かんどう',
  'がんとう',
  'がんどう',
  'かんとか',
  'かんとく',
  'かんどく',
  'かんとに',
  'かんどら',
  'かんとん',
  'がんなー',
  'かんない',
  'かんなぎ',
  'かんなび',
  'かんなみ',
  'かんなん',
  'がんにー',
  'がんにく',
  'かんにち',
  'がんにち',
  'かんにん',
  'がんにん',
  'かんぬき',
  'かんぬし',
  'かんぬひ',
  'かんねつ',
  'かんねん',
  'がんねん',
  'かんのう',
  'かんのき',
  'かんのん',
  'かんばい',
  'かんぱい',
  'かんばく',
  'かんぱく',
  'かんばす',
  'かんばせ',
  'かんはた',
  'かんばた',
  'かんぱち',
  'かんはつ',
  'かんばつ',
  'かんぱつ',
  'かんぱら',
  'がんばり',
  'がんばる',
  'がんばれ',
  'かんばん',
  'かんぱん',
  'がんばん',
  'がんびあ',
  'がんぴし',
  'かんぴん',
  'かんふー',
  'かんぷう',
  'がんぶー',
  'がんぶき',
  'かんふく',
  'かんぷく',
  'がんぷく',
  'かんぶつ',
  'がんぶつ',
  'かんぶな',
  'がんぷら',
  'かんぶり',
  'かんぷり',
  'かんふる',
  'かんぶん',
  'かんぷん',
  'かんべい',
  'かんぺい',
  'かんべき',
  'かんぺき',
  'がんぺき',
  'かんべつ',
  'かんべん',
  'かんぺん',
  'がんぺん',
  'かんぼう',
  'かんぽう',
  'がんぼう',
  'がんほー',
  'かんぼく',
  'かんぼつ',
  'かんぽん',
  'がんぽん',
  'がんまー',
  'かんまく',
  'かんまつ',
  'がんまは',
  'かんまん',
  'がんまん',
  'かんみん',
  'がんむし',
  'かんむり',
  'かんめい',
  'がんめい',
  'かんめし',
  'かんめん',
  'がんめん',
  'かんもう',
  'がんもう',
  'かんもく',
  'がんもく',
  'かんもじ',
  'かんもち',
  'かんもつ',
  'かんもん',
  'がんもん',
  'かんやく',
  'がんやく',
  'かんゆう',
  'がんゆう',
  'かんよう',
  'がんよう',
  'かんらい',
  'がんらい',
  'かんらく',
  'かんらん',
  'がんりき',
  'かんりし',
  'かんりつ',
  'かんりひ',
  'かんりん',
  'かんるい',
  'かんれい',
  'かんれき',
  'かんれつ',
  'かんれん',
  'がんろう',
  'かんろく',
  'かんろに',
  'かんわざ',
  'きあずま',
  'きーいん',
  'きーうぃ',
  'きぃきぃ',
  'きいきい',
  'きーきー',
  'ぎいぎい',
  'ぎーぎー',
  'きいぐみ',
  'きーさん',
  'きーしむ',
  'きーせん',
  'きいちご',
  'きーてく',
  'ぎいとん',
  'きーのー',
  'きーぱー',
  'きーまう',
  'きーまん',
  'きーみぞ',
  'きーむす',
  'きーれす',
  'きいろい',
  'きうつり',
  'きうるし',
  'ぎうんい',
  'きえいる',
  'きえぎえ',
  'きえさる',
  'きえしゃ',
  'きえゆく',
  'きおくぶ',
  'きおくれ',
  'きおすく',
  'ぎおんえ',
  'ぎおんご',
  'きがあう',
  'ぎがーす',
  'きがある',
  'きがいい',
  'きかいか',
  'きかいご',
  'きかいゆ',
  'きかえる',
  'きがえる',
  'きかがく',
  'きがかつ',
  'きがかり',
  'きかかる',
  'きがかん',
  'きがきく',
  'きかくか',
  'ぎかくし',
  'きかくぶ',
  'きかげき',
  'きがさす',
  'きかざる',
  'きかしゃ',
  'きかしゅ',
  'きかじん',
  'きがすむ',
  'きがする',
  'きがせく',
  'きかせる',
  'ぎかだい',
  'きがたつ',
  'きがたな',
  'きがちる',
  'きがつく',
  'きかっけ',
  'ぎがとん',
  'きがない',
  'きかぬき',
  'きかねつ',
  'きがのる',
  'きがはる',
  'きがへん',
  'きがまえ',
  'きがむく',
  'きがよい',
  'きがらく',
  'きがるい',
  'きがるに',
  'きがわり',
  'きかんき',
  'きかんく',
  'きかんこ',
  'きかんざ',
  'きかんし',
  'ききあし',
  'ききいる',
  'ききうで',
  'ききおく',
  'ききがき',
  'ききかた',
  'ききかん',
  'ききこう',
  'ききこみ',
  'ききこむ',
  'ききざけ',
  'ききしる',
  'ききだす',
  'ききちゃ',
  'ききてき',
  'ききとり',
  'ききとる',
  'ききなす',
  'ききべた',
  'ききみみ',
  'ききもの',
  'ききゃく',
  'ききやく',
  'ききゅう',
  'ぎぎゅう',
  'ききよい',
  'ききょう',
  'ききよう',
  'きぎょう',
  'ぎきょう',
  'ききょく',
  'ぎきょく',
  'ききわけ',
  'きくいし',
  'きくいも',
  'ぎくぎく',
  'きくきん',
  'きくざけ',
  'きくじん',
  'きくずす',
  'きくずみ',
  'きぐすり',
  'きくする',
  'きくずれ',
  'きくちば',
  'きくづき',
  'ぎくっと',
  'きくばり',
  'きくばん',
  'きくみみ',
  'きくもん',
  'きぐらい',
  'きくらげ',
  'きぐるみ',
  'きぐろう',
  'ぎくんし',
  'きけいじ',
  'きけもの',
  'きげんご',
  'きけんし',
  'きげんそ',
  'きけんび',
  'きこうか',
  'きごうか',
  'きこうし',
  'きごうそ',
  'きこうち',
  'きこえる',
  'きこきこ',
  'ぎこぎこ',
  'きごこち',
  'きごころ',
  'きことば',
  'きこなし',
  'きこなす',
  'ぎこぶん',
  'きこゆる',
  'きごろし',
  'きざいこ',
  'きさいと',
  'きさがい',
  'ぎざぎざ',
  'きささげ',
  'きざはし',
  'きざみち',
  'きざみに',
  'きざみめ',
  'きさらぎ',
  'きざわり',
  'きさんじ',
  'ぎしあん',
  'きしかた',
  'きしかん',
  'きしきし',
  'ぎしぎし',
  'きしだい',
  'きしだは',
  'きしだん',
  'ぎじっか',
  'きしてん',
  'きしどう',
  'ぎじどう',
  'きじとら',
  'きじねこ',
  'きじはた',
  'きじばと',
  'ぎじばり',
  'きじぶえ',
  'きじぶん',
  'きしめじ',
  'きしめん',
  'きじもく',
  'きしゃく',
  'きじゃく',
  'きしゃご',
  'きしゅう',
  'きじゅう',
  'きしゅく',
  'ぎじゅく',
  'きしゅつ',
  'きじゅつ',
  'ぎじゅつ',
  'きしゅん',
  'きじゅん',
  'きしょい',
  'きしょう',
  'きじょう',
  'ぎしょう',
  'ぎじょう',
  'きしょー',
  'きしょく',
  'きじらみ',
  'きしらん',
  'きじるし',
  'きしれん',
  'ぎじろく',
  'ぎじんか',
  'きずあと',
  'きすいこ',
  'きすうし',
  'きずおん',
  'ぎすぎす',
  'きずぐち',
  'きずつく',
  'きずばん',
  'きすふれ',
  'きずもの',
  'ぎせいご',
  'ぎせいだ',
  'きせにあ',
  'きせのん',
  'きそうご',
  'きそうま',
  'きそけい',
  'きそてき',
  'きそばり',
  'きそりつ',
  'きそれん',
  'ぎたいご',
  'きたいち',
  'きたうけ',
  'きたえる',
  'きだおれ',
  'きたかぜ',
  'きたがわ',
  'ぎたぎた',
  'きたぐち',
  'きたぐに',
  'きたくぶ',
  'きたごち',
  'きたこれ',
  'きたする',
  'きたたき',
  'きたたま',
  'きたては',
  'きたない',
  'きだはし',
  'きたむき',
  'きたもん',
  'きたやま',
  'ぎだゆう',
  'きたより',
  'きたりす',
  'きちがい',
  'きちきち',
  'ぎちぎち',
  'きちじつ',
  'きちすう',
  'きちっと',
  'きちにち',
  'きちゃく',
  'きちゅう',
  'きちょう',
  'ぎちょう',
  'きちれい',
  'きちんと',
  'きついん',
  'きつえん',
  'きつおん',
  'きっかー',
  'きっかい',
  'きづかい',
  'きづかう',
  'きっかけ',
  'きっかり',
  'きづかれ',
  'きっきょ',
  'きっきん',
  'きづくり',
  'ぎっくり',
  'きつける',
  'きっこう',
  'きっさき',
  'きつじつ',
  'ぎっしゃ',
  'きっしゅ',
  'きっしょ',
  'ぎっしり',
  'きっしん',
  'きっすい',
  'きっする',
  'きっせき',
  'きつぜん',
  'きっそう',
  'きったつ',
  'きったん',
  'きっちゅ',
  'ぎっちょ',
  'きっちり',
  'ぎっちり',
  'きっちん',
  'きつつき',
  'きっての',
  'きっとん',
  'きつねび',
  'きつねや',
  'きっぱー',
  'きっぱし',
  'きっぱり',
  'きっぱん',
  'きつぶす',
  'きっぽう',
  'きづまり',
  'きづもり',
  'きつもん',
  'きづよい',
  'きつりつ',
  'きつれい',
  'きでぃー',
  'きていち',
  'きていど',
  'きでのむ',
  'きてれつ',
  'きでんき',
  'きとうえ',
  'きどうき',
  'きとうし',
  'きどうじ',
  'ぎとぎと',
  'きどころ',
  'きとさん',
  'きどせん',
  'きどにー',
  'きどばん',
  'きどりや',
  'きどるい',
  'きとんぼ',
  'きなーぜ',
  'きないし',
  'きなおす',
  'きながし',
  'きなきな',
  'きにーね',
  'きにいり',
  'きにいる',
  'きにくい',
  'きにくは',
  'きにじん',
  'きにする',
  'きにそむ',
  'きになる',
  'きにめす',
  'きにやむ',
  'きにゅう',
  'ぎにゅう',
  'きにょう',
  'ぎにょる',
  'きぬあさ',
  'きぬいと',
  'きぬかわ',
  'きぬぎぬ',
  'きぬごし',
  'きぬさや',
  'きぬざる',
  'きぬずれ',
  'きぬなり',
  'きぬばり',
  'きぬべら',
  'きぬもの',
  'きぬらん',
  'きぬわた',
  'きねしす',
  'きねずみ',
  'きねちん',
  'きねづか',
  'きねれこ',
  'きねんし',
  'きねんひ',
  'きねんび',
  'きのいい',
  'きのうご',
  'きのうし',
  'きのうび',
  'きのえね',
  'きのかわ',
  'きのきく',
  'きのせい',
  'きのとい',
  'きのとう',
  'きのどく',
  'きのとみ',
  'きのない',
  'きのはし',
  'きのぼり',
  'きのまた',
  'きのよい',
  'きのりん',
  'きのろん',
  'きはーだ',
  'きばさみ',
  'きばしり',
  'きばせん',
  'きばだち',
  'きばたん',
  'きはちす',
  'きはつど',
  'きはつゆ',
  'きはない',
  'きはらい',
  'きばらい',
  'きばらし',
  'きびきび',
  'きびしい',
  'きびしさ',
  'きびしょ',
  'きびたき',
  'きびなご',
  'きひょう',
  'きびょう',
  'ぎひょう',
  'きふきん',
  'きぶくれ',
  'ぎふけん',
  'きふじん',
  'きぶとり',
  'きふほう',
  'きふるし',
  'きふるす',
  'きぶるす',
  'きぷろす',
  'きぷんじ',
  'きぶんや',
  'きべんか',
  'ぎぼうし',
  'きぼとけ',
  'きほよう',
  'きぼりし',
  'きほんご',
  'きほんち',
  'きぼんぬ',
  'きまいら',
  'きまかせ',
  'きまくら',
  'きまぐれ',
  'きまじめ',
  'きまずい',
  'きまって',
  'きまぶり',
  'きまもり',
  'きまよい',
  'きまりじ',
  'きまりて',
  'きまわし',
  'きみがよ',
  'きみかん',
  'きみじか',
  'きみずし',
  'きみたち',
  'ぎみっく',
  'きみつひ',
  'きみどり',
  'きみゃく',
  'きみょう',
  'きむかう',
  'ぎむかん',
  'きむすこ',
  'きむすめ',
  'ぎむづけ',
  'ぎむてき',
  'ぎむねま',
  'きむぱぷ',
  'きめうち',
  'きめがお',
  'きめこみ',
  'きめこむ',
  'きめせく',
  'きめだし',
  'きめだま',
  'きめわざ',
  'きもいり',
  'ぎもーゔ',
  'きもおた',
  'ぎもーぶ',
  'きもしん',
  'きもすい',
  'きもだま',
  'きものじ',
  'きものや',
  'きもめん',
  'きもをた',
  'ぎもんし',
  'ぎもんふ',
  'ぎゃくい',
  'きゃくご',
  'きゃくし',
  'ぎゃくし',
  'ぎゃくて',
  'きゃくど',
  'ぎゃくと',
  'ぎゃくに',
  'ぎゃくひ',
  'きゃくぶ',
  'きゃくま',
  'ぎゃぐる',
  'ぎゃざー',
  'きゃしゃ',
  'きやすい',
  'きゃすく',
  'きゃすた',
  'きゃすと',
  'きやすめ',
  'きゃたつ',
  'きゃっか',
  'きゃっち',
  'きゃっつ',
  'きゃっと',
  'きゃっぷ',
  'ぎゃっぷ',
  'ぎゃっべ',
  'きゃでぃ',
  'きゃのん',
  'きゃはん',
  'きゃびあ',
  'きゃびね',
  'きゃびん',
  'きゃふぇ',
  'ぎゃふん',
  'きゃべじ',
  'きゃべつ',
  'ぎやまん',
  'きゃめら',
  'きゃめる',
  'ぎゃもん',
  'きゃらこ',
  'きゃりあ',
  'きゃりー',
  'きゃりこ',
  'きゃりや',
  'ぎゃるお',
  'ぎゃるげ',
  'ぎゃるご',
  'きゃるす',
  'ぎゃれー',
  'きゃろむ',
  'きゃろる',
  'ぎゃんぐ',
  'きゃんぷ',
  'きゅうあ',
  'きゅうい',
  'きゅうう',
  'きゅうか',
  'きゅうき',
  'きゅうぎ',
  'きゅうぐ',
  'きゅうこ',
  'きゅうご',
  'ぎゅうご',
  'きゅうし',
  'きゅうじ',
  'ぎゅうし',
  'ぎゅうじ',
  'きゅうす',
  'きゅうそ',
  'きゅうち',
  'きゅーと',
  'きゅうと',
  'きゅうど',
  'きゅうに',
  'きゅうは',
  'きゅーば',
  'きゅうば',
  'ぎゅうば',
  'きゅうひ',
  'きゅうび',
  'ぎゅうひ',
  'きゅうふ',
  'きゅーぶ',
  'きゅうぶ',
  'きゅうぼ',
  'ぎゅうほ',
  'きゅうむ',
  'ぎゅうや',
  'きゅうゆ',
  'きゅうよ',
  'きゅうり',
  'ぎゅぎゅ',
  'ぎゅって',
  'きゅっと',
  'ぎゅっと',
  'きゅばん',
  'きゅびと',
  'きゅぷら',
  'きゅぽら',
  'ぎゅよー',
  'きゅりー',
  'きゅんし',
  'きょあく',
  'ぎょうあ',
  'きょうい',
  'きょうう',
  'きょうか',
  'きょうが',
  'ぎょうか',
  'ぎょうが',
  'きょうき',
  'きょうぎ',
  'ぎょうき',
  'ぎょうぎ',
  'きょうく',
  'きょうぐ',
  'きょうけ',
  'きょうげ',
  'きょうこ',
  'きょうご',
  'ぎょうこ',
  'きょうさ',
  'ぎょうざ',
  'きょうし',
  'きょうじ',
  'ぎょうし',
  'ぎょうじ',
  'きょうす',
  'きょうそ',
  'きょうだ',
  'きょうち',
  'きょうと',
  'きょうど',
  'きょうな',
  'きょうは',
  'きょうび',
  'きょうふ',
  'きょうぶ',
  'きょうほ',
  'きょうぼ',
  'きょうま',
  'きょうみ',
  'きょうむ',
  'ぎょうむ',
  'きょうゆ',
  'きょうよ',
  'きょうり',
  'きょうわ',
  'きょえい',
  'ぎょえい',
  'ぎょえん',
  'きょおく',
  'ぎょーざ',
  'きょかい',
  'ぎょかい',
  'きょがく',
  'ぎょかく',
  'ぎょかす',
  'きょかん',
  'きょがん',
  'ぎょがん',
  'きょきん',
  'きょくう',
  'きょくか',
  'きょくぎ',
  'きょくさ',
  'ぎょくざ',
  'きょくし',
  'きょくじ',
  'ぎょくじ',
  'きょくち',
  'きょくど',
  'ぎょくと',
  'きょくば',
  'きょくひ',
  'きょくび',
  'きょくふ',
  'きょくぶ',
  'きょくべ',
  'きょくほ',
  'きょくや',
  'きょくろ',
  'ぎょくろ',
  'きょくわ',
  'ぎょぐん',
  'きょげい',
  'ぎょけい',
  'きょけつ',
  'きょげつ',
  'きょげん',
  'きょこう',
  'きょごう',
  'ぎょこう',
  'きょこく',
  'きょこつ',
  'きょこん',
  'きょごん',
  'きょさい',
  'きょざい',
  'ぎょさい',
  'きょさつ',
  'きょしき',
  'きょしつ',
  'きょじつ',
  'ぎょしゃ',
  'きょしゅ',
  'きょじゅ',
  'ぎょしゅ',
  'きょしょ',
  'きょしり',
  'きょじり',
  'きょしん',
  'きょじん',
  'ぎょしん',
  'きょすい',
  'きょすう',
  'きよすく',
  'ぎょする',
  'きょせい',
  'ぎょせい',
  'きょせき',
  'きょせつ',
  'きょぜつ',
  'きょせん',
  'きょぜん',
  'ぎょせん',
  'きょそう',
  'きょぞう',
  'きょぞく',
  'ぎょぞく',
  'ぎょそん',
  'きょたい',
  'きょだい',
  'ぎょたい',
  'ぎょだい',
  'きょたく',
  'きょだく',
  'ぎょたく',
  'きょだつ',
  'きょたん',
  'きょだん',
  'ぎよちん',
  'きょっき',
  'ぎょっと',
  'ぎょてい',
  'きょてん',
  'きょでん',
  'ぎょでん',
  'きょとう',
  'きょどう',
  'ぎょとう',
  'ぎょどう',
  'きょどる',
  'きょとん',
  'ぎょにく',
  'きょねん',
  'きょはく',
  'ぎょばん',
  'きょひる',
  'きよぶき',
  'ぎょふく',
  'ぎょぶつ',
  'きょふて',
  'きょぶん',
  'ぎょふん',
  'きょへい',
  'きょへん',
  'きょほう',
  'きょぼう',
  'ぎょほう',
  'きょぼく',
  'きよまる',
  'きょまん',
  'きよみず',
  'ぎょみん',
  'きょめい',
  'ぎょめい',
  'きよめる',
  'きょもう',
  'ぎょもう',
  'きよもと',
  'ぎょゆう',
  'きょよう',
  'きょらい',
  'ぎょらい',
  'きよらか',
  'ぎょらん',
  'ぎょりん',
  'ぎょるい',
  'きょれい',
  'ぎょれん',
  'ぎょろう',
  'ぎょろめ',
  'きょろり',
  'ぎょろり',
  'きょろん',
  'きらきら',
  'ぎらぎら',
  'ぎらつく',
  'きらっと',
  'ぎらっと',
  'きらない',
  'きらぼし',
  'きらめき',
  'きらめく',
  'きらわず',
  'きりあい',
  'ぎりあい',
  'きりあう',
  'きりあげ',
  'きりいし',
  'きりいる',
  'きりうり',
  'きりえだ',
  'きりかえ',
  'きりかき',
  'きりかく',
  'きりかた',
  'きりかね',
  'きりかぶ',
  'きりかみ',
  'きりがみ',
  'きりぎし',
  'きりきず',
  'きりきり',
  'ぎりぎり',
  'きりくい',
  'きりくぎ',
  'きりくず',
  'きりくち',
  'きりくむ',
  'きりぐも',
  'きりげつ',
  'きりこみ',
  'きりこむ',
  'きりざい',
  'きりさく',
  'きりさげ',
  'きりさめ',
  'きりさる',
  'ぎりしあ',
  'きりじに',
  'ぎりしゃ',
  'ぎりしや',
  'きりすて',
  'きりすと',
  'きりずま',
  'きりずみ',
  'きりだし',
  'きりだす',
  'きりたつ',
  'きりたて',
  'ぎりだて',
  'きりちん',
  'きりつぎ',
  'きりつち',
  'きりっと',
  'きりづま',
  'きりつめ',
  'きりとり',
  'きりどり',
  'きりとる',
  'きりなし',
  'きりにじ',
  'ぎりにも',
  'きりぬき',
  'きりぬく',
  'きりぬさ',
  'きりはこ',
  'きりばこ',
  'きりはし',
  'きりばす',
  'きりはた',
  'きりばな',
  'きりばり',
  'きりばん',
  'きりふき',
  'きりふだ',
  'きりぼし',
  'きりまく',
  'きりまど',
  'ぎりまん',
  'きりもち',
  'きりもみ',
  'きりもり',
  'きりもん',
  'きりゃく',
  'きりゅう',
  'きりょう',
  'ぎりょう',
  'きりょく',
  'きりりく',
  'きりわる',
  'きりんか',
  'きりんざ',
  'きりんじ',
  'きるぎす',
  'きるしゅ',
  'ぎるだー',
  'ぎるてぃ',
  'きるめす',
  'きるもの',
  'きれあじ',
  'きれいめ',
  'きれーと',
  'きれおち',
  'きれかわ',
  'きれきれ',
  'きれぎれ',
  'きれくず',
  'きれくち',
  'きれこみ',
  'きれこむ',
  'きれっと',
  'きれない',
  'きれなが',
  'きれはし',
  'きれもの',
  'きれんが',
  'ぎろぎろ',
  'ぎろちん',
  'きろとん',
  'ぎろぴた',
  'きわだつ',
  'ぎわだん',
  'きわどい',
  'きわまり',
  'きわまる',
  'きわめて',
  'きわめる',
  'きわもの',
  'きをきる',
  'きをつけ',
  'きをぬく',
  'きをはく',
  'きをはる',
  'きをひく',
  'きをもむ',
  'きをやむ',
  'きんあか',
  'きんあつ',
  'ぎんあん',
  'きんいち',
  'きんいつ',
  'きんいろ',
  'ぎんいろ',
  'きんいん',
  'きんうん',
  'きんえい',
  'ぎんえい',
  'きんえつ',
  'きんえん',
  'ぎんえん',
  'きんかい',
  'ぎんかい',
  'きんかく',
  'きんがく',
  'きんかこ',
  'きんかぶ',
  'ぎんがみ',
  'ぎんがむ',
  'きんがわ',
  'ぎんがわ',
  'きんかん',
  'きんがん',
  'ぎんかん',
  'ぎんきせ',
  'きんぎょ',
  'きんきら',
  'ぎんぎら',
  'きんきん',
  'きんぎん',
  'ぎんぎん',
  'きんぐち',
  'きんぐん',
  'きんけい',
  'ぎんけい',
  'きんけつ',
  'きんけん',
  'きんげん',
  'きんこう',
  'きんごう',
  'ぎんこう',
  'きんこく',
  'きんごく',
  'きんこつ',
  'きんごま',
  'きんこん',
  'きんざい',
  'きんさく',
  'ぎんざけ',
  'きんさつ',
  'ぎんざめ',
  'きんざる',
  'きんざん',
  'ぎんざん',
  'きんじき',
  'きんじち',
  'きんしつ',
  'きんじつ',
  'きんじて',
  'きんしゃ',
  'ぎんしゃ',
  'きんしゅ',
  'きんじゅ',
  'ぎんしゅ',
  'きんしょ',
  'きんじょ',
  'きんじる',
  'ぎんじる',
  'きんしん',
  'きんすじ',
  'きんずる',
  'ぎんずる',
  'きんせい',
  'ぎんせい',
  'きんせき',
  'きんせつ',
  'ぎんせつ',
  'きんせん',
  'きんぜん',
  'ぎんせん',
  'きんぞう',
  'きんそく',
  'きんぞく',
  'きんそん',
  'きんたい',
  'きんだい',
  'きんだか',
  'きんだち',
  'きんたま',
  'ぎんだま',
  'きんだみ',
  'ぎんだみ',
  'ぎんだら',
  'きんたる',
  'きんたん',
  'きんだん',
  'きんちょ',
  'きんつう',
  'きんつぎ',
  'きんつば',
  'きんてい',
  'きんでい',
  'ぎんでい',
  'きんてき',
  'ぎんてき',
  'きんてつ',
  'きんてん',
  'きんとう',
  'きんとき',
  'きんどく',
  'きんとと',
  'きんどら',
  'きんとれ',
  'ぎんどろ',
  'きんとん',
  'きんなら',
  'ぎんなん',
  'きんにく',
  'ぎんねず',
  'きんねん',
  'きんのう',
  'きんばい',
  'きんぱい',
  'ぎんぱい',
  'きんばえ',
  'ぎんばえ',
  'きんばく',
  'きんぱく',
  'ぎんばく',
  'ぎんぱく',
  'きんぱち',
  'きんぱっ',
  'きんぱつ',
  'ぎんぱつ',
  'きんばと',
  'きんぱぷ',
  'きんぱら',
  'きんばり',
  'きんばん',
  'ぎんばん',
  'きんぴか',
  'きんぴら',
  'きんひん',
  'きんぴん',
  'きんぶち',
  'ぎんぶち',
  'きんぶな',
  'ぎんぶな',
  'きんぷら',
  'ぎんぶら',
  'きんぶん',
  'きんぷん',
  'ぎんぷん',
  'きんべん',
  'きんぺん',
  'きんぼう',
  'きんぽう',
  'きんぼし',
  'きんまく',
  'ぎんまく',
  'きんまん',
  'きんみつ',
  'きんむい',
  'きんむく',
  'きんむち',
  'ぎんむつ',
  'ぎんめん',
  'きんもう',
  'きんもー',
  'きんもじ',
  'ぎんもじ',
  'きんもつ',
  'きんやく',
  'きんゆう',
  'きんよう',
  'ぎんよう',
  'きんよく',
  'ぎんよく',
  'きんらい',
  'きんらめ',
  'きんらん',
  'きんりん',
  'ぎんりん',
  'きんるい',
  'きんれい',
  'ぎんれい',
  'きんろう',
  'ぎんろう',
  'くあっが',
  'くあっは',
  'ぐあなこ',
  'ぐあにん',
  'ぐあやく',
  'くいあー',
  'くいあい',
  'くいあう',
  'くいあげ',
  'くいいじ',
  'くいいる',
  'くぃーん',
  'くいーん',
  'くいうち',
  'くいかけ',
  'くいきる',
  'くいくい',
  'ぐいぐい',
  'くいこみ',
  'くいこむ',
  'くいごろ',
  'くいしろ',
  'くいすぎ',
  'くいぞめ',
  'くいだめ',
  'くいたん',
  'くいつき',
  'くいっく',
  'くいつく',
  'ぐいっと',
  'くいつみ',
  'くいなし',
  'くいにげ',
  'ぐいのみ',
  'くいぶち',
  'くいもの',
  'くうあつ',
  'くういき',
  'ぐういん',
  'くううん',
  'ぐうえい',
  'くーがー',
  'くうかぶ',
  'くうかん',
  'ぐうかん',
  'くーきー',
  'くうきょ',
  'ぐうきょ',
  'ぐうぎん',
  'くうくう',
  'ぐうぐう',
  'ぐーぐー',
  'ぐーぐる',
  'くうぐん',
  'くうけい',
  'くうげき',
  'くうけん',
  'くうげん',
  'ぐうげん',
  'くうこう',
  'くうごう',
  'くうこく',
  'ぐーごる',
  'くうさい',
  'ぐうさく',
  'くうさつ',
  'くうしつ',
  'くうしゃ',
  'くうじゅ',
  'くうしょ',
  'くうしん',
  'ぐうじん',
  'ぐうすう',
  'ぐうすか',
  'ぐーすか',
  'ぐうする',
  'ぐうせい',
  'くうせき',
  'くうせつ',
  'くうせん',
  'くうぜん',
  'ぐうぜん',
  'くうそう',
  'ぐうぞう',
  'くうぞく',
  'くうたい',
  'ぐうたら',
  'ぐーたら',
  'くうだん',
  'くーちん',
  'ぐうっと',
  'くうてい',
  'くーでた',
  'くうでれ',
  'くーでれ',
  'くうてん',
  'くうでん',
  'くうどう',
  'くうはく',
  'くうばく',
  'くうはつ',
  'ぐうはつ',
  'くーはん',
  'ぐーぱん',
  'くうふく',
  'くうぶん',
  'くーへん',
  'くうほう',
  'くーぽん',
  'くうめい',
  'ぐうもく',
  'ぐうゆう',
  'くーらー',
  'ぐーらみ',
  'くうらん',
  'くーりー',
  'くーりえ',
  'くうりき',
  'くうりく',
  'くーるー',
  'ぐーるめ',
  'くうれい',
  'くうれつ',
  'くうろん',
  'くーろん',
  'くぇいく',
  'くえすと',
  'くえない',
  'ぐぇのん',
  'ぐえのん',
  'くえりー',
  'くえんち',
  'くぉうと',
  'くぉーく',
  'くおーく',
  'くぉーた',
  'くおーた',
  'くぉーつ',
  'くおーつ',
  'くぉーと',
  'くおーと',
  'くおりあ',
  'くおんつ',
  'くかくず',
  'くがせん',
  'くかたち',
  'くかだち',
  'くがたち',
  'くぎかい',
  'ぐきぐき',
  'くきちゃ',
  'くきづけ',
  'くぎづけ',
  'くぎぬき',
  'くぎべら',
  'くきょう',
  'くぎょう',
  'くきりし',
  'くぎりし',
  'くぐつし',
  'ぐぐっと',
  'くぐつめ',
  'くぐまる',
  'くぐもる',
  'くぐりど',
  'くけいは',
  'くげしゅ',
  'くげでん',
  'くけぬい',
  'くけばり',
  'ぐげんか',
  'くごころ',
  'くこのみ',
  'くごほう',
  'くさいち',
  'くさいろ',
  'くさがま',
  'くさがめ',
  'くさかり',
  'くさがれ',
  'くさくさ',
  'くさぐさ',
  'くさぐも',
  'くさごえ',
  'くさずり',
  'くさたけ',
  'くさつき',
  'ぐさっと',
  'くさつみ',
  'くさとり',
  'くさのね',
  'くさのは',
  'くさばな',
  'くさはら',
  'くさぶえ',
  'くさぶき',
  'くさふぐ',
  'くさふじ',
  'くさぼけ',
  'くさむす',
  'くさむら',
  'くさもち',
  'くさもの',
  'くさやね',
  'くさやぶ',
  'くさらす',
  'ぐさりと',
  'くされる',
  'くさわけ',
  'くさわら',
  'くしあげ',
  'くしいた',
  'くじうん',
  'くしえら',
  'くしがき',
  'くしがた',
  'くしかつ',
  'くしぎり',
  'ぐしぐし',
  'ぐじぐじ',
  'くしくも',
  'くじける',
  'くじごじ',
  'くしざし',
  'ぐしぬい',
  'くしばこ',
  'くしばん',
  'くじびき',
  'くしやき',
  'くじゃく',
  'ぐじゃく',
  'くしゃみ',
  'ぐしゃり',
  'くしゅう',
  'くじゅう',
  'ぐしゅん',
  'ぐじゅん',
  'くしょう',
  'くじょう',
  'ぐしょう',
  'くじらざ',
  'くずあん',
  'くずいと',
  'くずいも',
  'くずいれ',
  'くずかけ',
  'くずかご',
  'くずきり',
  'くすくす',
  'ぐすぐす',
  'ぐずぐず',
  'くすぐり',
  'くすぐる',
  'くずごめ',
  'くずしじ',
  'くすだま',
  'ぐずつく',
  'くすっと',
  'くずてつ',
  'くずにく',
  'くすねる',
  'くすのき',
  'くすぶる',
  'くすべる',
  'くずまい',
  'くずまゆ',
  'くずもち',
  'くずもの',
  'くすりし',
  'くすりと',
  'くすりや',
  'くすりゆ',
  'くずれる',
  'くせごと',
  'くせして',
  'くせだま',
  'くせっけ',
  'くせのん',
  'くせまい',
  'くせもの',
  'くそあま',
  'くそおけ',
  'くそがき',
  'くそげー',
  'くそすれ',
  'くそだめ',
  'くそたれ',
  'くそつぼ',
  'くそとび',
  'くそばえ',
  'くそぼけ',
  'くそほど',
  'くそまる',
  'くそみそ',
  'くそむし',
  'くそりぷ',
  'くそわた',
  'ぐたいか',
  'ぐたいし',
  'くたかけ',
  'くたくた',
  'くだくだ',
  'ぐたぐた',
  'ぐだぐだ',
  'くだけた',
  'くだける',
  'ください',
  'くださる',
  'くだって',
  'くたばる',
  'くたばれ',
  'くだもの',
  'くだらぬ',
  'くだらん',
  'くちあけ',
  'くちあら',
  'くちいれ',
  'くちうら',
  'くちおも',
  'くちがき',
  'くちかず',
  'くちかせ',
  'くちがね',
  'くちがる',
  'くちきき',
  'くちきり',
  'くちぐせ',
  'くちぐち',
  'ぐちぐち',
  'くちくら',
  'くちこみ',
  'くちさき',
  'くちじり',
  'くちすぎ',
  'くちぞえ',
  'くちだし',
  'くちぢゃ',
  'くちつき',
  'くちづき',
  'くちづけ',
  'くちづて',
  'くちどけ',
  'くちどめ',
  'くちとり',
  'くちなし',
  'くちなわ',
  'くちぬき',
  'くちのは',
  'くちぱく',
  'くちばし',
  'くちばみ',
  'くちばや',
  'くちひげ',
  'くちひも',
  'くちびる',
  'くちぶえ',
  'くちふき',
  'くちぶり',
  'くちべた',
  'くちべに',
  'くちへん',
  'くちぼそ',
  'くちまえ',
  'くちまね',
  'くちまめ',
  'くちもと',
  'くちゃい',
  'ぐちゃり',
  'くちゅう',
  'ぐちゅう',
  'くちょう',
  'ぐちょく',
  'くちよせ',
  'くちわき',
  'くちわけ',
  'くつあと',
  'くついん',
  'くつうら',
  'くつおと',
  'くっかー',
  'くつがた',
  'くつがわ',
  'くっきー',
  'くっきり',
  'くっきん',
  'くっくー',
  'くつくつ',
  'ぐつぐつ',
  'くっさい',
  'くっさく',
  'くっさめ',
  'くっしー',
  'くつした',
  'くっしん',
  'くつずみ',
  'くつずり',
  'ぐっすり',
  'くっする',
  'くつずれ',
  'くっせい',
  'くっせつ',
  'くっそう',
  'くっそか',
  'くつぞこ',
  'くったく',
  'くつたび',
  'ぐったり',
  'くっつき',
  'くっつく',
  'くっとう',
  'くつとり',
  'くつぬぎ',
  'ぐっばい',
  'くつばこ',
  'くつばみ',
  'ぐっぴー',
  'くつひも',
  'くっぴん',
  'くつふき',
  'くっぷく',
  'くつべら',
  'くつもち',
  'くつろぎ',
  'くつろぐ',
  'くつわや',
  'ぐでぐで',
  'くどうき',
  'くどうし',
  'くどくど',
  'くながい',
  'くにいり',
  'くにうど',
  'くにうみ',
  'くにえず',
  'くにがえ',
  'くにがた',
  'くにがら',
  'くにがわ',
  'くにぐに',
  'くにする',
  'くにたみ',
  'くにつこ',
  'くにつち',
  'くになる',
  'くにばら',
  'くにびと',
  'くにぶり',
  'くにべつ',
  'くにます',
  'くにもと',
  'くにもの',
  'くにやむ',
  'くにゃり',
  'ぐにゃり',
  'ぐにゅー',
  'くねくね',
  'ぐねぐね',
  'くねらす',
  'くのいち',
  'ぐのもん',
  'くはんだ',
  'くばんだ',
  'くびかせ',
  'くびかみ',
  'くびかり',
  'くびがり',
  'くびきり',
  'くびきる',
  'ぐびぐび',
  'くびすじ',
  'くびづか',
  'くびつき',
  'くびっと',
  'くびつり',
  'くびなげ',
  'くびなし',
  'くびひも',
  'くびまき',
  'くびもと',
  'くひゃく',
  'くびれる',
  'ぐぶぐぶ',
  'ぐぶそう',
  'くぼまる',
  'くぼめる',
  'くまあり',
  'くまかし',
  'くまがし',
  'くまがり',
  'くまぐま',
  'くまげら',
  'くまざさ',
  'くましで',
  'くますず',
  'くまぜみ',
  'くまたか',
  'くまどり',
  'くまどる',
  'くまなく',
  'くまなべ',
  'くまにく',
  'くまねこ',
  'くまのい',
  'くまのみ',
  'くまばち',
  'くまむし',
  'くまもと',
  'くまりん',
  'くみあい',
  'くみあう',
  'くみいと',
  'くみいれ',
  'くみいん',
  'くみうた',
  'くみうち',
  'くみおき',
  'くみかえ',
  'くみかた',
  'くみこう',
  'くみこみ',
  'くみこむ',
  'くみしく',
  'くみした',
  'くみする',
  'くみだす',
  'くみたて',
  'くみつく',
  'くみつけ',
  'くみとり',
  'くみとる',
  'くみはん',
  'くみひも',
  'くみふだ',
  'ぐみべあ',
  'くみほす',
  'くみもじ',
  'くみもの',
  'くみわけ',
  'くめうた',
  'くもあい',
  'くもあし',
  'くもがい',
  'くもがた',
  'くもがに',
  'くもぎれ',
  'くもこう',
  'くもざる',
  'くもすけ',
  'くもつく',
  'くもなく',
  'くものこ',
  'くものす',
  'くもはぜ',
  'くもまく',
  'くもみず',
  'くもゆき',
  'くもらす',
  'くもらん',
  'くもりど',
  'くもるい',
  'くやしい',
  'くやしさ',
  'くゆらす',
  'くよくよ',
  'くらーく',
  'ぐらーと',
  'ぐらーべ',
  'くらーれ',
  'ぐらいこ',
  'くらいと',
  'ぐらいむ',
  'くらいり',
  'くらいれ',
  'くらうち',
  'くらうど',
  'ぐらうと',
  'くらうん',
  'くらがえ',
  'くらがり',
  'くらくら',
  'ぐらぐら',
  'ぐらごる',
  'くらさば',
  'ぐらさん',
  'くらしき',
  'くらした',
  'くらじり',
  'ぐらしん',
  'くらすた',
  'くらすと',
  'くらすぷ',
  'くらずれ',
  'くらだし',
  'ぐらたん',
  'ぐらちぇ',
  'くらっか',
  'くらっく',
  'ぐらつく',
  'ぐらっし',
  'ぐらっせ',
  'くらっち',
  'くらっと',
  'くらっど',
  'ぐらっと',
  'ぐらっぱ',
  'くらとむ',
  'ぐらどる',
  'くらとん',
  'ぐらにた',
  'ぐらにて',
  'くらぬし',
  'くらばー',
  'くらびあ',
  'ぐらびあ',
  'くらびと',
  'くらふと',
  'くらべる',
  'ぐらべる',
  'くらぼね',
  'ぐらまー',
  'くらまい',
  'くらます',
  'ぐらみー',
  'ぐらみん',
  'くらもと',
  'くらもの',
  'くらやみ',
  'くらりす',
  'くらわす',
  'くらんく',
  'くらんけ',
  'ぐらんじ',
  'ぐらんす',
  'くらんち',
  'ぐらんで',
  'くらんど',
  'ぐらんと',
  'ぐらんど',
  'ぐらんぱ',
  'くらんぷ',
  'ぐらんま',
  'くりあー',
  'くりあげ',
  'くりーく',
  'ぐりーく',
  'くりいし',
  'ぐりーす',
  'くりいと',
  'くりーと',
  'くりーぷ',
  'ぐりーふ',
  'くりーむ',
  'くりいれ',
  'くりいろ',
  'くりーん',
  'ぐりーん',
  'くりうめ',
  'ぐりおー',
  'くりおね',
  'くりかた',
  'くりから',
  'くりくり',
  'ぐりぐり',
  'くりこし',
  'くりこす',
  'くりごと',
  'くりこみ',
  'くりこむ',
  'くりこん',
  'くりさげ',
  'くりしぇ',
  'ぐりしん',
  'くりすと',
  'くりそつ',
  'くりだす',
  'ぐりちゃ',
  'くりっく',
  'ぐりっち',
  'くりっと',
  'ぐりっと',
  'ぐりっど',
  'くりっぷ',
  'ぐりっぷ',
  'ぐりっろ',
  'くりとる',
  'くりぬく',
  'くりのべ',
  'くりびあ',
  'くりふだ',
  'くりぷと',
  'くりふね',
  'くりぶね',
  'くりぷれ',
  'くりめし',
  'ぐりもあ',
  'くりもの',
  'くりやー',
  'くりゃる',
  'くりわた',
  'ぐりんご',
  'くりんち',
  'くりんぷ',
  'ぐるいん',
  'ぐるーゔ',
  'くるーず',
  'くるーそ',
  'くるーぷ',
  'ぐるーぷ',
  'ぐるおん',
  'ぐるくま',
  'くるくる',
  'ぐるぐる',
  'ぐるじあ',
  'くるしい',
  'くるしさ',
  'くるしみ',
  'くるしむ',
  'ぐるちゃ',
  'くるっと',
  'ぐるっと',
  'くるっぷ',
  'ぐるてん',
  'ぐるでん',
  'くるどご',
  'くるとし',
  'くるとん',
  'ぐるにえ',
  'くるぶし',
  'くるまざ',
  'くるまぶ',
  'くるまや',
  'くるまる',
  'ぐるまん',
  'くるみか',
  'くるみゆ',
  'くるめく',
  'くるめる',
  'ぐるりと',
  'くるるぎ',
  'くるるど',
  'くるわす',
  'ぐれいす',
  'ぐれいと',
  'ぐれいど',
  'ぐれいぶ',
  'くれいむ',
  'ぐれいん',
  'ぐれーず',
  'くれーた',
  'くれーど',
  'ぐれーと',
  'ぐれーど',
  'くれーぷ',
  'ぐれーぷ',
  'くれーむ',
  'ぐれーら',
  'くれーん',
  'ぐれーん',
  'くれおめ',
  'くれがた',
  'くれぐれ',
  'くれさら',
  'くれすと',
  'くれそん',
  'くれたけ',
  'ぐれっぷ',
  'くれない',
  'ぐれなだ',
  'くればー',
  'くればす',
  'くれぱす',
  'くれむつ',
  'くれめも',
  'くれゆく',
  'くれよん',
  'くれんず',
  'くれんめ',
  'くろあざ',
  'くろあり',
  'くろいし',
  'くろいぬ',
  'くろいめ',
  'くろいろ',
  'くろうし',
  'くろうと',
  'くろうど',
  'ぐろーゔ',
  'くろーく',
  'くろーす',
  'くろーず',
  'ぐろーす',
  'くろーな',
  'くろーね',
  'くろーば',
  'くろおび',
  'くろーぶ',
  'ぐろーぶ',
  'くろーむ',
  'くろーら',
  'くろーる',
  'くろーん',
  'くろかげ',
  'くろがし',
  'くろかす',
  'くろがね',
  'くろかび',
  'くろかみ',
  'くろがも',
  'くろかわ',
  'くろかん',
  'くろぎぬ',
  'くろくま',
  'くろぐま',
  'くろくも',
  'くろぐも',
  'くろぐろ',
  'くろこげ',
  'くろごま',
  'くろごめ',
  'くろさい',
  'くろさぎ',
  'くろざる',
  'くろしぇ',
  'くろしお',
  'くろじか',
  'くろしゅ',
  'くろしろ',
  'くろずみ',
  'くろずむ',
  'くろそい',
  'くろだい',
  'くろたま',
  'くろだま',
  'くろちく',
  'くろちゃ',
  'くろっく',
  'ぐろっぐ',
  'ぐろっけ',
  'くろっち',
  'くろつち',
  'くろっぷ',
  'くろづる',
  'くろてん',
  'くろとう',
  'くろとん',
  'くろにく',
  'くろぬり',
  'くろねこ',
  'くろのす',
  'くろばー',
  'くろはえ',
  'くろばえ',
  'くろはぎ',
  'くろばむ',
  'くろばん',
  'くろぱん',
  'くろひげ',
  'ぐろびん',
  'くろふく',
  'くろぶさ',
  'くろふだ',
  'くろぶた',
  'くろぶち',
  'くろふね',
  'くろへび',
  'くろぼく',
  'くろぼこ',
  'くろぼし',
  'くろまい',
  'くろまく',
  'くろまつ',
  'くろまめ',
  'くろまる',
  'くろみつ',
  'くろむぎ',
  'くろめる',
  'くろもじ',
  'くろやき',
  'くろやけ',
  'くろやま',
  'くろゆり',
  'くろらか',
  'ぐろりあ',
  'くろれら',
  'くろろり',
  'くろわく',
  'くろんぼ',
  'くわいあ',
  'くわいや',
  'くわいれ',
  'くわいろ',
  'くわえて',
  'くわえる',
  'くわがた',
  'くわしい',
  'くわしく',
  'くわせる',
  'くわだて',
  'くわっが',
  'くわっと',
  'くわつみ',
  'くわばた',
  'くわばら',
  'くわれる',
  'くわわる',
  'くわんざ',
  'くをきる',
  'くんいく',
  'ぐんえい',
  'ぐんえき',
  'くんえん',
  'くんおん',
  'くんかい',
  'ぐんかく',
  'ぐんがく',
  'くんがな',
  'ぐんかん',
  'ぐんきち',
  'ぐんきょ',
  'くんくん',
  'ぐんぐん',
  'ぐんけい',
  'くんげん',
  'ぐんけん',
  'くんこう',
  'ぐんこう',
  'くんこく',
  'ぐんこく',
  'ぐんこん',
  'くんさい',
  'ぐんさい',
  'ぐんざん',
  'ぐんじか',
  'ぐんじひ',
  'ぐんしゃ',
  'くんしゅ',
  'ぐんしゅ',
  'ぐんじゅ',
  'ぐんしょ',
  'くんじる',
  'くんしん',
  'ぐんしん',
  'ぐんじん',
  'くんずる',
  'くんせい',
  'ぐんせい',
  'ぐんぜい',
  'ぐんせき',
  'くんせん',
  'くんぜん',
  'ぐんせん',
  'ぐんそう',
  'ぐんぞう',
  'くんそく',
  'ぐんそく',
  'ぐんぞく',
  'ぐんそつ',
  'ぐんたい',
  'ぐんだり',
  'くんたん',
  'ぐんだん',
  'くんづけ',
  'くんてき',
  'くんてん',
  'くんでん',
  'くんとう',
  'くんどう',
  'ぐんとう',
  'ぐんどう',
  'くんどく',
  'くんない',
  'ぐんなり',
  'くんにく',
  'ぐんばい',
  'ぐんばつ',
  'ぐんぱつ',
  'くんふー',
  'くんぷう',
  'ぐんぷく',
  'ぐんぺい',
  'ぐんぼう',
  'ぐんぽう',
  'ぐんまー',
  'くんみん',
  'ぐんみん',
  'くんめい',
  'ぐんもう',
  'ぐんもん',
  'ぐんやく',
  'ぐんゆう',
  'ぐんよう',
  'くんよみ',
  'ぐんらく',
  'ぐんりつ',
  'ぐんりょ',
  'くんりん',
  'くんれい',
  'ぐんれい',
  'ぐんれき',
  'くんれん',
  'くんろく',
  'ぐんろん',
  'けあがり',
  'けあげる',
  'げあんご',
  'けいあい',
  'けいあん',
  'けいいぎ',
  'げいいき',
  'けいいど',
  'けいいん',
  'げいいん',
  'けいうん',
  'けいえい',
  'けいえん',
  'げいえん',
  'けいおう',
  'けいおす',
  'げいおん',
  'けいかー',
  'けいかい',
  'けいがい',
  'けいかく',
  'けいがく',
  'けいがし',
  'けいかん',
  'けいがん',
  'けいきょ',
  'けいきん',
  'けいぎん',
  'けいぐん',
  'けいけい',
  'けいげき',
  'げいげき',
  'けいけつ',
  'けいげつ',
  'けいけん',
  'けいげん',
  'けいこう',
  'けいごう',
  'げいごう',
  'けいこぎ',
  'けいこく',
  'けいごく',
  'けいこつ',
  'げいこつ',
  'げいごと',
  'けいこば',
  'けいこび',
  'けいさい',
  'けいざい',
  'けいさく',
  'けいさつ',
  'けいさん',
  'けいじか',
  'けいしき',
  'けいしく',
  'けいしつ',
  'けいじつ',
  'けいしゃ',
  'げいしゃ',
  'けいしゅ',
  'けいじゅ',
  'げいしゅ',
  'けいしょ',
  'けいじょ',
  'けいしん',
  'けいじん',
  'けいすい',
  'けいずい',
  'けいすう',
  'けいする',
  'けいせい',
  'けいせき',
  'けいせつ',
  'けいせん',
  'けいぜん',
  'げいせん',
  'けいそう',
  'けいぞう',
  'けいそく',
  'けいぞく',
  'けいそつ',
  'けいそん',
  'けいぞん',
  'けいたい',
  'けいだい',
  'げいだい',
  'けいたく',
  'けいたん',
  'げいだん',
  'けいちつ',
  'けいつい',
  'けいつね',
  'けいてい',
  'けいてき',
  'けいてん',
  'けいでん',
  'けいとう',
  'けいどう',
  'げいとう',
  'げいどう',
  'けいどく',
  'けいとら',
  'けいどろ',
  'げいなし',
  'けいなり',
  'けいにく',
  'げいにく',
  'げいにん',
  'けいねん',
  'げいのう',
  'けいぱー',
  'げいばー',
  'けいはい',
  'けいばい',
  'けいはく',
  'けいばく',
  'けいはつ',
  'けいばつ',
  'けいはん',
  'けいばん',
  'けいびき',
  'けいひち',
  'けいひつ',
  'けいひん',
  'けいびん',
  'げいひん',
  'けいふう',
  'げいふう',
  'けいふく',
  'けいぶつ',
  'けいふぼ',
  'けいぶほ',
  'けいふん',
  'げいぶん',
  'けいへき',
  'けいべつ',
  'けいべん',
  'けいほう',
  'けいぼう',
  'けいまい',
  'けいみん',
  'けいむぶ',
  'けいめい',
  'げいめい',
  'げいめん',
  'けいもう',
  'けいもん',
  'けいやく',
  'けいゆう',
  'けいゆち',
  'けいよう',
  'けいよん',
  'けいらく',
  'けいらん',
  'けいりか',
  'けいりく',
  'けいりし',
  'けいりつ',
  'けいりぶ',
  'げいりぶ',
  'けいりん',
  'げいりん',
  'けいるい',
  'げいるい',
  'けいれい',
  'けいれき',
  'げいれき',
  'けいれつ',
  'けいれん',
  'けいろう',
  'げいろう',
  'けいわい',
  'けいわく',
  'けいわん',
  'けーおー',
  'けーおす',
  'げーおた',
  'けーきや',
  'げえげえ',
  'げーげー',
  'けーげる',
  'げえずご',
  'げーずご',
  'げーせん',
  'けーそん',
  'けーたい',
  'けーてん',
  'げーとる',
  'けーどろ',
  'けーぱー',
  'けーばん',
  'けーぴー',
  'けーぶる',
  'げーまー',
  'げーむか',
  'げーむき',
  'げーむさ',
  'げーるご',
  'けーわい',
  'けおとす',
  'けかあみ',
  'けかえし',
  'けかえす',
  'げかがく',
  'けががち',
  'けがにん',
  'けがまけ',
  'けがれる',
  'げきあつ',
  'げきあま',
  'げきうま',
  'げきえつ',
  'げきかい',
  'げきかた',
  'げきから',
  'げきかわ',
  'げきけい',
  'げきけん',
  'げきげん',
  'げきこう',
  'げきこみ',
  'げきさい',
  'げきざい',
  'げきさく',
  'げきしゃ',
  'げきしょ',
  'げきしん',
  'げきじん',
  'げきする',
  'げきせき',
  'げきぜつ',
  'げきせん',
  'げきぜん',
  'げきそう',
  'げきぞう',
  'げきたい',
  'げきだか',
  'げきたく',
  'げきだん',
  'げきちん',
  'げきつい',
  'げきつう',
  'げきてき',
  'げきてつ',
  'げきとう',
  'げきどう',
  'げきどく',
  'げきとつ',
  'げきはく',
  'げきはつ',
  'げきばん',
  'げきひく',
  'げきぶつ',
  'げきふん',
  'げきぶん',
  'げきへん',
  'げきむず',
  'げきめつ',
  'げきやく',
  'げきやす',
  'げきょう',
  'けぎらい',
  'げきりょ',
  'げきりん',
  'げきれい',
  'げきれつ',
  'げきろう',
  'げきろん',
  'げこげこ',
  'けごろも',
  'げざうた',
  'けさがけ',
  'けさがた',
  'けさぎり',
  'けしいん',
  'けしかす',
  'けしくず',
  'げじげじ',
  'けしこみ',
  'けしごむ',
  'げしさい',
  'けしさる',
  'けしずみ',
  'げしせん',
  'けしつぶ',
  'けしつぼ',
  'げしてん',
  'けしとぶ',
  'げしゅく',
  'けじゅす',
  'げじゅん',
  'けしょう',
  'けじょう',
  'げしょう',
  'げじょう',
  'けじらみ',
  'けしんご',
  'げすばる',
  'けずれる',
  'げせない',
  'げそくば',
  'げそげそ',
  'げそこん',
  'けたあげ',
  'けたいち',
  'けたおす',
  'けたおち',
  'けだかい',
  'げたがけ',
  'けたぐり',
  'けたけた',
  'げたげた',
  'げだげだ',
  'けたした',
  'けたすう',
  'けたてる',
  'げたばき',
  'げたばこ',
  'けたばし',
  'げたばん',
  'けたみん',
  'けだもの',
  'けだらけ',
  'けだるい',
  'けちえん',
  'けちがん',
  'けちけち',
  'けちゅあ',
  'げちゅう',
  'けちょう',
  'けちらす',
  'けちんぼ',
  'けつあご',
  'けつあつ',
  'けついん',
  'げつうん',
  'けつえい',
  'げつえい',
  'けつえき',
  'けつえん',
  'げつおう',
  'けっかい',
  'けっかく',
  'げつがく',
  'げっかに',
  'けっかん',
  'けつがん',
  'げっかん',
  'けっきょ',
  'けっきん',
  'げっきん',
  'げつきん',
  'けっけい',
  'げっけい',
  'けつげき',
  'けつげん',
  'げっけん',
  'けっこう',
  'けつごう',
  'げっこう',
  'けっこん',
  'けっさい',
  'けっさく',
  'けっさつ',
  'けっさん',
  'げっさん',
  'けつじつ',
  'けっして',
  'けっしゃ',
  'げっしゃ',
  'けっしゅ',
  'けっしょ',
  'けつじょ',
  'けっしん',
  'けつじん',
  'げっしん',
  'けっすい',
  'けっする',
  'けっせい',
  'けつぜい',
  'けっせき',
  'けっせつ',
  'けつぜつ',
  'けっせん',
  'けつぜん',
  'けっそう',
  'けつぞう',
  'げっそう',
  'けっそく',
  'けつぞく',
  'げっそり',
  'けっそん',
  'げったー',
  'けったい',
  'けったく',
  'けったん',
  'けつだん',
  'げったん',
  'けっちん',
  'げっつー',
  'けってい',
  'けってき',
  'けってん',
  'けっとう',
  'げっとう',
  'げっとー',
  'けっとる',
  'げつない',
  'けつにく',
  'けっぱー',
  'けっぱい',
  'けっぱく',
  'けっぱつ',
  'けつばん',
  'けっぱん',
  'けつびん',
  'けっぴん',
  'けつぶつ',
  'けつぶん',
  'けっぺい',
  'げっぺい',
  'けっぺき',
  'けつべつ',
  'けつべん',
  'けつぼう',
  'げっぽう',
  'けっぽん',
  'けつまく',
  'けつまつ',
  'げつまつ',
  'けつめい',
  'げつめい',
  'けつめど',
  'げつめん',
  'けつもち',
  'げつよう',
  'けつよく',
  'けつらく',
  'げつりん',
  'けつるい',
  'けつれい',
  'げつれい',
  'けつれつ',
  'けつろん',
  'げてもの',
  'けとーす',
  'けとーる',
  'けとさん',
  'けとばす',
  'けとんき',
  'げにゅう',
  'げねぷろ',
  'けばけば',
  'げばさき',
  'けばたき',
  'けばだつ',
  'けはなし',
  'けはなす',
  'けはらい',
  'けばらい',
  'げばると',
  'けびいし',
  'けびょう',
  'けふぃあ',
  'けぶかい',
  'けぶがる',
  'けぶたい',
  'けぺしゅ',
  'けべっく',
  'けぼうし',
  'げほげほ',
  'けみかる',
  'けみすと',
  'けみする',
  'けみょう',
  'けむがる',
  'けむたい',
  'けむだし',
  'けもない',
  'けやぶる',
  'けらげい',
  'けらけら',
  'げらげら',
  'けらざい',
  'げらずり',
  'けらちん',
  'けりこむ',
  'けりだす',
  'げりどめ',
  'げりべん',
  'げりゃく',
  'けるとご',
  'けるなー',
  'けるびむ',
  'けるびん',
  'げるぴん',
  'げるまん',
  'げれいん',
  'げれーん',
  'けれども',
  'げれんで',
  'けれんみ',
  'けろいど',
  'けろけろ',
  'げろげろ',
  'けろしん',
  'けろっと',
  'けわしい',
  'けんあく',
  'げんあく',
  'けんあつ',
  'げんあつ',
  'けんあん',
  'げんあん',
  'けんいき',
  'けんいし',
  'げんいち',
  'けんいん',
  'げんいん',
  'けんうん',
  'げんうん',
  'けんえい',
  'げんえい',
  'けんえき',
  'げんえき',
  'けんえつ',
  'けんえん',
  'げんえん',
  'けんおう',
  'げんおう',
  'けんおん',
  'げんおん',
  'けんかい',
  'けんがい',
  'げんかい',
  'げんがい',
  'げんがか',
  'けんかく',
  'けんがく',
  'げんかく',
  'げんがく',
  'けんがた',
  'けんかつ',
  'けんかん',
  'けんがん',
  'げんかん',
  'けんきょ',
  'げんきょ',
  'けんきん',
  'げんきん',
  'けんぐん',
  'げんくん',
  'げんぐん',
  'けんけい',
  'げんけい',
  'けんげき',
  'けんけつ',
  'げんげつ',
  'けんけん',
  'けんげん',
  'げんげん',
  'けんこう',
  'けんごう',
  'げんこう',
  'げんごう',
  'げんごか',
  'けんこく',
  'げんこく',
  'けんごし',
  'けんこつ',
  'げんこつ',
  'げんごや',
  'けんこん',
  'げんこん',
  'けんさい',
  'けんざい',
  'げんさい',
  'げんざい',
  'けんさき',
  'げんさき',
  'けんさく',
  'げんさく',
  'けんさつ',
  'げんさつ',
  'けんさん',
  'けんざん',
  'げんさん',
  'げんざん',
  'げんじえ',
  'げんしか',
  'けんしき',
  'けんしこ',
  'げんしち',
  'けんじつ',
  'げんしつ',
  'げんじつ',
  'げんじな',
  'けんしゃ',
  'けんじゃ',
  'げんしゃ',
  'けんしゅ',
  'けんじゅ',
  'げんしゅ',
  'けんしょ',
  'けんじょ',
  'げんしょ',
  'けんじる',
  'げんじる',
  'げんしろ',
  'けんしん',
  'けんじん',
  'げんしん',
  'げんじん',
  'けんすい',
  'げんすい',
  'けんすう',
  'げんすう',
  'けんする',
  'けんずる',
  'げんずる',
  'げんすん',
  'けんせい',
  'けんぜい',
  'げんせい',
  'げんぜい',
  'けんせき',
  'げんせき',
  'けんせつ',
  'けんぜつ',
  'げんせつ',
  'けんせん',
  'けんぜん',
  'げんせん',
  'げんぜん',
  'けんそう',
  'けんぞう',
  'げんそう',
  'げんぞう',
  'けんそく',
  'けんぞく',
  'げんそく',
  'げんぞく',
  'けんそん',
  'げんそん',
  'げんぞん',
  'けんたい',
  'けんだい',
  'げんたい',
  'げんだい',
  'けんだか',
  'げんだか',
  'けんだく',
  'げんたつ',
  'けんだま',
  'けんたん',
  'げんたん',
  'げんだん',
  'げんちか',
  'けんちき',
  'けんちく',
  'げんちく',
  'げんちご',
  'けんちじ',
  'げんちし',
  'けんちつ',
  'けんちゃ',
  'げんちゃ',
  'けんちょ',
  'げんちょ',
  'けんちん',
  'げんつき',
  'けんつく',
  'けんてい',
  'げんてい',
  'けんてつ',
  'げんてつ',
  'けんてん',
  'けんでん',
  'げんてん',
  'けんとう',
  'けんどう',
  'げんとう',
  'げんどう',
  'けんとく',
  'げんとく',
  'けんとし',
  'けんない',
  'けんなた',
  'げんなま',
  'げんなり',
  'けんなん',
  'げんにく',
  'けんにょ',
  'けんにん',
  'げんにん',
  'けんねつ',
  'けんねる',
  'けんのう',
  'げんのう',
  'けんのん',
  'けんぱい',
  'げんぱい',
  'けんぱき',
  'けんぱく',
  'げんばく',
  'げんばつ',
  'げんぱつ',
  'けんばん',
  'げんばん',
  'げんぱん',
  'けんびき',
  'けんぴつ',
  'けんぴん',
  'げんびん',
  'げんぴん',
  'げんぷう',
  'げんぶく',
  'げんぷく',
  'けんぶつ',
  'げんぶつ',
  'けんぶん',
  'げんぶん',
  'けんべい',
  'けんぺい',
  'げんぺい',
  'けんべつ',
  'けんべん',
  'けんぼう',
  'けんぽう',
  'げんほう',
  'げんぽう',
  'けんぼく',
  'げんぼく',
  'けんぽん',
  'げんぽん',
  'げんまい',
  'けんまき',
  'けんまく',
  'けんまし',
  'げんまつ',
  'げんまん',
  'げんみつ',
  'けんみん',
  'げんみん',
  'けんむじ',
  'けんめい',
  'げんめい',
  'げんめつ',
  'けんめん',
  'げんめん',
  'けんもう',
  'げんもう',
  'けんもつ',
  'けんもん',
  'げんもん',
  'けんやく',
  'げんやく',
  'けんゆう',
  'げんゆう',
  'けんよう',
  'げんよう',
  'けんよく',
  'けんらん',
  'けんりつ',
  'げんりつ',
  'けんりょ',
  'けんりん',
  'けんるい',
  'けんれい',
  'けんれん',
  'けんろう',
  'げんろう',
  'げんろく',
  'けんろん',
  'げんろん',
  'げんわく',
  'けんわん',
  'こあがり',
  'こあくま',
  'こあけい',
  'こあたり',
  'こあまも',
  'こあみざ',
  'こあるき',
  'ごあんす',
  'こいうた',
  'こいかぜ',
  'こいかつ',
  'こいかわ',
  'こいぐさ',
  'こいくち',
  'こいぐち',
  'こいこい',
  'ごいさぎ',
  'こいさん',
  'こいしい',
  'こいじに',
  'ごいすー',
  'こいする',
  'こいぞく',
  'こいたす',
  'こいちゃ',
  'こいづか',
  'こいづま',
  'こいつら',
  'ごいてき',
  'こいとす',
  'こいとる',
  'こいなか',
  'こいぬざ',
  'こいねー',
  'こいねこ',
  'こいばな',
  'こいはん',
  'こいひげ',
  'こいびと',
  'こいぶみ',
  'こいほう',
  'こいまり',
  'こいみず',
  'こいむこ',
  'こいもく',
  'こいやみ',
  'ごいろん',
  'こいんし',
  'こうあつ',
  'ごうあと',
  'こうあん',
  'こういう',
  'こういか',
  'こういき',
  'こういた',
  'こういち',
  'こういつ',
  'ごういつ',
  'こういど',
  'こういん',
  'ごういん',
  'ごううか',
  'こううつ',
  'こううん',
  'こうえい',
  'ごうえい',
  'こうえき',
  'こうえつ',
  'こうえん',
  'こうおう',
  'ごうおく',
  'こうおつ',
  'こうおん',
  'ごうおん',
  'こうかい',
  'こうがい',
  'ごうかい',
  'ごうがい',
  'こうかく',
  'こうがく',
  'ごうかく',
  'ごうがく',
  'こうがけ',
  'こうかつ',
  'こうかど',
  'こうかゆ',
  'こうかん',
  'こうがん',
  'ごうかん',
  'ごうがん',
  'こうきど',
  'こうきょ',
  'こうぎょ',
  'ごうきょ',
  'こうきん',
  'こうぎん',
  'ごうきん',
  'こうくう',
  'こうぐう',
  'こうぐし',
  'ごうぐし',
  'こうぐち',
  'ごうぐち',
  'こうくつ',
  'ごうぐみ',
  'こうくり',
  'こうくん',
  'こうぐん',
  'ごうぐん',
  'こうけい',
  'こうげい',
  'ごうけい',
  'こうげき',
  'こうけち',
  'こうけつ',
  'こうげつ',
  'ごうけつ',
  'こうけん',
  'こうげん',
  'ごうけん',
  'こうこう',
  'こうごう',
  'ごうこう',
  'ごうごう',
  'こうごき',
  'こうこく',
  'ごうこく',
  'こうこつ',
  'こうごに',
  'こうこん',
  'ごうこん',
  'こうさい',
  'こうざい',
  'ごうさい',
  'ごうざい',
  'こうさく',
  'こうざく',
  'こうさじ',
  'こうさつ',
  'こうざつ',
  'ごうさつ',
  'こうさん',
  'こうざん',
  'ごうしお',
  'ごうじお',
  'こうしき',
  'こうじき',
  'ごうしき',
  'こうじく',
  'こうした',
  'こうしつ',
  'こうじつ',
  'ごうしつ',
  'こうして',
  'こうしど',
  'こうじひ',
  'こうしゃ',
  'ごうしゃ',
  'こうしゅ',
  'こうじゅ',
  'ごうしゅ',
  'こうしょ',
  'こうじょ',
  'こうじる',
  'こうしん',
  'こうじん',
  'ごうじん',
  'こうすい',
  'こうずい',
  'こうすう',
  'ごうすう',
  'こうずか',
  'こうずけ',
  'こうする',
  'こうずる',
  'ごうする',
  'こうせい',
  'ごうせい',
  'こうせき',
  'ごうせき',
  'こうぜち',
  'こうせつ',
  'こうぜつ',
  'ごうせつ',
  'こうせん',
  'こうぜん',
  'ごうせん',
  'ごうぜん',
  'こうそう',
  'こうぞう',
  'ごうそう',
  'こうそく',
  'こうぞく',
  'ごうぞく',
  'こうそつ',
  'こうそひ',
  'こうそふ',
  'こうそぼ',
  'こうそん',
  'ごうそん',
  'こうたい',
  'こうだい',
  'ごうたい',
  'こうだか',
  'こうたく',
  'こうだく',
  'こうたつ',
  'ごうだつ',
  'こうたん',
  'こうだん',
  'ごうたん',
  'ごうだん',
  'こうちく',
  'こうちし',
  'こうちゃ',
  'こうちょ',
  'ごうちょ',
  'こうちん',
  'ごうちん',
  'こうつう',
  'こうづき',
  'こうづる',
  'こうてい',
  'こうでい',
  'ごうてい',
  'こうてき',
  'ごうてき',
  'こうてつ',
  'こうてん',
  'こうでん',
  'こうとう',
  'こうどう',
  'ごうとう',
  'ごうどう',
  'こうどか',
  'こうとく',
  'こうどく',
  'こうどさ',
  'ごうどる',
  'ごうとれ',
  'こうない',
  'こうなご',
  'こうなん',
  'こうにち',
  'こうにん',
  'こうねい',
  'こうねつ',
  'こうねん',
  'こうのう',
  'ごうのう',
  'こうはい',
  'こうばい',
  'こうはく',
  'こうばく',
  'こうばこ',
  'こうばし',
  'こうはつ',
  'ごうばつ',
  'こうばな',
  'ごうはら',
  'こうはん',
  'こうばん',
  'ごうはん',
  'ごうばん',
  'こうびき',
  'こうひつ',
  'ごうひつ',
  'こうびん',
  'こうふう',
  'こうふか',
  'こうふく',
  'ごうふく',
  'こうふだ',
  'こうぶち',
  'こうぶつ',
  'こうふり',
  'こうぶり',
  'こうふん',
  'こうぶん',
  'こうへい',
  'こうべい',
  'こうへき',
  'こうべつ',
  'こうへん',
  'こうべん',
  'ごうべん',
  'こうほう',
  'こうぼう',
  'ごうほう',
  'こうぼく',
  'こうほち',
  'こうほね',
  'こうほん',
  'こうぼん',
  'こうまい',
  'ごうまい',
  'こうまく',
  'こうまざ',
  'ごうまつ',
  'こうまん',
  'ごうまん',
  'こうみつ',
  'こうみん',
  'こうむる',
  'こうめい',
  'こうもう',
  'ごうもう',
  'こうもく',
  'こうもり',
  'こうもん',
  'ごうもん',
  'こうやく',
  'こうゆう',
  'ごうゆう',
  'こうよう',
  'こうよく',
  'ごうよく',
  'こうらい',
  'こうらく',
  'こうらん',
  'ごうりか',
  'こうりき',
  'ごうりき',
  'こうりつ',
  'こうりね',
  'こうりょ',
  'こうりん',
  'ごうりん',
  'こうるい',
  'こうれい',
  'ごうれい',
  'こうれつ',
  'こうれん',
  'こうろう',
  'こうろく',
  'こうろん',
  'こうわか',
  'こうわく',
  'こうわん',
  'ごうわん',
  'ごえいか',
  'こえいご',
  'こえおけ',
  'こえかけ',
  'こえくみ',
  'こえごえ',
  'こえたご',
  'こえだめ',
  'こえつち',
  'こえつぼ',
  'こえとり',
  'こーぎー',
  'こーくす',
  'ごーぐる',
  'ごーごー',
  'こーさご',
  'こーしぇ',
  'こーしゃ',
  'こーすと',
  'ごーすと',
  'こーちや',
  'こーちん',
  'ごーつー',
  'こーどか',
  'こおとこ',
  'ごーとご',
  'こーとし',
  'こーどち',
  'こおどり',
  'こーなー',
  'こーにす',
  'こーぱい',
  'こーぱす',
  'こーぱる',
  'こーひー',
  'ごーふぁ',
  'こーぷす',
  'ごーふる',
  'ごおやあ',
  'ごーやー',
  'こーゆー',
  'こおらす',
  'こーらす',
  'こーらる',
  'ごーらる',
  'こーらん',
  'ごーりー',
  'こおりや',
  'こーるど',
  'ごーるど',
  'ごーれむ',
  'こーれる',
  'こおろぎ',
  'こーんず',
  'こおんな',
  'こがぁな',
  'こがあな',
  'こがーな',
  'こかいん',
  'こがえり',
  'こがくれ',
  'こがしら',
  'こがたか',
  'ごがたき',
  'こがたな',
  'ごかねん',
  'こかのき',
  'こかばん',
  'こがめん',
  'ごかもん',
  'こがらし',
  'こがれる',
  'こがわせ',
  'ごかんき',
  'こぎいた',
  'こきーゆ',
  'こきーる',
  'こきいろ',
  'ごきげん',
  'こきこう',
  'こきざみ',
  'こぎだす',
  'こぎって',
  'こぎつね',
  'ごきづる',
  'こきでん',
  'ごきない',
  'こぎのこ',
  'ごきぶり',
  'こきゃく',
  'ごぎゃく',
  'こぎゃる',
  'こきゅー',
  'こきゅう',
  'ごぎゅう',
  'こきょう',
  'こきよう',
  'こぎよう',
  'ごきょう',
  'ごぎょう',
  'こきょく',
  'こきりこ',
  'こぎれい',
  'こきろく',
  'こくあく',
  'ごくあく',
  'ごくあつ',
  'こくあん',
  'こくいん',
  'ごくいん',
  'こくうん',
  'こくーん',
  'こくえい',
  'こくえき',
  'こくえん',
  'こくおう',
  'こくおん',
  'こくがい',
  'こくがく',
  'こくかん',
  'こくがん',
  'ごくかん',
  'こくぐう',
  'こくぐら',
  'こくぐん',
  'ごくげつ',
  'こくげん',
  'こくごう',
  'こくごか',
  'こくこく',
  'ごくごく',
  'こくさい',
  'こくさく',
  'こくさん',
  'こくしつ',
  'ごくしゃ',
  'こくしゅ',
  'こくしょ',
  'ごくしょ',
  'こくじら',
  'こくじん',
  'こくすい',
  'こぐすり',
  'こくする',
  'こくせい',
  'こくぜい',
  'ごくせい',
  'こくせき',
  'こくせつ',
  'こくせん',
  'こくそう',
  'こくぞう',
  'ごくそう',
  'こくぞく',
  'ごくそく',
  'ごぐそく',
  'ごくそつ',
  'こくたい',
  'こくだい',
  'こくだか',
  'こくたつ',
  'こくたん',
  'こくつぶ',
  'こくてい',
  'こくてつ',
  'こくてる',
  'こくてん',
  'こくでん',
  'こくとう',
  'こくどう',
  'ごくどう',
  'こくない',
  'ごくない',
  'こくなん',
  'こくにん',
  'ごくねち',
  'こくねつ',
  'ごくねつ',
  'こくはく',
  'こくはつ',
  'こくはん',
  'こくばん',
  'こくひん',
  'ごくひん',
  'こくふう',
  'こくふく',
  'ごくぶと',
  'ごくふり',
  'ごくぶり',
  'こくふん',
  'こくぶん',
  'こくべつ',
  'こくへん',
  'こくべん',
  'こくほう',
  'こくぼう',
  'ごくぼそ',
  'こくほん',
  'こくまい',
  'こぐまざ',
  'ごくまれ',
  'ごくみつ',
  'こくみん',
  'こくめい',
  'こくもつ',
  'ごくもん',
  'こくやく',
  'こくゆう',
  'こくらい',
  'こぐらい',
  'ごくらく',
  'こくりこ',
  'こくりつ',
  'こくるい',
  'こぐるま',
  'こくれつ',
  'こくれん',
  'ごくろう',
  'こくろん',
  'こげあと',
  'こけいし',
  'こげーな',
  'ごけぐも',
  'こげこげ',
  'こけざる',
  'こけだま',
  'こげちゃ',
  'こげつき',
  'こげつく',
  'こけっと',
  'こけにわ',
  'ごけにん',
  'こけむし',
  'こけむす',
  'こけもも',
  'こけるい',
  'ごけんは',
  'ごごいち',
  'ここいら',
  'こごえる',
  'ここから',
  'ここじん',
  'ここなつ',
  'ここぬか',
  'ここのえ',
  'ここのか',
  'ここのつ',
  'こごまる',
  'こごめる',
  'ここやし',
  'こごらす',
  'ここりす',
  'こころえ',
  'こごろし',
  'こころす',
  'こころね',
  'こころみ',
  'こころむ',
  'こさーじ',
  'ござある',
  'ごさいえ',
  'こざいく',
  'こさいん',
  'こさえる',
  'こざかな',
  'こざしき',
  'ござしょ',
  'こさずけ',
  'こさっく',
  'ごさどう',
  'ごさはば',
  'ござぶね',
  'こさむい',
  'ごさんけ',
  'ござんす',
  'こしあげ',
  'こしあて',
  'こしあん',
  'こしいた',
  'こしいれ',
  'こじいん',
  'こしぇる',
  'こしおび',
  'こしおれ',
  'こしかき',
  'こしがき',
  'こしかけ',
  'こしかた',
  'こしかべ',
  'こしがみ',
  'ごしごし',
  'こじしざ',
  'こしじろ',
  'ごじしん',
  'こしだか',
  'こしだめ',
  'ごしちご',
  'こしつき',
  'ごしっく',
  'ごじっく',
  'こじつけ',
  'ごしっぷ',
  'こしづよ',
  'こしなげ',
  'こしなた',
  'こしなわ',
  'こしぬけ',
  'こしぬの',
  'こしばい',
  'こしばき',
  'こしばめ',
  'こしばり',
  'こしぱん',
  'こしひも',
  'こしべん',
  'こしぼそ',
  'こしぼね',
  'こしまき',
  'こじまり',
  'こしみの',
  'こしもと',
  'こしもの',
  'こしゃく',
  'こじゃく',
  'ごしゃく',
  'こしゃじ',
  'こしやね',
  'こしゅう',
  'こじゅう',
  'ごしゅう',
  'ごじゅう',
  'こしゅく',
  'ごしゅゆ',
  'ごじゅん',
  'こしょう',
  'こじょう',
  'ごしょう',
  'ごしよう',
  'ごじょう',
  'こしょー',
  'こしょく',
  'こじょく',
  'ごしょく',
  'こしょり',
  'こしよわ',
  'こしらえ',
  'こじらす',
  'こじれる',
  'こしわざ',
  'ごじんか',
  'こじんぎ',
  'ごしんき',
  'こじんご',
  'こじんさ',
  'ごしんぞ',
  'こずかい',
  'こすぷれ',
  'ごすぺる',
  'ごずめず',
  'こすもす',
  'こずるい',
  'こすれる',
  'ごすろり',
  'こせいは',
  'こせがれ',
  'こせきぼ',
  'こせこせ',
  'こせつく',
  'ごせっく',
  'ごせっけ',
  'こせっと',
  'ごせほう',
  'ごせんし',
  'ごせんふ',
  'こそあど',
  'こそあれ',
  'こそゔぉ',
  'こそうさ',
  'こそぐる',
  'こそげる',
  'こそこそ',
  'ごそごそ',
  'こそすれ',
  'こそだて',
  'こぞっこ',
  'こぞって',
  'こそっと',
  'ごそっと',
  'こそどろ',
  'こそばい',
  'ごぞんじ',
  'こだいこ',
  'こだいご',
  'こたいさ',
  'こだいし',
  'こたえる',
  'こだかい',
  'こだから',
  'ごたごた',
  'こだしる',
  'ごたつく',
  'ごたぶん',
  'ごたまぜ',
  'こだわり',
  'こだわる',
  'こちかぜ',
  'こちこち',
  'ごちそう',
  'ごちっく',
  'こちとら',
  'こちどり',
  'こちゃく',
  'こちゅう',
  'ごちゅう',
  'こちょう',
  'ごちょう',
  'こつあげ',
  'こつえし',
  'こつえん',
  'こっかい',
  'こつがい',
  'こづかい',
  'こっかく',
  'こつがく',
  'こっかご',
  'こつがめ',
  'こっから',
  'こつがら',
  'こっかん',
  'ごっかん',
  'こっきり',
  'こっきん',
  'こづくえ',
  'こっくす',
  'こっくり',
  'こづくり',
  'ごっくり',
  'こっくん',
  'ごっくん',
  'こっけい',
  'こっけん',
  'こっこう',
  'こっこく',
  'こつこつ',
  'ごつごつ',
  'こつざい',
  'こつじき',
  'こっしつ',
  'こっしゅ',
  'こつしゅ',
  'こつずい',
  'こっせつ',
  'こつぜん',
  'ごつぜん',
  'こっそう',
  'こっそり',
  'ごっそり',
  'こったー',
  'ごったに',
  'こったん',
  'こっちゃ',
  'ごっちゃ',
  'ごっつい',
  'こつつぼ',
  'こつづみ',
  'こづつみ',
  'こってい',
  'こってり',
  'ごってり',
  'こっとい',
  'こっとう',
  'こつどう',
  'こっとん',
  'こつにく',
  'こつばい',
  'こっぱい',
  'こつばこ',
  'こつばん',
  'こっぷざ',
  'こっぷん',
  'こっへる',
  'こっぺん',
  'こっぽう',
  'こつまく',
  'こつりつ',
  'ごつりつ',
  'こつりん',
  'こつんと',
  'こていし',
  'こていひ',
  'こでいん',
  'こてーじ',
  'こてこて',
  'ごてごて',
  'こてさき',
  'ごてつく',
  'こてなげ',
  'こてはん',
  'こでまり',
  'ごてんい',
  'こてんぐ',
  'こてんご',
  'こてんは',
  'こてんぱ',
  'ことあげ',
  'ごとうか',
  'こどうぐ',
  'ごどうさ',
  'ごとうち',
  'ごとおび',
  'ことかく',
  'ことから',
  'ことがら',
  'こどくし',
  'ごどけん',
  'ことこそ',
  'ことこと',
  'ことごと',
  'こどこど',
  'ごとごと',
  'ことさら',
  'ことぜん',
  'ことだま',
  'ことたる',
  'ことづけ',
  'ことづて',
  'ことづめ',
  'ことてん',
  'こととて',
  'ことども',
  'ことどり',
  'ことなく',
  'ことなし',
  'ことなり',
  'ことなる',
  'ことのえ',
  'ことので',
  'ことのは',
  'ことぶき',
  'ことぶく',
  'ごとべい',
  'ことほぐ',
  'ごとみそ',
  'ことゆえ',
  'ことよす',
  'ことよる',
  'ことよろ',
  'ことわざ',
  'ことわり',
  'ことわる',
  'こなあめ',
  'こないだ',
  'こなくり',
  'こなごな',
  'こなさま',
  'こなすび',
  'こなずみ',
  'こなだに',
  'こなちゃ',
  'こなみそ',
  'こなもち',
  'こなもの',
  'こなもん',
  'こなゆき',
  'こなれる',
  'こにーで',
  'こにいん',
  'こにもつ',
  'ごにゅう',
  'こにりん',
  'こにんず',
  'こねーな',
  'こねくた',
  'こねくと',
  'ごねどく',
  'こねばち',
  'このあと',
  'このいと',
  'ごのいみ',
  'このうえ',
  'このうち',
  'このうれ',
  'このかた',
  'このかみ',
  'このかん',
  'このきみ',
  'このくれ',
  'このころ',
  'このごろ',
  'このさい',
  'このさき',
  'このした',
  'このしゅ',
  'このしろ',
  'このせつ',
  'ごのせん',
  'このたび',
  'このため',
  'このつぎ',
  'このなか',
  'こののち',
  'このひと',
  'このぶん',
  'このへん',
  'このほう',
  'このほか',
  'このほど',
  'このまえ',
  'このまま',
  'このめで',
  'このもと',
  'このよう',
  'このるい',
  'このわた',
  'このんで',
  'ごばいし',
  'こばいや',
  'ごはさん',
  'こばしら',
  'こばしり',
  'こばたん',
  'ごはっと',
  'こばなし',
  'こばなれ',
  'こばねう',
  'ごばらい',
  'こばると',
  'こはるび',
  'ごばんめ',
  'こぴーき',
  'こひさん',
  'こひしつ',
  'こびぜん',
  'こひつか',
  'こひつじ',
  'こびっど',
  'こぴっと',
  'ごひてい',
  'ごひゃく',
  'ごびゅう',
  'こぴゅら',
  'こひょう',
  'こびょう',
  'ごびょう',
  'こふぃん',
  'こぶうし',
  'こぶかい',
  'ごぶがり',
  'ごふくや',
  'こぶくろ',
  'ごぶごぶ',
  'ごぶざき',
  'ごぶさた',
  'こぶだい',
  'こぶちゃ',
  'こぶつき',
  'こぶどう',
  'こふどき',
  'こぷとご',
  'こぶとり',
  'ごふない',
  'こぶまき',
  'ごぶらん',
  'ごぶりん',
  'こぺいか',
  'こべつか',
  'こぺっく',
  'こぺると',
  'こぼうず',
  'ごほうび',
  'ごほうら',
  'こほーと',
  'こほこほ',
  'ごほごほ',
  'ごぼごぼ',
  'こぼしや',
  'こぽりま',
  'こぼると',
  'こぼるど',
  'こぼれる',
  'ごまあえ',
  'こまーす',
  'こまあみ',
  'こまいた',
  'こまいぬ',
  'こまおち',
  'こまかい',
  'こまかく',
  'こまがく',
  'ごまかし',
  'ごまかす',
  'こまがた',
  'こまぎり',
  'こまぎれ',
  'こまくさ',
  'こまくら',
  'こまげた',
  'こまごま',
  'ごまさば',
  'ごましお',
  'ごますり',
  'こまそん',
  'こまだい',
  'こまだむ',
  'ごまたれ',
  'ごまだれ',
  'ごまだん',
  'こまった',
  'こまつな',
  'ごまつぶ',
  'こまとび',
  'こまどり',
  'ごまにざ',
  'こまぬく',
  'こまねく',
  'ごまはぎ',
  'こまぶえ',
  'こまふだ',
  'ごまみそ',
  'こまもの',
  'こまやか',
  'こまゆみ',
  'こまよせ',
  'こまわり',
  'こまんち',
  'こまんど',
  'ごまんと',
  'こみあう',
  'こみいる',
  'ごみいれ',
  'ごみおん',
  'ごみかす',
  'こみかる',
  'こみかれ',
  'ごみくず',
  'こみこみ',
  'ごみごみ',
  'こみじん',
  'こみだし',
  'ごみため',
  'こみっく',
  'こみっと',
  'こみどり',
  'ごみのひ',
  'ごみばこ',
  'こみばす',
  'ごみむし',
  'ごみゃく',
  'ごみょう',
  'こみんか',
  'こみんと',
  'ごむあみ',
  'ごむいん',
  'こむーね',
  'こむかで',
  'こむぎこ',
  'ごむぐつ',
  'ごむしゅ',
  'こむすび',
  'こむすめ',
  'ごむせん',
  'こむそう',
  'ごむだん',
  'ごむとび',
  'ごむなが',
  'ごむのき',
  'ごむのり',
  'ごむびき',
  'ごむひも',
  'ごむべら',
  'ごむまり',
  'こむわん',
  'こめかみ',
  'こめぐら',
  'こめさし',
  'こめつき',
  'こめっと',
  'こめつぶ',
  'こめでぃ',
  'こめぬか',
  'こめびつ',
  'こめへん',
  'こめみせ',
  'こめみそ',
  'こめらん',
  'こめんと',
  'こもーど',
  'こもごも',
  'こもそう',
  'こもぞう',
  'こもどす',
  'こもどり',
  'こもまき',
  'こもれび',
  'こもんず',
  'こやがけ',
  'こやぐみ',
  'こゆうち',
  'こようし',
  'こよーて',
  'こよない',
  'こよなく',
  'こよなし',
  'こらーど',
  'こらーる',
  'こらーん',
  'こらいと',
  'こらえる',
  'こらしめ',
  'こらむし',
  'こりあご',
  'こりあん',
  'こりーだ',
  'こりうす',
  'ごりおし',
  'こりくつ',
  'こりこう',
  'こりこり',
  'こりごり',
  'ごりごり',
  'こりだす',
  'こりつか',
  'こりっく',
  'こりつご',
  'こりつし',
  'ごりっぱ',
  'こりない',
  'ごりやく',
  'こりゅう',
  'ごりょう',
  'ごりんき',
  'ごるごー',
  'ごるごん',
  'ごるじゅ',
  'こるたん',
  'こるふぇ',
  'こるれす',
  'これうす',
  'これから',
  'これかれ',
  'これきり',
  'これぎり',
  'これくた',
  'これくと',
  'これこそ',
  'これこれ',
  'これじお',
  'これしき',
  'これしゃ',
  'これじよ',
  'これだけ',
  'これっと',
  'これでも',
  'これなら',
  'これはと',
  'これほど',
  'これぽん',
  'これまた',
  'これまで',
  'これもち',
  'これもの',
  'これもん',
  'これより',
  'ころあい',
  'ころいど',
  'ころおい',
  'ころがき',
  'ころがし',
  'ころがす',
  'ころがる',
  'ころげる',
  'ころころ',
  'ごろごろ',
  'ころしば',
  'ころしや',
  'ころそま',
  'ごろつき',
  'ごろつく',
  'ころっけ',
  'ころっと',
  'ごろっと',
  'ころっぷ',
  'ころなか',
  'ころにあ',
  'ころにー',
  'ころばす',
  'ころびね',
  'ころぶす',
  'ころもで',
  'ころらど',
  'ごろりと',
  'こわいあ',
  'こわいい',
  'こわいや',
  'こわいろ',
  'こわがり',
  'こわがる',
  'こわごわ',
  'ごわごわ',
  'ごわさん',
  'こわだか',
  'こわたり',
  'ごわつく',
  'こわっぱ',
  'こわばる',
  'こわめし',
  'こわもて',
  'こわゆみ',
  'こわらべ',
  'こわらわ',
  'こわれる',
  'ごわんす',
  'ごをうつ',
  'こんいろ',
  'こんいん',
  'こんおん',
  'こんかい',
  'こんがい',
  'こんかく',
  'こんかつ',
  'こんがり',
  'こんかん',
  'こんがん',
  'こんきょ',
  'こんぐら',
  'こんくり',
  'こんけい',
  'こんけつ',
  'こんげつ',
  'こんけん',
  'こんげん',
  'ごんげん',
  'こんこう',
  'こんごう',
  'こんごご',
  'こんこつ',
  'ごんこつ',
  'こんこん',
  'ごんごん',
  'こんさい',
  'こんざい',
  'ごんさい',
  'こんさく',
  'こんざつ',
  'こんさば',
  'こんさる',
  'こんさん',
  'こんじき',
  'こんじつ',
  'こんしょ',
  'こんじる',
  'こんしん',
  'こんじん',
  'こんすい',
  'ごんずい',
  'ごんすけ',
  'こんすと',
  'こんする',
  'こんずる',
  'こんせい',
  'こんせき',
  'こんせつ',
  'こんぜつ',
  'ごんぜつ',
  'ごんぜめ',
  'こんせん',
  'こんぜん',
  'こんそう',
  'こんそく',
  'こんそめ',
  'こんそん',
  'こんたー',
  'こんたい',
  'こんだく',
  'こんだけ',
  'こんたす',
  'こんたつ',
  'こんだて',
  'こんたみ',
  'こんたん',
  'こんだん',
  'こんちは',
  'こんちゃ',
  'こんちわ',
  'こんてい',
  'こんでい',
  'ごんてき',
  'こんでじ',
  'こんてな',
  'こんでん',
  'ごんでん',
  'こんとう',
  'こんどう',
  'こんとく',
  'こんとら',
  'ごんどら',
  'こんどる',
  'こんとん',
  'こんどん',
  'こんなに',
  'こんなん',
  'こんにち',
  'こんねん',
  'こんぱい',
  'こんぱく',
  'こんぱす',
  'こんぱち',
  'こんぱね',
  'こんばん',
  'こんぱん',
  'こんびに',
  'こんぴら',
  'こんふぃ',
  'こんぷら',
  'こんぶん',
  'こんべあ',
  'こんぺあ',
  'ごんべい',
  'ごんべえ',
  'こんぺき',
  'こんべに',
  'こんべや',
  'ごんべん',
  'こんぼい',
  'こんぼう',
  'こんぽう',
  'こんぽた',
  'こんぼん',
  'こんぽん',
  'こんまけ',
  'こんます',
  'こんまん',
  'こんめい',
  'こんもう',
  'こんもり',
  'こんやく',
  'こんゆう',
  'こんよう',
  'こんよく',
  'こんらん',
  'こんりん',
  'こんれい',
  'こんわく',
  'さーかす',
  'さーくる',
  'ざーこむ',
  'さあさあ',
  'ざあざあ',
  'ざーざー',
  'ざーさい',
  'さーじん',
  'さーせん',
  'さあっと',
  'さーてぃ',
  'ざーねん',
  'さーばー',
  'さーばる',
  'さーびす',
  'さーぶる',
  'さーべい',
  'さーべる',
  'さーまる',
  'さーみご',
  'さーめご',
  'さーめん',
  'ざーめん',
  'さーもす',
  'さーもん',
  'さあらぬ',
  'さいあい',
  'さいあく',
  'ざいあく',
  'さいあん',
  'ざいーる',
  'ざいいん',
  'さいうん',
  'ざいうん',
  'さいえい',
  'ざいえい',
  'さいえき',
  'ざいえき',
  'さいえね',
  'さいえん',
  'ざいえん',
  'さいおう',
  'ざいおう',
  'ざいおき',
  'さいおん',
  'さいかい',
  'さいがい',
  'ざいかい',
  'ざいがい',
  'さいかう',
  'さいかく',
  'さいがく',
  'ざいがく',
  'ざいかた',
  'さいかち',
  'さいかつ',
  'さいかふ',
  'さいかぶ',
  'さいかん',
  'ざいかん',
  'さいきょ',
  'ざいきょ',
  'さいぎる',
  'さいきん',
  'ざいきん',
  'さいぐう',
  'さいくし',
  'さいくつ',
  'さいくる',
  'さいくん',
  'さいけい',
  'さいげい',
  'ざいけい',
  'さいげき',
  'さいけつ',
  'さいげつ',
  'さいけん',
  'さいげん',
  'ざいげん',
  'さいこう',
  'ざいこう',
  'ざいごう',
  'さいこく',
  'さいごく',
  'ざいこく',
  'さいこつ',
  'さいごべ',
  'さいころ',
  'さいこん',
  'さいごん',
  'さいさい',
  'さいさき',
  'さいさく',
  'さいざる',
  'さいさん',
  'ざいさん',
  'さいしき',
  'さいじき',
  'さいしく',
  'さいしつ',
  'さいじつ',
  'ざいしつ',
  'さいして',
  'ざいしゃ',
  'さいしゅ',
  'さいしょ',
  'さいじょ',
  'ざいしょ',
  'さいしん',
  'さいじん',
  'さいすい',
  'ざいすう',
  'さいする',
  'さいすん',
  'さいせい',
  'ざいせい',
  'さいせき',
  'ざいせき',
  'さいせつ',
  'さいせん',
  'さいぜん',
  'さいそう',
  'さいそく',
  'ざいぞく',
  'さいだー',
  'さいたい',
  'さいだい',
  'ざいたい',
  'さいたく',
  'ざいたく',
  'さいたま',
  'さいたる',
  'さいたん',
  'さいだん',
  'ざいだん',
  'さいちく',
  'さいづち',
  'さいつぶ',
  'さいてい',
  'さいてき',
  'ざいてく',
  'さいてす',
  'さいてん',
  'さいでん',
  'ざいてん',
  'さいとう',
  'さいどう',
  'ざいとう',
  'さいとく',
  'さいどく',
  'ざいとく',
  'ざいどく',
  'さいとら',
  'さいとり',
  'さいとん',
  'さいなむ',
  'さいなら',
  'さいなん',
  'さいにち',
  'ざいにち',
  'さいにん',
  'ざいにん',
  'さいねん',
  'さいのう',
  'ざいのう',
  'さいのめ',
  'さいばー',
  'さいはい',
  'さいばい',
  'さいばし',
  'さいはつ',
  'ざいばつ',
  'さいはて',
  'さいばね',
  'さいばら',
  'さいはん',
  'さいばん',
  'ざいはん',
  'ざいばん',
  'さいひつ',
  'さいふく',
  'さいぶつ',
  'ざいぶつ',
  'さいぶん',
  'ざいべい',
  'さいべつ',
  'さいへん',
  'さいべん',
  'さいほう',
  'さいぼう',
  'ざいほう',
  'さいほく',
  'さいほん',
  'ざいまい',
  'さいまき',
  'さいまつ',
  'さいみつ',
  'さいみん',
  'ざいみん',
  'さいめい',
  'ざいめい',
  'さいもく',
  'ざいもく',
  'ざいもつ',
  'さいもん',
  'さいやく',
  'さいやす',
  'さいゆう',
  'さいよう',
  'さいらい',
  'ざいらい',
  'さいらむ',
  'さいらん',
  'さいりん',
  'さいるい',
  'さいれい',
  'さいれつ',
  'さいれん',
  'さいろう',
  'ざいろう',
  'さいろく',
  'さいろん',
  'さいわい',
  'さいわん',
  'ざうめい',
  'ざうるす',
  'さうんだ',
  'さうんど',
  'さえぎる',
  'さえざえ',
  'さえずり',
  'さえずる',
  'さえない',
  'さえゆく',
  'さおさす',
  'さおだけ',
  'さおだち',
  'さおとめ',
  'さおひめ',
  'さおもの',
  'ざかーと',
  'さかいき',
  'さかいめ',
  'さかえる',
  'さかかぜ',
  'さかがめ',
  'さかぐら',
  'さがけん',
  'さかごめ',
  'さかさま',
  'さかしい',
  'さかしお',
  'さがしに',
  'さかしま',
  'さかしら',
  'ざがしら',
  'さかしろ',
  'さかずき',
  'さかせる',
  'さかぞり',
  'さかだい',
  'さかだち',
  'さかだつ',
  'さかだな',
  'さかだる',
  'さかづき',
  'さがつく',
  'さかつぼ',
  'さかどの',
  'さかなぎ',
  'さかなで',
  'さかなみ',
  'さかなや',
  'さかねじ',
  'さかばた',
  'さかびと',
  'さかびん',
  'さかぶた',
  'さかぶね',
  'さかまい',
  'さかまく',
  'さかます',
  'さかまた',
  'さかみせ',
  'さかみち',
  'さかむけ',
  'さかむし',
  'さかもぎ',
  'さかもり',
  'さかやき',
  'さかやけ',
  'さかゆめ',
  'さからう',
  'さかりば',
  'さがりめ',
  'さがれん',
  'さかんに',
  'さかんや',
  'さきいか',
  'さきいき',
  'さきいれ',
  'さきうり',
  'さきおり',
  'さきがい',
  'さきがけ',
  'さきがし',
  'さきかた',
  'さきがた',
  'さきがち',
  'さきがね',
  'さきがり',
  'さきかん',
  'さきくさ',
  'さぎごけ',
  'さきごし',
  'さきごろ',
  'さぎざい',
  'さきざき',
  'さきさま',
  'さきざや',
  'さきずり',
  'さぎそう',
  'さきぞめ',
  'さきだか',
  'さきだし',
  'さきだす',
  'さきだち',
  'さきだつ',
  'さきづけ',
  'さきっぽ',
  'さきどり',
  'さきどる',
  'さきのひ',
  'さきのよ',
  'さきばら',
  'さぎふえ',
  'さきぶと',
  'さきぶれ',
  'さきぼう',
  'さきぼそ',
  'さきほど',
  'さきまけ',
  'さきもの',
  'さきもり',
  'さきやす',
  'さきやま',
  'さきゅう',
  'さきゆき',
  'さぎょう',
  'ざきょう',
  'ざぎょう',
  'さきよみ',
  'さきわけ',
  'さくいん',
  'さくおう',
  'さくがら',
  'ざくぎり',
  'さくげき',
  'さくげん',
  'さくこん',
  'さくさく',
  'ざくざく',
  'さくざつ',
  'さくさん',
  'さくしか',
  'さくじつ',
  'さくしゃ',
  'さくしゅ',
  'さくじょ',
  'さくしん',
  'ざくすか',
  'さくする',
  'さくせい',
  'さくせす',
  'さくせん',
  'さくぜん',
  'さくそう',
  'さくたい',
  'さくつけ',
  'さくづけ',
  'さくてい',
  'さくてき',
  'さくとう',
  'さくどう',
  'さくねん',
  'さくばく',
  'さくばん',
  'さくひん',
  'さくふう',
  'さくぶつ',
  'さくぶん',
  'さくへん',
  'さくほう',
  'さくぼう',
  'さくめい',
  'さくもつ',
  'さくもん',
  'さくやく',
  'さくゆう',
  'さくらく',
  'さくらゆ',
  'さくらん',
  'さくりつ',
  'さくれい',
  'さくれつ',
  'さげあし',
  'さけいか',
  'さけいき',
  'さけかす',
  'さげがみ',
  'さけがめ',
  'さけかん',
  'さけくせ',
  'さけぐせ',
  'さけごめ',
  'さげしお',
  'さけずき',
  'さけずし',
  'さげすみ',
  'さげすむ',
  'さげぜん',
  'さげちん',
  'さけてん',
  'さけのけ',
  'さけのみ',
  'さげはば',
  'さけびと',
  'さけびん',
  'さげふだ',
  'さげふり',
  'さけぶろ',
  'さげまく',
  'さげまん',
  'さけむし',
  'さけやけ',
  'さげゆみ',
  'さげよく',
  'さごやし',
  'ささえる',
  'ささがき',
  'ささがに',
  'ささぐも',
  'ささくれ',
  'ささげる',
  'ささずし',
  'ささたけ',
  'ささっと',
  'ささなき',
  'さざなみ',
  'ささはら',
  'ささぶね',
  'ざざむし',
  'ささめき',
  'さざめき',
  'ささめく',
  'さざめく',
  'ざざめく',
  'ささやか',
  'ささやき',
  'ささやく',
  'ささやぶ',
  'ささゆり',
  'ささらこ',
  'ささわら',
  'さざんか',
  'さしあい',
  'さしあげ',
  'さしあし',
  'さしあみ',
  'さしいと',
  'さしいれ',
  'さしうま',
  'さしおく',
  'さしかえ',
  'さしかけ',
  'さしがさ',
  'さしがた',
  'さしがね',
  'さしがみ',
  'さしがめ',
  'ざしきぎ',
  'さしきず',
  'さしくち',
  'さしぐむ',
  'さしくる',
  'さしごえ',
  'さしこす',
  'さしこみ',
  'さしこむ',
  'さししお',
  'さじずむ',
  'さしずめ',
  'さしぞえ',
  'さしだす',
  'さしたて',
  'さしたる',
  'さしつち',
  'さしづめ',
  'さしでる',
  'さしとめ',
  'さしなわ',
  'さしぬい',
  'さしぬき',
  'さしばえ',
  'さしばし',
  'さしばな',
  'さしひき',
  'さしひく',
  'さしぼう',
  'さしまえ',
  'さしみず',
  'さしもの',
  'さしゅう',
  'さじゅう',
  'さじゅつ',
  'さしょう',
  'さじょう',
  'ざしょう',
  'ざじょう',
  'ざしょく',
  'さすがに',
  'さすがは',
  'さずかる',
  'さすけね',
  'さずける',
  'さすぷろ',
  'さすまた',
  'さすらい',
  'さすらう',
  'さすれば',
  'させつか',
  'させぷろ',
  'さぞかし',
  'さそりざ',
  'さたーん',
  'さたいあ',
  'さたでー',
  'さだはる',
  'さだまり',
  'さだまる',
  'さだめし',
  'さだめて',
  'さだめる',
  'さたやみ',
  'さちある',
  'さちあれ',
  'さちほこ',
  'ざちゅう',
  'ざちょう',
  'さちょく',
  'ざつぃき',
  'さついれ',
  'さつえい',
  'ざつえき',
  'ざつおん',
  'さっかー',
  'さつがい',
  'さっかく',
  'ざつがく',
  'ざつかぶ',
  'ざつがみ',
  'ざっかや',
  'さっかん',
  'ざっかん',
  'さっきょ',
  'ざっきょ',
  'さっきん',
  'ざっきん',
  'さっくす',
  'さっくり',
  'ざっくり',
  'ざつげい',
  'ざっけん',
  'さっこう',
  'ざっこう',
  'ざっこく',
  'さっこん',
  'ざっこん',
  'さっさつ',
  'ざっさん',
  'ざっしき',
  'さっしゅ',
  'ざっしゅ',
  'ざっしょ',
  'さっしん',
  'さつじん',
  'さっすい',
  'さっすう',
  'さつすう',
  'さっする',
  'さっせい',
  'ざつぜい',
  'ざっせつ',
  'ざつぜん',
  'さっそう',
  'さつぞう',
  'ざっそう',
  'さっそく',
  'ざっそく',
  'ざっそん',
  'ざつだい',
  'さつたば',
  'ざつだん',
  'ざっちょ',
  'さっとう',
  'ざっとう',
  'ざつにく',
  'ざつねん',
  'ざつのう',
  'ざつのぶ',
  'ざっぱい',
  'ざっぱく',
  'さつばつ',
  'さっぱり',
  'さっぴく',
  'さっぴつ',
  'さつひと',
  'さつびら',
  'ざっぴん',
  'ざつぶつ',
  'ざつぶん',
  'さっぽう',
  'ざっぽう',
  'ざつぼく',
  'さっぽろ',
  'さつよう',
  'ざつよう',
  'さつりく',
  'ざつろく',
  'さであみ',
  'さておき',
  'さておく',
  'さてこそ',
  'さてさて',
  'さといぬ',
  'さといも',
  'さどうゆ',
  'さとおや',
  'さとかた',
  'さとびと',
  'さとへん',
  'さどまぞ',
  'さとみち',
  'さとむら',
  'さとやま',
  'さとゆき',
  'さながら',
  'さなくば',
  'さならず',
  'さねはぎ',
  'さばおり',
  'さばかり',
  'さばくか',
  'さばくは',
  'さばぐも',
  'さはけい',
  'さばげー',
  'さばける',
  'さばさば',
  'さばとら',
  'さばねこ',
  'さばひい',
  'さばひー',
  'さばぶし',
  'さばらん',
  'さはんじ',
  'さばんな',
  'さびいろ',
  'さびきん',
  'さびさび',
  'さびざん',
  'さびしい',
  'さびしげ',
  'さびしさ',
  'さびつく',
  'さびどめ',
  'さびぬき',
  'さびねこ',
  'さひょう',
  'さびょう',
  'ざひょう',
  'さびらん',
  'さびれる',
  'さびろい',
  'さぶあか',
  'さぶあど',
  'さふぁり',
  'さぶいぼ',
  'さぶかる',
  'さぶくえ',
  'さぶこん',
  'ざぶざぶ',
  'さぶすく',
  'ざぶとん',
  'さぶぱす',
  'さぶらい',
  'さぷらい',
  'さふらん',
  'さぶるこ',
  'さぶれー',
  'さぷれす',
  'さぶろう',
  'さべつか',
  'さべつご',
  'さへんち',
  'さぽーた',
  'さぽーと',
  'さほがみ',
  'さぽじら',
  'さぽせん',
  'さぼてん',
  'さぽにん',
  'さほひめ',
  'さまかた',
  'さまさま',
  'さまざま',
  'さまたげ',
  'さまづけ',
  'ざまみろ',
  'さまよう',
  'さまりー',
  'さみしい',
  'さみせん',
  'さみだれ',
  'さみっと',
  'さみんぐ',
  'さむがり',
  'さむがる',
  'さむざむ',
  'さむぞら',
  'さむらい',
  'さめがわ',
  'さめぎわ',
  'さめざめ',
  'さめざや',
  'さめはだ',
  'さめひれ',
  'さもあご',
  'さもしい',
  'さやあて',
  'さやがた',
  'さやさや',
  'さやじり',
  'さやとり',
  'さやなが',
  'さやまめ',
  'さようそ',
  'さよかく',
  'さよなか',
  'さよなら',
  'さらえる',
  'ざらがみ',
  'さらきん',
  'さらさら',
  'ざらざら',
  'さらしこ',
  'さらじゅ',
  'さらせん',
  'さらだな',
  'さらだゆ',
  'ざらつき',
  'ざらつく',
  'さらっと',
  'さらとい',
  'さらどれ',
  'さらなり',
  'さらなる',
  'さらねじ',
  'さらばち',
  'さらぴん',
  'さらりー',
  'さりいく',
  'ざりがに',
  'さりぎわ',
  'さりげに',
  'さりちる',
  'さりとて',
  'さりゃく',
  'さりゅう',
  'さりゆく',
  'さりょう',
  'さるーき',
  'さるーん',
  'さるがい',
  'ざるがい',
  'さるがお',
  'さるがく',
  'さるがみ',
  'さるきー',
  'さるけん',
  'さるごう',
  'さること',
  'さるざけ',
  'さるじえ',
  'ざるそば',
  'さるたん',
  'さるぢえ',
  'さるどし',
  'さるなし',
  'さるのひ',
  'さるびあ',
  'さるびん',
  'さるふぁ',
  'ざるほう',
  'さるぼお',
  'さるまた',
  'さるまね',
  'さるまめ',
  'ざるみみ',
  'さるめん',
  'さるもく',
  'さるもの',
  'さるやま',
  'ざれうた',
  'ざれがき',
  'ざれこと',
  'ざれごと',
  'されたし',
  'されづま',
  'されども',
  'さわかい',
  'さわがす',
  'さわがに',
  'さわさわ',
  'ざわざわ',
  'さわしば',
  'さわすじ',
  'ざわつく',
  'さわみず',
  'ざわめき',
  'ざわめく',
  'さわやか',
  'さわらび',
  'さわらん',
  'ざをたつ',
  'ざをもつ',
  'さんあい',
  'さんあく',
  'さんいく',
  'さんいつ',
  'さんいん',
  'さんうん',
  'ざんえい',
  'さんえき',
  'さんえつ',
  'さんえん',
  'ざんえん',
  'さんかい',
  'さんがい',
  'ざんがい',
  'さんかく',
  'さんがく',
  'ざんがく',
  'さんかた',
  'さんがつ',
  'さんかひ',
  'さんかん',
  'ざんかん',
  'ざんがん',
  'ざんぎく',
  'さんきゅ',
  'ざんぎり',
  'さんきん',
  'ざんきん',
  'さんぐう',
  'さんくす',
  'さんくみ',
  'さんぐん',
  'さんけい',
  'さんけー',
  'さんげき',
  'ざんげき',
  'さんけた',
  'さんけつ',
  'さんげつ',
  'ざんけつ',
  'ざんげつ',
  'さんけん',
  'さんげん',
  'ざんげん',
  'さんこう',
  'さんごう',
  'ざんこう',
  'ざんごう',
  'さんごか',
  'さんこく',
  'さんごく',
  'ざんこく',
  'さんこつ',
  'さんこん',
  'ざんこん',
  'さんさい',
  'さんざい',
  'ざんさい',
  'ざんざい',
  'さんさか',
  'さんざか',
  'さんさく',
  'さんざし',
  'ざんさつ',
  'さんざる',
  'さんさろ',
  'さんさん',
  'さんざん',
  'さんしき',
  'さんじき',
  'さんじく',
  'さんしし',
  'さんした',
  'さんしつ',
  'ざんしつ',
  'さんしゃ',
  'さんしゅ',
  'さんじゅ',
  'ざんしゅ',
  'さんしょ',
  'さんじょ',
  'ざんしょ',
  'さんじる',
  'さんしん',
  'さんじん',
  'ざんしん',
  'さんすい',
  'さんずい',
  'さんすう',
  'さんすけ',
  'さんする',
  'さんずる',
  'ざんする',
  'さんずん',
  'さんせい',
  'ざんせい',
  'さんせき',
  'ざんせき',
  'ざんせつ',
  'ざんぜつ',
  'さんせん',
  'さんぜん',
  'ざんぜん',
  'さんそう',
  'さんぞう',
  'ざんそう',
  'ざんぞう',
  'さんそー',
  'さんそか',
  'さんぞく',
  'さんそん',
  'さんぞん',
  'ざんそん',
  'ざんぞん',
  'さんだー',
  'さんたい',
  'さんだい',
  'ざんだか',
  'さんだつ',
  'さんだる',
  'さんたん',
  'さんだん',
  'ざんだん',
  'さんちゃ',
  'さんちゅ',
  'ざんちょ',
  'さんつう',
  'さんづけ',
  'さんてい',
  'ざんてい',
  'さんでー',
  'ざんてき',
  'さんてつ',
  'さんてん',
  'さんでん',
  'さんとう',
  'さんどう',
  'ざんとう',
  'さんとく',
  'さんどく',
  'ざんとく',
  'さんとす',
  'さんとめ',
  'さんとら',
  'さんない',
  'さんなく',
  'さんなん',
  'さんにん',
  'ざんにん',
  'さんぬる',
  'さんねん',
  'ざんねん',
  'さんのぜ',
  'さんばー',
  'さんばい',
  'さんぱい',
  'ざんぱい',
  'さんぱく',
  'さんはこ',
  'さんばこ',
  'さんぱこ',
  'さんばし',
  'さんぱち',
  'さんぱつ',
  'さんばん',
  'さんぱん',
  'ざんぱん',
  'ざんびあ',
  'さんぴー',
  'さんびか',
  'さんぴつ',
  'さんひめ',
  'さんぴん',
  'ざんぴん',
  'さんぷう',
  'さんぷく',
  'さんぷず',
  'さんぶつ',
  'ざんぶつ',
  'さんぷど',
  'さんぷら',
  'ざんぶり',
  'さんぷる',
  'さんぶん',
  'さんぷん',
  'さんぺい',
  'ざんぺい',
  'さんぺき',
  'さんべつ',
  'さんぺん',
  'ざんぺん',
  'さんぼう',
  'さんぽう',
  'ざんぼう',
  'さんほせ',
  'さんぼん',
  'さんまー',
  'さんまい',
  'ざんまい',
  'さんまく',
  'さんまた',
  'さんまや',
  'さんまん',
  'さんみつ',
  'さんめい',
  'さんめん',
  'さんもん',
  'さんやく',
  'さんよう',
  'さんらい',
  'さんらく',
  'さんらん',
  'さんりく',
  'さんりつ',
  'さんりん',
  'さんるい',
  'ざんるい',
  'さんれい',
  'さんれつ',
  'さんれん',
  'さんろう',
  'さんろく',
  'さんろん',
  'さんわく',
  'しあがり',
  'じあかり',
  'しあがる',
  'じあげや',
  'しあげる',
  'じあぞか',
  'しあたー',
  'じあたま',
  'しあつし',
  'しあとる',
  'しあのき',
  'じあまり',
  'じあみん',
  'しあわせ',
  'しあんき',
  'じーあい',
  'しーあは',
  'しーいー',
  'しーえー',
  'しーえふ',
  'しーえむ',
  'じーえむ',
  'じーおん',
  'しーかー',
  'じいがせ',
  'しーがた',
  'しーけー',
  'じーけー',
  'じーこむ',
  'しいさあ',
  'しーさー',
  'しいざあ',
  'しーざー',
  'じーざす',
  'じーさま',
  'しーさん',
  'じいさん',
  'しいしい',
  'しーしー',
  'しーじー',
  'じいじい',
  'じいしき',
  'しーしゃ',
  'しいしゅ',
  'しーすー',
  'しーずん',
  'しいせい',
  'じーぜる',
  'しーそう',
  'しーそー',
  'しいそん',
  'しいたけ',
  'じいっと',
  'じーっと',
  'しいてき',
  'じーてん',
  'しいとめ',
  'しーどる',
  'じーにー',
  'しいにび',
  'しいにぶ',
  'しーにゅ',
  'しいのき',
  'しーぱい',
  'しーばす',
  'じーぱん',
  'しーびー',
  'しーぴー',
  'しいひん',
  'しーひん',
  'じーぺん',
  'じーまん',
  'しいみい',
  'しーみー',
  'じーめん',
  'しーもす',
  'しーらぶ',
  'しーるど',
  'しいれね',
  'しいれる',
  'しーれん',
  'じーんず',
  'じいんと',
  'じーんと',
  'じうたい',
  'しうとめ',
  'じうのか',
  'しぇいく',
  'じぇいだ',
  'しぇいど',
  'じぇいど',
  'しぇいぱ',
  'しぇいふ',
  'しぇいぷ',
  'じぇいる',
  'しぇーく',
  'しぇーど',
  'じぇーど',
  'しぇーぷ',
  'しぇーま',
  'しぇーる',
  'しぇける',
  'しぇしぇ',
  'しえしえ',
  'しえすた',
  'じぇっと',
  'しえなー',
  'しえなは',
  'じぇみに',
  'しぇらふ',
  'しぇりー',
  'じぇりぃ',
  'じぇりー',
  'しぇりふ',
  'しぇるぱ',
  'しぇるふ',
  'じえんど',
  'しぇんな',
  'しえんな',
  'しおあい',
  'しおあし',
  'しおあじ',
  'しおあめ',
  'じおいど',
  'しおいり',
  'しおいれ',
  'しおえる',
  'じおーど',
  'じおーる',
  'しおがお',
  'しおかご',
  'しおかぜ',
  'しおかど',
  'しおがま',
  'しおから',
  'しおきば',
  'しおくぐ',
  'しおくみ',
  'しおくり',
  'しおさい',
  'しおざい',
  'しおさき',
  'しおざけ',
  'しおさめ',
  'しおしお',
  'しおじり',
  'しおじる',
  'しおそば',
  'しおだし',
  'しおだち',
  'しおたれ',
  'しおだれ',
  'しおちゃ',
  'しおっけ',
  'しおづけ',
  'しおどき',
  'しおとし',
  'しおとす',
  'しおぬき',
  'しおのめ',
  'しおばな',
  'しおびき',
  'しおふき',
  'しおぶた',
  'じおぷた',
  'しおぶろ',
  'しおぼし',
  'しおまき',
  'しおます',
  'しおまち',
  'しおまめ',
  'しおみず',
  'しおもの',
  'しおもみ',
  'しおやき',
  'しおやけ',
  'しおゆで',
  'じおらま',
  'しおりど',
  'しおれる',
  'しおんき',
  'じおんご',
  'しがいか',
  'しかいし',
  'しがいず',
  'しがいち',
  'しかえし',
  'しかえす',
  'しかえる',
  'しかおい',
  'しかがく',
  'しかかり',
  'しかかる',
  'しかがわ',
  'しかくい',
  'しかくか',
  'しがくし',
  'しかくや',
  'しかける',
  'しがけん',
  'じかざし',
  'しかざる',
  'しかざん',
  'しかじか',
  'しかして',
  'じかせい',
  'じかせん',
  'じがぞう',
  'しがたい',
  'じかたび',
  'じがため',
  'じかだん',
  'しがっか',
  'しかつく',
  'しがてら',
  'じがでる',
  'しかない',
  'しがない',
  'しかにく',
  'じかねつ',
  'しかねる',
  'じかのみ',
  'じかばき',
  'じかばし',
  'じがばち',
  'しかばな',
  'しかばね',
  'しかばん',
  'じかぶき',
  'しかめる',
  'じかやき',
  'しかよう',
  'じかよう',
  'しからば',
  'しがらみ',
  'しがりろ',
  'じかりん',
  'しかるに',
  'しかるを',
  'しかれば',
  'しかんど',
  'じかんめ',
  'しきいき',
  'しきいし',
  'しきいた',
  'しきいち',
  'しきかい',
  'しぎかい',
  'しきかく',
  'しきがく',
  'じきがく',
  'しきがみ',
  'しきがわ',
  'しきかん',
  'しききん',
  'しきげた',
  'しきけん',
  'じきけん',
  'しきさい',
  'じきさい',
  'しきざき',
  'じきさま',
  'じきざま',
  'じきさん',
  'じきじき',
  'しきじつ',
  'しきしま',
  'しきしゃ',
  'しきじょ',
  'しきしん',
  'じきしん',
  'しきそう',
  'じきそう',
  'しきだい',
  'しきたく',
  'じきたつ',
  'しきたり',
  'じきだん',
  'じきでし',
  'しきてん',
  'しきでん',
  'じきでん',
  'しきどう',
  'じきとう',
  'じきどう',
  'しきどず',
  'しきない',
  'しきねん',
  'しきびき',
  'じきひつ',
  'しきふく',
  'しきべつ',
  'しきほう',
  'しきぼう',
  'しきめい',
  'しきもう',
  'しきもく',
  'しきもの',
  'しきゃく',
  'しぎゃく',
  'じきゃく',
  'じぎゃく',
  'しきゅう',
  'じきゅう',
  'しきょう',
  'しぎょう',
  'じきょう',
  'じぎょう',
  'しきょく',
  'しきよく',
  'じきょく',
  'じぎょく',
  'じきらん',
  'しきりと',
  'しきりに',
  'しきりや',
  'しきれつ',
  'しきわら',
  'じくあし',
  'じくうけ',
  'じくがく',
  'じくきょ',
  'じくぐみ',
  'じくさく',
  'じぐざぐ',
  'しくさる',
  'しくしく',
  'じくじく',
  'しくじり',
  'しくじる',
  'じくせい',
  'じくせん',
  'じくそう',
  'じぐそー',
  'じくたん',
  'じくつい',
  'じくづり',
  'しぐなる',
  'じくばこ',
  'じくばり',
  'じくもの',
  'じぐるま',
  'しぐれき',
  'しぐれに',
  'しくんし',
  'じげいこ',
  'しげいさ',
  'しけいん',
  'しけこむ',
  'しげしげ',
  'しけめん',
  'しけもく',
  'しけんき',
  'しけんし',
  'じけんぼ',
  'じげんめ',
  'じけんや',
  'じこあい',
  'しこうか',
  'じこうぐ',
  'しこうさ',
  'じこうし',
  'しごおわ',
  'しごかん',
  'じごくえ',
  'じこくご',
  'じこさく',
  'しこしこ',
  'じこしゃ',
  'じごしん',
  'しごせん',
  'じこぞう',
  'しこたま',
  'しごとぎ',
  'しごとし',
  'しごとば',
  'しごとび',
  'しこなす',
  'じこまい',
  'じこまん',
  'じこもく',
  'じこれき',
  'しざーす',
  'しざーず',
  'じざいが',
  'じざいど',
  'じざいに',
  'じざかい',
  'じざかな',
  'しさくか',
  'しさくき',
  'しさてき',
  'じさない',
  'じさぼけ',
  'しさんか',
  'しざんじ',
  'ししあい',
  'じしあん',
  'じしいじ',
  'ししいろ',
  'ししうど',
  'ししおう',
  'ししおき',
  'じじかい',
  'ししがき',
  'ししがり',
  'しじくい',
  'しじぐい',
  'しじげん',
  'じじこう',
  'しじさき',
  'ししざる',
  'しじしゃ',
  'しじせん',
  'しじそう',
  'ししつき',
  'ししとう',
  'ししなべ',
  'ししのざ',
  'じしばい',
  'じじはつ',
  'ししばな',
  'ししばば',
  'じじばば',
  'じしばり',
  'しじばん',
  'しじぼう',
  'ししまい',
  'ししまひ',
  'ししむら',
  'ししゃく',
  'しじやく',
  'じしゃく',
  'じじゃく',
  'じしゃさ',
  'ししゃも',
  'ししゅう',
  'しじゅう',
  'じしゅう',
  'じじゅう',
  'ししゅく',
  'しじゅく',
  'じしゅく',
  'ししゅつ',
  'しじゅつ',
  'しじゅん',
  'じじゅん',
  'ししょう',
  'しじょう',
  'じしょう',
  'じじょう',
  'ししょく',
  'じしょく',
  'ししらん',
  'ししりー',
  'しじりつ',
  'じじろん',
  'じしんか',
  'じしんき',
  'じしんぎ',
  'じしんは',
  'しすあど',
  'しすいき',
  'しすうか',
  'しすうぶ',
  'しずおか',
  'しすおぺ',
  'しずかに',
  'しすぎる',
  'しずけさ',
  'しすこん',
  'しずしず',
  'しすたー',
  'しすちん',
  'しすてむ',
  'じすとま',
  'しずとり',
  'しすとれ',
  'しずのめ',
  'しすべき',
  'じすべり',
  'しすます',
  'しずまる',
  'しずめる',
  'しせいし',
  'しせいじ',
  'しせいち',
  'じせいち',
  'しせきぼ',
  'じせだい',
  'じぜんか',
  'じぜんご',
  'しぜんし',
  'しぜんび',
  'しそうか',
  'しそめる',
  'しそもく',
  'しそんじ',
  'したあご',
  'したあじ',
  'したあな',
  'したーる',
  'したーん',
  'したいし',
  'しだいに',
  'したいふ',
  'したうけ',
  'したうす',
  'したうち',
  'したえだ',
  'したおし',
  'したおす',
  'したおび',
  'したがい',
  'したがう',
  'したがき',
  'したがね',
  'したがり',
  'したがる',
  'したがわ',
  'したぎき',
  'したくさ',
  'したぐさ',
  'したさき',
  'したさく',
  'したしい',
  'したじき',
  'したしく',
  'したしさ',
  'したじた',
  'じたじた',
  'したしみ',
  'したしむ',
  'しだしや',
  'じだしゃ',
  'したずり',
  'したぞめ',
  'したぞり',
  'しただい',
  'したたか',
  'しただみ',
  'したたり',
  'したたる',
  'したちち',
  'したつき',
  'したっけ',
  'したっぱ',
  'したつま',
  'したづみ',
  'したつゆ',
  'したてや',
  'したてる',
  'じたとも',
  'したどり',
  'したぬい',
  'したぬり',
  'したのけ',
  'したのこ',
  'したのね',
  'したぱい',
  'したばえ',
  'したばき',
  'じたばぐ',
  'じたばた',
  'したはら',
  'したばら',
  'じたはら',
  'したばり',
  'したばん',
  'したひも',
  'したぶき',
  'したぶれ',
  'したへん',
  'したまえ',
  'じたまご',
  'したまち',
  'したみぎ',
  'したみず',
  'したみち',
  'したむき',
  'したむく',
  'したむし',
  'したもえ',
  'したもの',
  'したやく',
  'したゆで',
  'したよみ',
  'じだらく',
  'じたらず',
  'しだりお',
  'じだるき',
  'しだれる',
  'したんぶ',
  'しちいれ',
  'じちかい',
  'しちがつ',
  'しちぐさ',
  'しちくせ',
  'しちけつ',
  'しちけん',
  'じちけん',
  'しちごん',
  'しちさん',
  'しちしゅ',
  'しちずん',
  'しちせい',
  'しちせき',
  'しちせん',
  'じちたい',
  'しちだね',
  'しちちん',
  'しちてん',
  'しちでん',
  'しちとう',
  'しちどう',
  'じちとし',
  'しちなん',
  'しちふだ',
  'しちぶつ',
  'しちぶん',
  'しちへい',
  'しちほう',
  'しちみせ',
  'しちもつ',
  'しちもの',
  'しちゃく',
  'しちゅー',
  'しちゅう',
  'じちゅう',
  'しちょう',
  'しちよう',
  'じちょう',
  'しちょく',
  'しちらい',
  'しちりあ',
  'しちりん',
  'じつあみ',
  'じついん',
  'じつえき',
  'じつえん',
  'しつおう',
  'じつおや',
  'しつおん',
  'しっかい',
  'しつがい',
  'じっかい',
  'じつがい',
  'しっかく',
  'じつがく',
  'しっかつ',
  'しっかと',
  'じつかぶ',
  'しっかり',
  'しっかん',
  'しつかん',
  'じっかん',
  'しっきん',
  'じっきん',
  'しっくい',
  'しっくす',
  'しつくす',
  'しっくり',
  'じっくり',
  'しっけい',
  'しつげい',
  'じっけい',
  'しっけつ',
  'じっけつ',
  'じつげつ',
  'しっける',
  'しつける',
  'しっけん',
  'しつげん',
  'じっけん',
  'じつげん',
  'しつこい',
  'しっこう',
  'じっこう',
  'しっこく',
  'じつごと',
  'じっこん',
  'じっさい',
  'じつざい',
  'しっさく',
  'じっさつ',
  'しっしき',
  'しっしっ',
  'しつじつ',
  'じっしつ',
  'じっしび',
  'じっしゃ',
  'じつじゅ',
  'しっしん',
  'じっしん',
  'じっすう',
  'しっする',
  'じっすん',
  'しっせい',
  'じっせい',
  'しっせき',
  'じっせき',
  'しっせつ',
  'しつぜつ',
  'じっせつ',
  'じっせん',
  'しっそう',
  'じっそう',
  'じつぞう',
  'しっそく',
  'じっそく',
  'じつぞん',
  'しったー',
  'じったー',
  'しったい',
  'じったい',
  'しったん',
  'じつだん',
  'しっちん',
  'しっつい',
  'じつづき',
  'じってい',
  'しつてき',
  'じってつ',
  'しってん',
  'しつてん',
  'しつでん',
  'しっとう',
  'じつどう',
  'じっとく',
  'しっとり',
  'じっとり',
  'しつない',
  'しつにん',
  'しつねん',
  'じつねん',
  'じっぱー',
  'しっぱい',
  'じつばい',
  'じっぱり',
  'しつばん',
  'しっぱん',
  'しっぴつ',
  'しっぷう',
  'じつぶつ',
  'じっぷん',
  'しっぺい',
  'じっへる',
  'しつぼう',
  'しっぽう',
  'じっぽう',
  'しつぼく',
  'しっぽく',
  'しっぽり',
  'じっぽん',
  'じつまい',
  'じつむか',
  'しつめい',
  'じつめい',
  'じつもう',
  'しつもん',
  'しつよう',
  'じつよう',
  'しつらい',
  'しつらえ',
  'しつりん',
  'しつれい',
  'じつれい',
  'しつれん',
  'じつろく',
  'してぃー',
  'じでいく',
  'していし',
  'しでかす',
  'してかぶ',
  'してせん',
  'しでのき',
  'しでむし',
  'してやる',
  'じでゆく',
  'してんし',
  'しどうい',
  'じどうか',
  'じどうが',
  'じどうし',
  'しとうで',
  'しどうぶ',
  'しとげる',
  'しとこむ',
  'しどころ',
  'しとしと',
  'じとじと',
  'しとしょ',
  'しとしん',
  'しとたち',
  'しどにー',
  'しとみど',
  'しとめる',
  'しとやか',
  'しとらす',
  'しとりん',
  'しとろん',
  'しなうす',
  'じなおし',
  'しなおす',
  'しながき',
  'しながく',
  'しなかず',
  'しながら',
  'しながれ',
  'しなぎれ',
  'しなぐり',
  'しなじー',
  'しなしな',
  'しなじな',
  'しなじん',
  'しなそば',
  'しなだい',
  'しなだし',
  'しなだま',
  'しなちく',
  'しなのき',
  'しなばー',
  'しなびる',
  'しなふじ',
  'しなぷす',
  'しなぷり',
  'しなもじ',
  'しなもの',
  'しなもん',
  'しなやか',
  'じならし',
  'しなりお',
  'しなれる',
  'しなわけ',
  'しにいき',
  'しにうま',
  'しにがお',
  'しにかた',
  'しにがね',
  'しにがみ',
  'しにかる',
  'しにぎわ',
  'しにくい',
  'しにげー',
  'しにざま',
  'しにすじ',
  'しにすむ',
  'しにそう',
  'しにたい',
  'しにっく',
  'しにどき',
  'しにはじ',
  'しにばな',
  'しにみず',
  'しにゆく',
  'しにょう',
  'しにょん',
  'しによん',
  'じにりん',
  'しぬきで',
  'しぬほど',
  'しねこん',
  'しねしね',
  'しねすこ',
  'じねずみ',
  'しねらま',
  'じねんど',
  'しのぎば',
  'しのくみ',
  'しのこし',
  'しのこす',
  'しのざさ',
  'しのぜん',
  'しのだけ',
  'しのつく',
  'しのとこ',
  'しのにむ',
  'しののめ',
  'しのはい',
  'しのはら',
  'しのびね',
  'しのぶえ',
  'じのぶん',
  'しのぼう',
  'じはーど',
  'しはいか',
  'しばいぎ',
  'しばいげ',
  'しばいぬ',
  'しばえび',
  'しばおま',
  'しばがき',
  'しばかり',
  'しばくさ',
  'しばけん',
  'しばしば',
  'しぱしぱ',
  'しばたく',
  'しばづけ',
  'しばなか',
  'しばやき',
  'しはらい',
  'しはらう',
  'しばらく',
  'しはんき',
  'じはんき',
  'じぱんぐ',
  'しびあー',
  'じびーる',
  'しびえん',
  'じひさつ',
  'じひしん',
  'しびっく',
  'じひびき',
  'しびやー',
  'しびゅら',
  'しひょう',
  'しびょう',
  'じひょう',
  'じびょう',
  'しびれる',
  'しぶいろ',
  'しふぉん',
  'しぶがき',
  'しぶがみ',
  'しぶかわ',
  'しぶくさ',
  'じぶくろ',
  'しぶさく',
  'じぷしー',
  'しぶしぶ',
  'しぶしゅ',
  'じふしん',
  'しぶすと',
  'しふぞう',
  'しぶちゃ',
  'しぶちん',
  'しぶつか',
  'しぶつら',
  'しぶづら',
  'しぶとい',
  'しぶぬき',
  'しぶはろ',
  'じふぶき',
  'じぶるい',
  'しぶろく',
  'しぶんい',
  'しぶんぎ',
  'じぶんし',
  'じぶんで',
  'じぺーじ',
  'しべっと',
  'しべとん',
  'しべりあ',
  'しべりや',
  'じほうい',
  'しぼうち',
  'しぼうゆ',
  'しほけん',
  'しほこう',
  'しぼさい',
  'じぼしん',
  'じほすと',
  'しぼりき',
  'しほんか',
  'しまあじ',
  'しまいご',
  'しまいに',
  'しまうた',
  'しまうま',
  'しまかげ',
  'しまかぜ',
  'しまがら',
  'しまぐに',
  'しまざい',
  'しまざめ',
  'しましま',
  'しまじま',
  'しまそい',
  'しまぞい',
  'しまだい',
  'しまった',
  'しまつや',
  'しまばえ',
  'しまはぎ',
  'しまびと',
  'しまふぐ',
  'しまぶた',
  'しまへび',
  'しまもの',
  'しまもり',
  'しまやま',
  'しまりす',
  'しまりや',
  'じまわり',
  'じまんげ',
  'しみーず',
  'しみいる',
  'しみこむ',
  'じみこん',
  'しみじみ',
  'しみだし',
  'しみだす',
  'しみつく',
  'しみでる',
  'しみとり',
  'しみぬき',
  'しみむし',
  'しみもく',
  'しみゃく',
  'しみょう',
  'じみんが',
  'じむいん',
  'しむーん',
  'じむかい',
  'じむかた',
  'じむかで',
  'じむかん',
  'じむきき',
  'じむぐり',
  'しむける',
  'しむこむ',
  'じむしつ',
  'じむしょ',
  'じむてき',
  'じむとも',
  'じむぬら',
  'じむふく',
  'じむよう',
  'しめかす',
  'しめがね',
  'しめきり',
  'しめきる',
  'しめこみ',
  'しめこむ',
  'しめさば',
  'しめしめ',
  'じめじめ',
  'しめしろ',
  'しめだか',
  'しめだし',
  'しめだす',
  'しめつけ',
  'しめなわ',
  'しめひも',
  'しめやか',
  'しめやき',
  'しめらす',
  'しめりけ',
  'しめわざ',
  'じめんし',
  'しもあさ',
  'しもいち',
  'しもうさ',
  'しもうた',
  'しもがれ',
  'しもごえ',
  'しもさか',
  'しもざま',
  'しもじも',
  'しもたや',
  'しもちゃ',
  'しもつき',
  'しもつけ',
  'じもてぃ',
  'しもどけ',
  'じもとご',
  'じもとし',
  'しもとり',
  'しもねた',
  'しものく',
  'しものけ',
  'しもふり',
  'しもべや',
  'しもやけ',
  'しもよけ',
  'しもんじ',
  'しゃーく',
  'じゃーく',
  'じゃあく',
  'しゃーし',
  'じゃーじ',
  'しゃーっ',
  'しゃあっ',
  'じゃーね',
  'じゃあね',
  'しゃーば',
  'しゃーぷ',
  'しゃーれ',
  'じゃーん',
  'しゃいつ',
  'しゃいふ',
  'じゃいぶ',
  'じゃいろ',
  'しゃいん',
  'じゃいん',
  'じゃゔぁ',
  'しゃうと',
  'しゃうん',
  'しゃえい',
  'しゃおく',
  'しゃおん',
  'じゃがー',
  'しゃかい',
  'しゃがい',
  'しゃかく',
  'しやかく',
  'じゃかご',
  'しゃかつ',
  'しゃがむ',
  'しゃかん',
  'しゃがん',
  'じゃかん',
  'じゃがん',
  'しゃぎー',
  'じゃぎー',
  'しゃぎり',
  'しゃきん',
  'しゃくい',
  'じゃくう',
  'しゃくが',
  'しゃくぎ',
  'じゃくさ',
  'しゃくし',
  'しゃくじ',
  'じゃくし',
  'じゃくす',
  'しゃくち',
  'じゃぐち',
  'しゃくど',
  'しゃくふ',
  'しゃくま',
  'しゃぐま',
  'しゃくや',
  'じゃくら',
  'しゃくる',
  'じゃぐる',
  'じゃくろ',
  'しゃくん',
  'しゃけい',
  'しゃげい',
  'しゃげき',
  'しゃけつ',
  'じゃけつ',
  'しゃけん',
  'じゃけん',
  'しゃこう',
  'しゃごう',
  'じゃこう',
  'しゃこく',
  'しゃこん',
  'しゃさい',
  'しゃざい',
  'しゃさつ',
  'しゃしー',
  'じゃじき',
  'しゃじく',
  'しゃしつ',
  'しゃじつ',
  'しゃしゃ',
  'しゃしゅ',
  'しゃしょ',
  'しゃしん',
  'しゃじん',
  'じゃしん',
  'しやすい',
  'じゃすい',
  'じゃすと',
  'しゃすら',
  'しゃする',
  'じゃずる',
  'しゃせい',
  'しゃせき',
  'しゃせつ',
  'しゃぜつ',
  'じゃせつ',
  'しゃせん',
  'しゃそう',
  'しゃぞう',
  'しゃそく',
  'しゃそん',
  'じゃだー',
  'しゃたい',
  'しゃだい',
  'じゃたい',
  'しゃたく',
  'しゃだつ',
  'しゃだん',
  'しゃちく',
  'しゃっか',
  'じゃっか',
  'しゃつき',
  'じゃっき',
  'しゃっく',
  'じゃっく',
  'じゃっじ',
  'しゃっせ',
  'しゃった',
  'しやった',
  'じゃった',
  'しゃっと',
  'じゃっぷ',
  'しゃっぽ',
  'しゃつめ',
  'しゃてい',
  'しゃてき',
  'しゃでん',
  'しゃとう',
  'しゃどう',
  'じゃとう',
  'じゃどう',
  'しゃとー',
  'しゃどー',
  'じゃどく',
  'じゃどま',
  'しゃとる',
  'しゃない',
  'じゃない',
  'しゃにち',
  'じゃねぇ',
  'じゃねー',
  'しゃねつ',
  'じゃねん',
  'じゃのめ',
  'じゃばー',
  'しゃばい',
  'しゃばき',
  'しゃばけ',
  'しゃはば',
  'じゃばら',
  'じゃぱん',
  'しゃびー',
  'しゃひん',
  'しゃふう',
  'しゃふく',
  'しゃふつ',
  'しゃぶつ',
  'しゃふと',
  'しゃぶる',
  'しゃへい',
  'しゃべち',
  'しゃべつ',
  'しゃべり',
  'しゃべる',
  'しゃへん',
  'しゃほう',
  'じゃほう',
  'しゃぽー',
  'しゃほん',
  'しゃぼん',
  'じゃぽん',
  'じゃまー',
  'じゃまた',
  'しゃまん',
  'しゃみつ',
  'しゃみに',
  'しゃみん',
  'しゃむご',
  'じゃむる',
  'しゃむろ',
  'しゃめい',
  'じゃめぶ',
  'しゃめる',
  'しゃめん',
  'しゃもあ',
  'しゃもじ',
  'しゃもん',
  'しゃやく',
  'しゃゆう',
  'しゃよう',
  'じゃよう',
  'じゃよく',
  'しゃらく',
  'じゃらし',
  'じゃらす',
  'しゃりき',
  'しゃりん',
  'しゃるむ',
  'しゃれい',
  'しゃれき',
  'しゃれた',
  'しゃれつ',
  'しゃれる',
  'じゃれる',
  'じゃれん',
  'じゃろう',
  'しゃろん',
  'しゃわー',
  'じゃわご',
  'しやわせ',
  'しゃわり',
  'じゃんき',
  'しゃんく',
  'じゃんく',
  'じゃんし',
  'しゃんと',
  'じゃんぱ',
  'じゃんぷ',
  'じゃんぼ',
  'じゃんる',
  'しゅあー',
  'しゅいろ',
  'しゅいん',
  'じゅいん',
  'しゅうい',
  'じゅうい',
  'しゅうう',
  'じゅうう',
  'しゅうお',
  'しゅうか',
  'じゅうか',
  'じゆうか',
  'じゆうが',
  'しゅうき',
  'しゅうぎ',
  'じゅうき',
  'しゅうく',
  'しゅうぐ',
  'じゅうく',
  'しゅうご',
  'じゅうこ',
  'じゅうご',
  'しゅうさ',
  'じゅうざ',
  'しゅうし',
  'しゅうじ',
  'じゅうし',
  'じゆうし',
  'じゅうじ',
  'しゅーず',
  'じゅーす',
  'じゅうす',
  'しゅうそ',
  'じゅうそ',
  'しゅうた',
  'しゅうち',
  'しゆうち',
  'じゅーっ',
  'じゅうっ',
  'しゅーと',
  'しゅうと',
  'しゅーど',
  'じゅーと',
  'じゅうど',
  'じゆうど',
  'じゅうに',
  'じゆうに',
  'しゅうは',
  'じゅうは',
  'じゅうば',
  'しゅうび',
  'じゅうひ',
  'じゅうび',
  'しゅうふ',
  'しゅうほ',
  'しゅうみ',
  'しゅうむ',
  'しゅうや',
  'じゅうや',
  'しゅうゆ',
  'じゅうゆ',
  'しゅうり',
  'じゅうり',
  'しゅーる',
  'じゅーる',
  'しゅうろ',
  'じゅーん',
  'じゅうん',
  'しゅえい',
  'じゅえい',
  'じゅえき',
  'じゅえる',
  'しゅえん',
  'しゅおん',
  'しゅがー',
  'しゅかい',
  'しゅがい',
  'じゅかい',
  'しゅがき',
  'しゅかく',
  'じゅがく',
  'しゅかん',
  'しゅがん',
  'じゅかん',
  'しゅきー',
  'じゅぎょ',
  'しゅきん',
  'しゅくあ',
  'しゅくい',
  'しゅぐう',
  'しゅくが',
  'じゅくぎ',
  'じゅくご',
  'しゅくし',
  'しゅくじ',
  'じゅくし',
  'じゅくじ',
  'しゅくす',
  'しゅくず',
  'じゅくす',
  'しゅくせ',
  'じゅくそ',
  'じゅくち',
  'しゅくば',
  'しゅくふ',
  'しゅくほ',
  'しゅくぼ',
  'しゅくや',
  'しゅくん',
  'じゅくん',
  'しゅけい',
  'しゅげい',
  'じゅけい',
  'じゅげい',
  'しゅげた',
  'しゅけん',
  'じゅけん',
  'じゅげん',
  'しゅこう',
  'しゅごう',
  'じゅこう',
  'しゅこつ',
  'しゅこん',
  'じゅこん',
  'じゅごん',
  'しゅさい',
  'しゅざい',
  'しゅさつ',
  'じゅさつ',
  'しゅざや',
  'しゅさん',
  'しゅざん',
  'じゅさん',
  'しゅじい',
  'しゅじく',
  'しゅじつ',
  'しゅしゃ',
  'じゅしゃ',
  'しゅしゅ',
  'しゅじゅ',
  'じゅしゅ',
  'じゅじゅ',
  'しゅしょ',
  'しゅしん',
  'しゅじん',
  'じゅしん',
  'しゅすい',
  'じゅすい',
  'しゅすう',
  'しゅすじ',
  'しゅずつ',
  'しゅずみ',
  'じゅずも',
  'しゅする',
  'じゅする',
  'しゅせい',
  'しゅぜい',
  'じゅせい',
  'しゅせき',
  'しゅせつ',
  'しゅせん',
  'しゅぜん',
  'じゅせん',
  'しゅそう',
  'しゅぞう',
  'じゅそう',
  'じゅぞう',
  'しゅそく',
  'しゅぞく',
  'じゅそつ',
  'しゅたい',
  'しゅだい',
  'じゅたい',
  'じゅだい',
  'しゅたく',
  'じゅたく',
  'じゅだく',
  'しゅだら',
  'しゅたる',
  'しゅだん',
  'しゅちく',
  'しゅちょ',
  'しゅちん',
  'しゅっか',
  'しゅつが',
  'しゅっけ',
  'しゅっこ',
  'じゅつご',
  'しゅっし',
  'しゅつじ',
  'じゅっし',
  'じゅつし',
  'しゅっす',
  'しゅつず',
  'しゅっせ',
  'しゅっそ',
  'しゅっと',
  'しゅつど',
  'しゅつば',
  'しゅっぴ',
  'しゅっぷ',
  'じゅつぶ',
  'じゅつや',
  'しゅつろ',
  'しゅでい',
  'しゅてん',
  'しゅでん',
  'じゅでん',
  'しゅとう',
  'しゅどう',
  'じゅどう',
  'しゅとく',
  'しゅどく',
  'しゅとん',
  'じゅなん',
  'じゅにあ',
  'しゅにく',
  'じゅにく',
  'しゅにじ',
  'しゅにん',
  'じゅにん',
  'しゅぬり',
  'しゅのう',
  'じゅのう',
  'じゅのー',
  'しゅのひ',
  'しゅはい',
  'じゅはい',
  'じゅばく',
  'しゅばつ',
  'しゅはり',
  'しゅはん',
  'じゅばん',
  'しゅびき',
  'しゅひつ',
  'しゅひん',
  'しゅびん',
  'じゅひん',
  'しゅふく',
  'じゅふく',
  'しゅぶつ',
  'じゅぶつ',
  'しゅぶん',
  'じゅふん',
  'しゅへい',
  'しゅへき',
  'しゅべつ',
  'しゅほう',
  'しゅぼう',
  'じゅほう',
  'しゅぼく',
  'じゅぼく',
  'しゅぼば',
  'しゅぼん',
  'しゅまい',
  'しゅみか',
  'しゅみね',
  'しゅめい',
  'じゅめい',
  'しゅもく',
  'じゅもく',
  'しゅもち',
  'しゅもつ',
  'しゅもん',
  'じゅもん',
  'しゅやく',
  'しゅよう',
  'じゅよう',
  'しゅよく',
  'じゅらい',
  'じゅらき',
  'じゅらく',
  'しゅらば',
  'しゅらふ',
  'しゅらん',
  'じゅりー',
  'じゅりつ',
  'じゅりん',
  'しゅるい',
  'じゅるり',
  'しゅれい',
  'じゅれい',
  'しゅれん',
  'しゅろう',
  'じゅわき',
  'しゅわく',
  'しゅわん',
  'しゅんい',
  'じゅんい',
  'しゅんう',
  'しゅんか',
  'しゅんが',
  'じゅんか',
  'しゅんき',
  'じゅんこ',
  'じゅんさ',
  'しゅんし',
  'しゅんじ',
  'じゅんし',
  'じゅんじ',
  'じゅんち',
  'しゅんっ',
  'しゅんつ',
  'じゅんつ',
  'じゅんて',
  'しゅんと',
  'じゅんど',
  'じゅんに',
  'しゅんば',
  'じゅんび',
  'しゅんぷ',
  'しゅんめ',
  'じゅんよ',
  'じゅんら',
  'じゅんり',
  'じゅんろ',
  'しょあく',
  'しょいこ',
  'じょいす',
  'しょいん',
  'じょいん',
  'しょうい',
  'じょうい',
  'しょうう',
  'じょうえ',
  'しょうか',
  'しょうが',
  'じょうか',
  'じょうが',
  'しょうき',
  'しょうぎ',
  'じょうき',
  'じょうぎ',
  'しょうく',
  'じょうく',
  'しょうげ',
  'じょうげ',
  'しょうこ',
  'しょうご',
  'しようご',
  'じょうこ',
  'じょうご',
  'しょうさ',
  'しょうざ',
  'じょうざ',
  'しょうし',
  'しょうじ',
  'しようじ',
  'じょうし',
  'じょうじ',
  'しょうす',
  'しょうず',
  'じょうず',
  'しょうそ',
  'じょうそ',
  'じょうた',
  'しょうち',
  'じょうち',
  'じょうて',
  'しょうと',
  'しょうど',
  'じょうと',
  'じょうど',
  'しょうに',
  'しょうね',
  'しょうは',
  'じょうば',
  'しょうひ',
  'しょうび',
  'じょうひ',
  'じょうび',
  'しょうふ',
  'しょうぶ',
  'じょうふ',
  'じょうぶ',
  'しょうほ',
  'しょうぼ',
  'じょうほ',
  'じょうぼ',
  'しょうま',
  'しょうみ',
  'じょうみ',
  'しょうむ',
  'じょうむ',
  'しょうや',
  'じょうや',
  'しょうゆ',
  'じょうゆ',
  'しょうよ',
  'じょうよ',
  'しょうり',
  'じょうり',
  'しょうろ',
  'じょうろ',
  'しょうわ',
  'じょうわ',
  'しょえい',
  'しょえん',
  'じょえん',
  'しょおう',
  'じょおう',
  'じょーく',
  'じょーぐ',
  'しょーす',
  'じょーず',
  'しょーつ',
  'しょーと',
  'しょーむ',
  'しょーる',
  'しょーろ',
  'じょがー',
  'しょかい',
  'じょかい',
  'じょがい',
  'しょかく',
  'しょがく',
  'じょかく',
  'じょがく',
  'しょかつ',
  'しょかん',
  'しょがん',
  'じょかん',
  'しょきか',
  'しょきそ',
  'しょきち',
  'しょきほ',
  'じょきょ',
  'じょきん',
  'しょくい',
  'しょぐう',
  'しょくえ',
  'しょくご',
  'しょくし',
  'しょくじ',
  'しょくす',
  'しょくず',
  'じょくせ',
  'しょくそ',
  'しょくち',
  'じょくち',
  'しょくば',
  'しょくひ',
  'しょくふ',
  'じょくふ',
  'しょくみ',
  'しょくむ',
  'しょくゆ',
  'しょくん',
  'じょくん',
  'しょけい',
  'しょげい',
  'じょけい',
  'しょけつ',
  'しょげつ',
  'じょけつ',
  'じょげつ',
  'しょげる',
  'しょけん',
  'しょげん',
  'じょけん',
  'じょげん',
  'しょこう',
  'しょごう',
  'じょこう',
  'じょごう',
  'しょこく',
  'しょこつ',
  'じょこつ',
  'しょこら',
  'しょこん',
  'じょごん',
  'しょさい',
  'しょざい',
  'じょさい',
  'しょさく',
  'しょさつ',
  'しょさん',
  'しょざん',
  'じょさん',
  'じょざん',
  'しょしき',
  'じょしき',
  'じょじし',
  'しょじつ',
  'じょしつ',
  'じょじつ',
  'じょしぶ',
  'しょしゃ',
  'しょしゅ',
  'じょしゅ',
  'しょしょ',
  'しょじょ',
  'じょじょ',
  'しょしん',
  'しょじん',
  'じょしん',
  'じょじん',
  'じょすい',
  'じょすう',
  'しょずり',
  'しょする',
  'じょする',
  'しょせい',
  'じょせい',
  'しょせき',
  'じょせき',
  'しょせつ',
  'じょせつ',
  'しょせん',
  'じょせん',
  'しょそう',
  'しょぞう',
  'じょそう',
  'しょそく',
  'しょぞく',
  'じょぞく',
  'しょそん',
  'しょぞん',
  'じょそん',
  'しょたい',
  'しょだい',
  'じょたい',
  'しょたく',
  'しょだな',
  'しょたん',
  'しょだん',
  'じょたん',
  'しょっき',
  'じょっき',
  'しょっく',
  'しょっと',
  'しょっぷ',
  'しょてい',
  'じょてい',
  'じょてつ',
  'しょてん',
  'しょでん',
  'しょとう',
  'しょどう',
  'じょどう',
  'しょとく',
  'じょどく',
  'しょない',
  'しょなご',
  'じょなん',
  'しょにち',
  'しょにん',
  'じょにん',
  'しょねつ',
  'しょねん',
  'じょのう',
  'しょはい',
  'じょばす',
  'しょはつ',
  'しょばつ',
  'じょばつ',
  'じょばれ',
  'しょはん',
  'しょばん',
  'しょぱん',
  'じょばん',
  'じょびき',
  'しょびく',
  'しょひん',
  'じょひん',
  'しょふう',
  'じょふく',
  'じょぶく',
  'しょぶつ',
  'しょぶん',
  'じょぶん',
  'しょべる',
  'しょへん',
  'しょぼい',
  'しょほう',
  'しょぼう',
  'じょほう',
  'しょぼん',
  'じょまく',
  'しょみん',
  'しょむか',
  'しょめい',
  'じょめい',
  'しょめん',
  'しょもう',
  'じょもう',
  'しょもく',
  'じょもく',
  'しょもつ',
  'しょやく',
  'じょやく',
  'しょゆう',
  'じょゆう',
  'しょよう',
  'しょりば',
  'しょりぶ',
  'しょりん',
  'しょるい',
  'じょれい',
  'じょれつ',
  'じょれん',
  'しょろう',
  'じょろう',
  'しょろん',
  'じょろん',
  'しょわけ',
  'しらあい',
  'しらあえ',
  'しらーず',
  'じらいか',
  'しらいと',
  'しらうお',
  'しらうめ',
  'しらえび',
  'しらかし',
  'しらかば',
  'しらかべ',
  'しらかみ',
  'しらかゆ',
  'しらがゆ',
  'しらぎく',
  'しらぎぬ',
  'しらくび',
  'しらくぼ',
  'しらくも',
  'しらける',
  'しらげる',
  'しらこい',
  'しらこえ',
  'しらごえ',
  'しらさぎ',
  'しらしら',
  'しらじら',
  'しらすげ',
  'しらすな',
  'しらずみ',
  'しらせる',
  'しらたえ',
  'しらたき',
  'しらたま',
  'しらちゃ',
  'しらつち',
  'しらっと',
  'しらっぷ',
  'しらつゆ',
  'しらとり',
  'しらない',
  'しらなみ',
  'しらぬい',
  'しらぬひ',
  'しらはぎ',
  'しらばす',
  'しらはた',
  'しらはだ',
  'しらはま',
  'しらはり',
  'しらびそ',
  'しらひと',
  'しらびと',
  'しらぶる',
  'しらべる',
  'しらむし',
  'しらやき',
  'しらゆき',
  'しらゆり',
  'しらよね',
  'しられる',
  'しりあい',
  'しりあう',
  'しりあご',
  'しりあす',
  'しりあて',
  'しりあな',
  'しりある',
  'しりーず',
  'しりいん',
  'しりうす',
  'しりうま',
  'しりえる',
  'しりおし',
  'じりおし',
  'しりおも',
  'しりがい',
  'しりがる',
  'しりきれ',
  'しりくせ',
  'しりごみ',
  'しりこん',
  'じりじり',
  'しりぞく',
  'じりだか',
  'しりたぶ',
  'じりつご',
  'しりっぽ',
  'しりとり',
  'しりぬく',
  'しりぬけ',
  'しりびと',
  'しりびれ',
  'じりひん',
  'しりもじ',
  'しりもち',
  'しりゃく',
  'じりゃく',
  'じりやす',
  'しりやる',
  'しりゅう',
  'じりゅう',
  'しりょう',
  'じりょう',
  'しりょく',
  'じりょく',
  'しりんぐ',
  'しりんじ',
  'しりんだ',
  'しるきー',
  'しるこや',
  'じるこん',
  'しるばー',
  'しるひと',
  'しるみん',
  'しるもの',
  'しるるき',
  'しるわん',
  'しれいぶ',
  'しれごと',
  'しれっと',
  'しれもの',
  'じれんま',
  'しろあい',
  'しろあえ',
  'しろあと',
  'しろあり',
  'しろあん',
  'しろいし',
  'しろいぬ',
  'しろいろ',
  'しろうお',
  'しろうと',
  'しろうま',
  'しろうり',
  'しろえび',
  'しろえり',
  'しろおび',
  'じろーる',
  'しろかき',
  'しろかね',
  'しろがね',
  'しろかみ',
  'しろぎす',
  'しろきぬ',
  'しろぎぬ',
  'しろぐち',
  'しろぐつ',
  'しろくび',
  'しろくま',
  'しろぐみ',
  'しろくろ',
  'しろごま',
  'しろごめ',
  'しろころ',
  'しろさい',
  'しろざけ',
  'しろざめ',
  'じろじろ',
  'しろずみ',
  'しろぞう',
  'しろたえ',
  'しろたく',
  'しろたび',
  'しろちゃ',
  'しろっこ',
  'じろっと',
  'しろっぷ',
  'しろてん',
  'しろとび',
  'しろとり',
  'しろにく',
  'しろぬの',
  'しろぬり',
  'しろねぎ',
  'しろねこ',
  'しろばい',
  'しろはた',
  'しろはと',
  'しろはら',
  'しろひげ',
  'しろぶさ',
  'しろふだ',
  'しろぶた',
  'しろぶち',
  'しろへび',
  'しろぼけ',
  'しろぼし',
  'しろほん',
  'しろみず',
  'しろみそ',
  'しろむく',
  'しろめし',
  'しろもじ',
  'しろもつ',
  'しろもの',
  'しろもみ',
  'しろろむ',
  'しろろり',
  'しろわに',
  'しろんぼ',
  'しわける',
  'しわしわ',
  'じわじわ',
  'じわっと',
  'しわとり',
  'しわばむ',
  'しわぶき',
  'しわぶく',
  'しわほう',
  'しわよせ',
  'しんあい',
  'じんあい',
  'しんあん',
  'しんいき',
  'しんいぎ',
  'しんいり',
  'しんいん',
  'じんいん',
  'しんうち',
  'しんうん',
  'しんえい',
  'じんえい',
  'しんえき',
  'しんえつ',
  'しんえね',
  'しんえん',
  'じんえん',
  'しんおう',
  'しんおん',
  'しんかー',
  'しんがー',
  'しんかい',
  'しんがい',
  'じんかい',
  'じんがい',
  'しんがお',
  'しんかき',
  'しんかく',
  'しんがく',
  'じんかく',
  'じんがさ',
  'しんがた',
  'しんかな',
  'じんがね',
  'しんかぶ',
  'しんかべ',
  'しんかや',
  'しんから',
  'しんがら',
  'しんがり',
  'じんがり',
  'しんかん',
  'しんがん',
  'じんかん',
  'しんきこ',
  'しんぎち',
  'しんきょ',
  'じんきょ',
  'しんきん',
  'しんぎん',
  'しんくい',
  'しんくう',
  'しんぐう',
  'じんぐう',
  'じんくす',
  'しんくみ',
  'しんぐる',
  'じんぐる',
  'しんくろ',
  'しんぐん',
  'じんくん',
  'しんけい',
  'じんけい',
  'しんげき',
  'しんけつ',
  'しんげつ',
  'じんけつ',
  'じんげる',
  'しんけん',
  'しんげん',
  'じんけん',
  'しんこう',
  'しんごう',
  'じんこう',
  'しんこく',
  'しんこつ',
  'じんこつ',
  'しんごま',
  'しんこん',
  'しんごん',
  'しんさい',
  'しんざい',
  'じんさい',
  'じんざい',
  'しんさく',
  'しんさつ',
  'しんさん',
  'しんざん',
  'しんしあ',
  'じんじか',
  'しんしき',
  'しんじち',
  'しんしつ',
  'しんじつ',
  'じんじつ',
  'じんじぶ',
  'しんしゃ',
  'しんじゃ',
  'じんしゃ',
  'じんじゃ',
  'しんしゅ',
  'しんじゅ',
  'じんしゅ',
  'じんじゅ',
  'しんしょ',
  'しんじょ',
  'じんじょ',
  'しんじる',
  'しんしん',
  'しんじん',
  'じんしん',
  'じんじん',
  'しんすい',
  'しんずい',
  'じんすい',
  'じんずい',
  'しんすう',
  'しんずる',
  'しんせい',
  'しんぜい',
  'じんせい',
  'しんせき',
  'じんせき',
  'しんせつ',
  'しんぜる',
  'しんせん',
  'しんぜん',
  'じんせん',
  'じんぜん',
  'しんそう',
  'しんぞう',
  'じんぞう',
  'しんそく',
  'しんぞく',
  'じんそく',
  'しんそこ',
  'しんそつ',
  'しんそば',
  'しんだー',
  'しんたい',
  'しんだい',
  'じんたい',
  'じんだい',
  'しんたく',
  'しんだち',
  'しんたつ',
  'しんだつ',
  'じんだて',
  'しんたま',
  'しんたん',
  'しんだん',
  'じんたん',
  'しんちく',
  'じんちく',
  'しんちゃ',
  'しんちょ',
  'しんちん',
  'しんつう',
  'じんつう',
  'しんづけ',
  'しんてい',
  'じんてい',
  'しんてき',
  'じんてき',
  'しんでし',
  'しんでも',
  'しんてん',
  'しんでん',
  'じんてん',
  'しんどい',
  'しんとう',
  'しんどう',
  'じんとう',
  'じんどう',
  'しんとき',
  'しんとく',
  'しんどく',
  'じんとく',
  'しんどご',
  'じんとり',
  'じんどる',
  'しんなー',
  'しんない',
  'じんない',
  'しんなな',
  'しんなり',
  'じんにく',
  'しんにち',
  'しんにょ',
  'しんにん',
  'しんねり',
  'しんねん',
  'じんねん',
  'しんのう',
  'じんのう',
  'しんのり',
  'しんはい',
  'しんぱい',
  'じんはい',
  'じんぱい',
  'しんぱく',
  'しんばし',
  'しんばつ',
  'しんぱつ',
  'しんばる',
  'じんばる',
  'しんばん',
  'しんぱん',
  'しんぴつ',
  'しんびん',
  'しんぴん',
  'じんぴん',
  'しんぷう',
  'じんぷう',
  'しんぷく',
  'しんぶつ',
  'じんぶつ',
  'しんぶる',
  'しんぷる',
  'じんぶれ',
  'しんぶん',
  'じんぶん',
  'じんぷん',
  'しんべい',
  'しんぺい',
  'じんべい',
  'じんべえ',
  'しんべつ',
  'しんぺん',
  'しんほう',
  'しんぼう',
  'しんぽう',
  'じんぼう',
  'じんぽう',
  'しんぼく',
  'しんぽく',
  'しんぼち',
  'じんぼつ',
  'しんぼる',
  'しんぼん',
  'しんぽん',
  'しんまい',
  'しんまく',
  'じんまく',
  'しんまま',
  'じんみー',
  'しんみせ',
  'しんみつ',
  'しんみり',
  'しんみん',
  'じんみん',
  'しんめい',
  'じんめい',
  'じんめつ',
  'じんめん',
  'しんもう',
  'じんもく',
  'しんもつ',
  'しんもん',
  'じんもん',
  'しんやく',
  'しんゆう',
  'しんよう',
  'じんよう',
  'じんよく',
  'しんよめ',
  'しんらい',
  'じんらい',
  'しんらつ',
  'しんりき',
  'じんりき',
  'しんりち',
  'しんりつ',
  'しんりょ',
  'しんりん',
  'じんりん',
  'しんるい',
  'じんるい',
  'しんれい',
  'しんれき',
  'じんれつ',
  'しんろう',
  'じんろう',
  'しんろく',
  'じんろく',
  'しんろん',
  'しんわら',
  'じんわり',
  'すあらい',
  'すあわせ',
  'ずあんか',
  'すいあげ',
  'すいあつ',
  'すいある',
  'すいいき',
  'すいいず',
  'ずいいち',
  'すいーつ',
  'ずいいつ',
  'すぃーと',
  'すいーと',
  'すいーぷ',
  'ずぃーる',
  'ずいいん',
  'すいうん',
  'ずいうん',
  'すいえい',
  'すいえき',
  'ずいえき',
  'すいえし',
  'すいえん',
  'すいおん',
  'すいかい',
  'すいがい',
  'すいかく',
  'すいかけ',
  'すいがら',
  'すいかん',
  'すいがん',
  'ずいかん',
  'すいきく',
  'すいきょ',
  'すいぎょ',
  'すいきん',
  'すいぎん',
  'すいくち',
  'すいくん',
  'すいぐん',
  'すいけい',
  'すいげき',
  'すいげつ',
  'すいけん',
  'すいげん',
  'すいこう',
  'すいごう',
  'ずいこう',
  'すいこみ',
  'すいこむ',
  'すいさい',
  'すいさつ',
  'すいさん',
  'すいざん',
  'すいしつ',
  'ずいしつ',
  'すいじば',
  'すいじぶ',
  'すいしゃ',
  'すいしゅ',
  'ずいしょ',
  'すいしん',
  'すいじん',
  'ずいしん',
  'ずいじん',
  'すいすい',
  'すいせい',
  'ずいせい',
  'すいせき',
  'すいせん',
  'すいぜん',
  'すいそう',
  'すいぞう',
  'ずいそう',
  'すいそか',
  'すいそく',
  'すいぞく',
  'すいそん',
  'すいたい',
  'すいだい',
  'すいだす',
  'すいだん',
  'すいつく',
  'すぃっち',
  'すいっち',
  'すいてい',
  'すいてき',
  'すいてん',
  'すいでん',
  'すいとう',
  'すいどう',
  'ずいどう',
  'すいどく',
  'すいとる',
  'すいとん',
  'すいなん',
  'すいにん',
  'すいのう',
  'ずいのう',
  'すいのみ',
  'すいばく',
  'すいばる',
  'すいはん',
  'すいばん',
  'ずいはん',
  'ずいひつ',
  'すいひん',
  'すいびん',
  'すいふく',
  'すいふと',
  'すいふろ',
  'すいぶん',
  'ずいぶん',
  'すいへい',
  'すいべる',
  'すいへん',
  'すいほう',
  'すいぼう',
  'すいぼく',
  'すいぼつ',
  'すいまー',
  'ずいまく',
  'すいみつ',
  'すいみん',
  'ずいむし',
  'すいめい',
  'すいめつ',
  'すいめん',
  'すいもう',
  'すいもく',
  'すいもの',
  'すいもん',
  'すいやく',
  'すいよう',
  'すいよく',
  'すいらい',
  'すいらん',
  'すいりく',
  'すいれい',
  'すいれん',
  'すいろん',
  'すいんぐ',
  'すういく',
  'すうぇー',
  'すうぇる',
  'ずうぉち',
  'すうかい',
  'すうがく',
  'すうけい',
  'すうげつ',
  'すうけん',
  'すうこう',
  'すうこく',
  'すうさつ',
  'すうしき',
  'すうじく',
  'すうじつ',
  'すうじふ',
  'すうしゃ',
  'すうしゅ',
  'すうすう',
  'すーすー',
  'すうせい',
  'すうせき',
  'すうせん',
  'すうそう',
  'すうたい',
  'ずうたい',
  'すーたん',
  'すうだん',
  'すーだん',
  'すうちか',
  'すうちご',
  'すうっと',
  'すーっと',
  'ずうっと',
  'ずーっと',
  'すうてき',
  'すうとう',
  'すうどく',
  'すーどら',
  'すうどん',
  'すうにん',
  'すうねん',
  'すーぱー',
  'すうはい',
  'すうばい',
  'すうぱい',
  'すうぱつ',
  'すうひき',
  'すーふぃ',
  'すうふん',
  'すうまい',
  'すうまん',
  'すうみつ',
  'すうめい',
  'すうよう',
  'ずーれー',
  'すうれつ',
  'すうろん',
  'すえーど',
  'すえおき',
  'すえおく',
  'すえきち',
  'すえごろ',
  'すえざら',
  'すえずえ',
  'すえぜん',
  'すえつけ',
  'すえっこ',
  'すぇっと',
  'すえっと',
  'すえなり',
  'すえのよ',
  'すえひろ',
  'すえふろ',
  'すえもの',
  'すおみご',
  'すかーと',
  'すかーふ',
  'すかーる',
  'すかうと',
  'すがくれ',
  'すかさず',
  'すかじー',
  'すかしえ',
  'すかすか',
  'ずかずか',
  'すかせる',
  'すがたえ',
  'すがたず',
  'すがたに',
  'すがたみ',
  'すがたり',
  'すかっと',
  'すかっど',
  'すがでる',
  'すかとろ',
  'ずがない',
  'すがめる',
  'すからー',
  'すからち',
  'すからぶ',
  'すからべ',
  'すかるぷ',
  'すがれる',
  'すかんく',
  'すかんぴ',
  'すかんぽ',
  'すぎあい',
  'すきあや',
  'すきあり',
  'すぎいく',
  'すきーじ',
  'すぎいた',
  'すきーま',
  'すきーむ',
  'すきいれ',
  'すぎがき',
  'すぎかわ',
  'すきくわ',
  'すぎごけ',
  'すぎこし',
  'すぎざい',
  'すぎさる',
  'すきしゃ',
  'すきずき',
  'ずきずき',
  'すぎせき',
  'すぎたま',
  'すぎだま',
  'すきっと',
  'すきっど',
  'すきっぷ',
  'すきにー',
  'すぎばし',
  'すきはら',
  'すきばら',
  'すきびき',
  'すきへん',
  'すきまー',
  'すぎむら',
  'すきもの',
  'すぎもの',
  'すきやき',
  'すきゃな',
  'すきゃぷ',
  'すきゃん',
  'すきゅー',
  'すぎゆく',
  'すきゅら',
  'すぎょう',
  'ずきょう',
  'すぎわい',
  'すくいじ',
  'すくいず',
  'すくーば',
  'すくーぷ',
  'すくーる',
  'すくぇあ',
  'すくえあ',
  'すぐさま',
  'すくしょ',
  'すくすく',
  'すぐそこ',
  'すぐそば',
  'ずくてつ',
  'すくない',
  'すくなげ',
  'ずくなし',
  'すくなめ',
  'すぐにも',
  'すくぶす',
  'すくみず',
  'すぐみち',
  'すくめる',
  'すくよう',
  'すくらぶ',
  'すくらむ',
  'すくりむ',
  'すぐれた',
  'すぐれて',
  'すぐれる',
  'すぐろく',
  'すけーと',
  'すけーら',
  'すけーる',
  'すげがさ',
  'すけかん',
  'すけすけ',
  'ずけずけ',
  'すけぜい',
  'すけだち',
  'すけっち',
  'すけっと',
  'すけっぱ',
  'すげない',
  'すけばん',
  'すけべい',
  'すけべえ',
  'すけぼー',
  'すけろく',
  'すこあら',
  'すごうで',
  'すこーと',
  'すこーぷ',
  'すこーる',
  'すこーん',
  'すこしく',
  'すこしも',
  'すこすこ',
  'すごすご',
  'すこっち',
  'すこっぷ',
  'すこぴえ',
  'すこぶる',
  'すごもり',
  'すごもる',
  'すこやか',
  'すこりあ',
  'すごろく',
  'すごわざ',
  'すこんく',
  'すこんぶ',
  'すざかな',
  'すさのお',
  'すさのを',
  'すじあい',
  'すじえび',
  'すじかい',
  'すじがき',
  'すじがね',
  'ずしがめ',
  'すじぐも',
  'すしごめ',
  'ずしずし',
  'すじだて',
  'ずしだな',
  'すしだね',
  'ずしっと',
  'すしづめ',
  'すしてん',
  'すじなわ',
  'すじにく',
  'すしのぐ',
  'すじばる',
  'すじべら',
  'すじぼね',
  'すしまい',
  'すじみち',
  'すしめし',
  'すじもの',
  'すじもん',
  'すじゃく',
  'すじょう',
  'ずじょう',
  'すじろく',
  'すずいし',
  'すすいろ',
  'すずかぜ',
  'すずがも',
  'すずぐち',
  'すすける',
  'すずしい',
  'すずしげ',
  'すずしさ',
  'すずしろ',
  'すすたけ',
  'すすだけ',
  'すずたけ',
  'すずなり',
  'すすはき',
  'すずはく',
  'すずむし',
  'すずめが',
  'すすめる',
  'すずやか',
  'すずらん',
  'すすんで',
  'すそあげ',
  'すそうら',
  'すそがり',
  'すそぎり',
  'すそつき',
  'すそとり',
  'すそよけ',
  'すそわけ',
  'すたーち',
  'すたーと',
  'すたいる',
  'すたいん',
  'すたうと',
  'すだおし',
  'すたこら',
  'すだじい',
  'すたじお',
  'すたすた',
  'ずたずた',
  'ずだずだ',
  'すたちん',
  'すたっく',
  'すたっこ',
  'すたっつ',
  'すたっど',
  'すたっふ',
  'すたでぃ',
  'すたてる',
  'すたばく',
  'すたばる',
  'ずたぼろ',
  'すたみな',
  'すためん',
  'すたれた',
  'すたれる',
  'すたんざ',
  'すたんす',
  'すたんつ',
  'すたんと',
  'すたんど',
  'すたんぷ',
  'すちーむ',
  'すちーる',
  'すちこん',
  'ずちなし',
  'すちょう',
  'すちるぶ',
  'すちれん',
  'すつーる',
  'すっかり',
  'すっきり',
  'すっくと',
  'すっくり',
  'すづくり',
  'すっげぇ',
  'すっげえ',
  'すっげー',
  'すっごい',
  'ずっこい',
  'すっごく',
  'ずっこけ',
  'すっこむ',
  'ずっしり',
  'すっすっ',
  'すっちー',
  'すっとぶ',
  'ずっとも',
  'ずつなし',
  'すっぱい',
  'すっぱみ',
  'すっぱり',
  'すっぴん',
  'ずっぷり',
  'ずっぽし',
  'すっぽり',
  'ずっぽり',
  'すっぽん',
  'すていし',
  'すていと',
  'すていぬ',
  'すていん',
  'すてうり',
  'すてーき',
  'すてーじ',
  'すてーと',
  'すておく',
  'すてかせ',
  'すてかつ',
  'すてがな',
  'すてがね',
  'すてごま',
  'すてこみ',
  'すてこん',
  'すてさる',
  'すてっき',
  'すてっち',
  'すてっぷ',
  'すてでぃ',
  'すててこ',
  'すてねこ',
  'すてはい',
  'すてぱい',
  'すてばか',
  'すてばち',
  'すてびあ',
  'すてふだ',
  'すてぶち',
  'すてぽじ',
  'すてやま',
  'すてるす',
  'すてれお',
  'すてんと',
  'すとあー',
  'すとーゔ',
  'すどおし',
  'すとーぶ',
  'すとーま',
  'すとーむ',
  'すとーり',
  'すどおり',
  'すとーる',
  'すとーん',
  'すとけん',
  'すとっく',
  'すとっぷ',
  'すとぱー',
  'すとばす',
  'すとまい',
  'すどまり',
  'すとれす',
  'すとろー',
  'すとろぼ',
  'すとろま',
  'すとろん',
  'すとんぷ',
  'すなあび',
  'すながに',
  'すなかべ',
  'すながみ',
  'すなぎも',
  'すなずり',
  'すなっく',
  'すなっち',
  'すなっふ',
  'すなつぶ',
  'すなっぷ',
  'すなどり',
  'すなどる',
  'すなねこ',
  'すなのみ',
  'すなばち',
  'すなはま',
  'すなはら',
  'すなふき',
  'すなぶろ',
  'すなむし',
  'すなめり',
  'すなやま',
  'すなわち',
  'すにっぷ',
  'ずにのる',
  'すにふぁ',
  'すぬーす',
  'すぬーず',
  'ずぬける',
  'すねあて',
  'すねいく',
  'すねーく',
  'すねっぷ',
  'すねにく',
  'すねもの',
  'すのっぶ',
  'すのぼる',
  'すのもの',
  'すぱーく',
  'すぱーと',
  'すぱーら',
  'すぱいく',
  'すぱいす',
  'すぱいだ',
  'すぱいん',
  'すぱこん',
  'すばしり',
  'ずばずば',
  'すぱずむ',
  'すぱせん',
  'すはだか',
  'すはだし',
  'すぱだり',
  'すぱっつ',
  'すぱっと',
  'ずばっと',
  'すぱてる',
  'すばなし',
  'すばなれ',
  'すぱぶろ',
  'すばやい',
  'すぱんじ',
  'すぴーか',
  'すぴーく',
  'すぴーち',
  'すぴーど',
  'すぴけい',
  'すぴこん',
  'すぴっつ',
  'すぴなー',
  'すぴねる',
  'すぴのる',
  'ずひょう',
  'すぴるら',
  'すぷーら',
  'すぷーる',
  'すぷーん',
  'すぶえこ',
  'ずぶずぶ',
  'ずぶとい',
  'ずぶぬれ',
  'ずぶねり',
  'すぷれー',
  'すぺあな',
  'すぺいん',
  'すぺーさ',
  'すぺーす',
  'すぺーど',
  'すべおさ',
  'ずべこう',
  'すべすべ',
  'すぺっく',
  'すべなし',
  'すべらか',
  'すべらぎ',
  'すべらす',
  'すべりめ',
  'すぺるま',
  'すぽいと',
  'すぽいる',
  'すぽーく',
  'すぽーつ',
  'すぽーん',
  'すぽくら',
  'すぽこん',
  'すぽっと',
  'ずぼっと',
  'すぽどり',
  'すぽぶら',
  'すぼまる',
  'すぼめる',
  'すぽんさ',
  'すぽんじ',
  'すまーと',
  'すまーふ',
  'すまいて',
  'すまいる',
  'すまごと',
  'すまじき',
  'すましや',
  'すませる',
  'すまっく',
  'すまとら',
  'すまどら',
  'すまない',
  'すまふぉ',
  'すまへん',
  'すみあー',
  'すみいか',
  'すみいと',
  'すみいれ',
  'すみいろ',
  'すみいん',
  'すみかえ',
  'すみがき',
  'すみがま',
  'すみきる',
  'すみきん',
  'すみけし',
  'すみこみ',
  'すみこむ',
  'すみずみ',
  'すみずり',
  'すみせん',
  'すみぞめ',
  'すみつき',
  'すみつぎ',
  'すみつく',
  'すみつけ',
  'すみっこ',
  'すみつぼ',
  'すみとり',
  'すみなわ',
  'すみはん',
  'すみべた',
  'すみむね',
  'すみやか',
  'すみやき',
  'すみよい',
  'すみれか',
  'すみわけ',
  'すむーす',
  'すむーず',
  'すめあー',
  'すめぐま',
  'すめはら',
  'すめみま',
  'すめらき',
  'すめらぎ',
  'すめろぎ',
  'すもうじ',
  'すもーく',
  'すもーる',
  'すもかー',
  'すもぐり',
  'すもたら',
  'すもっく',
  'すもっぐ',
  'すもはら',
  'すやすや',
  'すらいす',
  'すらいだ',
  'すらいど',
  'すらいむ',
  'ずらかる',
  'すらすと',
  'すらすら',
  'ずらずら',
  'すらっく',
  'すらっぐ',
  'すらっじ',
  'すらっと',
  'ずらっと',
  'すらむか',
  'すらりー',
  'すらんぐ',
  'すらんぷ',
  'すりあし',
  'すりーゔ',
  'すりーぶ',
  'すりーぷ',
  'すりかた',
  'すりきず',
  'すりぎぬ',
  'すりきり',
  'すりきる',
  'すりけす',
  'すりこぎ',
  'すりごま',
  'すりこみ',
  'すりこむ',
  'ずりこむ',
  'すりすり',
  'ずりせん',
  'すりぞめ',
  'すりだし',
  'すりだす',
  'すりたて',
  'すりった',
  'すりっと',
  'すりっぱ',
  'すりっぷ',
  'ずりでる',
  'すりなむ',
  'ずりねた',
  'ずりばい',
  'すりはく',
  'すりばち',
  'すりばん',
  'すりへる',
  'すりほん',
  'すりむか',
  'すりむく',
  'すりもの',
  'ずりやま',
  'ずりょう',
  'すりよる',
  'すりらー',
  'すりんぐ',
  'するーぷ',
  'ずるける',
  'するする',
  'ずるずる',
  'するたん',
  'ずるちん',
  'するっと',
  'するどい',
  'するべき',
  'するほき',
  'ずるむけ',
  'すれあう',
  'すれいゔ',
  'すれいぶ',
  'すれーゔ',
  'すれーき',
  'すれーと',
  'すれーぶ',
  'すれきず',
  'ずれこむ',
  'すれすれ',
  'すれたい',
  'すれっど',
  'すれぬし',
  'ずろーす',
  'すろーと',
  'すろーぷ',
  'すろっと',
  'すわいぷ',
  'すわじご',
  'すわっち',
  'すわっと',
  'すわっぷ',
  'すわりゆ',
  'ずをかく',
  'すをくう',
  'すんいん',
  'すんかん',
  'ずんぐり',
  'すんげぇ',
  'すんげえ',
  'すんげー',
  'すんげき',
  'すんげん',
  'すんごい',
  'すんごう',
  'すんこく',
  'すんごく',
  'ずんずん',
  'すんぜん',
  'すんだご',
  'すんだん',
  'すんてつ',
  'すんでに',
  'ずんどう',
  'すんどめ',
  'すんなは',
  'すんなり',
  'すんにー',
  'すんには',
  'すんぶん',
  'すんぷん',
  'すんぽう',
  'せあぶら',
  'せいあい',
  'せいあく',
  'せいあつ',
  'せいあん',
  'せいいき',
  'せいいく',
  'せいいち',
  'せいいつ',
  'せいいん',
  'ぜいいん',
  'せいうち',
  'せいうん',
  'せいえい',
  'せいえき',
  'せいえつ',
  'せいえん',
  'せいおう',
  'せいおん',
  'せいかい',
  'せいかく',
  'せいがく',
  'ぜいがく',
  'せいかご',
  'せいかつ',
  'せいかん',
  'せいがん',
  'ぜいかん',
  'せいきか',
  'せいきく',
  'せいきょ',
  'せいぎょ',
  'せいきん',
  'ぜいきん',
  'せいくう',
  'せいくん',
  'せいぐん',
  'せいけい',
  'せいけつ',
  'せいげつ',
  'せいけん',
  'せいげん',
  'ぜいげん',
  'せいこう',
  'せいごう',
  'せいこく',
  'せいこつ',
  'ぜいこみ',
  'せいこん',
  'せいごん',
  'せいさい',
  'せいざい',
  'せいさく',
  'せいざず',
  'せいさつ',
  'せいさん',
  'せいざん',
  'せいしが',
  'せいじか',
  'せいしき',
  'せいしつ',
  'せいじつ',
  'せいしゃ',
  'せいじゃ',
  'せいじや',
  'せいしゅ',
  'せいじゅ',
  'せいしょ',
  'せいじょ',
  'せいしん',
  'せいじん',
  'せいすい',
  'せいずい',
  'せいすう',
  'せいずか',
  'せいする',
  'ぜいする',
  'せいせい',
  'せいぜい',
  'ぜいせい',
  'ぜいぜい',
  'せいせき',
  'せいせつ',
  'せいぜつ',
  'せいせん',
  'せいぜん',
  'せいそう',
  'せいぞう',
  'せいそく',
  'せいぞく',
  'せいぞん',
  'せいたい',
  'せいだい',
  'せいたか',
  'せいたく',
  'せいだく',
  'ぜいたく',
  'せいたけ',
  'せいだす',
  'せいたん',
  'せいだん',
  'せいちか',
  'ぜいちく',
  'せいちゃ',
  'せいちん',
  'せいつう',
  'せいてい',
  'せいてき',
  'せいてつ',
  'せいてん',
  'せいでん',
  'せいとう',
  'せいどう',
  'せいどか',
  'せいとく',
  'せいどく',
  'せいとし',
  'せいとん',
  'せいどん',
  'せいなる',
  'せいなん',
  'せいにく',
  'ぜいにく',
  'せいにち',
  'ぜいぬき',
  'せいねい',
  'せいねこ',
  'せいねん',
  'せいのう',
  'せいのー',
  'せいのじ',
  'せいはい',
  'せいばい',
  'せいはく',
  'せいばく',
  'せいはつ',
  'せいばつ',
  'せいばね',
  'せいはん',
  'せいばん',
  'せいぱん',
  'せいびき',
  'ぜいひき',
  'ぜいびき',
  'せいびし',
  'せいひつ',
  'せいびひ',
  'せいひん',
  'せいふう',
  'せいふく',
  'せいぶつ',
  'せいふん',
  'せいぶん',
  'せいへい',
  'せいへき',
  'せいべつ',
  'ぜいべつ',
  'せいへん',
  'せいほう',
  'せいぼう',
  'ぜいほう',
  'せいほく',
  'せいぼく',
  'せいぼつ',
  'せいほん',
  'せいまい',
  'せいまく',
  'せいみつ',
  'せいめい',
  'せいめん',
  'せいもく',
  'ぜいもく',
  'せいもん',
  'せいやく',
  'せいゆう',
  'せいよう',
  'せいよく',
  'せいらー',
  'せいらい',
  'せいらく',
  'せいらん',
  'ぜいりし',
  'せいりつ',
  'ぜいりつ',
  'せいりび',
  'せいりぶ',
  'せいりや',
  'せいるい',
  'せいれい',
  'せいれき',
  'せいれつ',
  'せいれん',
  'せいろう',
  'ぜいろく',
  'せいろん',
  'せいんと',
  'ぜえぜえ',
  'ぜーぜー',
  'せえたー',
  'せーたー',
  'せーぶる',
  'せえへん',
  'せーへん',
  'せーらー',
  'せーるす',
  'ぜえろく',
  'せおよぎ',
  'せおりー',
  'せかいご',
  'せかいし',
  'せかいじ',
  'せかせか',
  'せかせる',
  'せがたつ',
  'ぜかひか',
  'せかんと',
  'せかんど',
  'せきあく',
  'せきいた',
  'せきいり',
  'せきうん',
  'せきえい',
  'せきえん',
  'せきおう',
  'せきがい',
  'せきがえ',
  'せきかく',
  'せきがく',
  'せきかん',
  'せきがん',
  'せきぐち',
  'せきぐん',
  'せきけい',
  'せきこむ',
  'せきさい',
  'せきざい',
  'せきさく',
  'せきさん',
  'せきしつ',
  'せきじつ',
  'せきしゅ',
  'せきじゅ',
  'せきしょ',
  'せきじょ',
  'せきしん',
  'せきじん',
  'せきすい',
  'せきずい',
  'せきすん',
  'せきせい',
  'せきせき',
  'せきせつ',
  'せきせん',
  'せきぜん',
  'せきそう',
  'せきぞう',
  'せきぞく',
  'せきたい',
  'せきたん',
  'せきちく',
  'せきちん',
  'せきつい',
  'せきてい',
  'せきでい',
  'せきてき',
  'せきとう',
  'せきどう',
  'せきとく',
  'せきどめ',
  'せきとり',
  'せきにん',
  'せきねつ',
  'せきねん',
  'せきはい',
  'せきばく',
  'せきはん',
  'せきばん',
  'せきひつ',
  'せきひん',
  'せきぶつ',
  'せきぶね',
  'せきぶん',
  'せきへい',
  'せきへき',
  'せきべつ',
  'せきぼく',
  'せきめん',
  'せきもり',
  'せきゅあ',
  'せきよう',
  'せぎょう',
  'せきらら',
  'せきりつ',
  'せきりん',
  'せきるい',
  'せきれい',
  'せきれき',
  'せきろう',
  'せきわけ',
  'せきわり',
  'せきわん',
  'せくぐむ',
  'せくしぃ',
  'せくしー',
  'せくすぃ',
  'せくたー',
  'せくはら',
  'せくふれ',
  'せくまい',
  'せくらべ',
  'せくろす',
  'せけんち',
  'せこいあ',
  'せこはん',
  'せこんど',
  'せざーる',
  'せさみん',
  'せしうむ',
  'せしめる',
  'せじもの',
  'せしゅう',
  'せじゅつ',
  'せじょう',
  'せしょん',
  'ぜぜひひ',
  'せせらぎ',
  'せせらぐ',
  'せぞくか',
  'せたんか',
  'せちがい',
  'せちにち',
  'せちぶん',
  'せつあい',
  'せつあく',
  'せついん',
  'せつえい',
  'せつえん',
  'ぜつえん',
  'ぜつおん',
  'せっかい',
  'せつがい',
  'ぜっかい',
  'せっかく',
  'せっかち',
  'せっかん',
  'せつかん',
  'せつがん',
  'ぜつがん',
  'せっきん',
  'せつぐう',
  'せっくす',
  'せっくつ',
  'せっくる',
  'せっけい',
  'ぜっけい',
  'せっけつ',
  'せっけん',
  'せつげん',
  'ぜっけん',
  'せっこう',
  'せつごう',
  'ぜっこう',
  'せっこく',
  'せっこつ',
  'ぜっこつ',
  'せっこん',
  'ぜっこん',
  'せっさく',
  'せっさん',
  'せつざん',
  'ぜっさん',
  'せっしつ',
  'せつじつ',
  'せっしゃ',
  'せっしゅ',
  'せつじゅ',
  'せっしょ',
  'せつじょ',
  'せっしる',
  'せっしん',
  'せっすい',
  'せっする',
  'ぜっする',
  'せっせい',
  'せつぜい',
  'ぜっせい',
  'せつせつ',
  'せっせと',
  'せっせん',
  'せつぜん',
  'ぜっせん',
  'せっそう',
  'せつぞう',
  'せっそく',
  'せつぞく',
  'ぜっそく',
  'せったー',
  'せったい',
  'ぜったい',
  'ぜつだい',
  'せったく',
  'せつだん',
  'ぜったん',
  'せっちし',
  'せっちょ',
  'せっちん',
  'せっつく',
  'せってい',
  'せつでい',
  'ぜってぇ',
  'ぜってえ',
  'ぜってー',
  'せってき',
  'せってん',
  'せつでん',
  'せっとう',
  'せつどう',
  'ぜっとう',
  'せっとく',
  'せつどし',
  'せつない',
  'せつなる',
  'ぜつねん',
  'せっぱく',
  'せっぱん',
  'ぜっぱん',
  'せつびご',
  'せつびし',
  'せつびじ',
  'せっぴつ',
  'ぜっぴつ',
  'せつびひ',
  'ぜっぴん',
  'せっぷく',
  'せつぶん',
  'せっぷん',
  'ぜっぺき',
  'せっぺん',
  'せつぼう',
  'せっぽう',
  'ぜつぼう',
  'ぜっぽう',
  'せつまい',
  'せつめい',
  'ぜつめい',
  'ぜつめつ',
  'せつめん',
  'せつもう',
  'せつもん',
  'せつやく',
  'せつよう',
  'せつよく',
  'せつらい',
  'せつりつ',
  'ぜつりん',
  'せつれい',
  'せつれつ',
  'せつろん',
  'せどうか',
  'せとがや',
  'せとぎわ',
  'せとびき',
  'せともの',
  'せとやき',
  'ぜにいれ',
  'ぜにかね',
  'ぜにがめ',
  'ぜにごけ',
  'せにする',
  'ぜにばこ',
  'せにゅう',
  'せねがる',
  'ぜねこん',
  'ぜねすと',
  'せねたー',
  'ぜねらる',
  'せのーて',
  'せのきみ',
  'せぱーど',
  'せばまる',
  'せばめる',
  'ぜひぜひ',
  'せびちぇ',
  'ぜひとも',
  'ぜひない',
  'せひょう',
  'せびらき',
  'ぜふぁー',
  'せぷたむ',
  'せぶんす',
  'せぶんず',
  'せぼりー',
  'せまふぉ',
  'せみえび',
  'ぜみせい',
  'せみなー',
  'せみぷろ',
  'せみょう',
  'せみよん',
  'せむごは',
  'せむじん',
  'せむぞく',
  'せめあい',
  'せめあう',
  'せめいる',
  'せめうま',
  'せめくち',
  'せめぐち',
  'せめこむ',
  'せめても',
  'せめぬく',
  'せめんと',
  'せもたれ',
  'せもりな',
  'せらーど',
  'せらゔぃ',
  'ぜらちん',
  'せらっく',
  'せらぴー',
  'せらぴむ',
  'せらひん',
  'せらみど',
  'せられる',
  'せりあい',
  'せりあう',
  'せりある',
  'せりーぐ',
  'せりいし',
  'せりいち',
  'せりうむ',
  'せりうり',
  'せりかつ',
  'せりしん',
  'せりだい',
  'せりだす',
  'せりもく',
  'せりもち',
  'せりもと',
  'せりょう',
  'せるくる',
  'せるしん',
  'せるたす',
  'せるつき',
  'せるばす',
  'せるびあ',
  'せるふぃ',
  'せるほん',
  'せるらー',
  'せるりー',
  'せるろす',
  'せれおり',
  'せれくた',
  'せれくと',
  'せれしょ',
  'せれろん',
  'ぜろえみ',
  'ぜろがた',
  'ぜろから',
  'ぜろさい',
  'ぜろさむ',
  'ぜろせん',
  'せろはん',
  'ぜろはん',
  'ぜろよん',
  'せわしい',
  'せわしげ',
  'せわずき',
  'せわにん',
  'せわびと',
  'せわもの',
  'せわやき',
  'せわやく',
  'ぜんあく',
  'せんいき',
  'ぜんいき',
  'せんいず',
  'せんいそ',
  'せんいち',
  'せんいつ',
  'ぜんいつ',
  'せんいん',
  'ぜんいん',
  'せんうん',
  'せんえい',
  'ぜんえい',
  'せんえき',
  'せんえつ',
  'せんえん',
  'せんおう',
  'ぜんおう',
  'せんおく',
  'ぜんおん',
  'せんかい',
  'せんがい',
  'ぜんかい',
  'せんかく',
  'せんがく',
  'ぜんかく',
  'ぜんがく',
  'せんかし',
  'せんかた',
  'せんかち',
  'ぜんかつ',
  'せんかん',
  'せんがん',
  'ぜんかん',
  'ぜんがん',
  'ぜんきひ',
  'せんきゅ',
  'せんきょ',
  'せんぎょ',
  'せんぎり',
  'せんきん',
  'ぜんきん',
  'せんぐう',
  'せんくち',
  'せんくつ',
  'ぜんくつ',
  'せんくん',
  'せんぐん',
  'ぜんぐん',
  'せんけい',
  'ぜんけい',
  'せんげき',
  'せんけつ',
  'せんげつ',
  'ぜんげつ',
  'せんけん',
  'せんげん',
  'ぜんけん',
  'ぜんげん',
  'せんこう',
  'ぜんこう',
  'ぜんごう',
  'せんこく',
  'せんごく',
  'ぜんこく',
  'ぜんごし',
  'せんこつ',
  'せんごは',
  'せんころ',
  'ぜんこん',
  'せんさー',
  'せんさい',
  'せんざい',
  'ぜんさい',
  'ぜんざい',
  'せんさく',
  'ぜんさく',
  'せんさす',
  'ぜんさつ',
  'ぜんざん',
  'せんじか',
  'せんしつ',
  'せんじつ',
  'ぜんしつ',
  'ぜんじつ',
  'せんしゃ',
  'せんじゃ',
  'ぜんしゃ',
  'せんしゅ',
  'せんしょ',
  'せんじょ',
  'ぜんしょ',
  'せんじる',
  'せんしん',
  'せんじん',
  'ぜんしん',
  'ぜんじん',
  'せんすい',
  'ぜんすう',
  'せんすじ',
  'ぜんすと',
  'せんすべ',
  'せんずり',
  'せんする',
  'せんずる',
  'ぜんする',
  'せんせい',
  'せんぜい',
  'ぜんせい',
  'ぜんぜい',
  'せんせき',
  'ぜんせき',
  'ぜんせつ',
  'せんせん',
  'せんぜん',
  'ぜんせん',
  'ぜんぜん',
  'せんそう',
  'せんぞう',
  'ぜんそう',
  'ぜんぞう',
  'せんそく',
  'せんぞく',
  'ぜんそく',
  'ぜんそん',
  'せんたー',
  'せんたい',
  'せんだい',
  'ぜんたい',
  'ぜんだい',
  'せんたく',
  'せんだく',
  'ぜんだく',
  'せんだち',
  'せんだつ',
  'ぜんだて',
  'ぜんだま',
  'せんたん',
  'せんだん',
  'ぜんたん',
  'ぜんだん',
  'ぜんちし',
  'せんちも',
  'せんちゃ',
  'ぜんちょ',
  'ぜんちん',
  'せんつい',
  'せんつう',
  'ぜんつう',
  'せんてぃ',
  'せんてい',
  'ぜんてい',
  'せんでき',
  'ぜんてき',
  'せんてつ',
  'ぜんてつ',
  'ぜんでら',
  'せんてん',
  'せんでん',
  'ぜんてん',
  'ぜんでん',
  'せんとう',
  'せんどう',
  'ぜんとう',
  'ぜんどう',
  'せんとき',
  'せんとく',
  'ぜんとく',
  'せんない',
  'せんなり',
  'ぜんなん',
  'せんにく',
  'せんにち',
  'せんにゅ',
  'せんにょ',
  'ぜんにょ',
  'せんにん',
  'ぜんにん',
  'せんぬき',
  'せんねつ',
  'せんねん',
  'ぜんねん',
  'せんのう',
  'ぜんのう',
  'せんのき',
  'せんばい',
  'せんぱい',
  'ぜんぱい',
  'せんぱく',
  'ぜんはく',
  'ぜんばく',
  'ぜんぱく',
  'せんばつ',
  'せんぱつ',
  'せんばら',
  'せんばん',
  'せんぱん',
  'ぜんはん',
  'ぜんぱん',
  'せんひき',
  'せんびき',
  'せんぴつ',
  'せんびん',
  'ぜんびん',
  'ぜんぴん',
  'せんぷう',
  'せんぷく',
  'ぜんぷく',
  'ぜんぶつ',
  'せんぶり',
  'せんぶん',
  'ぜんぶん',
  'せんべい',
  'せんぺい',
  'ぜんべい',
  'ぜんぺき',
  'せんべつ',
  'せんべろ',
  'せんべん',
  'せんぺん',
  'ぜんぺん',
  'せんぼう',
  'せんぽう',
  'ぜんぼう',
  'ぜんぽう',
  'せんぼく',
  'せんぼつ',
  'せんまい',
  'ぜんまい',
  'せんまけ',
  'せんまん',
  'せんみん',
  'せんめい',
  'ぜんめい',
  'せんめつ',
  'ぜんめつ',
  'せんめん',
  'ぜんめん',
  'せんもう',
  'ぜんもう',
  'せんもじ',
  'せんもん',
  'ぜんもん',
  'せんやく',
  'ぜんやく',
  'せんゆう',
  'ぜんゆう',
  'せんよう',
  'ぜんよう',
  'ぜんらく',
  'せんらん',
  'ぜんらん',
  'せんりつ',
  'せんりょ',
  'ぜんりん',
  'せんるい',
  'せんれい',
  'ぜんれい',
  'せんれき',
  'ぜんれき',
  'せんれつ',
  'ぜんれつ',
  'せんれん',
  'ぜんろう',
  'せんろく',
  'せんろふ',
  'ぜんわん',
  'そあらー',
  'そいじゃ',
  'そいつら',
  'そいぶし',
  'そいぼし',
  'そうあい',
  'そうあげ',
  'そうあん',
  'そういう',
  'そういや',
  'そういん',
  'ぞういん',
  'そううつ',
  'そううら',
  'そううん',
  'ぞうえい',
  'ぞうえき',
  'そうえん',
  'ぞうえん',
  'そうおう',
  'そうおく',
  'そうおん',
  'そうかい',
  'そうがい',
  'そうかく',
  'そうがく',
  'ぞうかく',
  'ぞうがく',
  'そうがち',
  'そうかつ',
  'そうがな',
  'ぞうがめ',
  'そうがら',
  'そうがわ',
  'そうかん',
  'そうがん',
  'ぞうかん',
  'ぞうがん',
  'そうぎゃ',
  'そうぎや',
  'そうきょ',
  'そうぎょ',
  'そうぎり',
  'そうきん',
  'そうぎん',
  'ぞうきん',
  'そうくう',
  'そうぐう',
  'そうくつ',
  'そうぐん',
  'そうけい',
  'そうげい',
  'ぞうけい',
  'ぞうげい',
  'そうけつ',
  'そうげつ',
  'ぞうけつ',
  'そうけん',
  'そうげん',
  'ぞうげん',
  'そうこう',
  'そうごう',
  'ぞうごう',
  'そうこく',
  'そうこん',
  'そうごん',
  'ぞうごん',
  'そうさい',
  'そうざい',
  'そうさか',
  'そうさき',
  'そうさく',
  'ぞうさく',
  'そうさつ',
  'そうざつ',
  'ぞうさつ',
  'そうさぶ',
  'そうざん',
  'ぞうさん',
  'そうしき',
  'そうじき',
  'ぞうしき',
  'そうした',
  'そうしつ',
  'そうして',
  'そうじて',
  'そうじひ',
  'そうしぶ',
  'そうじふ',
  'そうじみ',
  'そうじめ',
  'そうしゃ',
  'そうじゃ',
  'そうじや',
  'ぞうしゃ',
  'そうしゅ',
  'そうじゅ',
  'ぞうしゅ',
  'そうしょ',
  'そうじょ',
  'ぞうしょ',
  'そうしん',
  'そうじん',
  'ぞうしん',
  'そうすい',
  'ぞうすい',
  'そうすう',
  'そうずく',
  'そうする',
  'ぞうする',
  'そうせい',
  'そうぜい',
  'ぞうせい',
  'ぞうぜい',
  'そうせき',
  'そうせつ',
  'そうぜつ',
  'ぞうせつ',
  'そうせん',
  'そうぜん',
  'ぞうせん',
  'そうそう',
  'そうぞう',
  'ぞうぞう',
  'そうそく',
  'そうぞく',
  'そうそつ',
  'そうそふ',
  'そうそぼ',
  'そうそん',
  'そうたい',
  'そうだい',
  'ぞうたい',
  'ぞうだい',
  'そうだか',
  'そうたく',
  'そうだち',
  'そうたつ',
  'そうだつ',
  'そうだね',
  'そうたん',
  'そうだん',
  'ぞうちく',
  'そうつい',
  'そうっと',
  'そうてい',
  'ぞうてい',
  'そうです',
  'そうてん',
  'そうでん',
  'そうとう',
  'そうどう',
  'ぞうとう',
  'そうとく',
  'そうどく',
  'ぞうとく',
  'そうとも',
  'そうどり',
  'そうとん',
  'そうなめ',
  'そうなん',
  'そうにん',
  'ぞうにん',
  'そうねえ',
  'そうねん',
  'そうのて',
  'そうはい',
  'そうばい',
  'ぞうはい',
  'そうはく',
  'ぞうはく',
  'そうばし',
  'そうはつ',
  'そうばつ',
  'ぞうはつ',
  'そうばな',
  'そうはん',
  'そうばん',
  'ぞうはん',
  'そうびん',
  'ぞうひん',
  'ぞうびん',
  'そうふう',
  'そうふく',
  'ぞうふく',
  'ぞうぶつ',
  'そうふん',
  'ぞうぶん',
  'そうへい',
  'ぞうへい',
  'そうへき',
  'そうべつ',
  'そうほう',
  'そうぼう',
  'ぞうほう',
  'ぞうぼう',
  'ぞうぼく',
  'そうほん',
  'ぞうほん',
  'そうむか',
  'ぞうむし',
  'そうむぶ',
  'そうめい',
  'そうめつ',
  'そうめん',
  'ぞうめん',
  'そうもう',
  'そうもく',
  'ぞうもつ',
  'そうもん',
  'そうやく',
  'そうゆう',
  'ぞうゆう',
  'そうよう',
  'ぞうよう',
  'そうよく',
  'そうらう',
  'そうらん',
  'そうりつ',
  'ぞうりつ',
  'そうりふ',
  'そうりょ',
  'そうりん',
  'ぞうりん',
  'そうるい',
  'そうるび',
  'そうれい',
  'そうれつ',
  'そうれん',
  'そうろう',
  'そうろん',
  'ぞうわい',
  'そうわき',
  'ぞうわく',
  'そえいた',
  'そえうた',
  'そえがき',
  'そえもの',
  'そーかつ',
  'そーがむ',
  'そーさー',
  'そーたー',
  'そおっと',
  'そーっと',
  'そーなー',
  'そーはら',
  'そーほー',
  'そーめん',
  'そーゆー',
  'そーらー',
  'そーりー',
  'そーれっ',
  'そがぁな',
  'そがいな',
  'そかぎょ',
  'そがれる',
  'そぎぎり',
  'そきゃく',
  'そきゅう',
  'そぎょう',
  'ぞくあく',
  'そくあつ',
  'そくいん',
  'ぞくうけ',
  'ぞくえい',
  'そくえん',
  'ぞくえん',
  'そくおう',
  'そくおん',
  'ぞくおん',
  'ぞくがい',
  'ぞくがく',
  'ぞくがら',
  'ぞくがん',
  'そくぎれ',
  'そくぎん',
  'そくぐん',
  'ぞくぐん',
  'そくげん',
  'ぞくげん',
  'そくこん',
  'そくさい',
  'ぞくさい',
  'ぞくざい',
  'そくさく',
  'そくざに',
  'そくさん',
  'ぞくしち',
  'そくしつ',
  'そくじつ',
  'そくしゃ',
  'ぞくしゅ',
  'ぞくじゅ',
  'そくしょ',
  'そくじょ',
  'ぞくしょ',
  'そくしん',
  'ぞくしん',
  'ぞくじん',
  'そくする',
  'ぞくする',
  'そくせい',
  'ぞくせい',
  'そくせき',
  'ぞくせき',
  'ぞくせつ',
  'そくせん',
  'ぞくそう',
  'そくそく',
  'ぞくぞく',
  'そくたい',
  'そくだい',
  'ぞくたい',
  'そくだく',
  'そくたつ',
  'そくだん',
  'ぞくだん',
  'ぞくっと',
  'そくてい',
  'そくてん',
  'ぞくでん',
  'そくとう',
  'そくどう',
  'ぞくとう',
  'そくどく',
  'ぞくなる',
  'ぞくねん',
  'そくのう',
  'そくはい',
  'そくばい',
  'ぞくはい',
  'そくはく',
  'そくばく',
  'そくはつ',
  'ぞくはつ',
  'そくはぼ',
  'そくはめ',
  'そくばん',
  'そくひつ',
  'ぞくひつ',
  'そくふく',
  'ぞくぶつ',
  'そくぶん',
  'ぞくぶん',
  'そくへき',
  'そくへん',
  'ぞくへん',
  'そくほう',
  'ぞくほう',
  'ぞくむき',
  'ぞくめい',
  'ぞくめつ',
  'そくめん',
  'ぞくよう',
  'そくよく',
  'ぞくらく',
  'ぞくるい',
  'そくれす',
  'そくろう',
  'ぞくろん',
  'そけいぶ',
  'そけっと',
  'そこあげ',
  'そこいじ',
  'そこいら',
  'そこいれ',
  'そこうお',
  'そこうち',
  'そこから',
  'そこがわ',
  'そこくつ',
  'そこここ',
  'そこそこ',
  'そこつち',
  'そこづみ',
  'そこなう',
  'そこなし',
  'そこぬけ',
  'そこねる',
  'そこのけ',
  'そこばく',
  'そこびえ',
  'そこぶる',
  'そこほん',
  'そこぼん',
  'そこまで',
  'そこまめ',
  'そこもと',
  'そこわれ',
  'そこんち',
  'そしある',
  'そじうむ',
  'そしきい',
  'そしきか',
  'そしきず',
  'そしぜん',
  'そしたら',
  'そじはら',
  'そじほう',
  'そしゃく',
  'そしゃげ',
  'そしゃる',
  'そじゅつ',
  'そしょう',
  'そじょう',
  'そしょく',
  'そしらぬ',
  'そすいき',
  'そそくさ',
  'そそける',
  'そぞろに',
  'そだてる',
  'そちのけ',
  'そちゅう',
  'そちょう',
  'そつある',
  'そつえん',
  'ぞっかい',
  'ぞっかく',
  'そっから',
  'そっかん',
  'ぞっかん',
  'ぞっきー',
  'ぞっきや',
  'そっきょ',
  'そっきん',
  'そっくす',
  'そっくび',
  'そっくり',
  'そっけつ',
  'そっけん',
  'そつけん',
  'ぞっけん',
  'そっこう',
  'ぞっこう',
  'そっこー',
  'そっこく',
  'ぞっこく',
  'そっこつ',
  'そっこん',
  'そつこん',
  'ぞっこん',
  'そつしゃ',
  'そつじゅ',
  'そっする',
  'そっせい',
  'そつせい',
  'そっせん',
  'そつぜん',
  'そつぞく',
  'そったく',
  'そつてん',
  'そっとう',
  'そつどく',
  'そつなく',
  'そつゆう',
  'そつろん',
  'そでうら',
  'そでがき',
  'そでぐち',
  'そでぐり',
  'そでごい',
  'そでした',
  'そでたけ',
  'そてつか',
  'そでつけ',
  'そでなし',
  'そでやま',
  'そといき',
  'そとうば',
  'そとうみ',
  'そとがい',
  'そとがき',
  'そとがけ',
  'そとかべ',
  'そとがま',
  'そとがわ',
  'そとぐに',
  'そとぜい',
  'そとだし',
  'そとづけ',
  'そとづら',
  'そとなる',
  'そとにわ',
  'そとねこ',
  'そとのり',
  'そとばき',
  'そとばこ',
  'そとばり',
  'そとぶた',
  'そとぼし',
  'そとぼり',
  'そとまご',
  'そとまた',
  'そどみー',
  'そとむき',
  'そともも',
  'そとろじ',
  'そとわく',
  'そとわに',
  'そなえる',
  'そなちね',
  'そなわる',
  'そにっく',
  'そにどり',
  'そねっと',
  'そのあと',
  'そのうえ',
  'そのうち',
  'そのおり',
  'そのかた',
  'そのかみ',
  'そのかん',
  'そのくせ',
  'そのこと',
  'そのころ',
  'そのさい',
  'そのさき',
  'そのじつ',
  'そのすじ',
  'そのせつ',
  'そのたび',
  'そのため',
  'そのつど',
  'そのとき',
  'そのなか',
  'そののち',
  'そのはず',
  'そのばん',
  'そのひと',
  'そのぶい',
  'そのぶん',
  'そのへん',
  'そのほう',
  'そのほか',
  'そのまま',
  'そのみち',
  'そのむね',
  'そのもと',
  'そのもの',
  'そのよう',
  'そばえい',
  'そばえる',
  'そばがき',
  'そばかす',
  'そばから',
  'そばがら',
  'そばきり',
  'そばだつ',
  'そばづえ',
  'そばっと',
  'そばつゆ',
  'そばてん',
  'そばのき',
  'そばはら',
  'そばみち',
  'そばむぎ',
  'そばめし',
  'そばめる',
  'そばやく',
  'そびえと',
  'そびえる',
  'そびょう',
  'そびれる',
  'そふぁー',
  'そふぃあ',
  'そふてに',
  'そふとか',
  'そぷらの',
  'そほうか',
  'そほーず',
  'そぼくは',
  'そぼそぼ',
  'そぼふる',
  'そまむぎ',
  'そまりあ',
  'そまりご',
  'そみつは',
  'そむける',
  'そむりえ',
  'そめいと',
  'そめいろ',
  'そめがた',
  'そめぎぬ',
  'そめこむ',
  'そめだす',
  'そめつけ',
  'そめぬく',
  'そめもの',
  'そめわけ',
  'そめんき',
  'そもそも',
  'そゆーず',
  'そよかぜ',
  'そよそよ',
  'そらあい',
  'そらいろ',
  'そらがき',
  'そらきた',
  'そらごと',
  'そらざま',
  'そらせる',
  'そらそら',
  'そらだき',
  'そらどけ',
  'そらとぶ',
  'そらなき',
  'そらにん',
  'そらばし',
  'そらびき',
  'そらまめ',
  'そらみみ',
  'そらゆめ',
  'そらりあ',
  'そらりす',
  'そりあと',
  'そりかた',
  'そりすと',
  'そりたつ',
  'そりたて',
  'そりっど',
  'そりてあ',
  'そりとん',
  'そりはし',
  'そりばし',
  'そりゃあ',
  'そりゃく',
  'そりゅう',
  'そるがむ',
  'そるごー',
  'そるだむ',
  'そるばー',
  'そるぶご',
  'それいけ',
  'それいゆ',
  'それがし',
  'それから',
  'それきた',
  'それきり',
  'それぎり',
  'それこそ',
  'それしき',
  'それしゃ',
  'それじゃ',
  'それすら',
  'それそれ',
  'それぞれ',
  'それだけ',
  'それだま',
  'それでは',
  'それでも',
  'それとて',
  'それとも',
  'それなし',
  'それなら',
  'それなり',
  'それほど',
  'それまで',
  'それみろ',
  'それゆえ',
  'それゆけ',
  'それより',
  'そろえる',
  'そろかつ',
  'そろそろ',
  'ぞろぞろ',
  'そろって',
  'そろっと',
  'そろばん',
  'ぞろやく',
  'そわせる',
  'そわそわ',
  'ぞわぞわ',
  'そわにえ',
  'そわみち',
  'そんえい',
  'そんえき',
  'そんおう',
  'そんかい',
  'そんがい',
  'ぞんがい',
  'ぞんかご',
  'そんかん',
  'そんがん',
  'そんきょ',
  'そんぎり',
  'そんきん',
  'そんくん',
  'そんけい',
  'そんげん',
  'そんこう',
  'そんごう',
  'そんざい',
  'ぞんざい',
  'そんしつ',
  'そんしゃ',
  'そんじゃ',
  'そんしゅ',
  'そんしょ',
  'そんじる',
  'ぞんじる',
  'そんしん',
  'そんすう',
  'そんする',
  'ぞんずる',
  'そんぞう',
  'そんぞく',
  'そんたい',
  'そんだい',
  'そんたく',
  'そんだけ',
  'そんどう',
  'そんとく',
  'そんない',
  'そんなに',
  'そんなら',
  'そんなん',
  'ぞんねん',
  'そんのう',
  'そんばい',
  'そんぱい',
  'ぞんびー',
  'ぞんぶん',
  'そんぼう',
  'そんみん',
  'そんめい',
  'ぞんめい',
  'そんもう',
  'そんゆう',
  'そんよう',
  'そんらい',
  'そんらく',
  'そんりつ',
  'そんりょ',
  'たーきー',
  'たーきん',
  'たあさい',
  'たーさい',
  'たあそび',
  'たーたん',
  'たーちゃ',
  'だーてぃ',
  'たーとる',
  'たーはい',
  'たーぱい',
  'たーばん',
  'たーぱん',
  'だーびー',
  'たーびん',
  'たーふる',
  'たーぽん',
  'たーまや',
  'だーりあ',
  'だーりや',
  'だーりん',
  'たーれー',
  'だいあく',
  'たいあつ',
  'だいあど',
  'だいあな',
  'たいあり',
  'だいある',
  'たいあん',
  'だいあん',
  'たいいき',
  'たいいく',
  'だいいし',
  'だいいた',
  'だいいち',
  'たいいん',
  'だいいん',
  'だいうす',
  'たいえい',
  'だいえい',
  'たいえき',
  'だいえり',
  'たいえん',
  'だいえん',
  'たいおう',
  'だいおう',
  'だいおど',
  'たいおん',
  'だいおん',
  'たいがー',
  'だいかー',
  'たいかい',
  'たいがい',
  'だいがい',
  'だいがえ',
  'たいかく',
  'たいがく',
  'だいかく',
  'だいがく',
  'だいかこ',
  'だいかつ',
  'だいかま',
  'たいかん',
  'たいがん',
  'だいかん',
  'だいがん',
  'だいきか',
  'たいぎご',
  'たいきさ',
  'だいぎし',
  'だいきち',
  'だいきぼ',
  'たいきょ',
  'たいぎょ',
  'だいきり',
  'たいきん',
  'だいきん',
  'たいくう',
  'たいぐう',
  'たいくつ',
  'たいくん',
  'たいぐん',
  'たいけい',
  'だいけい',
  'たいけつ',
  'たいけん',
  'たいげん',
  'だいけん',
  'だいげん',
  'たいこう',
  'たいごう',
  'だいこう',
  'だいごう',
  'たいこく',
  'たいごく',
  'だいこく',
  'だいごし',
  'たいこつ',
  'たいごは',
  'だいごみ',
  'たいこん',
  'たいごん',
  'だいこん',
  'たいさい',
  'たいざい',
  'だいざい',
  'だいさぎ',
  'たいさく',
  'だいさく',
  'たいさつ',
  'たいさん',
  'たいざん',
  'だいさん',
  'だいしき',
  'たいじく',
  'だいじこ',
  'たいした',
  'たいしつ',
  'たいして',
  'たいしゃ',
  'だいしゃ',
  'だいじゃ',
  'たいしゅ',
  'たいじゅ',
  'たいしょ',
  'だいしょ',
  'だいじょ',
  'だいじり',
  'たいじる',
  'たいしん',
  'たいじん',
  'だいしん',
  'だいじん',
  'たいすい',
  'たいすう',
  'だいすう',
  'たいすき',
  'だいすき',
  'だいすぎ',
  'だいずこ',
  'だいずゆ',
  'たいする',
  'だいする',
  'たいせい',
  'たいぜい',
  'だいせい',
  'たいせき',
  'たいせち',
  'たいせつ',
  'たいせん',
  'たいぜん',
  'だいせん',
  'だいぜん',
  'たいそう',
  'たいぞう',
  'だいそう',
  'たいそく',
  'たいぞく',
  'だいそつ',
  'たいそん',
  'だいそん',
  'たいたい',
  'たいだい',
  'だいたい',
  'だいだい',
  'たいだる',
  'たいたん',
  'たいだん',
  'だいたん',
  'たいちょ',
  'たいてい',
  'たいてき',
  'たいてん',
  'たいでん',
  'だいてん',
  'たいとう',
  'たいどう',
  'だいとう',
  'だいどう',
  'たいとく',
  'たいどく',
  'だいとく',
  'だいどく',
  'だいとこ',
  'だいどこ',
  'だいとし',
  'たいとる',
  'だいなー',
  'たいない',
  'だいなし',
  'だいなも',
  'だいなり',
  'たいなん',
  'だいなん',
  'たいにー',
  'だいにい',
  'だいにき',
  'だいにぎ',
  'だいにし',
  'だいにじ',
  'たいにち',
  'だいにち',
  'だいには',
  'だいにぶ',
  'たいにん',
  'だいにん',
  'たいねつ',
  'たいのう',
  'だいのう',
  'だいのじ',
  'たいのや',
  'だいばー',
  'たいはい',
  'たいはく',
  'たいばつ',
  'たいはん',
  'たいばん',
  'たいぱん',
  'だいはん',
  'だいばん',
  'たいひか',
  'だいひき',
  'だいびき',
  'だいひつ',
  'たいぴん',
  'だいひん',
  'たいふう',
  'たいふく',
  'だいふく',
  'だいぶく',
  'たいぶつ',
  'だいぶつ',
  'だいぶん',
  'たいへい',
  'たいべい',
  'たいぺい',
  'たいへき',
  'たいべつ',
  'たいへん',
  'たいべん',
  'だいへん',
  'だいべん',
  'たいほう',
  'たいぼう',
  'だいほう',
  'たいほく',
  'たいぼく',
  'だいぽる',
  'たいほん',
  'だいほん',
  'たいまー',
  'たいまい',
  'たいまく',
  'だいまち',
  'たいまつ',
  'たいまん',
  'たいみつ',
  'たいむず',
  'たいむり',
  'たいめい',
  'だいめい',
  'たいめし',
  'たいめん',
  'たいもう',
  'だいもう',
  'だいもく',
  'だいもす',
  'たいもん',
  'だいもん',
  'たいやき',
  'たいやく',
  'だいやく',
  'だいやる',
  'たいゆう',
  'たいよう',
  'だいよう',
  'たいよく',
  'だいよく',
  'だいよん',
  'たいらか',
  'たいらぎ',
  'たいらぐ',
  'たいらん',
  'だいりき',
  'たいりく',
  'たいりつ',
  'だいりぶ',
  'だいりぼ',
  'たいりょ',
  'たいりん',
  'たいるい',
  'たいるえ',
  'たいれい',
  'たいれつ',
  'たいれん',
  'だいれん',
  'たいろう',
  'たいろん',
  'だいわり',
  'だいわれ',
  'たいわん',
  'だいわん',
  'だうせん',
  'だうなー',
  'たうなぎ',
  'たうりん',
  'たえいる',
  'たえうる',
  'たえざる',
  'たえだえ',
  'たえない',
  'たえなる',
  'たえぬく',
  'たおこし',
  'たおぞく',
  'たおやか',
  'たおやめ',
  'たおるじ',
  'たおれる',
  'たおんじ',
  'だかーぽ',
  'だかーる',
  'たがいに',
  'たがいめ',
  'たがえる',
  'たかがみ',
  'たかがり',
  'たかきび',
  'たかくか',
  'たかげた',
  'たかごえ',
  'たかさき',
  'たかさご',
  'たかしお',
  'だがしや',
  'たかぞら',
  'たかだい',
  'たかだか',
  'たかだは',
  'たかつか',
  'たかづか',
  'たかつき',
  'だがっき',
  'たかどの',
  'たかとび',
  'たかどま',
  'たかなみ',
  'たかなり',
  'たかなる',
  'たかねる',
  'たがねる',
  'たかはた',
  'たかばた',
  'たかはや',
  'たかびー',
  'たかぴー',
  'たかひく',
  'たかふだ',
  'たかぶり',
  'たかぶる',
  'たかべい',
  'たかまき',
  'たかまつ',
  'たかまど',
  'たかまり',
  'たかまる',
  'たかむな',
  'たかむら',
  'たかめる',
  'たかもく',
  'たかもり',
  'たがやす',
  'たかゆか',
  'たからか',
  'たからけ',
  'たからげ',
  'たがらし',
  'たかりや',
  'たがろぐ',
  'たかんな',
  'だきあう',
  'たきあげ',
  'たきあせ',
  'だきいぬ',
  'たきおん',
  'だきかご',
  'たきがわ',
  'だきぐせ',
  'たきぐち',
  'たきこみ',
  'たきこむ',
  'だきこむ',
  'たきしー',
  'たぎせい',
  'たきだし',
  'たきだす',
  'たきたて',
  'だきつく',
  'たきつけ',
  'たきつぼ',
  'たぎてき',
  'たきのう',
  'たきふさ',
  'たきべら',
  'たきもの',
  'たきゃく',
  'だきゅう',
  'たきょう',
  'たぎょう',
  'だきょう',
  'だぎょう',
  'たきょく',
  'だきょる',
  'たぎんぐ',
  'だくあし',
  'たくあん',
  'たくいつ',
  'たくえつ',
  'たぐえる',
  'だくおん',
  'たくけい',
  'たくげん',
  'たくさん',
  'だくさん',
  'たくしー',
  'たくしき',
  'だくしゅ',
  'たくしょ',
  'たくしん',
  'だくすい',
  'たくする',
  'だくする',
  'だくせい',
  'たくせつ',
  'たくぜつ',
  'たくせん',
  'たくぜん',
  'たくそう',
  'たくぞう',
  'たくそん',
  'だくだく',
  'たぐつき',
  'たぐつけ',
  'たぐづけ',
  'たくでん',
  'だくてん',
  'たくのみ',
  'たくはい',
  'たくはつ',
  'たくばつ',
  'たくぱる',
  'たくひつ',
  'たくぼく',
  'だくぼく',
  'たくほん',
  'たくまぬ',
  'だくやく',
  'たくよう',
  'たくらみ',
  'たくらむ',
  'たぐらむ',
  'たくらん',
  'たくりつ',
  'たくろく',
  'たくろん',
  'だくろん',
  'たくわえ',
  'たくわん',
  'たけうま',
  'たけえん',
  'たけがき',
  'たけかご',
  'たけがさ',
  'たけがり',
  'たけぎれ',
  'たけくぎ',
  'たけぐし',
  'たけざお',
  'だけしか',
  'たけすみ',
  'たけずみ',
  'たけせい',
  'たけたば',
  'たけづつ',
  'たけとう',
  'だけども',
  'たけなが',
  'たけなわ',
  'たけのこ',
  'たけはい',
  'たけぱい',
  'たけばし',
  'たけひご',
  'たけぶえ',
  'たけべら',
  'たけみつ',
  'たけやぶ',
  'たけやり',
  'たげんご',
  'たげんし',
  'たこあげ',
  'たこあし',
  'たこいか',
  'たこいと',
  'たこうな',
  'たこつぼ',
  'たこのき',
  'たこひき',
  'たこぶね',
  'たこべや',
  'たこやき',
  'だざいふ',
  'ださめん',
  'だしあう',
  'だしいれ',
  'たしかに',
  'たしかめ',
  'だしがら',
  'だしきる',
  'たじくご',
  'たしけし',
  'たじげん',
  'たしざん',
  'だしじる',
  'たしすむ',
  'たじたじ',
  'だしなげ',
  'たしなみ',
  'たしなむ',
  'だしぬく',
  'だしぬけ',
  'だしぶん',
  'たしまえ',
  'だしまえ',
  'だしまき',
  'だしみせ',
  'だしもの',
  'だじゃく',
  'だじゃれ',
  'たしゅう',
  'たじゅう',
  'だじゅう',
  'たしゅつ',
  'たしゅみ',
  'だじゅん',
  'たしょう',
  'たじょう',
  'たしょく',
  'たしらか',
  'たじろぐ',
  'だしんき',
  'たすうは',
  'たすかる',
  'たすけて',
  'たすける',
  'だすたー',
  'たずねる',
  'たせかい',
  'たせたい',
  'たそーと',
  'たそがれ',
  'だたいい',
  'だだいこ',
  'たたいじ',
  'たたいた',
  'ただいま',
  'ただうど',
  'たたえる',
  'たたかい',
  'たたかう',
  'ただぐい',
  'ただけん',
  'ただこと',
  'ただごと',
  'たださえ',
  'ただざけ',
  'ただしい',
  'ただしく',
  'たたずみ',
  'たたずむ',
  'ただただ',
  'たたたん',
  'ただちに',
  'だだっこ',
  'ただでは',
  'ただとり',
  'ただどり',
  'ただなか',
  'ただのり',
  'ただひと',
  'ただびと',
  'たたまる',
  'ただまん',
  'たたみぜ',
  'たたみや',
  'ただめし',
  'ただもの',
  'だだもれ',
  'ただよう',
  'たたりめ',
  'ただれめ',
  'ただれる',
  'たちあい',
  'たちあう',
  'たちあげ',
  'たちいえ',
  'たちいく',
  'たちいた',
  'たちいち',
  'たちいり',
  'たちいる',
  'たちうお',
  'たちうち',
  'たちうり',
  'たちえず',
  'たちえり',
  'たちかた',
  'たぢから',
  'たちがれ',
  'たちぎえ',
  'たちぎき',
  'たちきく',
  'たちきり',
  'たちきる',
  'たちぐい',
  'たちくず',
  'だちこう',
  'たちこぎ',
  'たちさき',
  'たちさる',
  'たちすじ',
  'たちせき',
  'たちだす',
  'たちっぱ',
  'たちづめ',
  'だちとも',
  'たちぬい',
  'たちぬう',
  'たちのき',
  'たちのく',
  'たちのみ',
  'たちばな',
  'たちばん',
  'だちびん',
  'たちまち',
  'たちみみ',
  'たちもち',
  'たちもの',
  'たちやく',
  'たちゆく',
  'たちょう',
  'だちょう',
  'たちよみ',
  'たちよる',
  'たちわざ',
  'たちわる',
  'たちんぼ',
  'だつえい',
  'だつえん',
  'だっかい',
  'だっかく',
  'たっかん',
  'だっかん',
  'たっくし',
  'たっくす',
  'だっくす',
  'たつくり',
  'たづくり',
  'たっくる',
  'たっけい',
  'たっけん',
  'たっこう',
  'だっこう',
  'だっこく',
  'だつごく',
  'だっこん',
  'だっさい',
  'たつさき',
  'だっさら',
  'だつさら',
  'だっさん',
  'たっしき',
  'たっしゃ',
  'だっしゅ',
  'たつじん',
  'だっすい',
  'だつずい',
  'たっする',
  'だっする',
  'たっせい',
  'だつぜい',
  'だっせえ',
  'だっせー',
  'たっせる',
  'だっせん',
  'だっそう',
  'だつぞく',
  'だったい',
  'だったら',
  'だったろ',
  'だったん',
  'だっちつ',
  'たっとい',
  'だっとう',
  'たつどし',
  'たっとぶ',
  'たっとむ',
  'たつとり',
  'たつのひ',
  'たっぱー',
  'たっぱる',
  'だっぱん',
  'たっぴつ',
  'だつぷら',
  'たっぷり',
  'だっふる',
  'たつぶん',
  'だつぶん',
  'だっぷん',
  'たつへん',
  'たつべん',
  'だつぼう',
  'だっぽう',
  'だつほく',
  'だっぽく',
  'たつまき',
  'だつもう',
  'だつらく',
  'たつりつ',
  'だつりん',
  'だつろう',
  'たであい',
  'たてあな',
  'たてあみ',
  'だでぃー',
  'たていし',
  'たていと',
  'たてうり',
  'たてかえ',
  'たてがき',
  'たてかけ',
  'たてがた',
  'たてがみ',
  'たてかん',
  'たてきる',
  'たてぐし',
  'たてぐみ',
  'たてぐや',
  'たてこう',
  'たてごと',
  'たてこむ',
  'たてじく',
  'たてじま',
  'だてじめ',
  'だてしゃ',
  'たてせん',
  'たてつく',
  'たてつけ',
  'たてつぼ',
  'たてどい',
  'たてなが',
  'たてなみ',
  'たてぬき',
  'たてぬし',
  'たてのり',
  'たてばし',
  'たてぱす',
  'たてひき',
  'たてびき',
  'たてひく',
  'たてひざ',
  'たてぶえ',
  'たてふだ',
  'たてぼう',
  'たてぼり',
  'たてまえ',
  'たてまき',
  'だてまき',
  'たてまし',
  'たてます',
  'たてむき',
  'たてもの',
  'たてやく',
  'たてゆれ',
  'たてよこ',
  'たてよみ',
  'だてらに',
  'たてわり',
  'だてんし',
  'たとぅー',
  'たとうし',
  'たどうし',
  'たどうじ',
  'たとうび',
  'たとえば',
  'たとえる',
  'たどころ',
  'たとする',
  'たなあげ',
  'たなうけ',
  'たながり',
  'たなぐも',
  'たなさき',
  'たなだい',
  'たなだて',
  'たなちん',
  'たなっと',
  'たなとす',
  'たなばた',
  'たなびく',
  'たなぼた',
  'たなわり',
  'たにあい',
  'たにかぜ',
  'たにがわ',
  'たにくか',
  'たにぐく',
  'たにすじ',
  'たにそこ',
  'たにぞこ',
  'たにへん',
  'たにまち',
  'たにみず',
  'たにょう',
  'たにんず',
  'たぬきも',
  'たねいし',
  'たねいた',
  'たねいも',
  'たねうし',
  'たねうま',
  'たねがき',
  'たねがみ',
  'たねぎれ',
  'たねきん',
  'たねずみ',
  'たねつけ',
  'たねどこ',
  'たねとり',
  'たねなし',
  'たねふだ',
  'たねぶた',
  'たねほん',
  'たねまき',
  'たねもの',
  'たねもみ',
  'たのかみ',
  'たのしい',
  'たのしげ',
  'たのしみ',
  'たのしむ',
  'たのもう',
  'たのもし',
  'たばいと',
  'たばかる',
  'たばこや',
  'たばすこ',
  'たはたけ',
  'たはつき',
  'たばねる',
  'たひーな',
  'たひーに',
  'たぴおか',
  'たびかず',
  'たぴかつ',
  'たびごと',
  'たびさき',
  'たびしょ',
  'たびする',
  'たびそう',
  'たびだち',
  'たびだつ',
  'たびたび',
  'たひちご',
  'だびっと',
  'たびどり',
  'たびにん',
  'たひばり',
  'たびびと',
  'たびやど',
  'たびょう',
  'たびらこ',
  'たびれじ',
  'だびんぐ',
  'だびんち',
  'だふぁー',
  'たふぃー',
  'たぶーご',
  'たぶーし',
  'たぶーら',
  'たふがい',
  'たぶきー',
  'たふけん',
  'たぶこん',
  'だぶすた',
  'たぶたぶ',
  'たぷたぷ',
  'だぶだぶ',
  'だぶつく',
  'だぶとん',
  'だぶなん',
  'たふねす',
  'たぶのき',
  'だぶぺー',
  'たぶもじ',
  'だぶりー',
  'だぶりん',
  'だぶるす',
  'たぶろー',
  'たぶんか',
  'たぶんに',
  'たべかけ',
  'たべかす',
  'たべかた',
  'たぺくり',
  'たべごろ',
  'たべすぎ',
  'たぺっと',
  'たべもの',
  'たべよう',
  'たほいや',
  'たぽたぽ',
  'だぼだぼ',
  'だぼはぜ',
  'たまあい',
  'たまーれ',
  'たまいし',
  'たまいと',
  'たまいれ',
  'たまうき',
  'たまかい',
  'たまがい',
  'たまがき',
  'たまかけ',
  'たまがけ',
  'だまかす',
  'たまがた',
  'たまきず',
  'たまぎる',
  'たまぎわ',
  'たまきん',
  'たまくし',
  'たまぐし',
  'たまぐす',
  'たまけり',
  'たまげる',
  'たまさか',
  'たまざん',
  'たましい',
  'だましい',
  'だましえ',
  'たましき',
  'たましぎ',
  'たましだ',
  'だますく',
  'たまずさ',
  'たますじ',
  'たまたま',
  'たまだれ',
  'たまつき',
  'だまてん',
  'たまどの',
  'たまどめ',
  'たまどん',
  'たまなえ',
  'たまねぎ',
  'たまのお',
  'たまのり',
  'たまばえ',
  'たまばち',
  'たまぶき',
  'たまへん',
  'たまべん',
  'たままゆ',
  'たまみそ',
  'たまむし',
  'たまもの',
  'たまゆら',
  'たまよけ',
  'たまらん',
  'たまりば',
  'たまりろ',
  'たまりん',
  'たまれす',
  'たまわる',
  'たみくさ',
  'たみぐさ',
  'だみごえ',
  'たみふる',
  'たみるご',
  'だむあな',
  'たむける',
  'たむしば',
  'たむたむ',
  'だむはぶ',
  'たむろう',
  'ためいき',
  'ためいけ',
  'ためいろ',
  'だめーじ',
  'ためおけ',
  'だめおし',
  'ためがき',
  'ためぎん',
  'ためぐち',
  'ためこむ',
  'だめこん',
  'ためしに',
  'ためすじ',
  'だめだし',
  'だめだめ',
  'だめつめ',
  'だめづめ',
  'ためどし',
  'ためぬり',
  'ためはる',
  'だめもと',
  'ためらい',
  'ためらう',
  'だめりか',
  'だめんず',
  'たもあみ',
  'だもので',
  'たもろこ',
  'だもんで',
  'たやすい',
  'たゆたう',
  'たゆとう',
  'たゆまぬ',
  'たようか',
  'たようと',
  'だよねー',
  'たよりや',
  'たらーり',
  'だらくま',
  'だらける',
  'たらごん',
  'たらしい',
  'たらしむ',
  'たらじゅ',
  'だらすけ',
  'たらたら',
  'だらだら',
  'たらちね',
  'たらちめ',
  'たらっぷ',
  'たらない',
  'たらのき',
  'たらふく',
  'たらよう',
  'たられば',
  'たらんと',
  'たりーか',
  'たりうむ',
  'たりけり',
  'たりとも',
  'たりない',
  'たりばん',
  'たりゅう',
  'たりょう',
  'だりょく',
  'たるがき',
  'たるかん',
  'たるざけ',
  'たるたる',
  'だるまき',
  'たるめる',
  'だれうま',
  'たれえい',
  'たれかべ',
  'たれがみ',
  'たれかれ',
  'だれかれ',
  'たれぎぬ',
  'たれこみ',
  'たれこむ',
  'たれこめ',
  'たれしも',
  'だれしも',
  'だれそれ',
  'だれだれ',
  'たれっと',
  'だれでも',
  'だれとく',
  'だれにも',
  'たれぬの',
  'たれびと',
  'たれまく',
  'たれみみ',
  'たれんと',
  'たろいも',
  'だろうか',
  'だろうに',
  'たろっと',
  'たわける',
  'たわこと',
  'たわごと',
  'たわまん',
  'たわむる',
  'たわむれ',
  'たわめる',
  'たわやか',
  'たわやめ',
  'たをうつ',
  'だんあつ',
  'だんあん',
  'たんいち',
  'たんいつ',
  'だんいん',
  'たんえん',
  'たんおう',
  'たんおし',
  'だんおつ',
  'たんおん',
  'だんおん',
  'たんかー',
  'たんかい',
  'だんかい',
  'だんがい',
  'たんかか',
  'たんかく',
  'たんがら',
  'たんかる',
  'たんかん',
  'たんがん',
  'だんかん',
  'だんがん',
  'たんきに',
  'たんきん',
  'たんぎん',
  'だんきん',
  'たんくつ',
  'たんぐつ',
  'だんぐみ',
  'だんくん',
  'たんけい',
  'たんげい',
  'だんけい',
  'たんげつ',
  'だんけつ',
  'たんけん',
  'たんげん',
  'だんげん',
  'たんこう',
  'だんこう',
  'だんごう',
  'だんこく',
  'だんごく',
  'たんこぶ',
  'だんごや',
  'たんこん',
  'だんこん',
  'だんさー',
  'たんさい',
  'たんざい',
  'だんさい',
  'だんざい',
  'たんさき',
  'たんざき',
  'たんさく',
  'たんざく',
  'たんさん',
  'だんさん',
  'たんしお',
  'たんしき',
  'だんじき',
  'たんじく',
  'たんしつ',
  'たんじつ',
  'だんじて',
  'たんしゃ',
  'たんしゅ',
  'だんしゅ',
  'たんしょ',
  'だんじょ',
  'だんじり',
  'たんじる',
  'だんじる',
  'たんしん',
  'たんじん',
  'たんすい',
  'だんすい',
  'たんすう',
  'たんずる',
  'だんする',
  'だんずる',
  'たんせい',
  'たんぜい',
  'だんせい',
  'たんせき',
  'たんせつ',
  'だんせつ',
  'だんぜつ',
  'たんせん',
  'たんぜん',
  'だんせん',
  'だんぜん',
  'たんそう',
  'たんぞう',
  'だんそう',
  'たんそく',
  'だんぞく',
  'たんだー',
  'たんたい',
  'たんだい',
  'だんたい',
  'だんだら',
  'たんたる',
  'たんたん',
  'だんだん',
  'たんちき',
  'だんちく',
  'だんちま',
  'たんちゃ',
  'だんちゃ',
  'たんちょ',
  'だんぢり',
  'だんつう',
  'だんつく',
  'たんづつ',
  'たんつば',
  'たんつぼ',
  'たんてい',
  'だんてい',
  'だんでぃ',
  'たんてき',
  'たんでき',
  'たんてつ',
  'たんでむ',
  'だんでれ',
  'たんてん',
  'たんでん',
  'だんてん',
  'たんとう',
  'だんとう',
  'だんどう',
  'たんどき',
  'たんどく',
  'だんとつ',
  'たんとら',
  'だんどり',
  'たんなー',
  'だんなし',
  'たんなる',
  'たんにん',
  'だんねつ',
  'たんねん',
  'だんねん',
  'たんのう',
  'たんぱー',
  'だんぱー',
  'たんはい',
  'たんぱく',
  'だんばす',
  'たんぱつ',
  'だんぱつ',
  'だんばな',
  'たんぱら',
  'だんばら',
  'だんばれ',
  'たんばん',
  'たんぱん',
  'だんはん',
  'だんぱん',
  'だんぴつ',
  'たんびに',
  'たんびは',
  'だんびら',
  'たんぴん',
  'たんぷく',
  'だんぷら',
  'だんぶる',
  'たんぷれ',
  'たんぶん',
  'たんぺき',
  'たんべつ',
  'だんべる',
  'たんべん',
  'たんぺん',
  'だんぺん',
  'たんぼう',
  'たんぽう',
  'だんぼう',
  'たんぽぽ',
  'たんぽん',
  'だんまく',
  'たんまつ',
  'たんまり',
  'だんまり',
  'たんみん',
  'たんめい',
  'たんめん',
  'だんめん',
  'たんもう',
  'たんもの',
  'だんもの',
  'たんやお',
  'だんやく',
  'だんゆう',
  'たんよう',
  'たんよく',
  'たんよん',
  'たんらく',
  'だんらく',
  'たんらん',
  'だんらん',
  'たんりつ',
  'たんりょ',
  'だんりん',
  'たんれい',
  'だんれつ',
  'たんれん',
  'だんれん',
  'たんろく',
  'だんろん',
  'ちあじん',
  'ちあみん',
  'ちいきか',
  'ちいきさ',
  'ちいさい',
  'ちいざい',
  'ちいさな',
  'ちいさめ',
  'ちーぜる',
  'ちーたー',
  'ちいちい',
  'ちーちゃ',
  'ちいっと',
  'ちーぱお',
  'ちーほー',
  'ちーまー',
  'ちーまま',
  'ちいるい',
  'ちぇあー',
  'ちぇいん',
  'ちぇーん',
  'ちぇきる',
  'ちぇけら',
  'ちぇこご',
  'ちえしゃ',
  'ちぇじゅ',
  'ちぇすと',
  'ちぇだー',
  'ちぇっか',
  'ちぇっく',
  'ちえねつ',
  'ちえのわ',
  'ちぇぼる',
  'ちえまけ',
  'ちえもの',
  'ちぇらぶ',
  'ちぇりー',
  'ちぇりお',
  'ちぇんじ',
  'ちおてぱ',
  'ちおべん',
  'ちかーの',
  'ちがいめ',
  'ちかえき',
  'ちがえる',
  'ちかかい',
  'ちかがい',
  'ちかくち',
  'ちがくて',
  'ちかけい',
  'ちかごろ',
  'ちかしい',
  'ちかしつ',
  'ちかすい',
  'ちかずく',
  'ちかせん',
  'ちがたな',
  'ちかちか',
  'ちかぢか',
  'ちかづき',
  'ちかづく',
  'ちかって',
  'ちかてつ',
  'ちかどう',
  'ちかみち',
  'ちかよる',
  'ちかろう',
  'ちきゅう',
  'ちきょう',
  'ちぎょう',
  'ちぎりえ',
  'ちぎりき',
  'ちぎりぎ',
  'ちぎれる',
  'ちきんむ',
  'ちくあさ',
  'ちくいち',
  'ちくいつ',
  'ちくかん',
  'ちくけん',
  'ちくこう',
  'ちくさい',
  'ちくざい',
  'ちくさつ',
  'ちくさん',
  'ちくじつ',
  'ちくしゃ',
  'ちくしゅ',
  'ちくせき',
  'ちくぜん',
  'ちくそう',
  'ちくぞう',
  'ちくたく',
  'ちくたん',
  'ちくちく',
  'ちくっと',
  'ちくてい',
  'ちくでん',
  'ちくとう',
  'ちくにく',
  'ちくねつ',
  'ちくねん',
  'ちくはく',
  'ちぐはぐ',
  'ちくふる',
  'ちくふん',
  'ちくよう',
  'ちくりん',
  'ちくるい',
  'ちくるす',
  'ちくわぶ',
  'ちけいず',
  'ちけっと',
  'ちげなべ',
  'ちけむり',
  'ちけんし',
  'ちこうゆ',
  'ちこくま',
  'ちこりー',
  'ちさんは',
  'ちざんは',
  'ちしがく',
  'ちしきぎ',
  'ちしせい',
  'ちじせん',
  'ちしつず',
  'ちしゅん',
  'ちしょう',
  'ちじょう',
  'ちじょく',
  'ちしりつ',
  'ちしんじ',
  'ちずがく',
  'ちたいち',
  'ちだまり',
  'ちだらけ',
  'ちだるま',
  'ちちいろ',
  'ちちうえ',
  'ちちうし',
  'ちちうま',
  'ちちおう',
  'ちちおや',
  'ちちかた',
  'ちぢかむ',
  'ちちがわ',
  'ちちぎみ',
  'ちちくさ',
  'ちちくび',
  'ちちくる',
  'ちちしる',
  'ちちたけ',
  'ちちのひ',
  'ちちはは',
  'ちぢまる',
  'ちぢめる',
  'ちちゃく',
  'ちちゅう',
  'ちぢらす',
  'ちぢれげ',
  'ちぢれる',
  'ちつあつ',
  'ちつえき',
  'ちつえん',
  'ちっかー',
  'ちつがん',
  'ちっきょ',
  'ちっきん',
  'ちっけん',
  'ちっこい',
  'ちっこう',
  'ちつこう',
  'ちつじょ',
  'ちっそく',
  'ちつづき',
  'ちっとも',
  'ちつない',
  'ちっぱい',
  'ちっぷく',
  'ちつへき',
  'ちっぽけ',
  'ちつろく',
  'ちていこ',
  'ちてんし',
  'ちどりか',
  'ちなみに',
  'ちにちか',
  'ちにちは',
  'ちぬだい',
  'ちのあせ',
  'ちのあめ',
  'ちのいけ',
  'ちのうみ',
  'ちのはて',
  'ちのぱん',
  'ちのみご',
  'ちのみち',
  'ちばけん',
  'ちばしる',
  'ちぱたま',
  'ちばなれ',
  'ちはやぶ',
  'ちはらい',
  'ちはんじ',
  'ちびすけ',
  'ちびちび',
  'ちびっこ',
  'ちびっと',
  'ちひょう',
  'ちびょう',
  'ちぶくろ',
  'ちべっと',
  'ちほうく',
  'ちほうし',
  'ちほうじ',
  'ちぼしん',
  'ちまーぜ',
  'ちまちま',
  'ちまつり',
  'ちまなこ',
  'ちまみれ',
  'ちまよう',
  'ちみどろ',
  'ちみゃく',
  'ちむにー',
  'ちめいど',
  'ちもーる',
  'ちもしー',
  'ちゃーが',
  'ちゃーじ',
  'ちゃーち',
  'ちゃーと',
  'ちゃーぷ',
  'ちゃーむ',
  'ちゃいご',
  'ちゃいな',
  'ちゃいぶ',
  'ちゃいむ',
  'ちゃいれ',
  'ちゃいろ',
  'ちゃうか',
  'ちゃうけ',
  'ちゃうす',
  'ちゃえん',
  'ちゃおず',
  'ちゃおび',
  'ちゃがー',
  'ちゃかい',
  'ちゃがけ',
  'ちゃかご',
  'ちゃがし',
  'ちゃかす',
  'ちゃがま',
  'ちゃがゆ',
  'ちゃがら',
  'ちゃかん',
  'ちゃきん',
  'ちゃくい',
  'ちゃくえ',
  'ちゃくさ',
  'ちゃくざ',
  'ちゃくし',
  'ちゃくじ',
  'ちゃくち',
  'ちゃくに',
  'ちゃくひ',
  'ちゃくみ',
  'ちゃくら',
  'ちゃこし',
  'ちゃごと',
  'ちゃさじ',
  'ちゃしつ',
  'ちゃしぶ',
  'ちゃじゅ',
  'ちゃじん',
  'ちゃせき',
  'ちゃせん',
  'ちゃだい',
  'ちゃたく',
  'ちゃだし',
  'ちゃだち',
  'ちゃだな',
  'ちゃちゃ',
  'ちゃっか',
  'ちゃっく',
  'ちゃづけ',
  'ちゃっこ',
  'ちゃった',
  'ちゃづつ',
  'ちゃっと',
  'ちゃつね',
  'ちゃっぷ',
  'ちゃつぼ',
  'ちゃつみ',
  'ちゃてい',
  'ちゃでも',
  'ちゃとう',
  'ちゃどう',
  'ちゃとに',
  'ちゃとら',
  'ちゃどる',
  'ぢゃない',
  'ちゃにわ',
  'ぢゃねぇ',
  'ぢゃねー',
  'ちゃねず',
  'ちゃねる',
  'ちゃのき',
  'ちゃのこ',
  'ちゃのま',
  'ちゃのみ',
  'ちゃのゆ',
  'ちゃはく',
  'ちゃばこ',
  'ちゃばた',
  'ちゃぱつ',
  'ちゃばな',
  'ちゃばら',
  'ちゃばん',
  'ちゃびん',
  'ちゃぷた',
  'ちゃぶね',
  'ちゃぺる',
  'ちゃほや',
  'ちやほや',
  'ちゃぼん',
  'ちゃみせ',
  'ちゃめい',
  'ちゃめし',
  'ちゃめる',
  'ちゃよて',
  'ちゃらい',
  'ちゃらお',
  'ちゃらこ',
  'ちゃりん',
  'ちゃわん',
  'ちゃんぎ',
  'ちゃんく',
  'ちゃんぐ',
  'ちゃんこ',
  'ちゃんご',
  'ちゃんす',
  'ちゃんた',
  'ちゃんと',
  'ちゃんぱ',
  'ちゃんぷ',
  'ちゅうい',
  'ちゅうう',
  'ちゅーか',
  'ちゅうか',
  'ちゅうき',
  'ちゅうぎ',
  'ちゅうく',
  'ちゅうこ',
  'ちゅうさ',
  'ちゅうざ',
  'ちゅうし',
  'ちゅうじ',
  'ちゅうそ',
  'ちゅうと',
  'ちゅうど',
  'ちゅーな',
  'ちゅうに',
  'ちゅうは',
  'ちゅーば',
  'ちゅうば',
  'ちゅうひ',
  'ちゅうび',
  'ちゅうふ',
  'ちゅーぶ',
  'ちゅうぶ',
  'ちゅうほ',
  'ちゅうや',
  'ちゅうゆ',
  'ちゅうら',
  'ちゅーる',
  'ちゅうる',
  'ちゅうろ',
  'ちゅうわ',
  'ちゅーん',
  'ちゅそく',
  'ちゅちぇ',
  'ちゅちゅ',
  'ちゅっと',
  'ちゅにす',
  'ちゅのむ',
  'ちゅろす',
  'ちょいす',
  'ちょいと',
  'ちょうい',
  'ちょうか',
  'ちょうが',
  'ちょうき',
  'ちょうぎ',
  'ちょうく',
  'ちょうこ',
  'ちょうさ',
  'ちょうざ',
  'ちょうし',
  'ちょうじ',
  'ぢょうし',
  'ちょうす',
  'ちょうず',
  'ちょうそ',
  'ちょうだ',
  'ちょうと',
  'ちょうど',
  'ちょうな',
  'ちょうは',
  'ちょうば',
  'ちょうひ',
  'ちょうび',
  'ちょうふ',
  'ちょうぶ',
  'ちょうぼ',
  'ちょうま',
  'ちょうみ',
  'ちょうめ',
  'ちょうや',
  'ちょうり',
  'ちょうろ',
  'ちょうわ',
  'ちょーく',
  'ちよがみ',
  'ちょきん',
  'ちょくい',
  'ちょくご',
  'ちょくさ',
  'ちょくし',
  'ちょくじ',
  'ちょくち',
  'ちょくひ',
  'ちょくゆ',
  'ちょくる',
  'ちょくろ',
  'ちょくわ',
  'ちょける',
  'ちょげん',
  'ちょごり',
  'ちょこん',
  'ちょさい',
  'ちょざい',
  'ちょさく',
  'ちょしゃ',
  'ちょしょ',
  'ちょすい',
  'ちょせん',
  'ちょぞう',
  'ちょだい',
  'ちょたん',
  'ちょちく',
  'ちょっか',
  'ちょっき',
  'ちよっき',
  'ちょっく',
  'ちょっち',
  'ちょっと',
  'ちょっぷ',
  'ちょとつ',
  'ちょびと',
  'ちょぴり',
  'ちょぶん',
  'ちょぼく',
  'ちょむか',
  'ちょめい',
  'ちょもん',
  'ちょゆう',
  'ちょりそ',
  'ちょりつ',
  'ちょれい',
  'ちょろい',
  'ちょろぎ',
  'ちよろず',
  'ちょろり',
  'ちょろん',
  'ちょんこ',
  'ちょんぼ',
  'ちらかす',
  'ちらかる',
  'ちらちら',
  'ちらつき',
  'ちらつく',
  'ちらっと',
  'ちらばら',
  'ちらばる',
  'ちらほら',
  'ちらみせ',
  'ちらみん',
  'ちりがく',
  'ちりがみ',
  'ちりしく',
  'ちりじん',
  'ちりだに',
  'ちりちり',
  'ちりぢり',
  'ぢりぢり',
  'ちりづか',
  'ちりてき',
  'ちりとり',
  'ちりなべ',
  'ちりのお',
  'ちりほど',
  'ちりめん',
  'ちりゃく',
  'ちりょう',
  'ちりょく',
  'ちろしん',
  'ちろちろ',
  'ちわっす',
  'ちわんご',
  'ちをひく',
  'ちんあげ',
  'ちんあつ',
  'ちんあん',
  'ちんいち',
  'ちんいつ',
  'ちんうつ',
  'ちんがい',
  'ちんかく',
  'ちんがし',
  'ちんかす',
  'ちんがら',
  'ちんがり',
  'ちんぎょ',
  'ちんきん',
  'ちんぎん',
  'ちんくゆ',
  'ちんけい',
  'ちんげい',
  'ちんこう',
  'ちんこつ',
  'ちんこん',
  'ちんさい',
  'ちんさげ',
  'ちんしゃ',
  'ちんしゅ',
  'ちんじゅ',
  'ちんしょ',
  'ちんすい',
  'ちんする',
  'ちんせい',
  'ちんせき',
  'ちんせつ',
  'ちんせん',
  'ちんぜん',
  'ちんそう',
  'ちんぞう',
  'ちんたい',
  'ちんだい',
  'ちんたお',
  'ちんたら',
  'ちんだん',
  'ちんちら',
  'ちんちん',
  'ちんつう',
  'ちんてい',
  'ちんでい',
  'ちんでき',
  'ちんでん',
  'ちんとう',
  'ちんどう',
  'ちんなん',
  'ちんぴら',
  'ちんぴん',
  'ちんぷか',
  'ちんぶつ',
  'ちんぶん',
  'ちんべん',
  'ちんぼう',
  'ちんぽう',
  'ちんぼく',
  'ちんぼこ',
  'ちんぽこ',
  'ちんぽじ',
  'ちんぼつ',
  'ちんぽん',
  'ちんまり',
  'ちんめい',
  'ちんもく',
  'ちんもち',
  'ちんもん',
  'ちんやく',
  'ちんゆう',
  'ちんりつ',
  'ちんりん',
  'ちんれつ',
  'つぁーり',
  'つぁーる',
  'つあこん',
  'つぁじき',
  'つぃーと',
  'ついーと',
  'ついーど',
  'ついえる',
  'ついおく',
  'ついかい',
  'ついかき',
  'ついがき',
  'ついかび',
  'ついかん',
  'ついきそ',
  'ついけい',
  'ついげき',
  'ついこう',
  'ついごう',
  'ついこつ',
  'ついしゅ',
  'ついしん',
  'ついずい',
  'ついすと',
  'ついせき',
  'ついぜん',
  'ついそう',
  'ついぞう',
  'つぃたー',
  'ついたち',
  'ついたて',
  'ついつい',
  'ついでに',
  'ついては',
  'ついてる',
  'ついとう',
  'ついどう',
  'ついとつ',
  'ついにん',
  'ついぬし',
  'ついのう',
  'ついはい',
  'ついはく',
  'ついばむ',
  'ついひじ',
  'ついふく',
  'ついほう',
  'ついまつ',
  'ついまひ',
  'ついやす',
  'ついらく',
  'ついれん',
  'ついろく',
  'ついんて',
  'つういん',
  'つううん',
  'つうえん',
  'つうかあ',
  'つーかー',
  'つうかい',
  'つうかく',
  'つうがく',
  'つうがる',
  'つうかん',
  'つうきん',
  'つうけい',
  'つうげき',
  'つうけん',
  'つうげん',
  'つうこう',
  'つうこく',
  'つうこん',
  'つうさん',
  'つーじー',
  'つうじて',
  'つうしょ',
  'つうじる',
  'つうしん',
  'つうじん',
  'つうすい',
  'つうずる',
  'つうせい',
  'つうせき',
  'つうせつ',
  'つうせん',
  'つうそう',
  'つうそく',
  'つうぞく',
  'つうたつ',
  'つうだつ',
  'つうたん',
  'つうちぼ',
  'つうつう',
  'つうっと',
  'つーっと',
  'つうてい',
  'つうてん',
  'つうでん',
  'つうどく',
  'つーとん',
  'つうねん',
  'つーぱい',
  'つうはん',
  'つうふう',
  'つうぶる',
  'つうふん',
  'つうぶん',
  'つーぺあ',
  'つうへい',
  'つうべん',
  'つうほう',
  'つうぼう',
  'つうめい',
  'つーもー',
  'つうやく',
  'つうゆう',
  'つうよう',
  'つうらん',
  'つうりき',
  'つーるど',
  'つうれい',
  'つうれつ',
  'つうろん',
  'つーんと',
  'つかあな',
  'つかいて',
  'つかいで',
  'つかいね',
  'つかいま',
  'つかいめ',
  'つがいめ',
  'つかえめ',
  'つかえる',
  'つがえる',
  'つかせる',
  'つかたり',
  'つかつか',
  'つかねる',
  'つかのま',
  'つかまき',
  'つかまる',
  'つからす',
  'つかれた',
  'つかれめ',
  'つかれる',
  'つかわす',
  'つきあい',
  'つきあう',
  'つぎあし',
  'つぎあて',
  'つきいそ',
  'つきいた',
  'つきいち',
  'つきうす',
  'つきうま',
  'つきおし',
  'つきがき',
  'つきかげ',
  'つきがけ',
  'つきがさ',
  'つきがた',
  'つきがみ',
  'つぎがみ',
  'つききず',
  'つきぎめ',
  'つききり',
  'つきぎり',
  'つききる',
  'つぎぎれ',
  'つぎくち',
  'つぎぐち',
  'つきごし',
  'つきごと',
  'つきこむ',
  'つぎこむ',
  'つきごめ',
  'つきごろ',
  'つぎざお',
  'つきさす',
  'つきしろ',
  'つきずえ',
  'つきせぬ',
  'つきそい',
  'つきそう',
  'つぎだい',
  'つきだし',
  'つぎたし',
  'つきだす',
  'つぎたす',
  'つきたち',
  'つきたつ',
  'つきたて',
  'つぎたて',
  'つきづき',
  'つぎつぎ',
  'つきでた',
  'つきでる',
  'つきない',
  'つきなか',
  'つきなみ',
  'つぎなる',
  'つきぬく',
  'つきのき',
  'つきので',
  'つぎのま',
  'つきのわ',
  'つぎはぎ',
  'つきばん',
  'つきひざ',
  'つきびと',
  'つきべつ',
  'つきべら',
  'つきへん',
  'つきぼう',
  'つきまち',
  'つきもの',
  'つぎもの',
  'つきやく',
  'つきやま',
  'つきゆび',
  'つきわり',
  'つくだに',
  'つくつく',
  'つくづく',
  'つぐない',
  'つぐなう',
  'つくなむ',
  'つぐのう',
  'つくばい',
  'つくばう',
  'つくばね',
  'つくばる',
  'つくぼう',
  'つくよみ',
  'つくりえ',
  'つくりき',
  'つくりぎ',
  'つくりじ',
  'つくりて',
  'つくりな',
  'つくりみ',
  'つくりめ',
  'つくろい',
  'つくろう',
  'つけあい',
  'つけいた',
  'つけいる',
  'つけうお',
  'つけうち',
  'つけうま',
  'つけおき',
  'つけおち',
  'つけかえ',
  'つけかけ',
  'つけかた',
  'つけがみ',
  'つげぐち',
  'つけこみ',
  'つけこむ',
  'つけさげ',
  'つけじえ',
  'つけしる',
  'つけじる',
  'つけだい',
  'つけたし',
  'つけだし',
  'つけたす',
  'つけだす',
  'つけたり',
  'つけたれ',
  'つけだれ',
  'つけぢえ',
  'つけつけ',
  'づけづけ',
  'つけづめ',
  'つけばな',
  'つけひげ',
  'つけびと',
  'つけひも',
  'つけふだ',
  'つけぶみ',
  'つけぺん',
  'つけまげ',
  'つけめん',
  'つけもの',
  'つけやき',
  'っこない',
  'っこなし',
  'つごもり',
  'つじうら',
  'つじかご',
  'つじかぜ',
  'つじぎみ',
  'つじぎり',
  'つじげい',
  'つじつじ',
  'つじつま',
  'つじどう',
  'つじとり',
  'つじばん',
  'つじふだ',
  'つじぶろ',
  'つじまち',
  'つしまは',
  'つじみせ',
  'つじょん',
  'つたえる',
  'つたない',
  'つたわる',
  'つちあじ',
  'つちいろ',
  'つちおと',
  'つちかう',
  'つちかた',
  'つちかべ',
  'つちがみ',
  'つちぐも',
  'つちぐり',
  'つちくれ',
  'つちこつ',
  'つちすり',
  'つちたら',
  'つちつき',
  'つちづと',
  'つちなべ',
  'つちのえ',
  'つちのこ',
  'つちのと',
  'つちばし',
  'つちばち',
  'つちふき',
  'つちぶた',
  'つちぶね',
  'つちふる',
  'つちへん',
  'つちやき',
  'っちゅう',
  'つちよし',
  'つちよせ',
  'つちろう',
  'つつある',
  'つづいて',
  'っつうか',
  'っつーか',
  'つつおと',
  'つっかい',
  'つっかけ',
  'つつがた',
  'つっきり',
  'つつぎり',
  'つっきる',
  'つづけじ',
  'つづけて',
  'つづける',
  'つっこみ',
  'つっこむ',
  'つつさき',
  'つつじか',
  'つつしみ',
  'つつしむ',
  'つつそで',
  'つったつ',
  'つっつく',
  'つつどり',
  'つつぬけ',
  'つっぱり',
  'つっぱる',
  'つっぷす',
  'つづまる',
  'つつみな',
  'つづめる',
  'つつやき',
  'つづりじ',
  'っていう',
  'つてこと',
  'ってのは',
  'つとまる',
  'つとめぎ',
  'つとめて',
  'つとめる',
  'つながり',
  'つながる',
  'つなかん',
  'つなぎめ',
  'つなげる',
  'つなしめ',
  'つなとり',
  'つなどり',
  'つなひき',
  'つなまよ',
  'つねづね',
  'つのがい',
  'つのがき',
  'つのがみ',
  'つのごけ',
  'つのざめ',
  'つのぜみ',
  'つのだし',
  'つのだる',
  'つのなす',
  'つのぶえ',
  'つのへん',
  'つのまた',
  'つのらす',
  'つばおと',
  'つばきか',
  'つばくら',
  'つばくろ',
  'つばする',
  'っはなし',
  'っぱなし',
  'つぶあん',
  'つぶがい',
  'つぶぎん',
  'つぶさに',
  'つぶしね',
  'つぶだつ',
  'つぶつぶ',
  'つぶやき',
  'つぶやく',
  'つぶより',
  'つぶれる',
  'つべこべ',
  'つべたい',
  'つぼがた',
  'つぼがね',
  'つぼかび',
  'つぼくさ',
  'つぼざら',
  'つぼすう',
  'つぼにわ',
  'つぼまる',
  'つぼめる',
  'つぼやき',
  'つまいり',
  'つまおと',
  'つまかべ',
  'つまかわ',
  'つまぐる',
  'つまぐろ',
  'つまさき',
  'つましい',
  'つまじろ',
  'つまずき',
  'つまずく',
  'つまだち',
  'つまだつ',
  'つまづく',
  'つまとり',
  'つまどり',
  'つまびき',
  'つまびく',
  'つまみな',
  'つまらぬ',
  'つまらん',
  'つみあげ',
  'つみかえ',
  'つみかた',
  'つみきん',
  'つみくさ',
  'つみごえ',
  'つみこみ',
  'つみこむ',
  'つみすぎ',
  'つみする',
  'つみだし',
  'つみだす',
  'つみたて',
  'つみとり',
  'つみとる',
  'つみびと',
  'つみぼう',
  'つみまし',
  'つみます',
  'つむがた',
  'つむぶり',
  'つめあと',
  'つめいん',
  'つめえり',
  'つめきり',
  'つめきる',
  'つめくさ',
  'つめくそ',
  'つめこむ',
  'つめしょ',
  'つめそで',
  'つめたい',
  'つめだに',
  'つめとぎ',
  'つめばら',
  'つめびき',
  'つめもの',
  'つめよる',
  'つもぎり',
  'つもほー',
  'つもろー',
  'つやけし',
  'つやごと',
  'つやだし',
  'つやだね',
  'つやつや',
  'つやぶみ',
  'つやめく',
  'つやもの',
  'つややか',
  'つゆあけ',
  'つゆいり',
  'つゆくさ',
  'つゆさむ',
  'つゆざむ',
  'つゆしも',
  'つゆじも',
  'つゆぞら',
  'つゆだく',
  'つゆどき',
  'つゆのま',
  'つゆばれ',
  'つゆべら',
  'つゆほど',
  'つよがり',
  'つよがる',
  'つよごし',
  'つよまる',
  'つよめる',
  'つよゆみ',
  'つらあて',
  'つらいち',
  'つらだし',
  'つらづえ',
  'つらつき',
  'つらつら',
  'つらなり',
  'つらなる',
  'つらぬく',
  'つらねる',
  'つらぼね',
  'つられる',
  'つりあい',
  'つりあう',
  'つりあげ',
  'つりあぶ',
  'つりいと',
  'つりうき',
  'つりうむ',
  'つりえさ',
  'つりがき',
  'つりかご',
  'つりがね',
  'つりがま',
  'つりかわ',
  'つりこむ',
  'つりざお',
  'つりさく',
  'つりしょ',
  'つりせん',
  'つりだい',
  'つりだし',
  'つりだす',
  'つりだな',
  'つりだま',
  'つりどこ',
  'つりどの',
  'つりばか',
  'つりはし',
  'つりばし',
  'つりばち',
  'つりばな',
  'つりばり',
  'つりびと',
  'つりひも',
  'つりふね',
  'つりぶね',
  'つりぼり',
  'つりやね',
  'つるおと',
  'つるかめ',
  'つるくさ',
  'つるくび',
  'つるせい',
  'つるだち',
  'つるつる',
  'づるづる',
  'つるなべ',
  'つるのこ',
  'つるはし',
  'つるばみ',
  'つるばら',
  'つるまき',
  'つれあい',
  'つれあう',
  'つれこみ',
  'つれこむ',
  'つれさり',
  'つれさる',
  'つれそう',
  'つれだか',
  'つれだす',
  'つれだつ',
  'つれづれ',
  'つれない',
  'つれまい',
  'つわっぱ',
  'つわなご',
  'つわぶき',
  'つわもの',
  'つんけん',
  'つんざく',
  'つんだす',
  'つんつん',
  'つんでれ',
  'つんどく',
  'つんどら',
  'つんなめ',
  'であがり',
  'てあそび',
  'てあつい',
  'てあとる',
  'てあとろ',
  'てあにん',
  'てあぶり',
  'てあらい',
  'であるく',
  'であれば',
  'であろう',
  'てあわせ',
  'てぃあー',
  'ていあつ',
  'でぃあな',
  'てぃあら',
  'ていあん',
  'ていいち',
  'でぃーば',
  'でぃーぷ',
  'てぃーむ',
  'でぃーら',
  'てぃーん',
  'ていいん',
  'でぃーん',
  'ていうか',
  'ていうん',
  'ていえん',
  'ていおう',
  'ていおん',
  'でぃおん',
  'ていかい',
  'ていがい',
  'ていかく',
  'ていがく',
  'でぃかふ',
  'ていかん',
  'でいがん',
  'ていきん',
  'ていぎん',
  'ていくう',
  'でぃぐる',
  'でいけあ',
  'ていけい',
  'でぃけい',
  'ていげき',
  'ていけつ',
  'ていけん',
  'ていげん',
  'ていこう',
  'ていこく',
  'てぃざー',
  'ていさい',
  'ていさつ',
  'でいじー',
  'ていしき',
  'ていしつ',
  'ていじつ',
  'ていじぶ',
  'ていしゃ',
  'でいしゃ',
  'てぃしゅ',
  'ていしゅ',
  'ていしょ',
  'ていじょ',
  'ていじろ',
  'ていしん',
  'でいすい',
  'ていすう',
  'でぃすく',
  'でぃすこ',
  'ていすと',
  'ていする',
  'でぃする',
  'ていせい',
  'ていせつ',
  'ていせん',
  'ていぜん',
  'ていそう',
  'ていぞう',
  'でいぞう',
  'ていそく',
  'ていぞく',
  'ていたい',
  'ていだい',
  'ていたく',
  'ていだん',
  'でいたん',
  'ていちゃ',
  'てぃっく',
  'てぃっぷ',
  'でぃっぷ',
  'ていてい',
  'ていてつ',
  'ていてん',
  'ていでん',
  'ていとう',
  'ていどう',
  'ていとく',
  'ていとん',
  'でぃなー',
  'ていない',
  'ていねい',
  'でいねい',
  'ていねん',
  'ていのう',
  'ていばい',
  'ていはく',
  'ていはつ',
  'ていばん',
  'てぃぴー',
  'でぃぶく',
  'ていへん',
  'ていぼう',
  'ていぼく',
  'ていほん',
  'ていまい',
  'でいまん',
  'ていみつ',
  'ていめい',
  'ていめん',
  'ていもう',
  'でいもす',
  'ていもん',
  'ていやく',
  'ていゆう',
  'ていよう',
  'ていよく',
  'でいよく',
  'てぃらー',
  'ていらー',
  'でぃらー',
  'でいらー',
  'ていらく',
  'ていらず',
  'てぃらな',
  'でいりー',
  'ていりつ',
  'てぃるで',
  'てぃると',
  'でぃるど',
  'ていれい',
  'でぃれい',
  'でぃれー',
  'ていれつ',
  'ていれん',
  'ていろん',
  'でぃんご',
  'ていんと',
  'でゔぃる',
  'でーけあ',
  'でーじー',
  'てーすと',
  'でーたー',
  'でーたか',
  'でーたく',
  'でーたち',
  'てーぱー',
  'でーはー',
  'でーびー',
  'てーぶる',
  'てーべー',
  'でーもん',
  'てーらー',
  'でーりー',
  'ておくり',
  'ておくれ',
  'ておどり',
  'ておりあ',
  'でおんな',
  'てがあく',
  'でかーる',
  'てかがみ',
  'てがかり',
  'でかかる',
  'てがきく',
  'てがける',
  'でかける',
  'てかげん',
  'てかこう',
  'でかごえ',
  'てがこむ',
  'でかした',
  'でかじり',
  'てがすく',
  'でかせぎ',
  'てがたい',
  'てがたな',
  'でがたり',
  'でかだん',
  'でかちん',
  'てがつく',
  'てかてか',
  'でかでか',
  'てがでる',
  'てがない',
  'でかぱい',
  'でかふぇ',
  'でかぶつ',
  'でかまら',
  'でかもり',
  'でがらし',
  'でかろぐ',
  'でかわり',
  'でがわり',
  'でかわる',
  'でかんた',
  'できあい',
  'できあう',
  'できあき',
  'てきーら',
  'てきえい',
  'てきおう',
  'てきおん',
  'てきかく',
  'てきがた',
  'てきがわ',
  'てきかん',
  'てきぐん',
  'てきごう',
  'てきこく',
  'できごと',
  'できこん',
  'てきざい',
  'てきさく',
  'てきさす',
  'できしー',
  'てきした',
  'てきじだ',
  'てきしつ',
  'てきしゃ',
  'てきしゅ',
  'てきしょ',
  'てきじょ',
  'てきしん',
  'てきじん',
  'てきすい',
  'できすい',
  'できすぎ',
  'てきすと',
  'てきする',
  'てきせい',
  'てきぜい',
  'てきせつ',
  'てきせん',
  'てきぜん',
  'てきたい',
  'できだか',
  'できたて',
  'てきだん',
  'てきてい',
  'てきてき',
  'てきとう',
  'てきとー',
  'できどし',
  'てきにん',
  'できばえ',
  'てきばき',
  'てきぱき',
  'てきはつ',
  'できぶつ',
  'てきへい',
  'てきほう',
  'できぼし',
  'てきめん',
  'できもの',
  'てきやく',
  'できやく',
  'てきよう',
  'でぎらい',
  'てきるい',
  'てきれい',
  'てぎれい',
  'できれば',
  'てきろく',
  'てくしー',
  'てくすと',
  'てくせる',
  'てぐっき',
  'てくてく',
  'でくでく',
  'てくばり',
  'てくらむ',
  'でぐりー',
  'てくりは',
  'てぐるま',
  'でくわす',
  'でげいこ',
  'でけもの',
  'てこいれ',
  'でごうし',
  'でこーだ',
  'でこーど',
  'てごころ',
  'でござる',
  'でこすけ',
  'てこずる',
  'てごたえ',
  'てこてこ',
  'でこでん',
  'でことら',
  'でこぴん',
  'でこぼう',
  'でこぼこ',
  'でこぽん',
  'てこもり',
  'でこるて',
  'てごわい',
  'でごんす',
  'てこんど',
  'でざーと',
  'でさーる',
  'でざいあ',
  'てざいく',
  'でざいん',
  'でさかり',
  'でざかり',
  'でさかる',
  'てさぐり',
  'てさばき',
  'てざわり',
  'でじあな',
  'でじいち',
  'でしいり',
  'でじかむ',
  'でじかめ',
  'てしごと',
  'でしごと',
  'でじたこ',
  'でしたら',
  'でじたる',
  'でじちけ',
  'でじっと',
  'てじなし',
  'でじぱち',
  'でしぶる',
  'でしべる',
  'でじぼる',
  'てじまい',
  'てじまう',
  'でしまる',
  'でじゃう',
  'てじゃく',
  'でじゃぶ',
  'でじゅり',
  'てじゅん',
  'てじょう',
  'でしょう',
  'てしょく',
  'てじょく',
  'でしょく',
  'てしんご',
  'でずいり',
  'てずから',
  'ですから',
  'ですぎる',
  'ですごえ',
  'てすさび',
  'てすたー',
  'ですたい',
  'てすてす',
  'ですです',
  'ですぺる',
  'てすりこ',
  'てずれる',
  'でせーる',
  'てそうさ',
  'てそうみ',
  'でそろう',
  'でたがり',
  'てだすけ',
  'でたっち',
  'てたにー',
  'てたぬす',
  'てだまに',
  'でたらめ',
  'でたんと',
  'てちがい',
  'でちがう',
  'でちゅー',
  'てちょう',
  'てついろ',
  'てつえん',
  'てつおた',
  'てっかい',
  'てつがい',
  'でっかい',
  'てっかく',
  'てつがく',
  'てつかず',
  'てっかば',
  'てづかみ',
  'てつから',
  'てっかん',
  'てっきょ',
  'てつぎょ',
  'てっきり',
  'てっきん',
  'てっくす',
  'てつくず',
  'でつくす',
  'てづくり',
  'てっけつ',
  'てっけん',
  'てっこう',
  'てっこく',
  'てっこつ',
  'てつざい',
  'てっさく',
  'てっさつ',
  'てつさび',
  'てっさん',
  'てつざん',
  'でっさん',
  'てっしゅ',
  'てっしん',
  'てつじん',
  'てっする',
  'てっせい',
  'てつせい',
  'てっせき',
  'てっせん',
  'てっそう',
  'てっそく',
  'てつぞく',
  'てっそん',
  'てったい',
  'てつだい',
  'てつだう',
  'てっちり',
  'でっちり',
  'てっちん',
  'てっつい',
  'てつづき',
  'てってい',
  'てっとう',
  'てつどう',
  'てつなべ',
  'てっぱい',
  'てつばち',
  'てっぱち',
  'でっぱな',
  'でっぱり',
  'でっぱる',
  'てっぱん',
  'てつびし',
  'てっぴつ',
  'てつびん',
  'でっぷり',
  'てつぶん',
  'てっぷん',
  'てっぺい',
  'てっぺき',
  'てっぺん',
  'てつぼう',
  'てっぽう',
  'てづまり',
  'てつまん',
  'てつむじ',
  'てつめん',
  'てつもう',
  'てつゆう',
  'てづよい',
  'てつりつ',
  'てつりん',
  'てつろく',
  'てつわん',
  'てつをた',
  'てでぃー',
  'でていく',
  'でてーる',
  'でてくる',
  'ててはは',
  'ででむし',
  'でてゆく',
  'でどころ',
  'てどまり',
  'てとりす',
  'てとりる',
  'でないと',
  'てなおし',
  'でなおし',
  'でなおす',
  'でなおる',
  'てなもん',
  'てならい',
  'てならし',
  'てなれた',
  'てなれる',
  'てなんと',
  'でにーる',
  'でにくい',
  'てにする',
  'てにてに',
  'てにとる',
  'てにのる',
  'てにもつ',
  'てにをは',
  'てぬーと',
  'てぬかり',
  'てぬぐい',
  'てぬるい',
  'てねしー',
  'てねしん',
  'でねぼら',
  'てのうち',
  'てのーる',
  'てのこう',
  'てのはら',
  'てのひら',
  'てのもの',
  'てのゆび',
  'でぱーと',
  'ではある',
  'てはいし',
  'でばいす',
  'ではいり',
  'でばかめ',
  'でばがめ',
  'でぱこす',
  'てばさき',
  'てはじめ',
  'ではじめ',
  'でばしょ',
  'ではずれ',
  'でぱちか',
  'でばっが',
  'でばっぐ',
  'ではない',
  'てばなし',
  'てばなす',
  'てばなれ',
  'てばにく',
  'ではまた',
  'てばもと',
  'てばやい',
  'でばやし',
  'ではらい',
  'ではらう',
  'でぱれす',
  'でびあん',
  'てびかえ',
  'でびたい',
  'てひどい',
  'てびねり',
  'でびゅー',
  'でびゅう',
  'てびろい',
  'てびろく',
  'てぶくろ',
  'でふこん',
  'でぶせん',
  'てぶそく',
  'でぶちん',
  'でぶでぶ',
  'でふらぐ',
  'でぷろい',
  'てふろん',
  'てぶんこ',
  'てへぺろ',
  'てへらん',
  'てぼうき',
  'でぽざい',
  'てほどき',
  'てぽどん',
  'でぼんき',
  'でまかせ',
  'てまくら',
  'てまだい',
  'てまちん',
  'てまどる',
  'てまねき',
  'てまねく',
  'てまひま',
  'てまわし',
  'てまわり',
  'でまわり',
  'でまわる',
  'でまんど',
  'てみじか',
  'てみずや',
  'でみたす',
  'てみやげ',
  'てむかい',
  'てむかう',
  'でむかえ',
  'でめきん',
  'でめてる',
  'でもある',
  'てもいい',
  'でもいん',
  'でもしか',
  'でもたい',
  'でもって',
  'てもどり',
  'でもどり',
  'でもない',
  'てもなく',
  'でもばん',
  'てもよい',
  'でもわり',
  'でやすい',
  'でゅある',
  'てゆうか',
  'てゆーか',
  'でゅーく',
  'でゅーす',
  'てゅーば',
  'でゅーぷ',
  'でゅえる',
  'でゅろん',
  'でらーく',
  'てらいり',
  'てらうけ',
  'てらこや',
  'でらしね',
  'てらせん',
  'てらぞー',
  'てらてら',
  'てらぴあ',
  'てりあう',
  'てりあめ',
  'でりーと',
  'てりーぬ',
  'てりこむ',
  'でりっく',
  'てりぶる',
  'でりへる',
  'でりみた',
  'てりやき',
  'てるぐご',
  'でるたは',
  'てるぺん',
  'でるまえ',
  'てるみん',
  'てるりど',
  'てれあぽ',
  'てれくら',
  'てれぐり',
  'てれこみ',
  'てれこむ',
  'てれしね',
  'てれそん',
  'でれつく',
  'でれっと',
  'てれてる',
  'でれでれ',
  'てれびか',
  'てれびん',
  'てれぴん',
  'てれほん',
  'てれみん',
  'てろくろ',
  'てろっぷ',
  'てろめあ',
  'てわたし',
  'てわたす',
  'てをうつ',
  'てをかす',
  'てをきる',
  'てをくむ',
  'てをだす',
  'てをつく',
  'てをとる',
  'てをぬく',
  'てをひく',
  'てをふる',
  'てをやく',
  'てをやる',
  'でんあつ',
  'てんあん',
  'でんいさ',
  'てんいた',
  'てんいち',
  'てんいん',
  'てんうめ',
  'てんうん',
  'てんえい',
  'でんえい',
  'てんえん',
  'でんえん',
  'てんおう',
  'てんおん',
  'でんおん',
  'てんかい',
  'てんがい',
  'でんかい',
  'てんかき',
  'てんかく',
  'てんがく',
  'でんかく',
  'でんがく',
  'てんかす',
  'てんかつ',
  'てんから',
  'てんかん',
  'てんがん',
  'てんきー',
  'でんきし',
  'てんきず',
  'てんきぼ',
  'てんきや',
  'でんきや',
  'てんきょ',
  'でんきろ',
  'てんきん',
  'でんきん',
  'てんくう',
  'てんぐさ',
  'てんぐん',
  'でんぐん',
  'てんけい',
  'てんげき',
  'でんげき',
  'てんけつ',
  'でんけつ',
  'てんけん',
  'てんげん',
  'でんけん',
  'でんげん',
  'てんこう',
  'てんごう',
  'でんこう',
  'てんこく',
  'てんごく',
  'でんごん',
  'てんさい',
  'てんざい',
  'てんさく',
  'でんさく',
  'てんさん',
  'でんさん',
  'でんしか',
  'でんじき',
  'てんじく',
  'てんしち',
  'てんじち',
  'てんしつ',
  'てんじつ',
  'てんじて',
  'でんじは',
  'でんじば',
  'てんしゃ',
  'てんじゃ',
  'でんしゃ',
  'でんじゃ',
  'てんしゅ',
  'てんじゅ',
  'でんじゅ',
  'てんしょ',
  'てんじょ',
  'でんしょ',
  'てんじる',
  'てんしん',
  'てんじん',
  'でんしん',
  'てんすい',
  'てんすう',
  'でんすけ',
  'てんずる',
  'てんせい',
  'でんせい',
  'てんせき',
  'てんせつ',
  'でんせつ',
  'てんせん',
  'てんぜん',
  'でんせん',
  'てんそう',
  'てんぞう',
  'でんそう',
  'てんそく',
  'てんぞく',
  'てんそる',
  'でんそろ',
  'てんそん',
  'でんそん',
  'てんだー',
  'てんたい',
  'てんだい',
  'てんたく',
  'でんたく',
  'でんたつ',
  'でんたる',
  'てんたん',
  'でんたん',
  'でんだん',
  'でんちく',
  'てんちゃ',
  'てんつゆ',
  'てんてい',
  'でんてい',
  'てんてき',
  'てんてつ',
  'でんてつ',
  'てんでに',
  'てんてん',
  'てんでん',
  'てんとう',
  'てんどう',
  'でんとう',
  'でんどう',
  'てんとく',
  'てんとち',
  'でんとつ',
  'てんとり',
  'てんどん',
  'てんない',
  'てんにょ',
  'てんにん',
  'てんぬき',
  'でんねつ',
  'てんねん',
  'てんのう',
  'でんのう',
  'でんのこ',
  'てんぱー',
  'でんばー',
  'てんばい',
  'てんぱい',
  'てんばく',
  'でんばた',
  'でんぱた',
  'てんばつ',
  'てんぱる',
  'てんばん',
  'てんぱん',
  'でんばん',
  'でんぱん',
  'てんびき',
  'てんぴつ',
  'てんびん',
  'てんぴん',
  'てんぷう',
  'でんぷう',
  'てんぷく',
  'てんぶつ',
  'てんぷら',
  'てんぷる',
  'てんぷれ',
  'てんぶん',
  'でんぶん',
  'でんぷん',
  'てんへい',
  'てんぺい',
  'てんぺら',
  'てんぺん',
  'てんぼう',
  'てんぽう',
  'でんぼう',
  'でんぽう',
  'てんほー',
  'てんぽん',
  'でんぽん',
  'てんまく',
  'てんまつ',
  'てんまど',
  'てんむす',
  'てんめい',
  'でんめい',
  'てんめつ',
  'てんめん',
  'てんもう',
  'でんもう',
  'てんもく',
  'てんもん',
  'てんやく',
  'てんゆう',
  'でんゆう',
  'てんよう',
  'てんらい',
  'でんらい',
  'てんらく',
  'てんらん',
  'でんらん',
  'でんりく',
  'てんれい',
  'でんれい',
  'でんれつ',
  'てんろう',
  'でんろう',
  'てんろき',
  'てんろく',
  'でんろく',
  'でんわき',
  'どああい',
  'どあーず',
  'とあたり',
  'とあって',
  'どあっぷ',
  'どあのぶ',
  'どあべる',
  'どあほう',
  'どあほん',
  'どあまん',
  'とあらば',
  'とあれば',
  'といあげ',
  'というか',
  'というと',
  'といえど',
  'といえば',
  'といかけ',
  'といがん',
  'といきり',
  'どいたま',
  'どいっき',
  'どいつご',
  'といった',
  'といって',
  'といとれ',
  'どいなか',
  'どいひー',
  'といめん',
  'どいもい',
  'どいりー',
  'といわず',
  'どうあく',
  'どうあげ',
  'とうあつ',
  'どうあつ',
  'どうあて',
  'どうあれ',
  'とうあん',
  'どうあん',
  'どういう',
  'どういぎ',
  'どういご',
  'とういす',
  'とういつ',
  'どういつ',
  'どういみ',
  'とういも',
  'とういん',
  'どういん',
  'とぅーす',
  'どぅーぱ',
  'どぅーま',
  'どぅーむ',
  'どぅーら',
  'とぅーる',
  'とうえい',
  'どうえい',
  'とうえき',
  'とうえん',
  'とうおう',
  'どうおう',
  'とうおく',
  'どぅおも',
  'どうおや',
  'とうおん',
  'どうおん',
  'とうかい',
  'とうがい',
  'どうかい',
  'どうがか',
  'とうかき',
  'とうかく',
  'とうがく',
  'どうかく',
  'どうがく',
  'どうかけ',
  'どうがけ',
  'とうがさ',
  'とうがし',
  'どうがし',
  'とうかち',
  'とうかつ',
  'どうかつ',
  'どうかな',
  'とうかゆ',
  'とうかん',
  'とうがん',
  'どうかん',
  'どうがん',
  'とうきか',
  'どうきか',
  'どうぎご',
  'とうきし',
  'とうきび',
  'とうきぼ',
  'とうぎょ',
  'どうきょ',
  'とうぎり',
  'どうぎり',
  'とうきれ',
  'とうきん',
  'とうぎん',
  'どうきん',
  'とうぐう',
  'とうくつ',
  'どうくつ',
  'とうぐみ',
  'どうぐや',
  'どうくら',
  'とうぐん',
  'どうくん',
  'とうけい',
  'とうげい',
  'どうけい',
  'どうけし',
  'とうけつ',
  'とうげつ',
  'どうけつ',
  'どうげつ',
  'どうける',
  'とうけん',
  'とうげん',
  'どうけん',
  'どうげん',
  'とうこう',
  'とうごう',
  'どうこう',
  'どうごう',
  'とうごく',
  'どうこく',
  'とうこつ',
  'とうごま',
  'とうこん',
  'どうこん',
  'とうさい',
  'とうざい',
  'どうざい',
  'とうさぎ',
  'とうさく',
  'どうさく',
  'どうざし',
  'とうさつ',
  'どうさつ',
  'とうざに',
  'とうさん',
  'とうざん',
  'どうさん',
  'どうざん',
  'とうしか',
  'どうしか',
  'とうしき',
  'とうじき',
  'どうしく',
  'どうじく',
  'とうじご',
  'とうしず',
  'どうした',
  'とうしつ',
  'とうじつ',
  'どうしつ',
  'どうじつ',
  'どうして',
  'とうしど',
  'どうじに',
  'とうじば',
  'どうじめ',
  'とうしゃ',
  'とうじゃ',
  'どうしゃ',
  'どうじゃ',
  'とうしゅ',
  'どうしゅ',
  'とうしょ',
  'とうじょ',
  'どうしょ',
  'どうじょ',
  'とうじる',
  'どうじる',
  'とうしろ',
  'とうしん',
  'とうじん',
  'どうしん',
  'どうじん',
  'とうすい',
  'どうすい',
  'とうすう',
  'どうすう',
  'とうずる',
  'どうずる',
  'とうせい',
  'どうせい',
  'どうぜい',
  'とうせき',
  'どうせき',
  'とうせつ',
  'どうせつ',
  'とうせん',
  'とうぜん',
  'どうせん',
  'どうぜん',
  'とうそう',
  'とうぞう',
  'どうそう',
  'どうぞう',
  'とうそく',
  'とうぞく',
  'どうぞく',
  'とうそつ',
  'どうそん',
  'とうたい',
  'とうだい',
  'どうたい',
  'どうだい',
  'どうたく',
  'とうたつ',
  'とうだつ',
  'どうたら',
  'とうたん',
  'とうだん',
  'どうたん',
  'どうだん',
  'とうちー',
  'どうちー',
  'とうちか',
  'とうちく',
  'とうちゃ',
  'とうちん',
  'とうつう',
  'どうつう',
  'どうづき',
  'とうてい',
  'どうてい',
  'とぅでー',
  'とうてき',
  'どうてき',
  'とうてつ',
  'どうでも',
  'とうてん',
  'とうでん',
  'どうてん',
  'どうでん',
  'とうとい',
  'とうとう',
  'とうどう',
  'どうとう',
  'どうどう',
  'とうどく',
  'どうとく',
  'とうとつ',
  'とうとぶ',
  'どうとも',
  'とうどり',
  'どうとり',
  'とうない',
  'どうない',
  'どうなか',
  'どうなが',
  'とうなす',
  'とうなん',
  'どうなん',
  'どうにか',
  'とうにく',
  'どうにも',
  'どうにょ',
  'とうにん',
  'どうにん',
  'とうねん',
  'どうねん',
  'とうはい',
  'とうばい',
  'どうはい',
  'とうばく',
  'どうはく',
  'とうはつ',
  'とうばつ',
  'どうばと',
  'どうばね',
  'とうはば',
  'どうはろ',
  'とうはん',
  'とうばん',
  'どうはん',
  'どうばん',
  'どうひつ',
  'とうひゆ',
  'とうひん',
  'とうふぁ',
  'とうふう',
  'どうふう',
  'とうふく',
  'とうぶく',
  'どうふく',
  'とうぶつ',
  'どうぶつ',
  'どうふぼ',
  'とうふや',
  'とうぶん',
  'どうぶん',
  'とうへい',
  'とうへき',
  'どうべや',
  'とうへん',
  'とうべん',
  'とうほう',
  'とうぼう',
  'どうほう',
  'どうぼう',
  'とうほく',
  'とうぼく',
  'どうぼく',
  'どうほこ',
  'どうぼこ',
  'とうぼし',
  'どうぼし',
  'どうぽじ',
  'どうほわ',
  'とうほん',
  'どうまき',
  'どうまる',
  'とうみつ',
  'とうみん',
  'どうみん',
  'とうめい',
  'どうめい',
  'とうめつ',
  'とうめん',
  'どうもう',
  'とうもく',
  'どうもく',
  'とうもつ',
  'どうもと',
  'どうもり',
  'とうもん',
  'どうもん',
  'とうやく',
  'どうやく',
  'どうやら',
  'とうゆう',
  'どうゆう',
  'とうよう',
  'どうよう',
  'どうよく',
  'とうらい',
  'とうらく',
  'どうらく',
  'どうらん',
  'とうりつ',
  'どうりつ',
  'どうりで',
  'どうりょ',
  'とうりん',
  'どうりん',
  'とうるい',
  'どうるい',
  'とぅるー',
  'とうれい',
  'とうれき',
  'どうれつ',
  'とうろう',
  'どうろう',
  'とうろく',
  'どうろく',
  'とうろん',
  'とうわく',
  'とぅんち',
  'どえらい',
  'どえんか',
  'とおあさ',
  'とおいち',
  'とおいめ',
  'とーいん',
  'とおえん',
  'とおがけ',
  'とおかや',
  'とーきー',
  'とーくん',
  'とーけい',
  'どーさい',
  'どーじぇ',
  'とおじま',
  'とおしや',
  'とーすと',
  'どーたー',
  'とーたす',
  'とーたる',
  'とーちか',
  'とーちゃ',
  'とーてむ',
  'どーどー',
  'どーなつ',
  'とおなり',
  'とーなる',
  'とおのく',
  'とおのり',
  'とーふぁ',
  'とーふる',
  'とおぼえ',
  'どーまー',
  'とおまき',
  'どーみー',
  'とおみち',
  'とおみみ',
  'とおやま',
  'とーらー',
  'とーらす',
  'とーらん',
  'どーらん',
  'どーりあ',
  'どおりで',
  'とおりな',
  'とおりま',
  'どがいし',
  'とかいは',
  'どかぐい',
  'とかげざ',
  'どがつく',
  'とがった',
  'どかっと',
  'どかどか',
  'とがにん',
  'とかまく',
  'とがめる',
  'どかゆき',
  'とがらす',
  'とぎあげ',
  'とぎいし',
  'ときいろ',
  'ときおり',
  'とぎかい',
  'ときかた',
  'ときがね',
  'ときぐし',
  'ときざけ',
  'とぎしる',
  'とぎじる',
  'とぎせん',
  'ときそう',
  'とぎたて',
  'ときたま',
  'ときたら',
  'どぎつい',
  'どきつく',
  'どきっと',
  'ときどき',
  'どきどき',
  'ときなか',
  'ときには',
  'ときのけ',
  'どきへん',
  'とぎまぎ',
  'どぎまぎ',
  'ときめき',
  'ときめく',
  'ときもの',
  'とぎもの',
  'とぎゅう',
  'どきゅう',
  'どきゅそ',
  'どきゅん',
  'ときょう',
  'どきょう',
  'ときより',
  'とぎらす',
  'とぎれる',
  'ときわぎ',
  'ときわず',
  'ときわづ',
  'ときんば',
  'とくいく',
  'とくいげ',
  'とくいち',
  'とくいば',
  'とくいび',
  'どくいり',
  'どくえい',
  'どくえき',
  'どくえん',
  'どくおう',
  'とくおち',
  'どくおや',
  'どくがい',
  'とくがく',
  'どくがく',
  'どくがす',
  'とくがん',
  'どくがん',
  'どくぎょ',
  'どくきん',
  'どくぎん',
  'どくぐも',
  'どくけし',
  'どくげん',
  'どくこく',
  'とくざい',
  'どくさい',
  'とくさく',
  'とくさつ',
  'どくさつ',
  'とくさん',
  'どくさん',
  'とくしか',
  'とくしつ',
  'とくじつ',
  'どくしつ',
  'とくしま',
  'とくしゃ',
  'どくしゃ',
  'どくじゃ',
  'とくしゅ',
  'とくじゅ',
  'どくしゅ',
  'どくじゅ',
  'とくしょ',
  'どくしょ',
  'どくじょ',
  'とくしん',
  'どくしん',
  'どくじん',
  'とくすき',
  'とくする',
  'どくする',
  'とくせい',
  'どくせい',
  'とくせき',
  'とくせつ',
  'どくぜつ',
  'どくぜり',
  'とくせん',
  'どくせん',
  'どくぜん',
  'とくそう',
  'どくそう',
  'とくそく',
  'とくそん',
  'どくそん',
  'どくたー',
  'とくたい',
  'とくだい',
  'とくたく',
  'どくたけ',
  'とくだね',
  'とくだま',
  'どくだみ',
  'とくだん',
  'どくたん',
  'どくだん',
  'どくづく',
  'とくてい',
  'とくてん',
  'とくでん',
  'とくとう',
  'とくどう',
  'とくとく',
  'どくとく',
  'どくどく',
  'どくとる',
  'とくにん',
  'とくのう',
  'とくはい',
  'とくばい',
  'どくはい',
  'どくはく',
  'とくはつ',
  'どくはら',
  'どくばり',
  'とくばん',
  'とくひつ',
  'どくひつ',
  'とくびれ',
  'どくふつ',
  'どくぶつ',
  'とくぶん',
  'どくぶん',
  'とくべつ',
  'どくへび',
  'とくほう',
  'とくぼう',
  'どくほう',
  'どくぼう',
  'とくほん',
  'どくほん',
  'どくむぎ',
  'どくむし',
  'とくめい',
  'とくめん',
  'どくもう',
  'とくもく',
  'とくもり',
  'とくやく',
  'どくやく',
  'とくゆう',
  'とくよう',
  'どくよけ',
  'とくりつ',
  'どくりつ',
  'とぐるま',
  'とくれい',
  'とくろん',
  'とくわり',
  'とけあい',
  'とけあう',
  'とけいざ',
  'とけいし',
  'とげいも',
  'とけいや',
  'とげうお',
  'とけこみ',
  'とけこむ',
  'とけだす',
  'とげとげ',
  'とけない',
  'とげぬき',
  'とけんか',
  'どけんや',
  'とこあげ',
  'とこいた',
  'どこいら',
  'とこいり',
  'とこうし',
  'とこしえ',
  'とこしき',
  'とこずれ',
  'どこそこ',
  'どこでも',
  'とことこ',
  'どこどこ',
  'とことん',
  'とこなつ',
  'どこにも',
  'とこのま',
  'とこばな',
  'とこはる',
  'とこぶし',
  'どこへも',
  'どこまで',
  'とこみせ',
  'とこやま',
  'とこやみ',
  'どこやら',
  'ところが',
  'どころか',
  'ところで',
  'ところへ',
  'ところを',
  'とこわき',
  'とさいぬ',
  'どさくさ',
  'とさけん',
  'どさっと',
  'どさどさ',
  'とさべん',
  'とされる',
  'とざんか',
  'どさんこ',
  'としあけ',
  'とじいと',
  'としうえ',
  'どしうち',
  'としうら',
  'としおい',
  'としがい',
  'としかさ',
  'としがす',
  'としがた',
  'としがみ',
  'としくう',
  'としけん',
  'としこし',
  'としごと',
  'とじこみ',
  'とじこむ',
  'としごろ',
  'としした',
  'とじしろ',
  'としだま',
  'としたら',
  'としちゃ',
  'としつき',
  'どじっこ',
  'としづよ',
  'としては',
  'としても',
  'としどし',
  'どしどし',
  'としとり',
  'としとる',
  'としなか',
  'としなみ',
  'としのさ',
  'としのせ',
  'とじばり',
  'とじぶた',
  'とじほん',
  'とじまり',
  'としめい',
  'としゅつ',
  'としょう',
  'とじょう',
  'どじょう',
  'としょく',
  'としょひ',
  'としより',
  'としよる',
  'としよわ',
  'としわか',
  'とじんし',
  'としんぶ',
  'どすきん',
  'どすけべ',
  'どすこい',
  'どすっと',
  'どすぶい',
  'とすると',
  'とすれば',
  'とせんば',
  'どそくで',
  'とそさん',
  'とだえる',
  'とだぞく',
  'どたどた',
  'どたばた',
  'どたぶか',
  'どたりと',
  'とたんに',
  'どたんば',
  'とちいた',
  'とちがら',
  'とちかん',
  'どちざめ',
  'とちとち',
  'とちのき',
  'とちのみ',
  'とちぶき',
  'どちみち',
  'とちめん',
  'とちもち',
  'どちゃく',
  'とちゅう',
  'どちゅう',
  'とちょう',
  'どちょう',
  'どちらか',
  'どちらへ',
  'どちらも',
  'とちわか',
  'とつえん',
  'とつおう',
  'とっかい',
  'どっかい',
  'とっかく',
  'とつがく',
  'とつがた',
  'どっかつ',
  'どっかと',
  'どっかり',
  'とっかん',
  'とっきょ',
  'どっきょ',
  'どっきり',
  'とっきん',
  'どっきん',
  'とっくに',
  'とつくに',
  'とっくむ',
  'とっくり',
  'とっぐる',
  'とっくん',
  'どっくん',
  'とっけい',
  'とつけい',
  'とっけー',
  'とつげき',
  'とっけつ',
  'とっけん',
  'どっこい',
  'とっこう',
  'とつごう',
  'どっこう',
  'とっこつ',
  'とっさき',
  'とっさに',
  'どっさり',
  'とつじょ',
  'どっしり',
  'とっしん',
  'とつぜん',
  'どったー',
  'とったつ',
  'とったり',
  'とったん',
  'どっちか',
  'どっちも',
  'とっちる',
  'とっつき',
  'とっつく',
  'とってい',
  'とっても',
  'どっとえ',
  'とっとき',
  'とつとつ',
  'とっとと',
  'とっとり',
  'とっぱー',
  'とっぱつ',
  'とっぱな',
  'とっぱん',
  'どっぴゅ',
  'とっぷう',
  'とっぷく',
  'とっぷす',
  'とっぷつ',
  'とっぷや',
  'とっぷり',
  'どっぷり',
  'とっふる',
  'とつべん',
  'とっぽい',
  'とつほう',
  'どっぽう',
  'とっぽき',
  'とっぽぎ',
  'とつまち',
  'とつめん',
  'とでぃー',
  'どでかい',
  'どてなべ',
  'どてみち',
  'どてやき',
  'どどいつ',
  'どどーん',
  'とどけで',
  'とどける',
  'ととのう',
  'ととのえ',
  'とどまつ',
  'とどまる',
  'とどめる',
  'とともに',
  'とどらー',
  'どとりば',
  'とどろき',
  'とどろく',
  'どどんぱ',
  'となえる',
  'となかい',
  'どなたか',
  'となると',
  'となれば',
  'とにかく',
  'とにっく',
  'とにつく',
  'とにゅう',
  'とねりこ',
  'とのかた',
  'とのがた',
  'とのこと',
  'とのさま',
  'とのたち',
  'とのちゃ',
  'とのばら',
  'どのへん',
  'どのみち',
  'とのもり',
  'どのよう',
  'とぱーず',
  'とはいえ',
  'とばくし',
  'とばくち',
  'とばしや',
  'とばしり',
  'とばしる',
  'どはずれ',
  'とばちり',
  'どばどば',
  'どはまり',
  'とびいし',
  'とびいた',
  'とびいり',
  'とびいる',
  'とびいろ',
  'とびうお',
  'とびえい',
  'とびおり',
  'とびかう',
  'とぴかる',
  'とびきり',
  'とびぐち',
  'とびくら',
  'とびけら',
  'とびげり',
  'とびこう',
  'とびこし',
  'とびこす',
  'とびこみ',
  'とびこむ',
  'とびさる',
  'とびすぎ',
  'とぴずれ',
  'とびだし',
  'とびだす',
  'とびたつ',
  'とびちる',
  'とびつく',
  'とぴっく',
  'とびっこ',
  'とびでる',
  'とびとび',
  'とひとま',
  'とぴぬし',
  'とびのく',
  'とびのる',
  'とびばこ',
  'とびはじ',
  'とびはぜ',
  'とびむし',
  'どひょう',
  'とびらえ',
  'とびりし',
  'とふぃー',
  'どぶいた',
  'どぶがい',
  'どぶがわ',
  'とふぎょ',
  'とぶくろ',
  'とふけん',
  'とふざい',
  'どぶづけ',
  'とぶとり',
  'どぶどろ',
  'どぶみず',
  'とぶらい',
  'とぶらう',
  'どぶろく',
  'とぼがん',
  'とぼける',
  'とほざく',
  'とぼしい',
  'とぼしき',
  'どぼづけ',
  'とぼとぼ',
  'どぼどぼ',
  'とほほほ',
  'とぽろじ',
  'とまちん',
  'とまどい',
  'とまどう',
  'とまりぎ',
  'とみくじ',
  'とみずむ',
  'どみたす',
  'どみにか',
  'とみふだ',
  'どみんご',
  'とむとむ',
  'とむやむ',
  'とむらい',
  'とむらう',
  'どめいん',
  'とめおき',
  'とめおく',
  'とめおけ',
  'とめがね',
  'とめくぎ',
  'とめそで',
  'とめだて',
  'とめつぎ',
  'とめばり',
  'どめぶら',
  'とめぶろ',
  'とめへん',
  'とめやく',
  'とめやま',
  'とめわん',
  'ともあれ',
  'ともいう',
  'ともいろ',
  'ともうち',
  'ともうら',
  'ともえが',
  'ともえり',
  'ともがき',
  'ともかく',
  'ともがみ',
  'ともがら',
  'ともぎれ',
  'ともぐい',
  'ともしい',
  'ともしび',
  'ともぜい',
  'ともせん',
  'ともだい',
  'ともだち',
  'ともづな',
  'ともづり',
  'ともづれ',
  'ともども',
  'ともない',
  'ともなう',
  'ともなく',
  'ともなり',
  'ともぬの',
  'ともばら',
  'ともびき',
  'ともびと',
  'ともぶね',
  'ともぼし',
  'ともまち',
  'ともらい',
  'ともろく',
  'どやがい',
  'どやがお',
  'とやかく',
  'どやどや',
  'どようび',
  'とよくに',
  'どよめき',
  'どよめく',
  'どらぁぐ',
  'どらーど',
  'どらいば',
  'とらいぷ',
  'どらいぶ',
  'とらうま',
  'とらえび',
  'とらえる',
  'とらがら',
  'とらがり',
  'とらかん',
  'とらぎす',
  'とらくた',
  'とらくと',
  'どらくま',
  'どらくめ',
  'とらぐら',
  'どらごえ',
  'どらこん',
  'どらごん',
  'とらざめ',
  'どらじぇ',
  'とらすと',
  'どらせな',
  'とらっく',
  'どらっく',
  'どらっぐ',
  'とらっど',
  'とらっぷ',
  'どらてく',
  'とらどし',
  'とらねこ',
  'どらねこ',
  'とらのお',
  'とらのこ',
  'とらのひ',
  'どらぱい',
  'とらばこ',
  'とらぱん',
  'とらひげ',
  'とらふぐ',
  'どらふと',
  'とらぶる',
  'とらべる',
  'とらぺん',
  'とらぽん',
  'どらまー',
  'どらまか',
  'とらまめ',
  'どらやき',
  'どられこ',
  'とらわれ',
  'とらんく',
  'とらんす',
  'とらんぷ',
  'とりあい',
  'とりあう',
  'とりあげ',
  'とりあみ',
  'どりあん',
  'どりーね',
  'どりーむ',
  'とりいる',
  'とりいれ',
  'とりうち',
  'とりうむ',
  'とりえい',
  'とりおい',
  'とりおき',
  'とりおく',
  'とりがー',
  'とりかい',
  'とりがい',
  'とりかえ',
  'とりかげ',
  'とりかご',
  'とりかじ',
  'とりかた',
  'とりかつ',
  'とりがら',
  'とりかわ',
  'とりきめ',
  'とりきる',
  'とりくち',
  'とりくみ',
  'とりくむ',
  'とりくる',
  'とりくろ',
  'とりけし',
  'とりけす',
  'とりこみ',
  'とりこむ',
  'とりごや',
  'とりさげ',
  'とりさし',
  'とりざた',
  'とりざら',
  'とりさる',
  'どりしゃ',
  'とりしろ',
  'とりすぎ',
  'とりせつ',
  'とりだす',
  'とりたて',
  'とりだめ',
  'とりつぎ',
  'とりっく',
  'とりつく',
  'とりつぐ',
  'とりつけ',
  'とりっぱ',
  'とりっぷ',
  'どりっぷ',
  'とりてき',
  'とりてつ',
  'とりてん',
  'とりどく',
  'とりどし',
  'とりとま',
  'とりとめ',
  'とりとり',
  'とりどり',
  'とりとん',
  'とりなし',
  'とりなす',
  'とりなべ',
  'とりなわ',
  'とりにく',
  'とりのこ',
  'とりのひ',
  'とりばし',
  'とりはだ',
  'とりはむ',
  'とりびあ',
  'とりびー',
  'とりひき',
  'とりふだ',
  'どりふと',
  'とりふる',
  'とりぷる',
  'どりぶる',
  'とりぶん',
  'どりぶん',
  'とりへん',
  'とりぽり',
  'とりまー',
  'とりまい',
  'とりまえ',
  'とりまき',
  'とりまく',
  'とりめえ',
  'とりめし',
  'とりもち',
  'とりもつ',
  'とりもの',
  'とりやめ',
  'とりゅう',
  'どりゅう',
  'とりゅふ',
  'とりょう',
  'どりょう',
  'どりょく',
  'とりよせ',
  'とりれん',
  'とりわく',
  'とりわけ',
  'とりわさ',
  'どりんく',
  'どるいど',
  'とるえん',
  'どるおた',
  'どるかい',
  'とるこご',
  'とるこん',
  'どるさつ',
  'とるそー',
  'どるだか',
  'どるだて',
  'どるちぇ',
  'どるばこ',
  'どるまん',
  'どるめん',
  'どるやす',
  'どるらる',
  'どるをた',
  'とれいら',
  'とれいる',
  'とれいん',
  'どれいん',
  'とれーす',
  'とれーど',
  'どれーぷ',
  'とれーら',
  'とれーる',
  'とれーん',
  'どれーん',
  'とれすぎ',
  'とれせん',
  'とれだか',
  'どれだけ',
  'とれたて',
  'どれっじ',
  'とれっど',
  'どれでも',
  'どれどれ',
  'とれにあ',
  'どれにも',
  'とれぱん',
  'とれびあ',
  'とれびす',
  'とれぶる',
  'どれほど',
  'とれもろ',
  'とれらん',
  'とれんか',
  'とれんち',
  'とれんと',
  'とれんど',
  'どろあー',
  'どろあし',
  'とろいか',
  'とろいで',
  'どろうみ',
  'とろーち',
  'とろーる',
  'どろーん',
  'とろがお',
  'とろかす',
  'どろがめ',
  'どろぐつ',
  'どろけい',
  'どろけー',
  'とろける',
  'どろすと',
  'とろっこ',
  'とろっと',
  'どろっと',
  'どろっぷ',
  'とろとろ',
  'どろどろ',
  'どろなわ',
  'どろぬま',
  'どろのき',
  'とろばこ',
  'どろばち',
  'どろはね',
  'どろぶね',
  'どろぼう',
  'どろぼー',
  'どろみず',
  'どろみち',
  'どろよけ',
  'とろりー',
  'どろれす',
  'どろわー',
  'どろんこ',
  'とろんと',
  'どわーふ',
  'どわすれ',
  'どをこす',
  'とんあい',
  'どんあい',
  'とんえい',
  'どんかく',
  'とんがご',
  'とんかち',
  'とんかつ',
  'どんがめ',
  'とんがり',
  'とんがる',
  'どんかん',
  'どんきー',
  'とんきろ',
  'とんきん',
  'どんぐり',
  'どんぐる',
  'どんけつ',
  'とんけん',
  'とんこう',
  'どんこう',
  'とんこつ',
  'とんこり',
  'どんこん',
  'とんさい',
  'どんさい',
  'とんざん',
  'どんさん',
  'とんじき',
  'どんじき',
  'とんしゃ',
  'とんしゅ',
  'とんじゅ',
  'とんしょ',
  'どんじょ',
  'どんじり',
  'とんじる',
  'とんすう',
  'とんずら',
  'とんする',
  'とんせい',
  'とんぜい',
  'とんそう',
  'とんそく',
  'どんそく',
  'どんぞこ',
  'どんたく',
  'どんだけ',
  'とんちき',
  'とんちゃ',
  'とんつー',
  'どんつう',
  'どんつく',
  'とんてき',
  'とんでも',
  'とんでる',
  'とんでん',
  'どんてん',
  'どんとう',
  'とんとろ',
  'とんとん',
  'とんどん',
  'どんどん',
  'とんない',
  'どんなに',
  'どんなん',
  'とんにく',
  'とんねる',
  'どんぱち',
  'どんびき',
  'とんふあ',
  'とんぷく',
  'どんぶつ',
  'とんぶり',
  'どんぶり',
  'とんふん',
  'とんぷん',
  'とんぼう',
  'とんぽう',
  'とんぼく',
  'とんぼろ',
  'どんまい',
  'どんもの',
  'とんよう',
  'どんよう',
  'とんよく',
  'どんよく',
  'どんより',
  'どんらん',
  'どんれい',
  'なあなあ',
  'なーばす',
  'なーびー',
  'なあんだ',
  'なーんだ',
  'ないあす',
  'ないあつ',
  'ないあど',
  'ないーゔ',
  'ないーぶ',
  'ないいん',
  'ないえつ',
  'ないえん',
  'ないおう',
  'ないおん',
  'ないかい',
  'ないがい',
  'ないかく',
  'ないかひ',
  'ないかん',
  'ないがん',
  'ないきん',
  'ないくう',
  'ないぐう',
  'ないぐぶ',
  'ないくん',
  'ないけい',
  'ないけん',
  'ないこう',
  'ないごう',
  'ないこく',
  'ないこん',
  'ないさい',
  'ないざい',
  'ないしつ',
  'ないじつ',
  'ないじゅ',
  'ないしょ',
  'ないじょ',
  'ないしん',
  'ないじん',
  'ないすい',
  'ないすん',
  'ないせい',
  'ないせき',
  'ないせつ',
  'ないせん',
  'ないそう',
  'ないぞう',
  'ないそく',
  'ないぞく',
  'ないそん',
  'ないたー',
  'ないたい',
  'ないだく',
  'ないたつ',
  'ないたん',
  'ないだん',
  'ないちち',
  'ないつう',
  'ないてい',
  'ないてき',
  'ないてん',
  'ないでん',
  'ないどう',
  'ないない',
  'ないにく',
  'ないねん',
  'ないはつ',
  'ないふく',
  'ないふん',
  'ないぶん',
  'ないへき',
  'ないへん',
  'ないほう',
  'ないほく',
  'ないまく',
  'ないまぜ',
  'ないみつ',
  'ないめい',
  'ないめん',
  'ないもう',
  'ないやく',
  'ないゆう',
  'ないよう',
  'ないらん',
  'ないりく',
  'ないりん',
  'ないろび',
  'ないろん',
  'ないわん',
  'ないんす',
  'なえおち',
  'なえしろ',
  'なえどこ',
  'なおいい',
  'なおがき',
  'なおかつ',
  'なおさら',
  'なおざり',
  'なおなお',
  'なおびと',
  'なおまた',
  'なおもて',
  'なおよい',
  'なかあき',
  'ながあみ',
  'ながあめ',
  'なかいい',
  'なかいき',
  'ながいき',
  'なかいし',
  'ながいす',
  'ながいた',
  'なかいま',
  'ながいめ',
  'ながいも',
  'なかいり',
  'ながうじ',
  'ながうた',
  'なかうど',
  'なかうり',
  'ながおい',
  'なかおく',
  'なかおし',
  'ながおし',
  'なかおち',
  'なかおり',
  'なかおれ',
  'なかがい',
  'なかがき',
  'なががさ',
  'なかがみ',
  'なかぎり',
  'なかぐち',
  'ながぐつ',
  'なかぐり',
  'なかぐろ',
  'なかごろ',
  'ながさき',
  'なかしお',
  'なかじき',
  'なかしな',
  'ながしば',
  'なかじま',
  'なかじめ',
  'ながしめ',
  'ながじり',
  'なかずみ',
  'なかずり',
  'なかせき',
  'なかせる',
  'なかせん',
  'なかぞこ',
  'ながそで',
  'なかぞら',
  'なかぞり',
  'なかだか',
  'なかだし',
  'なかだち',
  'ながだち',
  'なかたび',
  'ながたび',
  'なかつぎ',
  'ながつき',
  'ながづき',
  'なかづみ',
  'なかづり',
  'なかでも',
  'なかてん',
  'なかとじ',
  'なかなか',
  'ながなが',
  'ながなき',
  'ながなく',
  'ながなす',
  'なかなめ',
  'ながにざ',
  'ながにし',
  'なかには',
  'なかにも',
  'なかにわ',
  'なかぬき',
  'なかぬけ',
  'なかぬり',
  'ながねぎ',
  'ながねん',
  'ながのし',
  'なかびく',
  'ながびく',
  'なかひと',
  'なかびと',
  'なかぶた',
  'なかぶと',
  'ながぶろ',
  'ながぼえ',
  'なかぼそ',
  'なかぽつ',
  'なかほど',
  'なかぼね',
  'ながまき',
  'なかまく',
  'なかみせ',
  'なかみち',
  'ながみち',
  'ながむし',
  'ながめる',
  'ながもち',
  'ながもの',
  'なかやど',
  'ながやり',
  'なかゆび',
  'なかよい',
  'なかよく',
  'なかよし',
  'ながらく',
  'ながらに',
  'ながらも',
  'ながれず',
  'ながれや',
  'ながれる',
  'なかろう',
  'なかわた',
  'なかわり',
  'なきあと',
  'なきいる',
  'なきおや',
  'なきがお',
  'なきがら',
  'なきごえ',
  'なきごと',
  'なきすな',
  'なきだす',
  'なきたま',
  'なきちち',
  'なきつく',
  'なきつら',
  'なきどり',
  'なぎなた',
  'なきはは',
  'なきひと',
  'なきふす',
  'なきべそ',
  'なきまね',
  'なきみそ',
  'なきむし',
  'なきもの',
  'なきやむ',
  'なぎょう',
  'なぐさみ',
  'なぐさむ',
  'なぐさめ',
  'なくして',
  'なくちゃ',
  'なくては',
  'なくても',
  'なくなく',
  'なくなす',
  'なくなる',
  'なげあい',
  'なげあう',
  'なげあみ',
  'なげいれ',
  'なげうつ',
  'なげうり',
  'なげきす',
  'なげくび',
  'なげこみ',
  'なげこむ',
  'なげぜに',
  'なげせん',
  'なげだす',
  'なげっと',
  'なけなし',
  'なげなわ',
  'なげぶみ',
  'なげもの',
  'なげやり',
  'なけりゃ',
  'なければ',
  'なげわざ',
  'なこうど',
  'なことば',
  'なごめる',
  'なごやか',
  'なさそう',
  'なされる',
  'なしうる',
  'なしえる',
  'なししゅ',
  'なしには',
  'なしのみ',
  'なしふぐ',
  'なすかく',
  'なすこん',
  'なすすべ',
  'なすぞく',
  'なすった',
  'なすって',
  'なすべき',
  'なぜだか',
  'なぜなら',
  'なぞかけ',
  'なぞぞめ',
  'なぞとき',
  'なぞなぞ',
  'なぞめく',
  'なだかい',
  'なたがま',
  'なだたる',
  'なたねな',
  'なたねゆ',
  'なたまめ',
  'なだめる',
  'なだらか',
  'なだれる',
  'なちずむ',
  'なちとう',
  'なちょす',
  'なつあし',
  'なついん',
  'なつーら',
  'なつがけ',
  'なつかし',
  'なつかぜ',
  'なつがれ',
  'なつかん',
  'なつぎく',
  'なつぎり',
  'なつくさ',
  'なつぐさ',
  'なつぐみ',
  'なつぐも',
  'なっくる',
  'なつける',
  'なづける',
  'なつこい',
  'なつごし',
  'なつさく',
  'なつしお',
  'なつじお',
  'なっしゅ',
  'なっしょ',
  'なつぜみ',
  'なっせん',
  'なっそー',
  'なつぞら',
  'なっちょ',
  'なっとう',
  'なつどき',
  'なっとく',
  'なつどり',
  'なつなか',
  'なつはぎ',
  'なつはぜ',
  'なつばて',
  'なつばね',
  'なつひめ',
  'なつふく',
  'なつふじ',
  'なつまけ',
  'なつむき',
  'なつむし',
  'なつめく',
  'なつめぐ',
  'なつめろ',
  'なつもの',
  'なつやせ',
  'なつやま',
  'なでがた',
  'なでぎり',
  'なでしこ',
  'なでつけ',
  'なでなで',
  'などころ',
  'などなど',
  'なないろ',
  'なながつ',
  'ななくさ',
  'ななくせ',
  'ななせん',
  'ななそじ',
  'ななたび',
  'ななつや',
  'ななばけ',
  'ななはん',
  'ななふし',
  'ななほん',
  'ななめに',
  'なにいろ',
  'なにおう',
  'なにがし',
  'なにがた',
  'なにかと',
  'なにがな',
  'なにくそ',
  'なにくれ',
  'なにげに',
  'なにごと',
  'なにこれ',
  'なにさま',
  'なにざま',
  'なにしろ',
  'なにじん',
  'なにそつ',
  'なにそれ',
  'なにとぞ',
  'なになに',
  'なににも',
  'なにびと',
  'なにぶん',
  'なにぼう',
  'なにほど',
  'なにもの',
  'なにやら',
  'なにゆえ',
  'なによう',
  'なにより',
  'なのくに',
  'なのてく',
  'なのです',
  'なのはな',
  'なのりざ',
  'なのりそ',
  'なぱーむ',
  'なばかり',
  'なばほー',
  'なばほご',
  'なばらん',
  'なびかす',
  'なびろめ',
  'なふきん',
  'なぷきん',
  'なふてん',
  'なふとる',
  'なべかま',
  'なべこう',
  'なべしき',
  'なべじり',
  'なべずみ',
  'なべぞこ',
  'なべづる',
  'なべぶた',
  'なべもの',
  'なべやき',
  'なまあげ',
  'なまあし',
  'なまあせ',
  'なまいき',
  'なまうお',
  'なまがい',
  'なまがし',
  'なまかべ',
  'なまかわ',
  'なまぎき',
  'なまきず',
  'なまぐさ',
  'なまくび',
  'なまくら',
  'なまける',
  'なまごみ',
  'なまごむ',
  'なまごめ',
  'なまこん',
  'なまざけ',
  'なまじい',
  'なまずえ',
  'なまずか',
  'なまぜん',
  'なまそば',
  'なまつば',
  'なまづめ',
  'なまなか',
  'なまなり',
  'なまなれ',
  'なまにえ',
  'なまにく',
  'なまはげ',
  'なまはむ',
  'なまぶし',
  'なまぼし',
  'なまほり',
  'なままめ',
  'なまみず',
  'なまめく',
  'なまめん',
  'なまもの',
  'なまやけ',
  'なまゆで',
  'なまよい',
  'なまろく',
  'なまわく',
  'なみあい',
  'なみあし',
  'なみいた',
  'なみいる',
  'なみうつ',
  'なみおと',
  'なみがい',
  'なみかぜ',
  'なみがた',
  'なみきじ',
  'なみする',
  'なみせい',
  'なみせん',
  'なみだつ',
  'なみだめ',
  'なみなみ',
  'なみにく',
  'なみのり',
  'なみはば',
  'なみびあ',
  'なみひん',
  'なみまに',
  'なみもり',
  'なみよけ',
  'なむたち',
  'なむだち',
  'なめくじ',
  'なめずる',
  'なめたけ',
  'なめとる',
  'なめなめ',
  'なめみそ',
  'なめらか',
  'なもない',
  'なもなき',
  'なやます',
  'なやめる',
  'なゆたけ',
  'なよたけ',
  'なよなよ',
  'なよやか',
  'ならけん',
  'ならして',
  'ならたけ',
  'ならづけ',
  'ならでは',
  'ならない',
  'ならびに',
  'ならべる',
  'ならわし',
  'ならわす',
  'ならんで',
  'なりーぐ',
  'なりかく',
  'なりきる',
  'なりきん',
  'なりぎん',
  'なりくせ',
  'なりけい',
  'なりけり',
  'なりこま',
  'なりごま',
  'なりこむ',
  'なりすな',
  'なりたけ',
  'なりだす',
  'なりたち',
  'なりたつ',
  'なりどし',
  'なりとも',
  'なりふり',
  'なりもの',
  'なりゆき',
  'なりわい',
  'なりわけ',
  'なるがた',
  'なるかみ',
  'なるぎれ',
  'なるしー',
  'なるしす',
  'なるたけ',
  'なるだけ',
  'なるはや',
  'なるべく',
  'なるへそ',
  'なるほど',
  'なるほろ',
  'なるらー',
  'なれあい',
  'なれあう',
  'なれずし',
  'なれそめ',
  'なれっこ',
  'なれっじ',
  'なれども',
  'なわあみ',
  'なわじり',
  'なわしろ',
  'なわぞく',
  'なわつき',
  'なわとび',
  'なわぬけ',
  'なわばり',
  'なわみず',
  'なわもじ',
  'なをうる',
  'なをとる',
  'なをなす',
  'なんいど',
  'なんおう',
  'なんおん',
  'なんかい',
  'なんがつ',
  'なんかん',
  'なんがん',
  'なんきつ',
  'なんきも',
  'なんきん',
  'なんぐう',
  'なんくせ',
  'なんくろ',
  'なんくん',
  'なんぐん',
  'なんけん',
  'なんげん',
  'なんこう',
  'なんごく',
  'なんこつ',
  'なんざあ',
  'なんさい',
  'なんざん',
  'なんしき',
  'なんしつ',
  'なんじゃ',
  'なんしょ',
  'なんじる',
  'なんしん',
  'なんすい',
  'なんずる',
  'なんせい',
  'なんせん',
  'なんぜん',
  'なんそう',
  'なんそく',
  'なんだい',
  'なんだか',
  'なんだと',
  'なんたる',
  'なんたん',
  'なんちゃ',
  'なんてい',
  'なんでい',
  'なんてき',
  'なんです',
  'なんてつ',
  'なんてね',
  'なんでも',
  'なんでよ',
  'なんてん',
  'なんとう',
  'なんとか',
  'なんどか',
  'なんどき',
  'なんどく',
  'なんとも',
  'なんども',
  'なんなく',
  'なんなら',
  'なんなり',
  'なんなん',
  'なんにち',
  'なんにも',
  'なんにょ',
  'なんにん',
  'なんねい',
  'なんねん',
  'なんばー',
  'なんぱく',
  'なんぱし',
  'なんはん',
  'なんばん',
  'なんぱん',
  'なんびと',
  'なんぴと',
  'なんぴん',
  'なんぷう',
  'なんふつ',
  'なんぶつ',
  'なんぷれ',
  'なんぶん',
  'なんぷん',
  'なんべい',
  'なんべん',
  'なんぼう',
  'なんぽう',
  'なんぼく',
  'なんまく',
  'なんまん',
  'なんみん',
  'なんめい',
  'なんめん',
  'なんもう',
  'なんもん',
  'なんやく',
  'なんよう',
  'なんより',
  'なんらか',
  'なんりょ',
  'なんろう',
  'なんろん',
  'なんわり',
  'にあがる',
  'にあげば',
  'にあたり',
  'にあって',
  'にあぴん',
  'にあみす',
  'にいがた',
  'にいさま',
  'にいさん',
  'にいづま',
  'にーどる',
  'にいなえ',
  'にいなめ',
  'にいにい',
  'にーにー',
  'にーはい',
  'にーはお',
  'にいはだ',
  'にーぱん',
  'にいぼん',
  'にいよめ',
  'にうごき',
  'にうりや',
  'にえたつ',
  'において',
  'におくり',
  'における',
  'におどり',
  'におもい',
  'におやか',
  'におろし',
  'におわす',
  'にかーぶ',
  'にかいは',
  'にかいや',
  'にがうり',
  'にかえす',
  'にがおえ',
  'にがかつ',
  'にかけて',
  'にがさみ',
  'にがしお',
  'にかしょ',
  'にがたけ',
  'にかっと',
  'にかねん',
  'にがむし',
  'にかよう',
  'にがわせ',
  'にかわり',
  'にかんし',
  'にぎあう',
  'にきさく',
  'にきせい',
  'にぎてき',
  'にきもの',
  'にぎやか',
  'にきゅう',
  'にきょう',
  'にぎょう',
  'にぎらす',
  'にぎりて',
  'にぎりべ',
  'にぎりぺ',
  'にぎりや',
  'にぎわい',
  'にぎわう',
  'にぎわす',
  'にくあい',
  'にくあつ',
  'にくいれ',
  'にくいろ',
  'にくうす',
  'にくえん',
  'にくかい',
  'にくかん',
  'にくがん',
  'にくきり',
  'にくけい',
  'にくげん',
  'にくざお',
  'にくさし',
  'にくじき',
  'にくしつ',
  'にくしみ',
  'にくしゅ',
  'にくじる',
  'にくしん',
  'にくすい',
  'にくずく',
  'にくずれ',
  'にくせい',
  'にくぜん',
  'にくたい',
  'にくだれ',
  'にくだん',
  'にくづき',
  'にくづく',
  'にくづけ',
  'にくつぼ',
  'にくてき',
  'にくなべ',
  'にくばえ',
  'にくはく',
  'にくひだ',
  'にくひつ',
  'にくぶと',
  'にくふん',
  'にくへん',
  'にくぼう',
  'にくぼそ',
  'にくまん',
  'にくみそ',
  'にくよく',
  'にくらべ',
  'にぐりと',
  'にぐりろ',
  'にくるい',
  'にぐるま',
  'にくろむ',
  'にくわえ',
  'にくわれ',
  'にげあし',
  'にげうま',
  'にげきる',
  'にげぐち',
  'にげごし',
  'にげこむ',
  'にげさる',
  'にげだす',
  'にげちる',
  'にげとく',
  'にげない',
  'にげぼえ',
  'にげみず',
  'にげみぞ',
  'にげみち',
  'にげんし',
  'にこいち',
  'にこごり',
  'にこしあ',
  'にこだて',
  'にこちん',
  'にこっと',
  'にこにこ',
  'にこぽん',
  'にこもの',
  'にごもの',
  'にこやか',
  'にこよん',
  'にごりえ',
  'にざかな',
  'にざだい',
  'にざだひ',
  'にさばき',
  'にじいろ',
  'にじかい',
  'にしかぜ',
  'にしがた',
  'にしがわ',
  'にしきえ',
  'にしきぎ',
  'にしきた',
  'にしぐち',
  'にじげん',
  'にじこん',
  'にじたい',
  'にじてき',
  'にしては',
  'にしても',
  'にじはぎ',
  'にじます',
  'にしむき',
  'にしめる',
  'にしやま',
  'にじゅう',
  'にじょう',
  'にしょく',
  'にしより',
  'にじりん',
  'にじるし',
  'にしんぎ',
  'にすがた',
  'にせあか',
  'にせいん',
  'にせがね',
  'にせくび',
  'にせさつ',
  'にせぱい',
  'にせふだ',
  'にせもの',
  'にせもん',
  'にそって',
  'にたぁー',
  'にたいし',
  'にだいめ',
  'にたつく',
  'にたっと',
  'にたてる',
  'にたにた',
  'にたまご',
  'にたもの',
  'にだゆう',
  'にだんめ',
  'にちいん',
  'にちうん',
  'にちえい',
  'にちえつ',
  'にちおう',
  'にちがい',
  'にちがく',
  'にちぎん',
  'にちげつ',
  'にちげん',
  'にちごう',
  'にちだく',
  'にちどく',
  'にちにち',
  'にちはく',
  'にちふつ',
  'にちぶん',
  'にちべい',
  'にちへん',
  'にちぼく',
  'にちぼつ',
  'にちゃく',
  'にちょう',
  'にちよう',
  'にちょく',
  'にちりん',
  'にちれい',
  'にちろく',
  'にちわー',
  'について',
  'にっかー',
  'にっかい',
  'にっかど',
  'にっかん',
  'にっきん',
  'にっくき',
  'にづくり',
  'にっけい',
  'につけて',
  'にっける',
  'につける',
  'にっこう',
  'にっこり',
  'にっさん',
  'にっしつ',
  'にっしゃ',
  'にっしん',
  'にっすい',
  'にっすう',
  'にっせい',
  'にっせき',
  'にっせん',
  'にっそう',
  'にったい',
  'にってい',
  'にってん',
  'にっとう',
  'にっぱー',
  'にっぱく',
  'にっぱち',
  'にっぽう',
  'にっぽん',
  'につまる',
  'につめる',
  'につれて',
  'にとかす',
  'にどがり',
  'にどざき',
  'にどずり',
  'にどぞい',
  'にどづけ',
  'にとって',
  'にどてま',
  'にどでま',
  'にとりる',
  'にとろか',
  'にとろき',
  'にないて',
  'になると',
  'にのあし',
  'にのいと',
  'にのうで',
  'にのぜん',
  'にのつぎ',
  'にのべき',
  'にのまい',
  'にのまち',
  'にのまつ',
  'にのまる',
  'にのみや',
  'にはいず',
  'にばしゃ',
  'にばんめ',
  'にびいろ',
  'にびたし',
  'にひゃく',
  'にぶいろ',
  'にぶさく',
  'にぶちん',
  'にぶらす',
  'にぷれす',
  'にぶんぎ',
  'にほどき',
  'にほんか',
  'にほんが',
  'にほんぎ',
  'にほんご',
  'にほんし',
  'にほんじ',
  'にほんま',
  'にまいめ',
  'にまにま',
  'にむけて',
  'にゃあご',
  'にゃーん',
  'にゃあん',
  'にやける',
  'にやつく',
  'にゃにゃ',
  'にやにや',
  'にゃんこ',
  'にゅうか',
  'にゅーく',
  'にゅうこ',
  'にゅうし',
  'にゅうじ',
  'にゅーす',
  'にゅーず',
  'にゅうひ',
  'にゅうび',
  'にゅうふ',
  'にゅうぶ',
  'にゅうぼ',
  'にゅうも',
  'にゅーろ',
  'にゅうわ',
  'にゅっと',
  'にゅるり',
  'にょいん',
  'にょうい',
  'にょうき',
  'にょうご',
  'にょうそ',
  'にょうぼ',
  'にょうろ',
  'にょおう',
  'にょかん',
  'にょけい',
  'にょじつ',
  'にょしょ',
  'にょぞく',
  'にょたい',
  'にょたく',
  'にょっき',
  'によって',
  'にょっと',
  'にょてい',
  'にょにん',
  'にょほう',
  'にょぼん',
  'にょらい',
  'によらず',
  'によると',
  'によれば',
  'にらねぎ',
  'にりゅう',
  'にるいだ',
  'にるがい',
  'にわいし',
  'にわうえ',
  'にわうめ',
  'にわかに',
  'にわきど',
  'にわぐち',
  'にわげた',
  'にわさき',
  'にわたし',
  'にわたり',
  'にわつき',
  'にわつつ',
  'にわづめ',
  'にわとこ',
  'にわとり',
  'にわない',
  'にわばん',
  'にわふじ',
  'にんあん',
  'にんいん',
  'にんがい',
  'にんかつ',
  'にんかん',
  'にんきど',
  'にんきょ',
  'にんぎょ',
  'にんげつ',
  'にんげん',
  'にんごく',
  'にんしき',
  'にんじゃ',
  'にんじゅ',
  'にんじる',
  'にんしん',
  'にんじん',
  'にんずう',
  'にんずる',
  'にんせい',
  'にんそう',
  'にんそく',
  'にんたい',
  'にんだく',
  'にんちど',
  'にんてい',
  'にんてん',
  'にんでん',
  'にんとう',
  'にんどう',
  'にんとく',
  'にんにく',
  'にんにち',
  'にんにん',
  'にんのう',
  'にんびー',
  'にんぺい',
  'にんべつ',
  'にんべん',
  'にんぽう',
  'にんぽー',
  'にんまえ',
  'にんまり',
  'にんめい',
  'にんめん',
  'にんよう',
  'ぬいあげ',
  'ぬいいと',
  'ぬいかた',
  'ぬいこみ',
  'ぬいこむ',
  'ぬいしろ',
  'ぬいとり',
  'ぬいとる',
  'ぬいはく',
  'ぬいばり',
  'ぬいもの',
  'ぬいもん',
  'ぬーゔぉ',
  'ぬうっと',
  'ぬーどる',
  'ぬーばす',
  'ぬーべる',
  'ぬーぼー',
  'ぬえてき',
  'ぬえどり',
  'ぬかあめ',
  'ぬかがみ',
  'ぬかずき',
  'ぬかずく',
  'ぬがせや',
  'ぬかつく',
  'ぬかづく',
  'ぬかづけ',
  'ぬかどこ',
  'ぬかばえ',
  'ぬかみそ',
  'ぬかるみ',
  'ぬかるむ',
  'ぬきあし',
  'ぬきいた',
  'ぬきいと',
  'ぬきうち',
  'ぬきがき',
  'ぬきがた',
  'ぬきさし',
  'ぬきさる',
  'ぬきしろ',
  'ぬきずり',
  'ぬきぞめ',
  'ぬきだす',
  'ぬきつけ',
  'ぬきでる',
  'ぬきとる',
  'ぬぎぬぎ',
  'ぬきねた',
  'ぬきほん',
  'ぬきよみ',
  'ぬきわざ',
  'ぬくてー',
  'ぬくぬく',
  'ぬくまる',
  'ぬくめる',
  'ぬくもり',
  'ぬくもる',
  'ぬけあな',
  'ぬけうら',
  'ぬけがけ',
  'ぬけがら',
  'ぬけかん',
  'ぬけさく',
  'ぬけだす',
  'ぬけでる',
  'ぬけにん',
  'ぬけぬけ',
  'ぬけみち',
  'ぬけやく',
  'ぬすっと',
  'ぬすびと',
  'ぬすみみ',
  'ぬたうつ',
  'ぬたくる',
  'ぬっぽり',
  'ぬのきれ',
  'ぬのぎれ',
  'ぬのせい',
  'ぬのはば',
  'ぬのばり',
  'ぬのびき',
  'ぬばたま',
  'ぬばっく',
  'ぬまおち',
  'ぬますぎ',
  'ぬまはぎ',
  'ぬまびる',
  'ぬまむつ',
  'ぬまわに',
  'ぬめかわ',
  'ぬめっと',
  'ぬめぬめ',
  'ぬらぬら',
  'ぬりいた',
  'ぬりがさ',
  'ぬりかべ',
  'ぬりげた',
  'ぬりこむ',
  'ぬりごめ',
  'ぬりたて',
  'ぬりばけ',
  'ぬりばし',
  'ぬりばん',
  'ぬりもの',
  'ぬるがた',
  'ぬるげー',
  'ぬるっと',
  'ぬるぬる',
  'ぬるまゆ',
  'ぬるめる',
  'ぬるもじ',
  'ぬれいろ',
  'ぬれえん',
  'ぬれがみ',
  'ぬれぎぬ',
  'ぬれごと',
  'ぬれすけ',
  'ぬれせい',
  'ぬれぬれ',
  'ねあがり',
  'ねあらい',
  'ねあわせ',
  'ねいあく',
  'ねいかん',
  'ねいじつ',
  'ねいしゃ',
  'ねいしん',
  'ねいじん',
  'ねいせい',
  'ねいちぶ',
  'ねいびー',
  'ねいぶる',
  'ねいべん',
  'ねいもう',
  'ねうごき',
  'ねえさん',
  'ねえねえ',
  'ねーねー',
  'ねーびー',
  'ねーぶる',
  'ねおこん',
  'ねおじむ',
  'ねおだだ',
  'ねおなち',
  'ねおろし',
  'ねがいで',
  'ねがえり',
  'ねがえる',
  'ねがかり',
  'ねかせる',
  'ねがちぶ',
  'ねがつく',
  'ねがはる',
  'ねかふぇ',
  'ねぎだく',
  'ねぎとろ',
  'ねぎやき',
  'ねぎらい',
  'ねぎらう',
  'ねくさす',
  'ねくすと',
  'ねくずれ',
  'ねくたー',
  'ねくたい',
  'ねくたる',
  'ねくとん',
  'ねぐりと',
  'ねぐりろ',
  'ねげーと',
  'ねげっと',
  'ねこあし',
  'ねこいた',
  'ねこかん',
  'ねこぎぎ',
  'ねこくさ',
  'ねごこち',
  'ねこざめ',
  'ねこじた',
  'ねこずき',
  'ねこすな',
  'ねこずな',
  'ねこそぎ',
  'ねこぞく',
  'ねこっけ',
  'ねこにく',
  'ねこのみ',
  'ねこのめ',
  'ねこばば',
  'ねこまた',
  'ねこみみ',
  'ねこめし',
  'ねこもく',
  'ねころぶ',
  'ねざかな',
  'ねさがり',
  'ねさがる',
  'ねざめる',
  'ねじきり',
  'ねじきる',
  'ねじくぎ',
  'ねじける',
  'ねじこむ',
  'ねじしき',
  'ねじとる',
  'ねじばな',
  'ねしゃか',
  'ねじゃか',
  'ねじやま',
  'ねじれる',
  'ねすがた',
  'ねすぎる',
  'ねすごす',
  'ねずっぽ',
  'ねずばん',
  'ねずみか',
  'ねずみげ',
  'ねずもち',
  'ねせろり',
  'ねそべる',
  'ねだいた',
  'ねたきり',
  'ねたばこ',
  'ねたばれ',
  'ねだやし',
  'ねたりる',
  'ねちがい',
  'ねちがえ',
  'ねちこい',
  'ねちずん',
  'ねちねち',
  'ねつあい',
  'ねつうん',
  'ねつえん',
  'ねつがく',
  'ねつかそ',
  'ねっから',
  'ねつかん',
  'ねつがん',
  'ねつきぐ',
  'ねっけい',
  'ねつけい',
  'ねっけつ',
  'ねつけん',
  'ねつげん',
  'ねっさん',
  'ねっしー',
  'ねっしん',
  'ねっすい',
  'ねっする',
  'ねっせい',
  'ねっせん',
  'ねつぞう',
  'ねったい',
  'ねっとう',
  'ねっとご',
  'ねっとり',
  'ねっぱつ',
  'ねつばて',
  'ねっぷう',
  'ねつべん',
  'ねつぼう',
  'ねづもり',
  'ねづよい',
  'ねつよく',
  'ねつらい',
  'ねつるい',
  'ねつれつ',
  'ねどうぐ',
  'ねとうよ',
  'ねとげー',
  'ねどころ',
  'ねとねと',
  'ねとふり',
  'ねとまり',
  'ねとらじ',
  'ねとられ',
  'ねなおす',
  'ねにもつ',
  'ねのくに',
  'ねのこく',
  'ねのとき',
  'ねぱーる',
  'ねばぎば',
  'ねばしょ',
  'ねばっく',
  'ねばつく',
  'ねばつち',
  'ねばねば',
  'ねばりけ',
  'ねはんえ',
  'ねぴどー',
  'ねびゅら',
  'ねぶかい',
  'ねぶくろ',
  'ねぶそく',
  'ねぶたい',
  'ねぶるず',
  'ねふろん',
  'ねぼける',
  'ねぼすけ',
  'ねぼとけ',
  'ねまつり',
  'ねまわし',
  'ねまわり',
  'ねむそう',
  'ねむたい',
  'ねむのき',
  'ねむらす',
  'ねもころ',
  'ねやごと',
  'ねらいめ',
  'ねりいと',
  'ねりえさ',
  'ねりがし',
  'ねりぎぬ',
  'ねりけし',
  'ねりこう',
  'ねりこむ',
  'ねりぞめ',
  'ねりべい',
  'ねりべに',
  'ねりみそ',
  'ねりもの',
  'ねるそん',
  'ねろりゆ',
  'ねわざし',
  'ねをはる',
  'ねんあき',
  'ねんあけ',
  'ねんいり',
  'ねんいれ',
  'ねんえき',
  'ねんおう',
  'ねんおし',
  'ねんおち',
  'ねんかい',
  'ねんかく',
  'ねんがく',
  'ねんがけ',
  'ねんがた',
  'ねんかつ',
  'ねんかん',
  'ねんがん',
  'ねんぎょ',
  'ねんきん',
  'ねんくれ',
  'ねんぐん',
  'ねんけつ',
  'ねんげつ',
  'ねんげん',
  'ねんこう',
  'ねんごう',
  'ねんごろ',
  'ねんさい',
  'ねんさん',
  'ねんしき',
  'ねんしぎ',
  'ねんしゃ',
  'ねんじゃ',
  'ねんしゅ',
  'ねんじゅ',
  'ねんしょ',
  'ねんじる',
  'ねんじん',
  'ねんすう',
  'ねんずる',
  'ねんせい',
  'ねんぜい',
  'ねんだい',
  'ねんてん',
  'ねんとう',
  'ねんどう',
  'ねんとれ',
  'ねんない',
  'ねんなし',
  'ねんにん',
  'ねんねえ',
  'ねんねこ',
  'ねんねん',
  'ねんぱい',
  'ねんぶつ',
  'ねんぶり',
  'ねんぶん',
  'ねんべつ',
  'ねんぽう',
  'ねんまく',
  'ねんまつ',
  'ねんゆう',
  'ねんらい',
  'ねんりき',
  'ねんりつ',
  'ねんりん',
  'ねんれい',
  'ねんわり',
  'のあざみ',
  'のあそび',
  'のあまり',
  'のいじー',
  'のいずぃ',
  'のいちご',
  'のいばら',
  'のいろん',
  'のうあつ',
  'のゔぇる',
  'のうえん',
  'のうおん',
  'のうかい',
  'のうがき',
  'のうがく',
  'のうかん',
  'のうきぐ',
  'のうきん',
  'のうげい',
  'のうげか',
  'のうこう',
  'のうこつ',
  'のうこん',
  'のうさい',
  'のうさぎ',
  'のうさく',
  'のうさつ',
  'のうさん',
  'のうじず',
  'のうしつ',
  'のうしゃ',
  'のうしゅ',
  'のうじゅ',
  'のうしょ',
  'のうじょ',
  'のうじん',
  'のうすい',
  'のうずい',
  'のうせい',
  'のうぜい',
  'のうせん',
  'のうそう',
  'のうそん',
  'のうだい',
  'のうたん',
  'のうてい',
  'のうてん',
  'のうとう',
  'のうどう',
  'のうとれ',
  'のうない',
  'のうなし',
  'のうなる',
  'のうにん',
  'のうのう',
  'のうはい',
  'のうはう',
  'のうはく',
  'のうひつ',
  'のうひん',
  'のうぶん',
  'のうへい',
  'のうべん',
  'のうほう',
  'のうぼく',
  'のうほん',
  'のうまく',
  'のうみそ',
  'のうみつ',
  'のうみん',
  'のうめん',
  'のうやく',
  'のうよう',
  'のうらん',
  'のうりき',
  'のうりつ',
  'のうりん',
  'のうれん',
  'のーかん',
  'のーこん',
  'のーすり',
  'のーずろ',
  'のーたい',
  'のーたむ',
  'のーだん',
  'のーてん',
  'のーとん',
  'のーのー',
  'のーはう',
  'のーぱそ',
  'のーぱん',
  'のーぶら',
  'のーぶる',
  'のーぶれ',
  'のーぺな',
  'のーへる',
  'のーべん',
  'のーまる',
  'のーみす',
  'のーもあ',
  'のーらん',
  'のがれる',
  'のきさき',
  'のきざる',
  'のきした',
  'のきたけ',
  'のぎつね',
  'のきてん',
  'のきどい',
  'のきなみ',
  'のぎへん',
  'のけさま',
  'のけざま',
  'のけぞる',
  'のけもの',
  'のこぎり',
  'のこくず',
  'のこさず',
  'のこしゆ',
  'のこった',
  'のこのこ',
  'のこばん',
  'のこべん',
  'のこらず',
  'のこりか',
  'のこりが',
  'のこりび',
  'のこんの',
  'のさばる',
  'のざらし',
  'のざわな',
  'のじあい',
  'のしいた',
  'のしいと',
  'のしがみ',
  'のしのし',
  'のしぼう',
  'のしもち',
  'のじゅく',
  'のせいで',
  'のせこみ',
  'のせこむ',
  'のぞいて',
  'のぞきま',
  'のぞきみ',
  'のそだち',
  'のそのそ',
  'のぞのぞ',
  'のたうつ',
  'のたくる',
  'のたのた',
  'のたびに',
  'のだふじ',
  'のたまう',
  'のたもう',
  'のちざん',
  'のぢしゃ',
  'のちすみ',
  'のちぞい',
  'のちぞえ',
  'のちのち',
  'のちのよ',
  'のちほど',
  'のっかー',
  'のっかる',
  'のっきる',
  'のっくす',
  'のっける',
  'のっこみ',
  'のっそり',
  'のっとり',
  'のっとる',
  'のっぴき',
  'のっぺい',
  'のっぺり',
  'のどあめ',
  'のどうた',
  'のどかぜ',
  'のどぐろ',
  'のどごし',
  'のどしゃ',
  'のどぶえ',
  'のどもと',
  'のどやか',
  'のねずみ',
  'ののしり',
  'ののしる',
  'ののてん',
  'ののはな',
  'のばくち',
  'のばなし',
  'のびしろ',
  'のびたき',
  'のびのび',
  'のびやか',
  'のびりつ',
  'のふうぞ',
  'のぶすま',
  'のぶせり',
  'のぶとい',
  'のぶどう',
  'のぶれー',
  'のべあう',
  'のべいた',
  'のべかね',
  'のべがね',
  'のべがみ',
  'のべざお',
  'のべつぼ',
  'のべぼう',
  'のべるす',
  'のべるず',
  'のほうず',
  'のぼせる',
  'のぼたん',
  'のほほん',
  'のませる',
  'のまっど',
  'のまれる',
  'のみかい',
  'のみかけ',
  'のみかた',
  'のみくい',
  'のみくち',
  'のみぐち',
  'のみこみ',
  'のみこむ',
  'のみさす',
  'のみしろ',
  'のみすぎ',
  'のみすけ',
  'のみだい',
  'のみとり',
  'のみなる',
  'のみにげ',
  'のみぬけ',
  'のみばえ',
  'のみぶり',
  'のみほす',
  'のみみず',
  'のみむし',
  'のみもの',
  'のめのめ',
  'のゆさん',
  'のように',
  'のらいぬ',
  'のらくら',
  'のらねこ',
  'のりあい',
  'のりいい',
  'のりいる',
  'のりいれ',
  'のりうま',
  'のりおき',
  'のりおり',
  'のりかえ',
  'のりきる',
  'のりくち',
  'のりぐち',
  'のりくみ',
  'のりくむ',
  'のりこし',
  'のりこす',
  'のりこむ',
  'のりしろ',
  'のりする',
  'のりだす',
  'のりつぎ',
  'のりつぐ',
  'のりつけ',
  'のりづけ',
  'のりっじ',
  'のりてつ',
  'のりとる',
  'のりにげ',
  'のりのり',
  'のりばり',
  'のりべん',
  'のりまき',
  'のりめん',
  'のりもの',
  'のりゆみ',
  'のりよい',
  'のるどご',
  'のるまる',
  'のれっじ',
  'のれんな',
  'のろける',
  'のろのろ',
  'のわーる',
  'のんある',
  'のんどり',
  'のんのん',
  'のんびり',
  'のんぶる',
  'のんぷろ',
  'のんべえ',
  'のんぽり',
  'のんらー',
  'のんらん',
  'のんれん',
  'ぱーおん',
  'ばーがー',
  'ぱーかー',
  'はーけん',
  'ばーげん',
  'ぱーごら',
  'ぱーさー',
  'ぱーざー',
  'ばーさす',
  'ばあさん',
  'ばーさん',
  'ばーじん',
  'ばーすと',
  'ぱーせく',
  'ぱーそん',
  'ばーたー',
  'ばあたり',
  'ばーちゅ',
  'ぱあっと',
  'ぱーっと',
  'ぱーてぃ',
  'ぱーてる',
  'ぱーでれ',
  'ばーてん',
  'はーどる',
  'ぱーどれ',
  'ばーなー',
  'ばーにあ',
  'はーにー',
  'ばーにゃ',
  'ばーにや',
  'はーねす',
  'はぁはぁ',
  'はあはあ',
  'はーはー',
  'はーばー',
  'ばーばー',
  'はーぱん',
  'はーぴー',
  'はーぶゆ',
  'ぱーぷる',
  'ぱーぺき',
  'ばーべな',
  'ばーべる',
  'ばーぼん',
  'ぱーまや',
  'ぱーみる',
  'ぱーむゆ',
  'ぱーらー',
  'ばーらと',
  'はありい',
  'はーりー',
  'ぱーりー',
  'ぱーりご',
  'はーれむ',
  'ばーれる',
  'ぱーれん',
  'はいあか',
  'ばいあす',
  'はいあつ',
  'ばいある',
  'はいあん',
  'はいいし',
  'ぱいいつ',
  'はいいろ',
  'はいいん',
  'ばいいん',
  'ばいうき',
  'はいうけ',
  'はいえい',
  'はいえき',
  'はいえそ',
  'はいえつ',
  'はいえな',
  'はいえん',
  'ばいえん',
  'はいおく',
  'はいおし',
  'ばいおす',
  'ぱいおつ',
  'ばいおる',
  'ばいおん',
  'ぱいおん',
  'はいかー',
  'はいかい',
  'はいがい',
  'ばいかい',
  'ばいがい',
  'ぱいがお',
  'はいがく',
  'ばいかく',
  'ばいがく',
  'はいがす',
  'ぱいがた',
  'はいから',
  'はいがら',
  'ぱいかる',
  'ぱいがわ',
  'はいかん',
  'はいがん',
  'ばいかん',
  'はいきー',
  'はいきょ',
  'はいぎょ',
  'はいきん',
  'ばいきん',
  'はいぐう',
  'ぱいくー',
  'ぱいぐー',
  'はいくつ',
  'はいぐん',
  'はいけい',
  'はいげき',
  'ばいげつ',
  'はいけん',
  'ばいけん',
  'はいこう',
  'はいごう',
  'ぱいごう',
  'ばいこく',
  'ばいごま',
  'はいこむ',
  'ばいざー',
  'はいさい',
  'はいざい',
  'はいさく',
  'はいさじ',
  'はいさつ',
  'はいざら',
  'はいざん',
  'ばいさん',
  'ばいじい',
  'はいじく',
  'はいしつ',
  'ばいしつ',
  'はいしゃ',
  'ばいしゃ',
  'はいしゅ',
  'はいじゅ',
  'はいしょ',
  'はいじょ',
  'ばいじょ',
  'はいしん',
  'はいじん',
  'ばいしん',
  'ばいじん',
  'はいすい',
  'はいすう',
  'ばいすう',
  'はいすぺ',
  'ぱいすら',
  'ぱいずり',
  'はいする',
  'はいずる',
  'ばいする',
  'はいせい',
  'はいせき',
  'ばいせき',
  'ばいせく',
  'はいせつ',
  'はいぜつ',
  'はいせん',
  'はいぜん',
  'ばいせん',
  'ばいぜん',
  'ぱいせん',
  'はいそう',
  'はいぞう',
  'ばいぞう',
  'はいそく',
  'はいぞく',
  'ばいそく',
  'はいそん',
  'ばいそん',
  'ぱいそん',
  'はいたい',
  'ばいたい',
  'ばいだい',
  'はいたか',
  'はいたく',
  'はいだす',
  'はいたつ',
  'はいだつ',
  'はいだて',
  'ばいたら',
  'ばいたる',
  'はいだん',
  'ぱいたん',
  'ぱいちー',
  'はいちず',
  'ばいちず',
  'はいつう',
  'ばいづけ',
  'はいつち',
  'はいてい',
  'はいてく',
  'はいでる',
  'はいてん',
  'はいでん',
  'ばいてん',
  'ばいでん',
  'はいとう',
  'はいどう',
  'はいとく',
  'はいどく',
  'ばいどく',
  'はいとこ',
  'ばいとち',
  'はいどら',
  'はいとり',
  'はいどろ',
  'はいどん',
  'ばいなら',
  'ばいなり',
  'ばいなる',
  'はいにく',
  'ばいにく',
  'はいにち',
  'はいにん',
  'ばいにん',
  'はいねこ',
  'はいねず',
  'はいねつ',
  'はいのう',
  'はいぱー',
  'ばいぱー',
  'はいはい',
  'はいぱい',
  'ばいばい',
  'ぱいぱい',
  'ばいぱす',
  'はいはん',
  'はいばん',
  'ぱいぱん',
  'ばいびー',
  'はいびる',
  'はいひん',
  'ばいひん',
  'はいふう',
  'はいふき',
  'はいふく',
  'ばいぶす',
  'はいぶつ',
  'ばいぶる',
  'はいふん',
  'はいぶん',
  'ばいぶん',
  'はいへい',
  'はいべん',
  'ばいべん',
  'はいほう',
  'はいぼう',
  'ぱいぼう',
  'はいほー',
  'はいぼく',
  'ばいぼく',
  'はいほん',
  'はいまく',
  'ばいまし',
  'はいまつ',
  'ばいまん',
  'はいみす',
  'はいめい',
  'ばいめい',
  'はいめつ',
  'はいめん',
  'はいもん',
  'はいやー',
  'ばいやー',
  'はいやく',
  'ばいやく',
  'ばいやす',
  'はいやま',
  'ぱいやま',
  'はいゆう',
  'はいよう',
  'ばいよう',
  'はいよる',
  'ばいよん',
  'ばいらす',
  'ばいらる',
  'はいらん',
  'ばいりつ',
  'はいりょ',
  'はいりん',
  'ばいりん',
  'ぱいるじ',
  'はいれい',
  'はいれぐ',
  'はいれぞ',
  'はいれつ',
  'はいれん',
  'ぱいろん',
  'ばいんど',
  'ぱいんと',
  'はゔぁな',
  'はうさご',
  'はうじん',
  'ぱうだー',
  'はうちわ',
  'はうつー',
  'はうめあ',
  'ばうんす',
  'はうんと',
  'はうんど',
  'ばうんど',
  'ぱうんど',
  'はえある',
  'はえぎわ',
  'ぱえじゃ',
  'はえでる',
  'はえとり',
  'はえなわ',
  'はえぬき',
  'はえもく',
  'ぱえりあ',
  'ぱえりゃ',
  'ぱえりや',
  'ばおくれ',
  'はおこぜ',
  'ばおばぶ',
  'はおゆー',
  'はかあな',
  'ばかあな',
  'はかいし',
  'はがうく',
  'ばかうけ',
  'ばかうよ',
  'ばかうれ',
  'ばかがい',
  'ばかくい',
  'ばかぐい',
  'はがくれ',
  'ばかげー',
  'ばかげた',
  'ばかげる',
  'ばかざめ',
  'ばかさよ',
  'ばかじた',
  'はかしょ',
  'ばかじょ',
  'はがたつ',
  'はがため',
  'ばかたれ',
  'はがつお',
  'ぱかっと',
  'ばかづら',
  'ばかどり',
  'はかどる',
  'はかない',
  'はかなむ',
  'ぱかぱか',
  'はかぴく',
  'はかほり',
  'はかまぎ',
  'はかまじ',
  'ばかもの',
  'はかもり',
  'ばかやす',
  'はがゆい',
  'ばかよけ',
  'はからい',
  'はからう',
  'ばからお',
  'ばかりか',
  'ばかりに',
  'はかりめ',
  'はがれる',
  'ばかんす',
  'はぎごと',
  'はぎしり',
  'はぎぞく',
  'はきだす',
  'はきたて',
  'はきだめ',
  'ばきっと',
  'はぎとり',
  'はぎとる',
  'はきはき',
  'ばきばき',
  'はぎはら',
  'はきもの',
  'はぎやき',
  'はきゃく',
  'ばきゃく',
  'ぱぎゃる',
  'はきゅう',
  'はきょう',
  'はぎょう',
  'ばぎょう',
  'ぱぎょう',
  'はきょく',
  'はぎわら',
  'ぱぎんす',
  'はくあい',
  'はくあき',
  'ばくあげ',
  'ばくあつ',
  'はくいん',
  'はくうち',
  'ばくうれ',
  'はくうん',
  'ばくえい',
  'ばくえき',
  'はくえん',
  'ばくえん',
  'はくおし',
  'ばくおん',
  'はくがい',
  'ばくがい',
  'はくがく',
  'はくがん',
  'はくぎん',
  'ばくぐい',
  'はくぐう',
  'はぐくむ',
  'はくぐん',
  'ばくぐん',
  'はくげい',
  'はくげき',
  'ばくげき',
  'ばくごう',
  'はくさい',
  'ばくさい',
  'ばくさつ',
  'ばくさん',
  'はくしき',
  'はくしつ',
  'はくじつ',
  'はくしゃ',
  'はくじゃ',
  'ばくしゃ',
  'はくしゅ',
  'はくじゅ',
  'ばくしゅ',
  'はくしょ',
  'ばくしょ',
  'はくじら',
  'はくしん',
  'はくじん',
  'ばくしん',
  'ばくすい',
  'はくすう',
  'はくすら',
  'はくする',
  'ばくする',
  'はくせい',
  'ばくせい',
  'はくせき',
  'はくせつ',
  'はくせん',
  'はくぜん',
  'ばくぜん',
  'はくそう',
  'はくぞう',
  'ばくそう',
  'ばくそく',
  'はくたい',
  'はくだい',
  'ばくたい',
  'ばくだい',
  'はくたく',
  'はくだく',
  'はくだつ',
  'はくたん',
  'ばくたん',
  'ばくだん',
  'ぱくちー',
  'ばくちく',
  'はくちず',
  'はくちび',
  'ばくちん',
  'ぱくつく',
  'ぱくっと',
  'はくてい',
  'はくでん',
  'ばくてん',
  'はくとう',
  'はくどう',
  'はくどひ',
  'はくにー',
  'はくにく',
  'はくねつ',
  'ばくねん',
  'はくばい',
  'はくぱい',
  'はくはく',
  'ばくばく',
  'ぱくぱく',
  'はくはつ',
  'ばくはつ',
  'はくはん',
  'はくばん',
  'ばくはん',
  'ばくふう',
  'はくぶつ',
  'はくぶん',
  'ばくふん',
  'ばぐべあ',
  'はくへい',
  'はくへき',
  'はくへん',
  'はくほう',
  'はくぼく',
  'はくまい',
  'はくまく',
  'ばくまつ',
  'はくめい',
  'はくめん',
  'ばくやく',
  'はくよう',
  'ばくよう',
  'はくらい',
  'ばくらい',
  'はくらく',
  'ばくらむ',
  'はくらん',
  'はくりし',
  'ぱくりや',
  'はくりん',
  'はぐるま',
  'ばくれつ',
  'はぐれる',
  'ぱぐれる',
  'はくれん',
  'ばくれん',
  'はくろう',
  'ばくろう',
  'ばくろん',
  'ばげーじ',
  'ぱけがい',
  'ばけがく',
  'はけぐち',
  'はけさき',
  'はげしい',
  'ぱけだい',
  'はげたか',
  'ばげっじ',
  'ばけっと',
  'ばげっと',
  'ぱけっと',
  'はげどう',
  'はけぬり',
  'ばけねこ',
  'ばけふだ',
  'はげまし',
  'はげます',
  'ばけもの',
  'ばけもん',
  'はげやま',
  'はげわし',
  'はごいた',
  'はこいり',
  'はこえび',
  'はこおし',
  'ぱこーら',
  'はこがい',
  'はこがき',
  'はこがた',
  'はこがめ',
  'はこずし',
  'はごたえ',
  'はこだて',
  'はこづめ',
  'はこてん',
  'はこにわ',
  'はこのり',
  'ぱこぱこ',
  'はこびや',
  'はこふぐ',
  'はこぶね',
  'はこべら',
  'はこぼれ',
  'はこもの',
  'はごろも',
  'ぱさーた',
  'はざーど',
  'ばざーる',
  'はさいき',
  'はざくら',
  'ぱさつく',
  'ばさっと',
  'はさっぷ',
  'ばさばさ',
  'ぱさぱさ',
  'はさまる',
  'はざわり',
  'はしーし',
  'はしいた',
  'はじいる',
  'はしおき',
  'はしおる',
  'はしがき',
  'はしかけ',
  'はしかし',
  'はしがみ',
  'はじかみ',
  'はしから',
  'はしぐい',
  'はしくれ',
  'はしげた',
  'はじける',
  'はしこい',
  'はししゅ',
  'はしぞめ',
  'はじぞめ',
  'はしだい',
  'はしたか',
  'はしたて',
  'はしため',
  'はしぢか',
  'はしっこ',
  'はじっこ',
  'はしづつ',
  'ばしっと',
  'はしどい',
  'はしばこ',
  'はしばし',
  'ばしばし',
  'ぱしぱし',
  'はしばみ',
  'はじまり',
  'はじまる',
  'はじめて',
  'はじめに',
  'はじめね',
  'はじめは',
  'はじめる',
  'はしゃぐ',
  'ぱじゃま',
  'ばしゃら',
  'ぱしゃり',
  'ぱしゃん',
  'ばしゅー',
  'はしゅつ',
  'ばじゅつ',
  'はじゅん',
  'はじょう',
  'ばしょう',
  'ばじょう',
  'はしょく',
  'ばしょく',
  'はしょる',
  'はじらい',
  'はじらう',
  'はしらす',
  'ばしらす',
  'はしらま',
  'はじらみ',
  'ばしりか',
  'ばじりか',
  'ばじりこ',
  'はしりや',
  'はじろう',
  'はすいけ',
  'はすいも',
  'ばずーか',
  'ばすーん',
  'はずおし',
  'はすかい',
  'ばすがた',
  'ぱすかる',
  'はすきー',
  'ばすくご',
  'ばすけぶ',
  'ばすこん',
  'ぱすこん',
  'ばすたー',
  'ばすたぶ',
  'ばすちん',
  'はすっぱ',
  'ばすてい',
  'はずです',
  'ぱすてる',
  'ばすとれ',
  'はずない',
  'ばすはば',
  'はずべき',
  'ぱすめい',
  'はすもち',
  'はすらー',
  'はずれち',
  'はずれる',
  'はせいご',
  'はせっぷ',
  'はぜのき',
  'はぜろう',
  'ぱそげー',
  'ぱそこん',
  'ぱそつう',
  'ばそりす',
  'はだあい',
  'はたあげ',
  'ばたあし',
  'ばたーに',
  'ばたーる',
  'はだあれ',
  'ぱたーん',
  'はたいろ',
  'はだいろ',
  'はたうち',
  'はだうま',
  'はだおち',
  'はたおり',
  'はだかぎ',
  'はだかび',
  'はだかみ',
  'はたから',
  'はだかる',
  'はだぎぬ',
  'はだける',
  'はたごや',
  'はたざお',
  'はたさく',
  'はたさし',
  'はださむ',
  'はだしつ',
  'はたして',
  'はたぞり',
  'はたたく',
  'ばたつく',
  'ばたっと',
  'ぱたっと',
  'はたとせ',
  'はだぬぎ',
  'はだぬぐ',
  'はたばこ',
  'はたはた',
  'ばたばた',
  'ぱたぱた',
  'ぱたはら',
  'ばたぴー',
  'はたふり',
  'はたほこ',
  'はたぼこ',
  'はたまた',
  'はためく',
  'はたもち',
  'はたもと',
  'はたやき',
  'ばだらい',
  'はたらき',
  'はたらく',
  'ばたりー',
  'はたりす',
  'はちうえ',
  'ばちおと',
  'はちかい',
  'ばちがい',
  'はちがつ',
  'ばちかわ',
  'ばちかん',
  'はちきん',
  'ばちくそ',
  'はちくま',
  'ぱちくり',
  'はちけー',
  'はちけん',
  'はちこう',
  'ぱちこく',
  'はちしき',
  'はちじく',
  'ばちすと',
  'はちすは',
  'はちすば',
  'ぱちすろ',
  'はちどう',
  'はちどり',
  'はちのき',
  'はちのこ',
  'はちのじ',
  'はちのす',
  'はちはち',
  'ばちばち',
  'ぱちぱち',
  'ばちびん',
  'はちふう',
  'はちふく',
  'はちぶめ',
  'ぱちぷろ',
  'はちほん',
  'はちまき',
  'はちまん',
  'はちみつ',
  'はちめん',
  'ばちめん',
  'はちもく',
  'はちもの',
  'ぱちもの',
  'ぱちもん',
  'ばちゃく',
  'ばちゃん',
  'はちゅう',
  'はちょう',
  'ぱちょり',
  'ばちるす',
  'はちろう',
  'はちわれ',
  'ぱちんこ',
  'はつあき',
  'はつあん',
  'はついく',
  'はついち',
  'ばついち',
  'はつうま',
  'はつうり',
  'ばつえい',
  'はつえき',
  'はつえん',
  'はつおん',
  'はっかー',
  'ばっかー',
  'ぱっかー',
  'はっかい',
  'はつがい',
  'はっかく',
  'ばっかく',
  'はっかけ',
  'はっかご',
  'ばっかし',
  'ばっかす',
  'はつかぜ',
  'はつがま',
  'はっかゆ',
  'ばっかり',
  'ばっかる',
  'はっかん',
  'はつがん',
  'ばっかん',
  'はつぎく',
  'はつきす',
  'はつぎょ',
  'ばっきょ',
  'はっきり',
  'はっきん',
  'ばっきん',
  'ぱっきん',
  'ぱつきん',
  'ばっくす',
  'はっくつ',
  'はっくぶ',
  'ぱっくり',
  'ばっくる',
  'ばっくれ',
  'ばっくん',
  'ばつぐん',
  'はっけい',
  'はっけん',
  'はつげん',
  'ばっけん',
  'はつこい',
  'はっこう',
  'はつこえ',
  'はっこく',
  'ばっこす',
  'はつこち',
  'はっこつ',
  'はっこん',
  'はっさい',
  'ばっさい',
  'はっさく',
  'ばっさり',
  'はっさん',
  'はつざん',
  'ばつさん',
  'はっじー',
  'はっしき',
  'ばっしつ',
  'ぱっしぶ',
  'はつしも',
  'はっしゃ',
  'はっしゅ',
  'ばっしゅ',
  'はっしん',
  'はつじん',
  'ばっしん',
  'はっすい',
  'ばっすい',
  'はつずり',
  'はっする',
  'ばっする',
  'はっすん',
  'はっせい',
  'はっせき',
  'ばっせき',
  'はつぜみ',
  'はつせり',
  'はっせん',
  'ばっせん',
  'はっそう',
  'ばっそう',
  'ばつぞう',
  'はっそく',
  'ばっそく',
  'ばつぞく',
  'はつそら',
  'はつぞら',
  'ばっそん',
  'ばったー',
  'はったい',
  'ぱったい',
  'ばったく',
  'はったつ',
  'はったと',
  'はったり',
  'ばったり',
  'ぱったり',
  'はったん',
  'ばったん',
  'ばっちぃ',
  'ばっちい',
  'ばっちー',
  'ぱっちぎ',
  'ばっちし',
  'ぱっちむ',
  'ばっちり',
  'ぱっちり',
  'はっちん',
  'はつつき',
  'はつづき',
  'はっつけ',
  'ぱっつん',
  'ばってい',
  'ばってき',
  'ばってら',
  'ばってり',
  'ばってれ',
  'はってん',
  'はつでん',
  'ばってん',
  'はっとう',
  'はつどう',
  'ばっとう',
  'はっとく',
  'はっとぐ',
  'ぱっとみ',
  'はつとり',
  'はつなき',
  'はつなぎ',
  'ばつなぎ',
  'はつなつ',
  'はつなり',
  'ばつなん',
  'はつねつ',
  'はつのり',
  'ばっぱー',
  'はつばい',
  'ばっぱい',
  'はつばき',
  'はっぱく',
  'ぱつぱつ',
  'はつばと',
  'ぱっぱと',
  'はつはな',
  'はつはる',
  'はっぴー',
  'ばっふぁ',
  'はつふじ',
  'はつふゆ',
  'ばっふる',
  'はつぶろ',
  'はっぷん',
  'ばつぶん',
  'はっぽう',
  'ばっぽう',
  'ばつぼく',
  'はつぼん',
  'はっぽん',
  'ばっぽん',
  'はつまご',
  'はつみつ',
  'はつみみ',
  'はつめい',
  'はつもう',
  'ばつもう',
  'はつもの',
  'はつもん',
  'はつやく',
  'はつゆき',
  'はつゆめ',
  'はつよう',
  'ばつよう',
  'はつらい',
  'はつらつ',
  'はつれい',
  'ばでぃー',
  'ぱてぃお',
  'ぱてぃす',
  'ばていら',
  'はでこん',
  'はてさて',
  'はでずき',
  'はてはて',
  'はでやか',
  'ばてれん',
  'ぱてんと',
  'ぱとかー',
  'はとごや',
  'はどっく',
  'ぱどっく',
  'ぱどどぅ',
  'はとぶえ',
  'はとほる',
  'はとむぎ',
  'はとむね',
  'はともく',
  'ばとらー',
  'ぱとりき',
  'ばとろわ',
  'はどろん',
  'ぱとろん',
  'ぱとわご',
  'はなあせ',
  'はなあぶ',
  'はないか',
  'はないき',
  'はないけ',
  'はないた',
  'はないれ',
  'はないろ',
  'はなうた',
  'はなうど',
  'はなうり',
  'はなおち',
  'はながい',
  'はなかご',
  'はながさ',
  'はなかぜ',
  'はながた',
  'はながみ',
  'はながめ',
  'はなから',
  'はながら',
  'はながわ',
  'はなきり',
  'はなぎれ',
  'はなきん',
  'はなくそ',
  'はなぐま',
  'はなぐも',
  'はなぐろ',
  'はなごえ',
  'はなごけ',
  'はなござ',
  'はなごま',
  'はなさき',
  'はなさく',
  'はなさけ',
  'はなざけ',
  'はなざめ',
  'はなじお',
  'はなしか',
  'はなして',
  'はなしる',
  'はなじる',
  'ばなじん',
  'はなすじ',
  'はなすみ',
  'はなずみ',
  'はなせる',
  'はなせん',
  'はなぞの',
  'はなだい',
  'はなたか',
  'はなたけ',
  'はなたて',
  'はなたば',
  'はなたれ',
  'はなちで',
  'はなづか',
  'はなつき',
  'はなづな',
  'はなづの',
  'はなつみ',
  'はなづら',
  'はなどき',
  'はななえ',
  'はななべ',
  'はなのか',
  'はなのき',
  'はなはい',
  'はなぱい',
  'はなはだ',
  'はなばち',
  'はなばな',
  'はなびえ',
  'はなひげ',
  'はなびし',
  'はなびら',
  'はなひる',
  'はなふき',
  'はなぶさ',
  'はなふだ',
  'はなへん',
  'はなまち',
  'はなまめ',
  'はなまる',
  'はなみず',
  'はなみち',
  'はなむけ',
  'はなむこ',
  'はなもじ',
  'はなもち',
  'はなもと',
  'はなもの',
  'はなもり',
  'はなやか',
  'はなやぎ',
  'はなやぐ',
  'はなよめ',
  'はならび',
  'はなれや',
  'はなれる',
  'はなろく',
  'ばにあん',
  'ぱにーに',
  'ぱにーの',
  'ぱにーる',
  'ばにおん',
  'はにかみ',
  'はにかむ',
  'ぱにくる',
  'はにそう',
  'はにぞう',
  'ぱにっく',
  'ばにてぃ',
  'はにとー',
  'はにとら',
  'ばにやん',
  'はにゅう',
  'ばにりん',
  'ばにんぐ',
  'ぱにんぐ',
  'ばぬあつ',
  'はぬかー',
  'はねあげ',
  'はねあり',
  'はねいた',
  'はねうま',
  'はねおき',
  'はねおと',
  'はねかす',
  'はねかむ',
  'はねけん',
  'はねだす',
  'はねつき',
  'はねでる',
  'はねばし',
  'はねぺん',
  'はねまん',
  'はねもの',
  'ばねゆび',
  'ぱねらー',
  'ぱのらま',
  'ぱばーぬ',
  'ぱぱいあ',
  'ぱぱいや',
  'ぱぱいん',
  'ははうえ',
  'ははうし',
  'ははうじ',
  'ははおや',
  'ははかた',
  'ぱぱかつ',
  'はばかり',
  'はばかる',
  'ははがわ',
  'はばきき',
  'ははぎみ',
  'ははくそ',
  'ははぐま',
  'ははくろ',
  'ははざる',
  'ぱぱさん',
  'ははじゃ',
  'はばたき',
  'はばたく',
  'ぱぱっこ',
  'ぱぱっと',
  'ははとじ',
  'ばばどの',
  'はばとび',
  'ははどり',
  'ははなる',
  'ばばぬき',
  'はばねら',
  'はばねろ',
  'ははのひ',
  'はばのり',
  'はばはば',
  'はばびろ',
  'ばばへら',
  'はばへん',
  'ははもの',
  'はばよせ',
  'ばばろあ',
  'はびこる',
  'はびっと',
  'ばびにく',
  'はぴばー',
  'ぱぴよん',
  'ばびるさ',
  'ぱぴるす',
  'はふいた',
  'ばふーす',
  'はぶーぶ',
  'ばふぇい',
  'ぱふぇー',
  'ばぶしか',
  'はぶそう',
  'はぶたえ',
  'はぶちゃ',
  'はぷてん',
  'はぷばー',
  'はふはふ',
  'ばぶばぶ',
  'ばふばん',
  'はぶらし',
  'はふらす',
  'ばぶりー',
  'ぱぷりか',
  'ぱぶろば',
  'ぱぶろわ',
  'ばふんし',
  'ぱぺっと',
  'はべらす',
  'はぼうき',
  'はぼたん',
  'はまかぜ',
  'はまぐり',
  'はまごう',
  'はますげ',
  'はまぜり',
  'はまだい',
  'はまっこ',
  'はまとら',
  'はまなし',
  'はまなす',
  'はまびし',
  'はままつ',
  'はまやき',
  'はまゆう',
  'はまゆみ',
  'ぱみーる',
  'はみうり',
  'はみがき',
  'はみだし',
  'はみだす',
  'はみちち',
  'はみでる',
  'はみぱん',
  'はみんぐ',
  'はむかう',
  'はむかつ',
  'はむしゃ',
  'ばむばむ',
  'はめあい',
  'はめいた',
  'はめこみ',
  'はめこむ',
  'はめどり',
  'はめはめ',
  'はもじい',
  'はもにか',
  'はものし',
  'はもれび',
  'はやあし',
  'はやうち',
  'はやうま',
  'はやおき',
  'はやおけ',
  'はやおし',
  'はやがね',
  'はやぐい',
  'はやくち',
  'はやぐち',
  'はやくも',
  'はやさい',
  'はやざき',
  'はやざし',
  'はやしお',
  'はやじに',
  'はやじも',
  'はやずし',
  'はやたき',
  'はやだち',
  'はやづけ',
  'はやにえ',
  'はやはや',
  'はやばや',
  'はやばれ',
  'はやばん',
  'はやびき',
  'はやびけ',
  'はやひと',
  'はやぶさ',
  'はやふね',
  'はやぶね',
  'はやべん',
  'はやまき',
  'はやまる',
  'はやみち',
  'はやみみ',
  'はやめし',
  'はやめに',
  'はやめる',
  'はやゆで',
  'はやらす',
  'はやりぎ',
  'はやりめ',
  'はやわざ',
  'はやわり',
  'はらあか',
  'はらあて',
  'ばらーど',
  'はらーむ',
  'はらーる',
  'はらいし',
  'はらいせ',
  'はらいそ',
  'ぱらいそ',
  'ぱらいぞ',
  'はらいた',
  'ばらいた',
  'はらいど',
  'ばらいと',
  'ばらいろ',
  'ばらうり',
  'ばらえん',
  'はらおち',
  'はらおび',
  'はらがけ',
  'はらから',
  'はらきり',
  'はらげい',
  'ばらけつ',
  'ばらける',
  'ぱらごむ',
  'はらすじ',
  'ばらずし',
  'ばらすと',
  'ばらずみ',
  'ばらせん',
  'ぱらそる',
  'はらたけ',
  'はらだち',
  'はらだつ',
  'ばらつき',
  'ばらっく',
  'ばらつく',
  'ぱらっく',
  'ぱらつく',
  'ばらっど',
  'ぱらっと',
  'はらっぱ',
  'ばらづみ',
  'ばらどる',
  'ばらにく',
  'はらばい',
  'はらばう',
  'ばらはた',
  'はらはら',
  'ばらばら',
  'ぱらぱら',
  'はらびれ',
  'はらぺこ',
  'はらぼて',
  'ぱらぼら',
  'はらまき',
  'ばらまき',
  'ばらまく',
  'はらませ',
  'はらみた',
  'はらみつ',
  'ぱらみつ',
  'ばらむつ',
  'ぱらめた',
  'ばらもく',
  'はらもち',
  'ばらもん',
  'はらやみ',
  'はららご',
  'ぱられる',
  'はらわた',
  'ばらんす',
  'はらんで',
  'ばりあー',
  'はりあい',
  'はりあう',
  'はりあな',
  'はりいか',
  'ぱりーぐ',
  'はりいた',
  'はりうお',
  'ばりうむ',
  'ばりえて',
  'ばりおん',
  'はりかえ',
  'はりかた',
  'はりがた',
  'はりがね',
  'はりがみ',
  'ばりかん',
  'はりぎり',
  'はりきる',
  'はりぐわ',
  'はりこみ',
  'はりこむ',
  'ぱりこれ',
  'ばりこん',
  'ぱりさい',
  'はりさし',
  'ばりさん',
  'ばりすた',
  'はりせい',
  'はりせん',
  'ぱりそん',
  'はりだし',
  'はりだす',
  'ばりたち',
  'はりつく',
  'はりつけ',
  'はりっさ',
  'ばりっと',
  'ぱりっと',
  'ぱりてぃ',
  'ばりとん',
  'はりぬき',
  'はりのめ',
  'はりばこ',
  'はりはり',
  'ばりばり',
  'ぱりぱり',
  'はりばん',
  'はりびゆ',
  'はりふぁ',
  'はりふだ',
  'はりぼて',
  'はりみせ',
  'はりめど',
  'はりもみ',
  'ばりやー',
  'はりやま',
  'ばりゅー',
  'ばりょう',
  'はりょく',
  'はりらや',
  'ぱりんぐ',
  'はるあき',
  'はるあれ',
  'ばるあん',
  'はるーみ',
  'ばるーん',
  'ばるかー',
  'はるかぜ',
  'はるかに',
  'ばるきー',
  'ばるくか',
  'はるごま',
  'ばるこん',
  'ぱるさー',
  'はるさき',
  'はるさく',
  'ばるさむ',
  'はるさめ',
  'はるしも',
  'はるしゃ',
  'ぱるすは',
  'はるぜみ',
  'ぱるたい',
  'ぱるっく',
  'はるつみ',
  'はるなつ',
  'はるにれ',
  'はるのの',
  'はるのひ',
  'はるのよ',
  'ばるはら',
  'はるばる',
  'はるびん',
  'ぱるふぇ',
  'はるふく',
  'ばるぼあ',
  'はるぼう',
  'ばるぼる',
  'はるまき',
  'はるまゆ',
  'はるめく',
  'はるもの',
  'はるやま',
  'ぱれーど',
  'はれたす',
  'ばれった',
  'ばれっと',
  'ぱれっと',
  'はれのひ',
  'はればれ',
  'ばればれ',
  'はれもの',
  'はれやか',
  'はれるや',
  'はれんち',
  'ばろーす',
  'ぱろーる',
  'はろげん',
  'はろせん',
  'はろたん',
  'ぱろちん',
  'ばろっく',
  'ばろっと',
  'ぱろでぃ',
  'ばろねす',
  'ぱろみの',
  'はわいご',
  'はわうじ',
  'ぱわえれ',
  'はわじゃ',
  'ぱわすて',
  'はわたり',
  'ぱわはら',
  'ぱわふる',
  'ばをとる',
  'はをぬく',
  'はんあい',
  'はんいご',
  'ばんいち',
  'ぱんいち',
  'ばんいつ',
  'はんいん',
  'はんえい',
  'はんえり',
  'はんえん',
  'はんおう',
  'はんおく',
  'はんおん',
  'はんがー',
  'ばんかー',
  'はんかい',
  'ばんかい',
  'ばんがい',
  'はんがお',
  'はんがか',
  'はんかく',
  'はんがく',
  'ばんがく',
  'はんかこ',
  'ばんがさ',
  'はんがた',
  'ばんがた',
  'はんかち',
  'ばんかつ',
  'ばんから',
  'はんかん',
  'はんがん',
  'ばんかん',
  'ばんぎく',
  'はんぎご',
  'ぱんきじ',
  'ばんぎゃ',
  'ばんきょ',
  'はんぎり',
  'はんきれ',
  'はんぎれ',
  'はんきん',
  'ばんきん',
  'ぱんくず',
  'はんくち',
  'はんぐつ',
  'ばんぐみ',
  'ばんぐら',
  'はんぐる',
  'ばんぐる',
  'はんぐれ',
  'ぱんくろ',
  'はんぐん',
  'ばんぐん',
  'ぱんげあ',
  'はんけい',
  'ばんけい',
  'ばんげい',
  'はんげき',
  'はんけち',
  'はんけつ',
  'はんげつ',
  'はんけん',
  'はんげん',
  'ばんけん',
  'はんこう',
  'はんごう',
  'ばんこう',
  'ばんごう',
  'はんこえ',
  'はんこく',
  'はんごく',
  'ばんこく',
  'はんこつ',
  'ばんこつ',
  'ばんごや',
  'はんこん',
  'はんごん',
  'ばんこん',
  'ぱんさー',
  'はんさい',
  'はんざい',
  'ばんさい',
  'ばんざい',
  'はんざき',
  'はんさく',
  'ばんさく',
  'はんさつ',
  'はんざつ',
  'はんさむ',
  'ばんさん',
  'ばんしー',
  'ぱんじー',
  'はんじえ',
  'ばんしき',
  'はんした',
  'はんじち',
  'はんじつ',
  'ばんしつ',
  'はんじほ',
  'はんしゃ',
  'はんじゃ',
  'ばんしゃ',
  'はんしゅ',
  'はんじゅ',
  'ばんしゅ',
  'ばんじゅ',
  'ばんしょ',
  'はんじる',
  'はんしん',
  'ばんしん',
  'ばんじん',
  'はんすい',
  'はんすう',
  'ぱんすけ',
  'はんすと',
  'ぱんすと',
  'はんする',
  'はんずる',
  'はんせい',
  'はんぜい',
  'ばんせい',
  'ばんぜい',
  'はんせき',
  'はんせつ',
  'ばんせつ',
  'はんせむ',
  'はんせん',
  'はんぜん',
  'ばんせん',
  'ばんぜん',
  'はんそう',
  'はんぞう',
  'ばんそう',
  'はんそく',
  'はんぞく',
  'ばんぞく',
  'ばんそつ',
  'はんそで',
  'はんたー',
  'はんたい',
  'はんだい',
  'ばんだい',
  'はんだて',
  'ばんだな',
  'ぱんだね',
  'はんたま',
  'ばんたむ',
  'はんだん',
  'ばんたん',
  'ぱんだん',
  'はんちか',
  'はんちじ',
  'ばんちゃ',
  'ぱんちら',
  'はんちん',
  'ばんつー',
  'はんつき',
  'ばんづけ',
  'はんつや',
  'はんづら',
  'はんてい',
  'はんでぃ',
  'ぱんてぃ',
  'ばんてき',
  'はんでし',
  'はんてん',
  'はんでん',
  'ばんてん',
  'はんどあ',
  'はんとう',
  'はんどう',
  'ばんとう',
  'ばんどう',
  'はんとき',
  'はんどく',
  'はんとし',
  'はんどら',
  'はんとり',
  'はんどる',
  'ばんどる',
  'ぱんどる',
  'はんどん',
  'ぱんとん',
  'はんなが',
  'はんなき',
  'はんなり',
  'ばんなん',
  'はんにえ',
  'はんにち',
  'はんにゃ',
  'はんにん',
  'ばんにん',
  'はんねん',
  'ばんねん',
  'はんのう',
  'ばんのう',
  'はんのき',
  'ぱんのき',
  'ばんぱー',
  'はんばい',
  'はんばく',
  'はんぱく',
  'ばんぱく',
  'はんばこ',
  'ぱんぱす',
  'はんばつ',
  'はんぱつ',
  'はんはば',
  'はんばり',
  'はんはん',
  'はんぱん',
  'ばんばん',
  'ばんぱん',
  'ぱんぱん',
  'ぱんぴー',
  'ぱんぴざ',
  'ばんぶー',
  'ばんぷう',
  'はんぷく',
  'ばんぷく',
  'ぱんぷす',
  'ばんぶつ',
  'はんぶる',
  'はんぶん',
  'はんぷん',
  'はんべい',
  'はんぺい',
  'ばんぺい',
  'はんべそ',
  'はんべつ',
  'ばんべつ',
  'はんぺら',
  'はんべり',
  'はんぺん',
  'はんぼう',
  'ばんぽう',
  'はんぼっ',
  'はんほり',
  'はんぽん',
  'はんまー',
  'はんまい',
  'はんみち',
  'ぱんみみ',
  'ばんみん',
  'はんめい',
  'ばんめし',
  'はんめん',
  'ばんめん',
  'はんもう',
  'はんもく',
  'ばんもく',
  'ばんもつ',
  'はんもと',
  'はんもん',
  'はんやく',
  'はんやけ',
  'ばんやん',
  'ばんゆう',
  'はんよう',
  'ばんらい',
  'はんらく',
  'はんらん',
  'はんりょ',
  'ばんりょ',
  'はんりん',
  'はんるい',
  'はんれい',
  'ばんれい',
  'はんれき',
  'はんれつ',
  'はんろう',
  'ばんろぜ',
  'ぱんろり',
  'はんろん',
  'はんわく',
  'ひあかり',
  'ひあがる',
  'ぴあさー',
  'ぴあじぇ',
  'ひあそび',
  'ひあたり',
  'びあだる',
  'ぴあにか',
  'ぴあのら',
  'ひあぶり',
  'びあまぐ',
  'ひありん',
  'びあんこ',
  'ぴーえー',
  'びーえす',
  'ぴーえす',
  'びーえむ',
  'ぴーえむ',
  'びーえる',
  'びーかー',
  'ぴーかき',
  'びーがた',
  'びーがん',
  'ぴいかん',
  'ぴーかん',
  'ひいきめ',
  'ぴーくじ',
  'びーくる',
  'びーぐる',
  'びーけい',
  'ぴーけー',
  'ひいこら',
  'ひーこら',
  'びーこん',
  'びーさん',
  'びーしー',
  'びーじー',
  'ぴーしー',
  'びいしき',
  'ひいじじ',
  'ひいじり',
  'びーすと',
  'びーせん',
  'びーそう',
  'ひーたー',
  'びーたー',
  'びーだま',
  'ぴーたん',
  'びーちく',
  'ひいっち',
  'ひいです',
  'ひーです',
  'ひいては',
  'ひいでる',
  'ぴーとす',
  'びーとる',
  'びーどろ',
  'ぴーとろ',
  'ひーとん',
  'びーなす',
  'ぴーなつ',
  'びーばー',
  'ぴーぱい',
  'ひいばば',
  'ひいひい',
  'ひーひー',
  'びいびい',
  'びーびー',
  'ぴいぴい',
  'ぴーぴー',
  'びーひん',
  'ぴーぶい',
  'ぴーぷる',
  'びーふん',
  'ぴーへん',
  'ぴーぽー',
  'ひーぽん',
  'ひいまご',
  'ぴーまん',
  'ひーめん',
  'びーめん',
  'ひーらー',
  'ぴーらー',
  'ひいらぎ',
  'ぴーらむ',
  'びーるす',
  'ひーろー',
  'ぴーろく',
  'ぴーろむ',
  'びーんず',
  'ひうつり',
  'ひえいり',
  'ひえいる',
  'ぴえーん',
  'ひえきる',
  'ひえこみ',
  'ひえこむ',
  'ひえどり',
  'ひえばら',
  'ひえびえ',
  'ひえめし',
  'ひえもの',
  'ひおうぎ',
  'ひおおい',
  'ひおおじ',
  'ひおおば',
  'びおーる',
  'びおちん',
  'ひおどし',
  'びおろん',
  'びおんか',
  'ひがいち',
  'ぴかいち',
  'ひかえめ',
  'ひがえり',
  'ひかえる',
  'びかがく',
  'ひかがみ',
  'ひかかん',
  'ひかくか',
  'ひかくき',
  'ひかげん',
  'ひがごと',
  'ひがさす',
  'ひかすう',
  'ひかぜい',
  'ひかせき',
  'びかせき',
  'びかたる',
  'ひがつく',
  'ぴかっと',
  'ぴかどん',
  'ひがのこ',
  'びかびか',
  'ぴかぴか',
  'ひかぶん',
  'ひからす',
  'ひかりか',
  'ひかりも',
  'ひかれる',
  'ひがわり',
  'ひがんえ',
  'ひかんち',
  'ひきあい',
  'ひきあう',
  'ひきあけ',
  'ひきあげ',
  'ひきあて',
  'ひきあみ',
  'ひきいる',
  'ひきうけ',
  'ひきうす',
  'ひきうま',
  'ひきかえ',
  'ひきがし',
  'ひきがね',
  'ひききる',
  'ひきぎわ',
  'ひきげき',
  'びきこう',
  'ひきこす',
  'ひきこむ',
  'ひきさく',
  'ひきさげ',
  'ひきさる',
  'ひきざん',
  'ひきしお',
  'ひきしめ',
  'ひぎしゃ',
  'ひきすう',
  'ひきずり',
  'ひきずる',
  'ひきぞめ',
  'ひきだい',
  'ひきだし',
  'ひきだす',
  'ひきたつ',
  'ひきたて',
  'ひきちゃ',
  'ひきつぎ',
  'ひきつぐ',
  'ひきつけ',
  'ひきづな',
  'ひぎつね',
  'ひきつり',
  'ひきづり',
  'ひきつる',
  'ひきどき',
  'ひきとり',
  'ひきとる',
  'びぎなー',
  'ひきなみ',
  'ひきにく',
  'ひきにげ',
  'ひきぬき',
  'ひきぬく',
  'ひきはく',
  'ひきはぐ',
  'びきびき',
  'ぴきぴき',
  'ひきひも',
  'ひきふだ',
  'ひきふね',
  'ひきまい',
  'ひきまく',
  'ひきまど',
  'ひきまゆ',
  'ひきもの',
  'ひきゃく',
  'ひぎゃく',
  'びきゃく',
  'ひきやま',
  'ひきゅう',
  'びきゅう',
  'ひきょう',
  'ひぎょう',
  'びきょう',
  'びぎょう',
  'ひきょく',
  'ひきょり',
  'ひきわけ',
  'ひきわざ',
  'ひきわた',
  'ひきわり',
  'ひくいな',
  'ぴくしー',
  'ぴくせる',
  'びくたー',
  'ぴくちゃ',
  'ひくつく',
  'びくつく',
  'びくっと',
  'ぴくっと',
  'びくにん',
  'ひくひく',
  'びくびく',
  'ぴくぴく',
  'ひくまる',
  'ぴぐみー',
  'ひくめる',
  'ひくらげ',
  'ひぐらし',
  'びくりと',
  'ぴくるす',
  'ひぐんじ',
  'ひけぎわ',
  'ひげざめ',
  'ひげそり',
  'ぴけっと',
  'ひげづら',
  'ひけどき',
  'ひげむし',
  'ひげわし',
  'ひこいし',
  'ひこうか',
  'ひこうき',
  'ひこうし',
  'ひごうし',
  'ひごうり',
  'ぴこーん',
  'ひごけん',
  'ひごしゃ',
  'ぴこっと',
  'ひごとに',
  'ひこばえ',
  'ぴこぴこ',
  'ひこふだ',
  'ひこぼし',
  'ひこまご',
  'ひごよく',
  'ひごよみ',
  'びざーる',
  'ひさいち',
  'ひざうえ',
  'ひさかき',
  'ひざかけ',
  'ひさかた',
  'ひざかな',
  'ぴざがま',
  'ひざかり',
  'ひざくら',
  'ひざげり',
  'ひさしい',
  'ひさしく',
  'ひざした',
  'ひざたけ',
  'ひざだち',
  'ひざづめ',
  'ぴざでぶ',
  'ぴざぱい',
  'ひさびさ',
  'ひさべつ',
  'ぴざまん',
  'ひざもと',
  'びさやご',
  'ひじあて',
  'ひじうち',
  'ひじかけ',
  'ひしがた',
  'ひしきじ',
  'ひしくい',
  'びしけく',
  'ひしげる',
  'びじこん',
  'ひしせん',
  'びじたー',
  'びしちぇ',
  'びしっと',
  'ぴしっと',
  'びしてき',
  'ひじてつ',
  'びじねす',
  'びしばし',
  'ひじばる',
  'ひしひし',
  'びしびし',
  'びじぶる',
  'ひじめい',
  'ひしめき',
  'ひしめく',
  'ひしもち',
  'ひしゃく',
  'びじゃく',
  'ひじゃぶ',
  'ぴじゃま',
  'ぴしゃり',
  'びしゃん',
  'ひしゅう',
  'ひじゅう',
  'びしゅう',
  'びじゅー',
  'びじゅう',
  'びじゅく',
  'ひじゅつ',
  'びじゅつ',
  'びしゅぬ',
  'ひじゅら',
  'ひじゅん',
  'ひしょう',
  'ひじょう',
  'びしょう',
  'びじょう',
  'ひしょか',
  'ひしょく',
  'びしょく',
  'ひしょち',
  'びじょん',
  'ひじりつ',
  'びじんが',
  'ぴじんご',
  'びじんゆ',
  'びずぃた',
  'ぴすきー',
  'ひすずし',
  'びすちぇ',
  'ひすとり',
  'ぴすとる',
  'びすとろ',
  'ひすとん',
  'ぴすとん',
  'ひずぼら',
  'びすます',
  'びすむす',
  'ひせいき',
  'ひせいふ',
  'びそきん',
  'びそくど',
  'ひそざい',
  'ひぞっこ',
  'ひそひそ',
  'ひそめる',
  'ひそやか',
  'びたーず',
  'ひだいか',
  'びたいち',
  'ひだえり',
  'ひたすら',
  'びたぜに',
  'びたせん',
  'ひたたき',
  'ひたたれ',
  'ひだっそ',
  'ぴたっと',
  'ぴたぱん',
  'ひたひた',
  'びたびた',
  'ぴたぴた',
  'ひたぶる',
  'ひだまり',
  'びたみん',
  'ひたむき',
  'ひためん',
  'ひだりて',
  'ひだりめ',
  'ひだるい',
  'ひだるま',
  'ぴたんこ',
  'びだんし',
  'びちけい',
  'ひちしゃ',
  'ぴちっと',
  'びちびち',
  'ぴちぴち',
  'ぴちゃり',
  'ぴちゃん',
  'ひちゅう',
  'びちゅう',
  'ひちょう',
  'ひちりき',
  'ひつあつ',
  'ひつうち',
  'ひつかい',
  'ひっかく',
  'ひっかけ',
  'ひっきー',
  'ひっきぐ',
  'ひつぐう',
  'びっくら',
  'びっくり',
  'ひっけい',
  'ぴっける',
  'ひっけん',
  'ひっこう',
  'ひっこし',
  'ひっこす',
  'ひっこみ',
  'ひっこむ',
  'ぴっころ',
  'ひっさい',
  'ひっさつ',
  'ひっさん',
  'ひっしゃ',
  'ひっしゅ',
  'ひつじゅ',
  'びっしり',
  'ひつじん',
  'ひっすい',
  'ひっすう',
  'ひっする',
  'ひっせい',
  'ひっせき',
  'ひつぜつ',
  'ひっせん',
  'ひつぜん',
  'ひっそく',
  'ひっそり',
  'ぴったし',
  'ひったつ',
  'ぴったり',
  'ひったん',
  'ひつだん',
  'びっちり',
  'ぴっちり',
  'ぴっつぁ',
  'ぴっつあ',
  'ひっつく',
  'ひっつめ',
  'ひっつり',
  'ひってき',
  'ひっとう',
  'ひつどく',
  'ひっぱい',
  'ひっぱく',
  'ひっぱぐ',
  'ひつばつ',
  'ひっぱり',
  'ひっぱる',
  'ひっぱれ',
  'ひっぴー',
  'びっぷす',
  'ひっぽう',
  'ひつぼく',
  'ひつめい',
  'ひつめつ',
  'ひつもう',
  'ひつよう',
  'ひつろく',
  'ひていご',
  'ひていわ',
  'びでおや',
  'びでこん',
  'ひでんか',
  'ひとあか',
  'ひとあし',
  'ひとあじ',
  'ひとあせ',
  'ひとあと',
  'ひとあな',
  'ひとあび',
  'ひとあめ',
  'ひとあれ',
  'ひとあわ',
  'ひといき',
  'ひといろ',
  'ひどうき',
  'ひとうけ',
  'ひとうち',
  'ひとうり',
  'ひとえに',
  'ひとおさ',
  'ひとおし',
  'ひとおじ',
  'ひとおり',
  'ひとかい',
  'ひとがき',
  'ひとかげ',
  'ひとかず',
  'ひとかた',
  'ひとかど',
  'ひとから',
  'ひとがら',
  'ひとかわ',
  'ひとぎき',
  'ひときり',
  'ひときれ',
  'ひときわ',
  'ひとくい',
  'ひとくき',
  'ひとくせ',
  'ひとくち',
  'ひとくみ',
  'ひどけい',
  'ひとけた',
  'ひとけり',
  'ひとこえ',
  'ひとごえ',
  'ひとこと',
  'ひとごと',
  'ひとこま',
  'ひとごみ',
  'ひところ',
  'ひとさし',
  'ひとざと',
  'ひとさま',
  'ひとさら',
  'ひとしい',
  'ひとしお',
  'ひとしく',
  'ひとじち',
  'ひとしな',
  'ひとじに',
  'ひとずき',
  'ひとすじ',
  'ひとすみ',
  'ひとずれ',
  'ひとぞく',
  'ひとたち',
  'ひとだち',
  'ひとたば',
  'ひとたび',
  'ひとだま',
  'ひとつき',
  'ひとづき',
  'ひとっこ',
  'ひとづて',
  'ひとつぶ',
  'ひとづま',
  'ひとつみ',
  'ひとつめ',
  'ひとつや',
  'ひとてま',
  'ひととき',
  'ひととし',
  'ひととせ',
  'ひととび',
  'ひととり',
  'ひとなか',
  'ひとなつ',
  'ひとなで',
  'ひとなみ',
  'ひとなめ',
  'ひとなれ',
  'ひとのこ',
  'ひとのみ',
  'ひとはこ',
  'ひとはた',
  'ひとはだ',
  'ひとはな',
  'ひとはば',
  'ひとはら',
  'ひとばん',
  'ひとびと',
  'ひとひら',
  'ひとびん',
  'ひとふき',
  'ひとふさ',
  'ひとふし',
  'ひとふで',
  'ひとふり',
  'ひとふろ',
  'ひとまえ',
  'ひとまき',
  'ひとまく',
  'ひとます',
  'ひとまず',
  'ひとまち',
  'ひとまね',
  'ひとむね',
  'ひとむら',
  'ひとむれ',
  'ひともし',
  'ひともじ',
  'ひともり',
  'ひとやく',
  'ひとやね',
  'ひとやま',
  'ひとよい',
  'ひとよさ',
  'ひとよせ',
  'ひとより',
  'ひとらー',
  'ひとりが',
  'ひとりご',
  'ひとりで',
  'ひとりね',
  'ひとりみ',
  'ひとるい',
  'ひなうた',
  'ひながし',
  'ひながた',
  'ひなぎく',
  'ぴなくる',
  'ひなげし',
  'ひなだん',
  'ひなどり',
  'ひなびた',
  'ひなびと',
  'ひなびる',
  'ひなぶり',
  'ひなゆり',
  'ひならず',
  'びなんし',
  'ひなんち',
  'ひなんば',
  'ひなんろ',
  'びにーる',
  'ぴにおん',
  'びにがさ',
  'ひにくや',
  'ひにくる',
  'ひにけに',
  'びにこん',
  'びにはん',
  'ひにひに',
  'びにぼん',
  'ぴにゃた',
  'ひにゅう',
  'びにゅう',
  'ひにょう',
  'びにるき',
  'びにろう',
  'びにろん',
  'ひにんぐ',
  'びねがー',
  'ひねくる',
  'ひねづけ',
  'ひねもす',
  'ひねりて',
  'ひのいり',
  'ひのうみ',
  'ひのえね',
  'ひのかみ',
  'ひのかわ',
  'ひのきか',
  'ひのきく',
  'ひのぎく',
  'ひのくに',
  'ぴのぐり',
  'ひのせい',
  'ひのたま',
  'ひのとう',
  'ひのとみ',
  'ひのとり',
  'ぴのねろ',
  'ひのばん',
  'ひのまる',
  'ひのもと',
  'びばーく',
  'ぴぱーず',
  'ぴぱーち',
  'ぴぱーつ',
  'ひはかい',
  'ひばかま',
  'ひばかり',
  'ひばくち',
  'ひばごん',
  'ひばさみ',
  'ひばしら',
  'ひはたき',
  'びはだゆ',
  'びばっぷ',
  'ひばまた',
  'ひばめし',
  'ひばらい',
  'ひひいん',
  'ひひーん',
  'ひびかす',
  'びひくる',
  'びびしい',
  'びひずす',
  'ひひぞく',
  'びびっと',
  'びびっど',
  'びびびっ',
  'びひもす',
  'ひびやき',
  'ひひょう',
  'ひびょう',
  'ひびわれ',
  'びびんば',
  'びびんぱ',
  'ぴびんぱ',
  'ひふえん',
  'びふぉあ',
  'びふぉー',
  'ひふかい',
  'ひふがん',
  'ひふくひ',
  'ひぶくれ',
  'ひぶくろ',
  'ひふせん',
  'ひぶそう',
  'びふてき',
  'ひふべん',
  'びぶりお',
  'ひへいわ',
  'ぴぺっと',
  'ぴぺりん',
  'びぼいん',
  'ぴぼっと',
  'ぴぽっと',
  'びぼでぃ',
  'ひぼろき',
  'ひぼろぎ',
  'ひましに',
  'ひましゆ',
  'びまじょ',
  'ひまじん',
  'ひまつり',
  'ひまどる',
  'ひまねた',
  'ひまひま',
  'ひまらや',
  'ひまわり',
  'ひまんじ',
  'ひみつり',
  'びみょう',
  'びみょー',
  'ひむかし',
  'ひめあり',
  'ひめいい',
  'ひめがき',
  'ひめかた',
  'ひめかみ',
  'ひめがみ',
  'ひめかわ',
  'ひめぎす',
  'ひめぎみ',
  'ひめぐも',
  'ひめくり',
  'ひめごい',
  'ひめごと',
  'ひめさま',
  'ひめだい',
  'ひめだか',
  'ひめだに',
  'ひめでん',
  'ひめのり',
  'ひめはぎ',
  'ひめはぜ',
  'ひめばち',
  'ひめはぶ',
  'ひめびし',
  'ひめます',
  'ひめまつ',
  'ひめみこ',
  'ひめみや',
  'ひめもす',
  'ひめもち',
  'ひめやか',
  'ひめゆり',
  'ぴめんと',
  'ひもかわ',
  'ひもじい',
  'ひもたい',
  'ひもつき',
  'ひもづく',
  'ひもづけ',
  'ひもとく',
  'ひもぱん',
  'ひもむし',
  'ひもろき',
  'ひもろぎ',
  'ひやあせ',
  'ひやかし',
  'ひやかす',
  'びゃくい',
  'びゃくえ',
  'ひゃくじ',
  'びゃくし',
  'ひゃくど',
  'ひゃくみ',
  'ひゃくめ',
  'びゃくや',
  'ひやざけ',
  'ひやじる',
  'びやだる',
  'ひゃっか',
  'びゃっこ',
  'ひやっと',
  'ひやとい',
  'ひやひや',
  'びやぼん',
  'びやまぐ',
  'ひやみず',
  'ひやむぎ',
  'ひやめし',
  'ひややか',
  'びゅあー',
  'ぴゅあー',
  'びゅーあ',
  'ひゅうが',
  'ひゅーず',
  'ひゅーっ',
  'ぴゅうっ',
  'ぴゅーま',
  'ぴゅーれ',
  'びゅーわ',
  'びゅーん',
  'びゅうん',
  'ぴゅーん',
  'ひゅっげ',
  'ひゅって',
  'ひゆてき',
  'ひゅどら',
  'ぴゅぴゅ',
  'ひゅれー',
  'びゅわー',
  'ひょいと',
  'ぴょいと',
  'ひょうい',
  'びょうい',
  'びょうう',
  'ひょうえ',
  'ひょうか',
  'ひょうが',
  'びょうが',
  'ひょうき',
  'ひょうぎ',
  'びょうき',
  'びょうぎ',
  'ひょうぐ',
  'びょうく',
  'ひょうご',
  'びょうご',
  'ひょうさ',
  'ひょうし',
  'ひょうじ',
  'びょうし',
  'びようし',
  'びょうじ',
  'ひょうす',
  'ひょうそ',
  'びょうち',
  'びょうで',
  'ひょうど',
  'びょうは',
  'びょうば',
  'ひょうひ',
  'ひょうび',
  'びょうぶ',
  'びょうほ',
  'びょうま',
  'ひょうむ',
  'ひょうり',
  'びょうり',
  'びよーん',
  'ぴょーん',
  'ぴょこん',
  'ひよっこ',
  'ひょっと',
  'ひよどり',
  'ひよひよ',
  'ぴよぴよ',
  'ひよめき',
  'ひよりみ',
  'ひょろい',
  'ひょろり',
  'ひよわい',
  'ひょんな',
  'ひらいり',
  'ひらうす',
  'ひらうち',
  'ひらおき',
  'ひらおち',
  'ひらおり',
  'ひらがい',
  'ひらがな',
  'ひらきど',
  'ひらぎぬ',
  'ひらくさ',
  'ひらぐも',
  'ひらける',
  'ひらごむ',
  'ひらさら',
  'ひらざら',
  'ひらしば',
  'ひらじろ',
  'ひらぞこ',
  'ひらそで',
  'ひらたい',
  'ひらたけ',
  'ひらつく',
  'ひらつぼ',
  'ひらづみ',
  'ひらづめ',
  'ぴらてす',
  'ひらどま',
  'ひらとり',
  'ひらなべ',
  'ぴらにあ',
  'ひらにざ',
  'ひらにわ',
  'ひらのみ',
  'ひらばん',
  'ひらひら',
  'びらびら',
  'ぴらぴら',
  'ひらふで',
  'ひらぶん',
  'ひらまき',
  'ひらまく',
  'ひらまさ',
  'ひらまめ',
  'ひらむし',
  'ひらめき',
  'ひらめく',
  'ひらめん',
  'ひらもん',
  'ひらやね',
  'ぴらるく',
  'ぴりおど',
  'びりおん',
  'ぴりから',
  'びりけつ',
  'びりけん',
  'ぴりじん',
  'ひりだす',
  'ひりつく',
  'ぴりつく',
  'びりっと',
  'ぴりっと',
  'ひりひり',
  'びりびり',
  'ぴりぴり',
  'ひりゅう',
  'びりゅう',
  'ひりょう',
  'びりょう',
  'びりょく',
  'ひりんく',
  'ぴりんぐ',
  'ひるいし',
  'ひるおび',
  'びるがい',
  'ひるがお',
  'びるかぜ',
  'ひるごろ',
  'ひるじん',
  'ひるすぎ',
  'ひるせき',
  'びるぜん',
  'びるだー',
  'ひるどき',
  'ひるとび',
  'ひるどら',
  'ひるなか',
  'ひるのぶ',
  'ひるはん',
  'ひるまえ',
  'びるまご',
  'ひるめし',
  'ひるめろ',
  'ひれいく',
  'ひれざけ',
  'びれそん',
  'びれぞん',
  'びれっじ',
  'びれっと',
  'ひれにく',
  'ひれふす',
  'ひろいが',
  'ひろいめ',
  'ひろいや',
  'ひろいん',
  'ひろうす',
  'びろうど',
  'ひろえん',
  'ぴろーぐ',
  'びろーど',
  'ぴろーる',
  'ひろがり',
  'ひろがる',
  'ひろくち',
  'ひろげる',
  'ひろさき',
  'びろしき',
  'ぴろしき',
  'ひろしま',
  'ひろそで',
  'ぴろてぃ',
  'ひろはば',
  'ひろびろ',
  'ぴろぴろ',
  'ひろぽん',
  'ひろまり',
  'ひろまる',
  'ひろめく',
  'ひろめる',
  'ひわいろ',
  'びわこう',
  'びわしゅ',
  'ひわたり',
  'ひわちゃ',
  'びわます',
  'ひわれる',
  'ひをふく',
  'ぴんいん',
  'ひんうつ',
  'ひんかい',
  'ひんかく',
  'びんかけ',
  'ひんがし',
  'びんがた',
  'びんかつ',
  'ひんかん',
  'ひんがん',
  'びんかん',
  'ぴんきー',
  'びんきり',
  'びんぎり',
  'ぴんきり',
  'ひんけい',
  'ひんけつ',
  'ひんこう',
  'ひんこく',
  'ひんこん',
  'びんさし',
  'びんさつ',
  'ぴんさつ',
  'ぴんさろ',
  'ひんしつ',
  'ひんじも',
  'ひんじゃ',
  'ひんしゅ',
  'びんしょ',
  'びんじょ',
  'びんずい',
  'ひんすう',
  'ひんずー',
  'ひんする',
  'びんずる',
  'ひんせい',
  'ひんせき',
  'ひんせん',
  'びんせん',
  'びんぜん',
  'ひんそう',
  'びんそぎ',
  'びんそく',
  'ぴんぞろ',
  'ひんそん',
  'びんつけ',
  'びんづめ',
  'ひんてい',
  'びんでぃ',
  'びんでん',
  'ひんとう',
  'ひんどぅ',
  'ひんどう',
  'ぴんどめ',
  'びんとろ',
  'びんなが',
  'ぴんにげ',
  'ひんぬく',
  'ひんのう',
  'びんばー',
  'ひんぱつ',
  'びんぱつ',
  'ぴんはね',
  'ひんばん',
  'ひんぱん',
  'ひんぴん',
  'びんびん',
  'ぴんぴん',
  'ひんぷん',
  'びんべん',
  'びんぼう',
  'ぴんほー',
  'ぴんぼけ',
  'ぴんぽん',
  'ひんみん',
  'ひんむく',
  'ひんめい',
  'びんめい',
  'ひんもく',
  'ひんやり',
  'ひんよう',
  'ひんよく',
  'びんらん',
  'びんろう',
  'びんわん',
  'ふぁーじ',
  'ふぁーす',
  'ふぁーむ',
  'ふぁーる',
  'ふぁいあ',
  'ふぁいと',
  'ふぁいば',
  'ふぁいぶ',
  'ふぁいや',
  'ふぁいら',
  'ふぁいる',
  'ふぁいん',
  'ふぁうな',
  'ふぁうる',
  'ふぁくす',
  'ふぁくと',
  'ふぁこむ',
  'ふぁじぃ',
  'ふぁじー',
  'ふぁすと',
  'ふぁぞむ',
  'ふあたり',
  'ぶあつい',
  'ふぁっく',
  'ふぁっじ',
  'ふぁっと',
  'ふぁっど',
  'ふぁとぅ',
  'ふぁとう',
  'ふぁとわ',
  'ふぁにー',
  'ふぁぱい',
  'ふぁぶる',
  'ふぁみり',
  'ふぁらお',
  'ふぁらど',
  'ふぁるし',
  'ふぁるす',
  'ふぁんき',
  'ふぁんく',
  'ふあんげ',
  'ふぁんご',
  'ふぁんさ',
  'ふあんし',
  'ふぁんで',
  'ふぁんど',
  'ぶいあい',
  'ぶいいー',
  'ふぃーだ',
  'ふぃーと',
  'ふぃーど',
  'ふいうち',
  'ぶいえー',
  'ぶいえす',
  'ぶいえむ',
  'ふぃぎあ',
  'ふぃくす',
  'ふぃぐす',
  'ぶいけい',
  'ふぃじー',
  'ふぃしん',
  'ふぃせる',
  'ふいっち',
  'ふぃっと',
  'ぷいっと',
  'ふぃどる',
  'ふぃなる',
  'ふぃねす',
  'ぶいびー',
  'ぶいよん',
  'ふぃらー',
  'ぶいらむ',
  'ふぃるた',
  'ふぃるむ',
  'ふいるむ',
  'ふぃれー',
  'ぶいろぐ',
  'ふぃんが',
  'ふいんき',
  'ふぃんご',
  'ふぃんち',
  'ふうあい',
  'ふうあつ',
  'ふーいず',
  'ふういん',
  'ふううん',
  'ふうえい',
  'ふうえん',
  'ふうかい',
  'ふうがい',
  'ふうかく',
  'ふうかん',
  'ふうがん',
  'ふうきり',
  'ふうきる',
  'ふうぎる',
  'ふうきん',
  'ふうけい',
  'ふうけつ',
  'ふうげつ',
  'ふうこう',
  'ふうさい',
  'ふうさつ',
  'ぶーさん',
  'ふうしが',
  'ふうじて',
  'ふうじめ',
  'ふうしゃ',
  'ふうじゃ',
  'ふうしゅ',
  'ふうじゅ',
  'ふうしょ',
  'ふうじる',
  'ふうしん',
  'ふうじん',
  'ふうすい',
  'ぶーすた',
  'ぶーすと',
  'ふうする',
  'ふうずる',
  'ふうせい',
  'ふうせつ',
  'ふうせん',
  'ふうぜん',
  'ふうそう',
  'ふうそく',
  'ふうぞく',
  'ふーぞく',
  'ふうたい',
  'ふうたく',
  'ぶーたん',
  'ふうちん',
  'ふうっと',
  'ふーっと',
  'ふうてい',
  'ふーでぃ',
  'ふうでい',
  'ふうてき',
  'ふうてん',
  'ふーてん',
  'ふうとう',
  'ふうどう',
  'ふうどき',
  'ふーどる',
  'ぷーどる',
  'ふーとん',
  'ふうばい',
  'ぷうばい',
  'ぶーびー',
  'ふぅふぅ',
  'ふうふう',
  'ふーふー',
  'ぶうぶう',
  'ぶーぶー',
  'ふーぷす',
  'ふうぶつ',
  'ふうぶん',
  'ふうぼう',
  'ふうぼく',
  'ふうもん',
  'ふうよう',
  'ふうらい',
  'ぷーりー',
  'ふうりん',
  'ふうるう',
  'ふーるー',
  'ぶーるち',
  'ふうろう',
  'ふぇあー',
  'ふぇいく',
  'ふぇいす',
  'ふぇいず',
  'ふぇいる',
  'ふぇーく',
  'ふぇーざ',
  'ふぇーす',
  'ふぇーず',
  'ふぇーど',
  'ふぇーる',
  'ふぇーん',
  'ふぇざー',
  'ふぇすた',
  'ふえだい',
  'ふえたけ',
  'ふぇっち',
  'ふぇっぷ',
  'ふぇどら',
  'ふぇにる',
  'ふぇねる',
  'ふえふき',
  'ぷえぶろ',
  'ふぇむと',
  'ふぇりー',
  'ふぇると',
  'ふぇるみ',
  'ふぇろー',
  'ふぇんす',
  'ふぉいる',
  'ふおうき',
  'ふぉーゔ',
  'ふぉーく',
  'ふぉーじ',
  'ふぉーす',
  'ふぉーど',
  'ふぉーぶ',
  'ふぉーま',
  'ふぉーむ',
  'ふぉーる',
  'ふぉーん',
  'ふぉっさ',
  'ぶおとこ',
  'ふぉとん',
  'ふぉにー',
  'ふぉにお',
  'ふぉのん',
  'ふぉぼす',
  'ふぉりお',
  'ふぉるだ',
  'ふぉるて',
  'ふぉると',
  'ふぉるむ',
  'ふぉろう',
  'ふぉろー',
  'ふぉろば',
  'ふぉんと',
  'ぶおんな',
  'ふかあお',
  'ふがーと',
  'ふかいじ',
  'ふかいど',
  'ぶがいひ',
  'ふかいり',
  'ふかおい',
  'ふかかい',
  'ふかかち',
  'ぶがかり',
  'ふかぐつ',
  'ふかけい',
  'ふかけつ',
  'ふかざけ',
  'ふかざら',
  'ふかさん',
  'ふかしぎ',
  'ふかしん',
  'ふかぜい',
  'ふかぞり',
  'ふかつか',
  'ふかって',
  'ふかづめ',
  'ふかとく',
  'ふかなべ',
  'ふかのう',
  'ふかばち',
  'ふかひれ',
  'ふかふか',
  'ふかぶか',
  'ふがふが',
  'ぶかぶか',
  'ぷかぷか',
  'ふかぶん',
  'ふかぼり',
  'ふかまる',
  'ふかめる',
  'ふかもじ',
  'ふかよみ',
  'ふかりつ',
  'ふかんず',
  'ふきあげ',
  'ふきいた',
  'ぶぎうぎ',
  'ふぎかい',
  'ふきかえ',
  'ぶきぐら',
  'ふきけす',
  'ふきげん',
  'ふきこみ',
  'ふきこむ',
  'ふきそく',
  'ふきだし',
  'ふきだす',
  'ふきつけ',
  'ふきでる',
  'ふきとぶ',
  'ふきとる',
  'ふきぬき',
  'ふきぬく',
  'ふきぬけ',
  'ふきのの',
  'ふきばり',
  'ふきふき',
  'ふきぶり',
  'ふきもの',
  'ふきやむ',
  'ふきゅう',
  'ふきょう',
  'ふぎょう',
  'ぶきょう',
  'ぶきよう',
  'ぶぎょう',
  'ふきょか',
  'ふきょく',
  'ぶきょく',
  'ふきよせ',
  'ふきりつ',
  'ふぐあい',
  'ふくあか',
  'ふくあん',
  'ふくいく',
  'ぷくいち',
  'ふくいん',
  'ふくうん',
  'ふくえき',
  'ふくえん',
  'ふくおか',
  'ふくおん',
  'ふくかく',
  'ふくがく',
  'ふくかん',
  'ふくがん',
  'ふくきん',
  'ふくくう',
  'ふくけい',
  'ふくけん',
  'ふくげん',
  'ふくこう',
  'ふくごう',
  'ふくこん',
  'ふくさい',
  'ふくざい',
  'ふくざき',
  'ふくざさ',
  'ふぐさし',
  'ふくざつ',
  'ふくしあ',
  'ふくしき',
  'ふくしく',
  'ふくしし',
  'ふくしま',
  'ふくしゃ',
  'ふぐしゃ',
  'ふくしゅ',
  'ふくじゅ',
  'ふくしょ',
  'ふくしん',
  'ふくじん',
  'ふくすい',
  'ふくすう',
  'ふくすけ',
  'ふくする',
  'ふくせい',
  'ふくぜい',
  'ふくせき',
  'ふくぜつ',
  'ふくせん',
  'ふくそう',
  'ふくぞう',
  'ふくそく',
  'ふくぞく',
  'ふくたい',
  'ふくだい',
  'ふくちじ',
  'ふくちゃ',
  'ふくつう',
  'ぷくっと',
  'ふくでん',
  'ふくとう',
  'ふくとく',
  'ふくどく',
  'ふぐどく',
  'ふくにじ',
  'ふくはい',
  'ふくばち',
  'ふくびき',
  'ぶくぶく',
  'ぷくぷく',
  'ふくぶん',
  'ふくへい',
  'ふくへき',
  'ふくへん',
  'ふくほう',
  'ふくぼく',
  'ふくぼつ',
  'ふくほん',
  'ふくまく',
  'ふくます',
  'ふくまめ',
  'ふくみみ',
  'ふくめい',
  'ふくめつ',
  'ふくめに',
  'ふくめる',
  'ふくめん',
  'ふくやく',
  'ふくよう',
  'ふくよか',
  'ふくらか',
  'ふくらく',
  'ふくらす',
  'ふくらみ',
  'ふくらむ',
  'ふくりん',
  'ふくれる',
  'ふくろう',
  'ふくろく',
  'ふくろじ',
  'ふくろち',
  'ふくろど',
  'ふけいき',
  'ふけがお',
  'ふけこむ',
  'ふけっか',
  'ふげった',
  'ふけにく',
  'ぶけもの',
  'ふけやく',
  'ふごうか',
  'ふごうき',
  'ふごうご',
  'ふこうふ',
  'ふごうり',
  'ふこくち',
  'ふさいか',
  'ぶさいく',
  'ぶざいく',
  'ふさがり',
  'ふさがる',
  'ぶさかわ',
  'ぶさきも',
  'ふさくい',
  'ふさげる',
  'ふざける',
  'ふさふさ',
  'ぶさほう',
  'ぶさめん',
  'ふさるく',
  'ふさんか',
  'ぶざんは',
  'ふしあな',
  'ふしいと',
  'ふじいろ',
  'ふしうき',
  'ふしおり',
  'ふしぎに',
  'ふじぎぬ',
  'ふしくれ',
  'ふじこう',
  'ふじごこ',
  'ふじさん',
  'ふししゃ',
  'ふしぜん',
  'ふしぞめ',
  'ふじだな',
  'ふしだら',
  'ぶしだん',
  'ふじづか',
  'ふしづけ',
  'ぶしつけ',
  'ふじつぼ',
  'ふじっり',
  'ふじづる',
  'ぶしどう',
  'ふしのき',
  'ふしのま',
  'ふじばい',
  'ふしばち',
  'ふしぶし',
  'ふしまつ',
  'ふじまめ',
  'ふじやま',
  'ふしゅう',
  'ふじゆう',
  'ふしゅく',
  'ふじゅく',
  'ふじゅつ',
  'ぶじゅつ',
  'ふしゅび',
  'ふじゅん',
  'ふしょう',
  'ふしよう',
  'ふじょう',
  'ぶしょう',
  'ふじょき',
  'ふしょく',
  'ぶじょく',
  'ふじょし',
  'ふじるし',
  'ふじんか',
  'ふしんぎ',
  'ふしんし',
  'ふじんし',
  'ふしんば',
  'ふしんび',
  'ふずいい',
  'ぶずーき',
  'ぶすかわ',
  'ぶすせん',
  'ぶすっと',
  'ぶすぶす',
  'ぷすぷす',
  'ふすぶる',
  'ふすべる',
  'ふすまえ',
  'ふせいい',
  'ふせいき',
  'ふせいし',
  'ふせいち',
  'ふせかご',
  'ふせこし',
  'ふせぜい',
  'ふせどい',
  'ふせなが',
  'ふせぬい',
  'ふせのり',
  'ふせんし',
  'ぷそいど',
  'ぶそうぐ',
  'ふぞくご',
  'ふぞくし',
  'ふそろい',
  'ふぞろい',
  'ふたあい',
  'ふたあけ',
  'ふたいか',
  'ぶたいか',
  'ふたいろ',
  'ふたおき',
  'ふたおや',
  'ふたかた',
  'ふたがり',
  'ふたがる',
  'ぶたくさ',
  'ふたくみ',
  'ふたけた',
  'ふたごご',
  'ふたござ',
  'ふたこと',
  'ぶたごや',
  'ふたしか',
  'ふだしょ',
  'ぶたじる',
  'ふたそじ',
  'ふたたば',
  'ふたたび',
  'ぶたたま',
  'ふたつき',
  'ふだつき',
  'ふたつな',
  'ふたつぶ',
  'ふたつめ',
  'ふたとき',
  'ふだどめ',
  'ぶたどん',
  'ふたなり',
  'ぶたにく',
  'ぶたねつ',
  'ぶたばこ',
  'ぶたばな',
  'ぶたばら',
  'ぶたふる',
  'ふたまた',
  'ぶたまん',
  'ぶたみそ',
  'ふたみち',
  'ふためく',
  'ぶためし',
  'ふたもじ',
  'ふたもの',
  'ふたやく',
  'ふたりめ',
  'ぶたんい',
  'ふだんぎ',
  'ふだんし',
  'ぶちあげ',
  'ふちいし',
  'ぶちうま',
  'ふちぎれ',
  'ぶちきれ',
  'ぶちぎれ',
  'ぷちきれ',
  'ぷちぎれ',
  'ぶちこむ',
  'ふちせい',
  'ぷちでぶ',
  'ふちどり',
  'ふちどる',
  'ぶちぬき',
  'ぶちぬく',
  'ぷちぷち',
  'ぷちぷら',
  'ぷちぶる',
  'ふちまい',
  'ふちゃく',
  'ふちゅう',
  'ぷちゅっ',
  'ふちょう',
  'ぶちょう',
  'ぶちるき',
  'ぶちれん',
  'ぶちわる',
  'ふついん',
  'ふつうか',
  'ふつうし',
  'ふつうじ',
  'ふつうに',
  'ふつーに',
  'ふつうわ',
  'ふつえい',
  'ぶつえん',
  'ふつおた',
  'ぶつおん',
  'ふっかー',
  'ぶっかー',
  'ふっかい',
  'ぶっかい',
  'ぶつがい',
  'ふっかく',
  'ぶっかく',
  'ぶつがく',
  'ぶっかけ',
  'ふっかつ',
  'ぶつかり',
  'ふっかる',
  'ぶつかる',
  'ふっかん',
  'ふつかん',
  'ぶっきー',
  'ぶつぎり',
  'ふっきる',
  'ぶっきる',
  'ふっきん',
  'ふづくえ',
  'ぶつくさ',
  'ふっくら',
  'ふっくり',
  'ぷっくり',
  'ふっけい',
  'ぶっけい',
  'ぶつける',
  'ふっけん',
  'ぶっけん',
  'ぶつげん',
  'ふっこう',
  'ふつごう',
  'ぶっこう',
  'ふっこく',
  'ふつこく',
  'ぶっこく',
  'ぶっこみ',
  'ぶっこむ',
  'ぶっさつ',
  'ふっさん',
  'ぶっさん',
  'ぷっしー',
  'ふっしき',
  'ふつしき',
  'ぶっしき',
  'ぶっしつ',
  'ぶっしゃ',
  'ぶっしゅ',
  'ぷっしゅ',
  'ぶっしょ',
  'ぶつじょ',
  'ふつじん',
  'ぶっしん',
  'ぶつじん',
  'ぶっせい',
  'ぶつぜい',
  'ふっせき',
  'ぶっせき',
  'ぶっせつ',
  'ふつぜん',
  'ぶつぜん',
  'ぶっそう',
  'ぶつぞう',
  'ぶっそん',
  'ふったー',
  'ぶったい',
  'ぶつだん',
  'ふつつか',
  'ぶっつけ',
  'ふっつり',
  'ぶっつり',
  'ぷっつり',
  'ぷっつん',
  'ふってい',
  'ぶってき',
  'ぶつでし',
  'ふってん',
  'ぶってん',
  'ぶつでん',
  'ぶっとい',
  'ふっとう',
  'ぶっとう',
  'ぶつどう',
  'ふつどく',
  'ぶっとく',
  'ぶっとび',
  'ふっとぶ',
  'ぶっとぶ',
  'ぶつどり',
  'ふつとん',
  'ぶつのう',
  'ぶつばち',
  'ぶつばつ',
  'ぶつばな',
  'ぶっぱん',
  'ぶっぴん',
  'ぶっぶー',
  'ぶっふぇ',
  'ふつふつ',
  'ぶつぶつ',
  'ぷつぷつ',
  'ふつぶん',
  'ふつほう',
  'ぶっぽう',
  'ぶつまく',
  'ふつまし',
  'ふつめい',
  'ぶつめい',
  'ぶつめつ',
  'ふつめん',
  'ぶつもん',
  'ふつやく',
  'ぶつよく',
  'ぶつりき',
  'ぶつれき',
  'ふであと',
  'ふていき',
  'ふていし',
  'ふでいし',
  'ふでいれ',
  'ふでかき',
  'ふでがき',
  'ふてぎわ',
  'ふでくせ',
  'ふでぐせ',
  'ふでさき',
  'ふでたて',
  'ふでづか',
  'ふでつき',
  'ふでづつ',
  'ふでばこ',
  'ふでぶと',
  'ふでぺん',
  'ふでまめ',
  'ふでもじ',
  'ふでんか',
  'ふでんき',
  'ふといと',
  'ふどうい',
  'ふどうか',
  'ぶとうか',
  'ぶどうか',
  'ふどうり',
  'ふとおり',
  'ふとがき',
  'ふとくい',
  'ふとくぎ',
  'ふところ',
  'ふとざお',
  'ふとした',
  'ふとせん',
  'ふとった',
  'ふとどき',
  'ふとばし',
  'ふとぱぱ',
  'ふとばら',
  'ふとぶえ',
  'ふとまき',
  'ふとまに',
  'ふとまゆ',
  'ふとまら',
  'ぶどまり',
  'ふとめん',
  'ふともの',
  'ふともも',
  'ふとわく',
  'ふなあし',
  'ふないた',
  'ふなうた',
  'ふなおさ',
  'ふなかげ',
  'ふなかじ',
  'ふなかた',
  'ふながた',
  'ふながも',
  'ふなぐら',
  'ふなけん',
  'ふなごや',
  'ぶなざい',
  'ふなずし',
  'ふなそこ',
  'ふなぞこ',
  'ふなだな',
  'ふなたび',
  'ふなだま',
  'ふなちん',
  'ふなづみ',
  'ふなづり',
  'ふなどこ',
  'ふなどめ',
  'ふなぬし',
  'ぶなのき',
  'ふなのり',
  'ふなはし',
  'ふなばし',
  'ふなばた',
  'ふなばら',
  'ぶなぴー',
  'ふなびと',
  'ふなびん',
  'ふなべり',
  'ふなまち',
  'ふなむし',
  'ふなもり',
  'ふなやど',
  'ふなよい',
  'ふにあい',
  'ふにふに',
  'ぷにぷに',
  'ふにゃっ',
  'ふにゃり',
  'ふにゅう',
  'ふにょい',
  'ふにょう',
  'ぶにょう',
  'ふにんか',
  'ふにんき',
  'ふにんち',
  'ふぬける',
  'ぷねうま',
  'ふねがい',
  'ふねだこ',
  'ふねづり',
  'ふねへん',
  'ふのすう',
  'ふばらい',
  'ぶばらい',
  'ふびじん',
  'ぶひぶひ',
  'ふひょう',
  'ふふごう',
  'ぶぶぜら',
  'ぶぶづけ',
  'ふふほと',
  'ぶぶんご',
  'ぶぶんわ',
  'ぶべつご',
  'ふへんか',
  'ふほうわ',
  'ふぼかい',
  'ふほんい',
  'ふまえる',
  'ふまじめ',
  'ふまんげ',
  'ふみあげ',
  'ふみあと',
  'ふみいし',
  'ふみいた',
  'ふみきり',
  'ふみきる',
  'ふみけす',
  'ふみこう',
  'ふみこす',
  'ふみこみ',
  'ふみこむ',
  'ふみだい',
  'ふみだし',
  'ふみだす',
  'ふみだん',
  'ふみつぎ',
  'ふみづき',
  'ふみづら',
  'ふみぬく',
  'ふみばこ',
  'ふみひと',
  'ふみびと',
  'ふみふみ',
  'ふみめん',
  'ふみもち',
  'ふみわる',
  'ふむふむ',
  'ふめいよ',
  'ふめくり',
  'ふもーる',
  'ふやかす',
  'ふやける',
  'ふゅーぐ',
  'ふゅーず',
  'ふゅえる',
  'ふゆかい',
  'ふゆがた',
  'ふゆがれ',
  'ふゆぎく',
  'ふゆぎり',
  'ふゆごし',
  'ふゆさく',
  'ふゆしば',
  'ふゆぞら',
  'ふゆどり',
  'ふゆねぎ',
  'ふゆばら',
  'ふゆふく',
  'ふゆむき',
  'ふゆめく',
  'ふゆもの',
  'ふゆやま',
  'ふようい',
  'ぶようか',
  'ふようど',
  'ぶよぶよ',
  'ぷよぷよ',
  'ぷらーく',
  'ぷらーぐ',
  'ぷらーざ',
  'ぶらーた',
  'ぷらーな',
  'ぷらいあ',
  'ふらいす',
  'ふらいず',
  'ぷらいす',
  'ぷらいず',
  'ふらいと',
  'ふらいど',
  'ぶらいど',
  'ぷらいど',
  'ぶらいは',
  'ぷらいむ',
  'ぷらいや',
  'ぶらいん',
  'ぶらうざ',
  'ぶらうす',
  'ぶらうず',
  'ぶらうん',
  'ぶらくら',
  'ぷらごみ',
  'ぶらこん',
  'ぷらこん',
  'ぶらざー',
  'ぶらじる',
  'ふらすこ',
  'ぷらすた',
  'ぶらすと',
  'ぷらずま',
  'ぷらせぼ',
  'ぶらせら',
  'ふらせる',
  'ぷらたー',
  'ぷらだん',
  'ぷらちな',
  'ふらつき',
  'ふらつく',
  'ふらっぐ',
  'ぶらっく',
  'ぶらつく',
  'ぷらった',
  'ぷらっつ',
  'ふらっと',
  'ふらっど',
  'ぶらっと',
  'ぶらっど',
  'ふらっぷ',
  'ふらっぺ',
  'ぷらてぃ',
  'ぷらてん',
  'ぷらとー',
  'ふらにご',
  'ぷらぬら',
  'ぶらばん',
  'ぷらばん',
  'ふらびん',
  'ふらふら',
  'ぶらぶら',
  'ぶらぼー',
  'ふらぼん',
  'ぷらまい',
  'ふらまぐ',
  'ふらまん',
  'ぶらもの',
  'ぷららん',
  'ぷらりぬ',
  'ぷらりね',
  'ふられる',
  'ふらわー',
  'ふらんき',
  'ふらんく',
  'ぶらんく',
  'ぶらんこ',
  'ふらんじ',
  'ふらんす',
  'ふらんせ',
  'ぶらんち',
  'ぶらんで',
  'ぶらんど',
  'ぷらんと',
  'ふらんべ',
  'ふりあー',
  'ふりあい',
  'ふりあう',
  'ぶりーゔ',
  'ふりーく',
  'ふりーす',
  'ふりーず',
  'ぶりーず',
  'ぷりーず',
  'ぶりーち',
  'ぷりーつ',
  'ぶりーと',
  'ぶりーど',
  'ぶりーふ',
  'ふりーま',
  'ふりえき',
  'ぷりおん',
  'ふりかえ',
  'ふりかけ',
  'ふりかた',
  'ふりがな',
  'ふりきる',
  'ぷりくら',
  'ぷりけつ',
  'ふりこう',
  'ふりこみ',
  'ふりこむ',
  'ふりしく',
  'ぶりすけ',
  'ぷりずむ',
  'ぷりずん',
  'ふりそで',
  'ふりだし',
  'ふりだす',
  'ふりちん',
  'ふりっか',
  'ふりっく',
  'ぶりっぐ',
  'ふりつけ',
  'ぶりっこ',
  'ぶりっじ',
  'ぶりっつ',
  'ふりっぷ',
  'ぷりてぃ',
  'ふりてん',
  'ぶりてん',
  'ぶりとー',
  'ふりにげ',
  'ぶりぬい',
  'ふりはば',
  'ふりふり',
  'ぶりぶり',
  'ぷりぷり',
  'ぷりぷろ',
  'ふりまく',
  'ふりむく',
  'ぷりむら',
  'ぶりゃく',
  'ふりやむ',
  'ふりゅう',
  'ぶりゅー',
  'ふりょう',
  'ぶりょう',
  'ふりょく',
  'ぶりょく',
  'ふりわけ',
  'ぶりんく',
  'ふりんじ',
  'ぷりんす',
  'ぷりんた',
  'ぶりんつ',
  'ふりんと',
  'ぷりんと',
  'ふるあと',
  'ふるいえ',
  'ふるいけ',
  'ふるいど',
  'ぷるーく',
  'ぶるーす',
  'ぶるーず',
  'ふるうた',
  'ぶるーた',
  'ふるーつ',
  'ぶるーて',
  'ふるーと',
  'ふるーど',
  'ぷるーふ',
  'ぶるーむ',
  'ぷるーむ',
  'ふるーれ',
  'ぷるーん',
  'ふるえる',
  'ふるがお',
  'ふるがね',
  'ふるかぶ',
  'ふるかわ',
  'ふるきず',
  'ぶるきに',
  'ふるぎや',
  'ふるぎれ',
  'ぶるぐあ',
  'ふるくさ',
  'ふるぐつ',
  'ぶるぐる',
  'ふるける',
  'ぷるこぎ',
  'ふるごめ',
  'ふるざけ',
  'ふるさと',
  'ぶるしん',
  'ぶるせら',
  'ぶるぞん',
  'ぷるたぶ',
  'ふるちん',
  'ぶるっく',
  'ふるづけ',
  'ふるった',
  'ふるって',
  'ぶるっと',
  'ふるてつ',
  'ふるでら',
  'ふるとし',
  'ふるとり',
  'ぶるとれ',
  'ぶるねい',
  'ふるのり',
  'ふるぱす',
  'ふるびと',
  'ふるびる',
  'ぷるぶい',
  'ふるふく',
  'ふるふる',
  'ぶるぶる',
  'ぷるぷる',
  'ぶるぺん',
  'ふるほん',
  'ふるぼん',
  'ぶるまー',
  'ふるまい',
  'ふるまう',
  'ふるみち',
  'ふるもの',
  'ぶるるん',
  'ぷるれす',
  'ふるわす',
  'ぶるんじ',
  'ふれあー',
  'ふれあい',
  'ふれあう',
  'ぶれいゔ',
  'ぶれいく',
  'ぶれいず',
  'ぷれいす',
  'ふれいと',
  'ぶれいど',
  'ふれいば',
  'ぶれいぶ',
  'ぷれいや',
  'ふれいる',
  'ぶれいん',
  'ぷれいん',
  'ぶれーゔ',
  'ぶれーか',
  'ぶれーき',
  'ふれーく',
  'ぶれーく',
  'ふれーず',
  'ぶれーす',
  'ぷれーす',
  'ふれーと',
  'ぶれーど',
  'ぷれーと',
  'ふれーば',
  'ぶれーぶ',
  'ふれーま',
  'ふれーむ',
  'ぷれーや',
  'ぶれーん',
  'ぷれーん',
  'ふれおん',
  'ふれがき',
  'ぷれきん',
  'ふれこみ',
  'ふれこむ',
  'ふれこん',
  'ぶれざー',
  'ぷれじゃ',
  'ぷれすき',
  'ふれすこ',
  'ぷれすこ',
  'ふれすた',
  'ぶれすと',
  'ぷれすと',
  'ぷれぜん',
  'ぷれっじ',
  'ふれっと',
  'ぶれっど',
  'ぷれっぷ',
  'ふれとり',
  'ふれはば',
  'ぷれぱぱ',
  'ぷれはぶ',
  'ぷれぶす',
  'ぷれふら',
  'ふれぶる',
  'ぷれまま',
  'ぷれみあ',
  'ぷれみす',
  'ふれんず',
  'ふれんち',
  'ふれんど',
  'ぶれんど',
  'ふろあー',
  'ぶろあー',
  'ぷろあま',
  'ふろうじ',
  'ぶろーか',
  'ぶろーぐ',
  'ふろおけ',
  'ぷろーず',
  'ぶろーち',
  'ふろーと',
  'ぶろーど',
  'ぷろーぶ',
  'ふろーら',
  'ぷろーん',
  'ぶろがー',
  'ぶろかい',
  'ふろがま',
  'ぷろきし',
  'ぷろくし',
  'ぶろぐる',
  'ぷろぐれ',
  'ぶろこり',
  'ぷろしあ',
  'ふろしき',
  'ぷろしゃ',
  'ふろすと',
  'ぷろせす',
  'ふろだい',
  'ふろっく',
  'ふろっぐ',
  'ぶろっく',
  'ぶろっす',
  'ぷろった',
  'ぷろっと',
  'ふろっぴ',
  'ぶろっぶ',
  'ぷろっぷ',
  'ぷろとん',
  'ぷろぱー',
  'ぷろはん',
  'ぷろぱん',
  'ぷろぴる',
  'ふろふき',
  'ふろふた',
  'ぷろぺら',
  'ぷろぼの',
  'ぷろまね',
  'ふろみず',
  'ぷろみす',
  'ぷろみん',
  'ふろりだ',
  'ふろりん',
  'ぷろりん',
  'ぷろれす',
  'ぷろろぐ',
  'ぶろわー',
  'ぶろんず',
  'ふろんと',
  'ぶろんど',
  'ふろんり',
  'ふわーと',
  'ふわたり',
  'ふわっと',
  'ふわふわ',
  'ぶわぶわ',
  'ふわもこ',
  'ふをつく',
  'ぶをねる',
  'ぶんあん',
  'ふんいき',
  'ぶんいん',
  'ふんうん',
  'ぶんうん',
  'ふんえい',
  'ぶんえい',
  'ふんえん',
  'ぶんえん',
  'ぶんおう',
  'ふんかい',
  'ふんがい',
  'ぶんかい',
  'ぶんがい',
  'ぶんかく',
  'ぶんがく',
  'ぶんかし',
  'ぶんかつ',
  'ぶんかふ',
  'ふんかん',
  'ぶんかん',
  'ぶんきき',
  'ぶんぎき',
  'ふんぎり',
  'ぶんきろ',
  'ふんけい',
  'ぶんけい',
  'ぶんげい',
  'ふんげき',
  'ぶんけつ',
  'ぶんげつ',
  'ぶんけん',
  'ぶんげん',
  'ふんこう',
  'ふんごう',
  'ぶんこう',
  'ぶんごう',
  'ぶんこか',
  'ぶんこつ',
  'ふんさい',
  'ふんざい',
  'ぶんさい',
  'ぶんざい',
  'ぶんさつ',
  'ぶんさん',
  'ふんしつ',
  'ぶんしつ',
  'ふんしゃ',
  'ぶんしゃ',
  'ふんしゅ',
  'ぶんしゅ',
  'ぷんしゅ',
  'ふんしょ',
  'ぶんしょ',
  'ぶんじょ',
  'ふんしん',
  'ふんじん',
  'ぶんしん',
  'ぶんじん',
  'ふんすい',
  'ぶんすう',
  'ぷんすか',
  'ふんする',
  'ふんせい',
  'ぶんせい',
  'ふんせき',
  'ぶんせき',
  'ぶんせつ',
  'ふんせん',
  'ふんぜん',
  'ぶんせん',
  'ふんそう',
  'ぶんそう',
  'ふんそく',
  'ふんぞく',
  'ふんたい',
  'ぶんたい',
  'ぶんだい',
  'ぶんだけ',
  'ふんたん',
  'ふんだん',
  'ぶんたん',
  'ぶんだん',
  'ぶんちん',
  'ぶんつう',
  'ぶんてつ',
  'ぶんてん',
  'ふんとう',
  'ふんどう',
  'ぶんとう',
  'ぶんどう',
  'ぶんどき',
  'ふんどし',
  'ぶんどり',
  'ぶんどる',
  'ふんどん',
  'ぶんとん',
  'ぶんなん',
  'ぶんのう',
  'ぶんばい',
  'ぶんぱい',
  'ふんばえ',
  'ぶんぱき',
  'ぶんはく',
  'ふんぱつ',
  'ふんばり',
  'ふんばる',
  'ふんぱん',
  'ぶんぱん',
  'ぶんぴつ',
  'ぶんぷず',
  'ぶんぶつ',
  'ふんふん',
  'ふんぷん',
  'ぶんぶん',
  'ぷんぷん',
  'ぶんべい',
  'ふんぺき',
  'ふんべつ',
  'ぶんべつ',
  'ふんべん',
  'ぶんべん',
  'ぶんぽう',
  'ぶんぼし',
  'ふんぽん',
  'ぶんまき',
  'ふんまつ',
  'ぶんまつ',
  'ふんまん',
  'ぶんみん',
  'ふんむき',
  'ふんむす',
  'ぶんめい',
  'ぶんめん',
  'ふんもん',
  'ぶんゆう',
  'ぶんらく',
  'ふんらん',
  'ぶんらん',
  'ぶんりか',
  'ぶんりき',
  'ぶんりし',
  'ぶんりつ',
  'ぶんりは',
  'ぶんりふ',
  'ふんりん',
  'ぶんりん',
  'ぶんるい',
  'ふんれい',
  'ぶんれい',
  'ぶんれつ',
  'ぶんろく',
  'ふんわり',
  'へあがる',
  'へあけあ',
  'へあごむ',
  'へあだい',
  'へあぴん',
  'へいあり',
  'へいあん',
  'へいいか',
  'へいいき',
  'へいいん',
  'へいえい',
  'べいえい',
  'へいえき',
  'へいえん',
  'べいえん',
  'べいおう',
  'ぺいおふ',
  'へいおん',
  'へいかい',
  'へいがい',
  'へいかく',
  'へいがく',
  'へいかつ',
  'べいかぶ',
  'べいがわ',
  'へいかん',
  'へいがん',
  'べいかん',
  'ぺいかん',
  'へいきこ',
  'へいきで',
  'へいきょ',
  'へいきん',
  'へいぎん',
  'べいぎん',
  'へいぐし',
  'べいぐん',
  'へいけい',
  'へいげい',
  'へいけん',
  'へいげん',
  'へいこう',
  'へいごう',
  'べいこく',
  'へいごし',
  'べいごま',
  'べいこん',
  'へいさい',
  'べいざい',
  'へいさく',
  'べいさく',
  'へいさつ',
  'へいざん',
  'べいさん',
  'へいしき',
  'べいしき',
  'へいじつ',
  'へいしゃ',
  'へいしゅ',
  'べいじゅ',
  'へいしょ',
  'へいしん',
  'へいじん',
  'べいしん',
  'べいじん',
  'へいすい',
  'へいすう',
  'べいすぎ',
  'へいすと',
  'べいすん',
  'へいせい',
  'へいぜい',
  'へいせき',
  'へいせつ',
  'へいせん',
  'へいぜん',
  'べいせん',
  'へいそう',
  'へいそく',
  'へいぞく',
  'べいぞく',
  'へいそつ',
  'へいそは',
  'へいそん',
  'へいぞん',
  'へいたー',
  'へいたい',
  'へいたん',
  'へいだん',
  'べいだん',
  'ぺいちん',
  'べいつぼ',
  'へいてい',
  'べいてい',
  'ぺいでー',
  'へいてん',
  'へいでん',
  'へいどく',
  'べいどく',
  'べいどる',
  'へいどん',
  'べいとん',
  'へいなん',
  'へいねつ',
  'へいねん',
  'へいのう',
  'ぺいぱー',
  'へいばい',
  'ぺいぱい',
  'へいはく',
  'べいばく',
  'へいはつ',
  'へいはん',
  'へいばん',
  'べいはん',
  'べいばん',
  'べいびー',
  'へいふう',
  'へいふく',
  'べいふつ',
  'へいぶん',
  'べいふん',
  'へいへい',
  'へいべい',
  'べいへい',
  'ぺいぺい',
  'へいへん',
  'へいほう',
  'へいぼん',
  'へいまく',
  'べいまつ',
  'へいみん',
  'へいめい',
  'へいめん',
  'べいめん',
  'へいもつ',
  'へいもん',
  'へいゆう',
  'へいよう',
  'へいらん',
  'へいりつ',
  'べいるり',
  'へいれつ',
  'へいろく',
  'へいわり',
  'ぺいんと',
  'べーぐる',
  'べえごま',
  'べーごま',
  'べーこん',
  'ぺーじゃ',
  'べーじゅ',
  'ぺーすと',
  'へーぜる',
  'ぺーそす',
  'べーたー',
  'べーたは',
  'ぺーちか',
  'ぺーちゃ',
  'ぺーはー',
  'ぺーぱー',
  'べーびー',
  'ぺえぺえ',
  'ぺーぺー',
  'へーらー',
  'べーらむ',
  'ぺーろん',
  'ぺがさす',
  'ぺがすす',
  'ぺがそす',
  'べかぶね',
  'べからず',
  'へぎいた',
  'へきうん',
  'へきえき',
  'へきえん',
  'へきかい',
  'へきかん',
  'へきがん',
  'へきくう',
  'へきぐう',
  'へきけん',
  'へきげん',
  'べきこん',
  'へきざい',
  'へきさん',
  'へきざん',
  'へきしょ',
  'へきすい',
  'へきすう',
  'べきすう',
  'へきする',
  'へきせつ',
  'へきそん',
  'へきとう',
  'へきへき',
  'べきべき',
  'へきめん',
  'へきゆう',
  'へきりつ',
  'べきれい',
  'へきれき',
  'へきろん',
  'ぺぎんぐ',
  'ぺきんご',
  'べくして',
  'べくたー',
  'ぺくちん',
  'べくとる',
  'べくはい',
  'べくれる',
  'ぺけひん',
  'へこあゆ',
  'へこおび',
  'べごにあ',
  'へこへこ',
  'べこべこ',
  'ぺこぺこ',
  'へこます',
  'ぺこりん',
  'ぺころす',
  'ぺざんて',
  'ぺざんと',
  'へしあう',
  'へしおる',
  'へしこむ',
  'へじゃぶ',
  'ぺすとう',
  'ぺすとる',
  'べすぽじ',
  'へずぼら',
  'へそくり',
  'へそのお',
  'べたあし',
  'へたいら',
  'べたうち',
  'へたうま',
  'へたえら',
  'べたおり',
  'べたきじ',
  'へたくそ',
  'べたぐみ',
  'へだたり',
  'へだたる',
  'べたつく',
  'べたっと',
  'へたっぴ',
  'へだてる',
  'べたぬり',
  'へたばる',
  'べたふみ',
  'べたぶみ',
  'へたへた',
  'べたべた',
  'ぺたぺた',
  'べたほめ',
  'べたぼめ',
  'べたぼれ',
  'べたまけ',
  'べたやき',
  'べたゆき',
  'へたれる',
  'ぺたんく',
  'べたんこ',
  'ぺたんこ',
  'ぺだんと',
  'べちだん',
  'へちょう',
  'べつあか',
  'べついん',
  'べつうり',
  'べつえん',
  'べっかく',
  'べつがく',
  'べっかん',
  'べっきょ',
  'べつぐう',
  'べつくち',
  'べっけい',
  'べっけん',
  'べつげん',
  'べっこう',
  'べつごう',
  'べっこん',
  'べっさつ',
  'べっしつ',
  'べっして',
  'べっしゅ',
  'へっしょ',
  'べっしょ',
  'べつじん',
  'べつずり',
  'べっせい',
  'べっせき',
  'べっそう',
  'べつぞめ',
  'へっだー',
  'べったい',
  'べったく',
  'べったこ',
  'べつだて',
  'べったり',
  'ぺったり',
  'べったん',
  'べつだん',
  'ぺったん',
  'べっちん',
  'へっつい',
  'べってい',
  'べってん',
  'べつでん',
  'べっとう',
  'べつどう',
  'ぺっとや',
  'べっとり',
  'べつなく',
  'べつにん',
  'べつのう',
  'ぺっぱー',
  'べつばい',
  'べっぱい',
  'べつばら',
  'へっぴり',
  'べつびん',
  'べっぴん',
  'べっぷう',
  'べつべつ',
  'ぺっぺっ',
  'べつへや',
  'べつべや',
  'べっぽう',
  'へっぽこ',
  'へつぽつ',
  'べつむね',
  'べつめい',
  'べつもの',
  'べつやく',
  'べつよう',
  'へつらい',
  'へつらう',
  'べつわく',
  'べてらん',
  'べでらん',
  'ぺてんし',
  'べとこん',
  'べとつく',
  'べとなむ',
  'へどばん',
  'へとへと',
  'べとべと',
  'べとみん',
  'へどもど',
  'へなつち',
  'へなへな',
  'ぺなんと',
  'べにあか',
  'べにいも',
  'べにいろ',
  'べにうめ',
  'べにがい',
  'べにがら',
  'べにざけ',
  'べにしだ',
  'べにたけ',
  'べにたで',
  'べにづる',
  'べにはぜ',
  'べにはな',
  'べにばな',
  'ぺにばん',
  'べにひわ',
  'べにふで',
  'べにます',
  'べにゆき',
  'べねちあ',
  'べのたみ',
  'ぺぱくら',
  'へぱりん',
  'ぺぱろに',
  'ぺぴーの',
  'へびうり',
  'へびがら',
  'へびがわ',
  'へびざけ',
  'へびぜめ',
  'へびどく',
  'へびどし',
  'へびめた',
  'へびろて',
  'ぺぷしん',
  'へぷたん',
  'ぺぷちど',
  'ぺぷとん',
  'へぶらい',
  'ぺぷらむ',
  'ぺへれい',
  'へべれけ',
  'へみおら',
  'ぺみかん',
  'へむてつ',
  'へめぐる',
  'へやがた',
  'へやずみ',
  'へやだい',
  'へやのみ',
  'へやばき',
  'へやぼし',
  'へやもち',
  'へやわり',
  'ぺよーて',
  'ぺらがみ',
  'ぺらぐら',
  'へらさぎ',
  'へらざめ',
  'へらじか',
  'へらしめ',
  'ぺらっと',
  'へらぶな',
  'へらへら',
  'べらべら',
  'ぺらぺら',
  'べらぼう',
  'べらぼー',
  'へらるど',
  'べらんだ',
  'へりいし',
  'べりーず',
  'べりーぬ',
  'べりーん',
  'へりうむ',
  'へりおす',
  'へりかる',
  'ぺりかん',
  'へりくつ',
  'べりしょ',
  'べりずも',
  'へりつき',
  'ぺりっと',
  'へりてれ',
  'へりとり',
  'べりべり',
  'ぺりぺり',
  'べるーが',
  'べるがた',
  'べるぎー',
  'べるくろ',
  'ぺるしあ',
  'へるしー',
  'ぺるしゃ',
  'べるすた',
  'べるせき',
  'ぺるそな',
  'べるでほ',
  'べるとも',
  'へるにあ',
  'へるぱー',
  'へるぺす',
  'べるまひ',
  'ぺるむき',
  'へるめす',
  'べるりん',
  'ぺれっと',
  'へれねす',
  'へろいん',
  'べろーず',
  'べろきす',
  'べろっと',
  'ぺろっと',
  'へろへろ',
  'べろべろ',
  'ぺろぺろ',
  'へをこく',
  'へをひる',
  'へんあい',
  'へんあつ',
  'へんいき',
  'ぺんいれ',
  'へんうん',
  'へんえい',
  'へんえき',
  'べんえき',
  'へんえん',
  'へんかい',
  'べんかい',
  'へんがお',
  'ぺんがき',
  'へんかく',
  'へんがく',
  'べんがく',
  'ぺんがた',
  'べんがら',
  'へんかん',
  'へんがん',
  'べんかん',
  'ぺんきえ',
  'ぺんきや',
  'へんきん',
  'ぺんぎん',
  'へんくつ',
  'へんけい',
  'べんけい',
  'へんけん',
  'へんげん',
  'へんこう',
  'べんこう',
  'へんごく',
  'べんごし',
  'へんさい',
  'へんざい',
  'べんさい',
  'べんざい',
  'ぺんさき',
  'へんさち',
  'ぺんざら',
  'へんさん',
  'ぺんじく',
  'へんしつ',
  'へんしゃ',
  'へんじゃ',
  'べんしゃ',
  'へんしゅ',
  'へんしょ',
  'べんじょ',
  'へんじる',
  'べんじる',
  'ぺんしる',
  'へんしん',
  'へんじん',
  'べんじん',
  'へんすう',
  'へんする',
  'へんずる',
  'べんずる',
  'へんせい',
  'へんせつ',
  'べんぜつ',
  'へんせん',
  'べんぜん',
  'へんそう',
  'へんぞう',
  'べんそう',
  'へんそく',
  'べんだー',
  'へんたい',
  'ぺんだこ',
  'べんたつ',
  'ぺんたて',
  'ぺんたん',
  'べんちゃ',
  'へんちょ',
  'へんつう',
  'べんつう',
  'べんつぼ',
  'べんてぃ',
  'へんてこ',
  'へんてつ',
  'へんでり',
  'へんてん',
  'へんでん',
  'べんてん',
  'べんでん',
  'へんとう',
  'へんどう',
  'べんとう',
  'べんとす',
  'べんなん',
  'べんねい',
  'へんねん',
  'へんのう',
  'へんばい',
  'へんぱい',
  'べんばく',
  'べんぱく',
  'べんぱつ',
  'ぺんぱる',
  'へんぴん',
  'へんぷく',
  'べんぷく',
  'へんぶつ',
  'へんぶん',
  'へんぺい',
  'へんぺき',
  'べんべつ',
  'べんべら',
  'へんぺん',
  'べんべん',
  'ぺんぺん',
  'へんぼう',
  'へんぽう',
  'べんぽう',
  'へんぽん',
  'べんまく',
  'へんめい',
  'べんめい',
  'べんもう',
  'へんやく',
  'へんよう',
  'へんよく',
  'へんらん',
  'べんらん',
  'へんりー',
  'べんりさ',
  'べんりし',
  'べんりや',
  'へんりん',
  'へんれい',
  'べんれい',
  'へんれき',
  'べんろん',
  'ほあかり',
  'ぽあそん',
  'ほあちん',
  'ほあぱい',
  'ほあんか',
  'ほあんぶ',
  'ほいーる',
  'ほいかご',
  'ぽいかつ',
  'ほいきた',
  'ほいくき',
  'ほいくし',
  'ほいすか',
  'ぽいすて',
  'ほいすと',
  'ぽいする',
  'ぽいずん',
  'ほいそつ',
  'ぼいちゃ',
  'ほいっぷ',
  'ぼいっぷ',
  'ほいっぽ',
  'ほいとう',
  'ぼいとれ',
  'ほいない',
  'ほいほい',
  'ぽいぽい',
  'ぼいらー',
  'ほいりげ',
  'ぼいるど',
  'ぼいるゆ',
  'ほいんし',
  'ぽいんた',
  'ぽいんと',
  'ぼうあく',
  'ぼうあつ',
  'ぼうあめ',
  'ほうあん',
  'ほういき',
  'ほういつ',
  'ほういん',
  'ぼういん',
  'ほうえい',
  'ぼうえい',
  'ほうえき',
  'ぼうえき',
  'ほうえつ',
  'ほうえん',
  'ぼうえん',
  'ほうおう',
  'ぼうおく',
  'ほうおん',
  'ぼうおん',
  'ほうかい',
  'ほうがい',
  'ぼうがい',
  'ほうがき',
  'ほうかく',
  'ほうがく',
  'ほうかご',
  'ほうかつ',
  'ぼうかど',
  'ぼうかび',
  'ほうかま',
  'ぼうかめ',
  'ほうかん',
  'ほうがん',
  'ぼうかん',
  'ぼうがん',
  'ほうきぎ',
  'ほうぎょ',
  'ぼうきょ',
  'ぼうぎょ',
  'ぼうきれ',
  'ぼうぎれ',
  'ほうきん',
  'ほうぎん',
  'ぼうきん',
  'ぼうぐい',
  'ぼうくう',
  'ほうくつ',
  'ぼうぐみ',
  'ぼうくん',
  'ほうけい',
  'ほうげい',
  'ぼうけい',
  'ほうげき',
  'ぼうげつ',
  'ほうける',
  'ほうけん',
  'ほうげん',
  'ぼうけん',
  'ぼうげん',
  'ほうこう',
  'ほうごう',
  'ぼうこう',
  'ほうこく',
  'ぼうこく',
  'ほうこつ',
  'ほうこん',
  'ぼうこん',
  'ほうざい',
  'ぼうさい',
  'ぼうざい',
  'ぼうさき',
  'ほうさく',
  'ぼうさつ',
  'ほうさん',
  'ぼうさん',
  'ほうしき',
  'ほうじし',
  'ぼうしつ',
  'ぼうじつ',
  'ぼうじま',
  'ほうしめ',
  'ほうしゃ',
  'ぼうしゃ',
  'ぼうしや',
  'ほうしゅ',
  'ほうじゅ',
  'ぼうしゅ',
  'ぼうじゅ',
  'ほうしょ',
  'ほうじょ',
  'ぼうしょ',
  'ぼうじょ',
  'ほうじる',
  'ほうしん',
  'ほうじん',
  'ぼうしん',
  'ぼうじん',
  'ほうすい',
  'ぼうすい',
  'ほうすう',
  'ほうずき',
  'ほうする',
  'ほうずる',
  'ほうすん',
  'ほうせい',
  'ぼうせい',
  'ほうせき',
  'ぼうせき',
  'ほうせつ',
  'ぼうせつ',
  'ほうせん',
  'ほうぜん',
  'ぼうせん',
  'ぼうぜん',
  'ほうそう',
  'ほうぞう',
  'ぼうそう',
  'ほうそく',
  'ぼうそつ',
  'ぼうそふ',
  'ほうたい',
  'ほうだい',
  'ぼうたい',
  'ぼうだい',
  'ぼうだち',
  'ほうだて',
  'ぼうだに',
  'ぼうだま',
  'ぼうだら',
  'ほうたん',
  'ほうだん',
  'ぼうたん',
  'ぼうだん',
  'ほうちき',
  'ほうちく',
  'ぼうちゃ',
  'ほうづえ',
  'ぼうつき',
  'ほうっと',
  'ぼうっと',
  'ぽうっと',
  'ほうてい',
  'ぼうてい',
  'ほうてき',
  'ぼうてき',
  'ほうてん',
  'ほうでん',
  'ぼうてん',
  'ほうとう',
  'ほうどう',
  'ぼうとう',
  'ぼうどう',
  'ほうとく',
  'ほうどく',
  'ぼうとく',
  'ぼうどく',
  'ほうなん',
  'ほうにち',
  'ほうにん',
  'ほうねつ',
  'ぼうねつ',
  'ほうねん',
  'ぼうねん',
  'ほうのう',
  'ほうのき',
  'ほうはい',
  'ほうばい',
  'ぼうはい',
  'ぼうばい',
  'ほうはく',
  'ぼうはく',
  'ぼうばく',
  'ぼうはち',
  'ほうはつ',
  'ぼうはつ',
  'ぼうばり',
  'ほうばる',
  'ぼうはん',
  'ぼうびき',
  'ほうひん',
  'ほうびん',
  'ぼうふう',
  'ほうふく',
  'ほうふつ',
  'ぼうふら',
  'ぼうぶら',
  'ぼうふり',
  'ほうぶる',
  'ほうふん',
  'ほうぶん',
  'ぼうふん',
  'ほうへい',
  'ほうべい',
  'ぼうへき',
  'ぼうべに',
  'ほうへん',
  'ほうべん',
  'ぼうへん',
  'ぼうべん',
  'ほうほう',
  'ほうぼう',
  'ぼうぼう',
  'ほうぼく',
  'ぼうまい',
  'ほうまく',
  'ほうまつ',
  'ぼうまつ',
  'ほうまん',
  'ぼうまん',
  'ぼうみん',
  'ほうむず',
  'ほうむぶ',
  'ほうむり',
  'ほうむる',
  'ほうめい',
  'ぼうめい',
  'ほうめん',
  'ほうもう',
  'ぼうもう',
  'ほうもち',
  'ほうもつ',
  'ほうもん',
  'ぼうもん',
  'ほうやく',
  'ほうゆう',
  'ぼうゆう',
  'ほうよう',
  'ぼうよう',
  'ほうよく',
  'ぼうよみ',
  'ぼうらー',
  'ほうらい',
  'ほうらく',
  'ぼうらく',
  'ほうらつ',
  'ほうらん',
  'ほうりき',
  'ほうりつ',
  'ほうりん',
  'ほうるい',
  'ぼうるい',
  'ほうれい',
  'ぼうれい',
  'ほうれき',
  'ほうれつ',
  'ほうれん',
  'ほうろう',
  'ぼうろう',
  'ほうろく',
  'ほうろん',
  'ぼうろん',
  'ほぇーる',
  'ほえーる',
  'ほえごえ',
  'ほえざる',
  'ぽえじー',
  'ほえじか',
  'ほえだす',
  'ほえつく',
  'ぽえっと',
  'ほえづら',
  'ぽえまー',
  'ほおえみ',
  'ぽーかー',
  'ぼーかる',
  'ぼーがん',
  'ほおげた',
  'ぼーげん',
  'ほーこー',
  'ほーさー',
  'ほーざー',
  'ほおじろ',
  'ほおずき',
  'ほおずり',
  'ぼーすん',
  'ぼーぜん',
  'ほおぞめ',
  'ぼーたー',
  'ぼーだー',
  'ぽーたー',
  'ぼーたい',
  'ぽーたる',
  'ぽーちこ',
  'ほおづえ',
  'ほおづき',
  'ぼおっと',
  'ぼーっと',
  'ぼーてる',
  'ほーでん',
  'ぼーなす',
  'ほおにく',
  'ほおのき',
  'ほおばる',
  'ほおひげ',
  'ぼーふら',
  'ほおべに',
  'ほーほー',
  'ほーぼー',
  'ぼーぼー',
  'ぽーぽー',
  'ほおぼね',
  'ほーまー',
  'ほーむず',
  'ぽーらー',
  'ぼーらす',
  'ほーりー',
  'ほーるど',
  'ぼーると',
  'ぼーるど',
  'ほーろー',
  'ほかない',
  'ほかにも',
  'ほかびと',
  'ほかべん',
  'ほかほか',
  'ぽかぽか',
  'ぽかみす',
  'ぽかよけ',
  'ほがらか',
  'ほかんこ',
  'ほかんす',
  'ほきしつ',
  'ぼきっと',
  'ぽきっと',
  'ぼきぼき',
  'ぽきぽき',
  'ほきゃく',
  'ほきゅう',
  'ほきょう',
  'ほくおう',
  'ほぐかご',
  'ほくがん',
  'ぼくぎょ',
  'ほくぐん',
  'ぼくけい',
  'ほくげん',
  'ぼくけん',
  'ぼくさー',
  'ぼくさつ',
  'ぼくしゃ',
  'ぼくしゅ',
  'ぼくしょ',
  'ほくしん',
  'ぼくしん',
  'ぼくじん',
  'ぼくする',
  'ほくせい',
  'ぼくぜい',
  'ぼくせき',
  'ぼくせる',
  'ほくせん',
  'ぼくせん',
  'ほくそう',
  'ぼくそう',
  'ほくそく',
  'ぼくたく',
  'ぼくたち',
  'ほくたん',
  'ぼくちく',
  'ぼくっこ',
  'ぼくてい',
  'ほくてき',
  'ぼくてき',
  'ほくてん',
  'ほくとう',
  'ほくどう',
  'ぼくとう',
  'ぼくどう',
  'ぼくとつ',
  'ほくばく',
  'ほくはん',
  'ぼくはん',
  'ほくふう',
  'ほくべい',
  'ほくへき',
  'ほくへん',
  'ほくほく',
  'ぼくぼく',
  'ぽくぽく',
  'ほくまん',
  'ぼくみん',
  'ぼくめつ',
  'ほくめん',
  'ほくもん',
  'ほくよう',
  'ぼくよう',
  'ほくりく',
  'ほくれい',
  'ほぐれる',
  'ぽぐろむ',
  'ぼくんち',
  'ぼけあじ',
  'ぼけっと',
  'ぽけっと',
  'ぼけなす',
  'ぽけばい',
  'ぽけはろ',
  'ぽけべる',
  'ぽけもん',
  'ほけんい',
  'ほけんし',
  'ほけんふ',
  'ほけんや',
  'ほこうき',
  'ほこうそ',
  'ぼこーだ',
  'ほごがみ',
  'ほごきー',
  'ほごきん',
  'ぼこくご',
  'ほごけん',
  'ほごこく',
  'ほこさき',
  'ほごしつ',
  'ほごしゃ',
  'ほこすぎ',
  'ほごぜい',
  'ほこだし',
  'ぽこちん',
  'ほこてん',
  'ほごばん',
  'ほこへん',
  'ぽこぺん',
  'ほごほう',
  'ほごぼう',
  'ほこほこ',
  'ぼこぼこ',
  'ぽこぽこ',
  'ほごまく',
  'ほこらか',
  'ほごりん',
  'ほころび',
  'ほころぶ',
  'ぼさあげ',
  'ほさかん',
  'ぼさっと',
  'ほさてき',
  'ほさにん',
  'ぼさのば',
  'ぼさぼさ',
  'ほさやく',
  'ほしあい',
  'ほしいい',
  'ほしいお',
  'ほしいし',
  'ほしいも',
  'ほしうお',
  'ほしえび',
  'ほしがき',
  'ほしかげ',
  'ほしがた',
  'ほしがる',
  'ほしくさ',
  'ほしぐさ',
  'ほしくず',
  'ほしくそ',
  'ほしくび',
  'ほじくる',
  'ほしさま',
  'ほしざめ',
  'ほじしゃ',
  'ほしぞら',
  'ほしだら',
  'ほしづき',
  'ぼしとも',
  'ほしなゆ',
  'ほしにく',
  'ほしのり',
  'ほしふぐ',
  'ぽしぶる',
  'ほしぼし',
  'ほしむし',
  'ぼしめい',
  'ほしもの',
  'ほしゃく',
  'ぽしゃる',
  'ほしゅう',
  'ほじゅう',
  'ぼしゅう',
  'ぼじゅつ',
  'ほしゅは',
  'ぼしゅん',
  'ほしょう',
  'ほじょう',
  'ぼしょう',
  'ぼじょう',
  'ほしょく',
  'ぼしょく',
  'ほじょご',
  'ほじょひ',
  'ほすうき',
  'ほすげん',
  'ぼすせん',
  'ぽすたー',
  'ほすちあ',
  'ほすてす',
  'ほすてる',
  'ぽすどく',
  'ぼすとん',
  'ぼすにあ',
  'ほすぴす',
  'ぼすべん',
  'ほせんく',
  'ほぞあな',
  'ほそいじ',
  'ほそいと',
  'ほそうぐ',
  'ほそうち',
  'ほそうで',
  'ほそうろ',
  'ほそおび',
  'ほそがき',
  'ほそぎり',
  'ほそごし',
  'ほそざお',
  'ほそじま',
  'ほそせん',
  'ほそだは',
  'ぼそっと',
  'ほそなわ',
  'ほそびき',
  'ほそぼそ',
  'ぼそぼそ',
  'ほそまき',
  'ほそまる',
  'ほそみち',
  'ほそむぎ',
  'ほそめに',
  'ほそめる',
  'ほぞんこ',
  'ぼだいじ',
  'ほたえる',
  'ほだえる',
  'ぼたぼた',
  'ぽたぽた',
  'ぼたもち',
  'ぼたやま',
  'ほたるい',
  'ほたるび',
  'ぼたんぴ',
  'ほちきす',
  'ぼちぼち',
  'ぽちぽち',
  'ぽちゃこ',
  'ぽちゃり',
  'ぼちゃん',
  'ぽちゃん',
  'ほちゅう',
  'ほちょう',
  'ほっかい',
  'ぼっかく',
  'ほっかり',
  'ぽっかり',
  'ほっかん',
  'ほつがん',
  'ぼっきょ',
  'ぽっきり',
  'ぼっくす',
  'ぼっくり',
  'ぽっくり',
  'ぼっけい',
  'ほっけー',
  'ぼっけん',
  'ほっこう',
  'ぼっこう',
  'ほっこく',
  'ぼっこつ',
  'ほっこり',
  'ぽっこり',
  'ぼっこん',
  'ぼっさむ',
  'ぽっさむ',
  'ほっしゅ',
  'ぼっしゅ',
  'ぼっしょ',
  'ほっしん',
  'ほっする',
  'ぼっする',
  'ほっせき',
  'ぼつぜん',
  'ほっそう',
  'ほっそく',
  'ほっそり',
  'ほったい',
  'ぼったい',
  'ほったて',
  'ぼったり',
  'ほったん',
  'ほっちく',
  'ぼっちゃ',
  'ぽっちり',
  'ほっつく',
  'ぽっつり',
  'ぼってり',
  'ぽってり',
  'ほっとう',
  'ぼっとう',
  'ほっとく',
  'ぽっとで',
  'ほつねつ',
  'ぼつねん',
  'ほっぱー',
  'ぼっぱつ',
  'ぽっぴー',
  'ぽっぷす',
  'ほっぺた',
  'ほっぽう',
  'ぼつぼつ',
  'ぽつぽつ',
  'ぽっぽと',
  'ほっぽる',
  'ぼつらく',
  'ほつれげ',
  'ほつれる',
  'ぼつわな',
  'ぼでぃー',
  'ぼでぃす',
  'ほていち',
  'ぽてさら',
  'ぼてっと',
  'ほてとる',
  'ぼてばら',
  'ぼてふり',
  'ほてへる',
  'ぼてぼて',
  'ぽてぽて',
  'ほてりえ',
  'ぽてんつ',
  'ほどあい',
  'ほとけぎ',
  'ほどける',
  'ほどこし',
  'ほどこす',
  'ぽどそる',
  'ぽどぞる',
  'ほどなく',
  'ほとびる',
  'ほどへて',
  'ほとほと',
  'ほどほど',
  'ぼとぼと',
  'ぽとぽと',
  'ほとぼり',
  'ほとまる',
  'ぼとむす',
  'ほとめく',
  'ほどよい',
  'ほどよく',
  'ぼとらー',
  'ほとんど',
  'ぼなんざ',
  'ほにゅう',
  'ぼにゅう',
  'ぽにょる',
  'ほねあげ',
  'ほねおり',
  'ほねおる',
  'ほねかみ',
  'ほねきり',
  'ほねぐみ',
  'ほねずり',
  'ほねつき',
  'ほねつぎ',
  'ほねなし',
  'ほねぬき',
  'ほねばる',
  'ほねぶし',
  'ほねぶと',
  'ほねへん',
  'ほねぼそ',
  'ほのぼの',
  'ほのめく',
  'ほのるる',
  'ほばしら',
  'ほびっと',
  'ぼひめい',
  'ぼひょう',
  'ほぶばん',
  'ぽぶらの',
  'ぽぷりん',
  'ぼぶんか',
  'ほぺいろ',
  'ほほえみ',
  'ほほえむ',
  'ほほじろ',
  'ほほづえ',
  'ほほにく',
  'ほほぼね',
  'ほぼほぼ',
  'ぽまーど',
  'ぼまいぇ',
  'ほめあい',
  'ほめぱげ',
  'ほもだち',
  'ほもにむ',
  'ほものか',
  'ほもばー',
  'ぼやーる',
  'ぼやかす',
  'ぼやける',
  'ぼやっと',
  'ほやほや',
  'ぼやぼや',
  'ほようち',
  'ぽよーん',
  'ぽよぽよ',
  'ぼらーど',
  'ほらあな',
  'ほらがい',
  'ぽらっく',
  'ほらふき',
  'ほらほら',
  'ぼらぼら',
  'ぽらりす',
  'ぼらんち',
  'ほらんと',
  'ほりあげ',
  'ほりあと',
  'ほりいど',
  'ぽりーぷ',
  'ぽりいん',
  'ぽりえん',
  'ほりかわ',
  'ほりきり',
  'ぽりこう',
  'ほりこむ',
  'ぽりこれ',
  'ぽりごん',
  'ぽりさん',
  'ぽりしー',
  'ほりずむ',
  'ほりだす',
  'ぽりっじ',
  'ほりでぃ',
  'ほりでい',
  'ほりでー',
  'ぽりにや',
  'ほりぬく',
  'ぽりばす',
  'ほりばた',
  'ぼりびあ',
  'ぼりぼり',
  'ぽりぽり',
  'ぽりまー',
  'ほりもの',
  'ほりゅう',
  'ほりわり',
  'ぼるしち',
  'ぼるぞい',
  'ほるだー',
  'ぼるだー',
  'ぽるだー',
  'ぽるちお',
  'ぽるちこ',
  'ぼるどー',
  'ぼるねお',
  'ほるほる',
  'ほるもん',
  'ほれこむ',
  'ほれほれ',
  'ほれぼれ',
  'ぽれんた',
  'ぼろかす',
  'ぼろがち',
  'ほろがや',
  'ぼろきれ',
  'ぼろくそ',
  'ほろっと',
  'ぽろっと',
  'ぼろぬの',
  'ぽろねぎ',
  'ほろびる',
  'ほろぼす',
  'ほろほろ',
  'ぼろぼろ',
  'ぽろぽろ',
  'ぼろまけ',
  'ほろよい',
  'ぽろろん',
  'ほわいえ',
  'ほわいと',
  'ぽわそん',
  'ほわなん',
  'ほわぱい',
  'ぽわろー',
  'ほをはく',
  'ほんあか',
  'ぼんあけ',
  'ほんあん',
  'ほんいえ',
  'ほんいち',
  'ほんいつ',
  'ほんいん',
  'ほんえい',
  'ほんえん',
  'ほんおく',
  'ほんおん',
  'ほんかい',
  'ほんかく',
  'ほんがく',
  'ぼんがく',
  'ぽんがし',
  'ほんがす',
  'ほんかや',
  'ほんかれ',
  'ほんかわ',
  'ほんがわ',
  'ほんかん',
  'ほんがん',
  'ぼんがん',
  'ぽんかん',
  'ほんきで',
  'ほんきど',
  'ほんきょ',
  'ほんきん',
  'ほんぐう',
  'ほんくじ',
  'ほんぐみ',
  'ぼんくら',
  'ぼんくれ',
  'ぼんけい',
  'ほんげつ',
  'ほんけん',
  'ほんげん',
  'ほんこう',
  'ほんごう',
  'ほんこく',
  'ほんごく',
  'ぼんござ',
  'ほんごし',
  'ぼんこつ',
  'ぽんこつ',
  'ほんこれ',
  'ぼんごれ',
  'ほんこん',
  'ほんさい',
  'ぼんさい',
  'ほんさく',
  'ぼんさく',
  'ぼんさつ',
  'ほんさば',
  'ぼんさま',
  'ほんざん',
  'ぽんじー',
  'ほんしき',
  'ほんしつ',
  'ほんじつ',
  'ぼんしつ',
  'ほんしゃ',
  'ほんじゃ',
  'ぼんしゅ',
  'ぽんしゅ',
  'ほんしょ',
  'ぼんしょ',
  'ぼんじり',
  'ぽんじり',
  'ほんしん',
  'ほんじん',
  'ぼんじん',
  'ほんすう',
  'ほんずき',
  'ほんすじ',
  'ほんせい',
  'ほんせき',
  'ぼんせき',
  'ほんせつ',
  'ぼんせつ',
  'ほんせん',
  'ほんぜん',
  'ぼんせん',
  'ほんそう',
  'ほんぞう',
  'ぼんそう',
  'ぼんぞう',
  'ほんそく',
  'ぼんぞく',
  'ほんそれ',
  'ほんぞん',
  'ほんたい',
  'ほんだい',
  'ぼんたい',
  'ほんたく',
  'ほんたて',
  'ほんだな',
  'ぼんだな',
  'ほんだら',
  'ぼんたん',
  'ぽんちえ',
  'ぽんちき',
  'ぽんちょ',
  'ぽんつく',
  'ぽんっと',
  'ほんてい',
  'ぽんてぎ',
  'ほんてん',
  'ほんでん',
  'ぼんてん',
  'ぼんでん',
  'ほんとう',
  'ほんどう',
  'ほんとー',
  'ぼんどし',
  'ほんとに',
  'ぼんなか',
  'ほんなら',
  'ほんにん',
  'ぼんにん',
  'ほんぬい',
  'ほんねん',
  'ほんのう',
  'ぼんのう',
  'ほんのり',
  'ぼんばー',
  'ぼんばい',
  'ほんばこ',
  'ぼんばな',
  'ほんはぶ',
  'ほんばら',
  'ほんばん',
  'ぼんびー',
  'ぽんびき',
  'ぽんぴき',
  'ほんぴん',
  'ほんぷく',
  'ぽんぷざ',
  'ほんぶし',
  'ほんぶり',
  'ほんぶん',
  'ぼんぶん',
  'ほんぺん',
  'ほんぼう',
  'ほんぽう',
  'ぽんぽこ',
  'ほんぼし',
  'ぼんぼり',
  'ぼんぼん',
  'ぼんぽん',
  'ぽんぽん',
  'ほんまく',
  'ほんまつ',
  'ほんまる',
  'ぼんみす',
  'ほんめい',
  'ほんめん',
  'ほんもう',
  'ほんもと',
  'ほんもの',
  'ほんもん',
  'ほんやく',
  'ぼんやり',
  'ほんゆう',
  'ぽんゆー',
  'ほんよう',
  'ぼんよう',
  'ほんよみ',
  'ほんらい',
  'ほんらん',
  'ぼんりょ',
  'ほんるい',
  'ほんれい',
  'ほんれき',
  'ほんろう',
  'ほんろん',
  'ほんわか',
  'ほんわり',
  'まーかー',
  'まーげい',
  'まーさん',
  'まーしゅ',
  'まーじん',
  'まーだー',
  'まーちょ',
  'まーとー',
  'まあなご',
  'まーぶる',
  'まあまあ',
  'まーらー',
  'まーりん',
  'まあるい',
  'まーるす',
  'まいあさ',
  'まいあし',
  'まいあみ',
  'まいうー',
  'まいうど',
  'まいかー',
  'まいかい',
  'まいかぜ',
  'まいきょ',
  'まいぎり',
  'まいぐせ',
  'まいぐみ',
  'まいくろ',
  'まいくん',
  'まいげつ',
  'まいごう',
  'まいこつ',
  'まいこむ',
  'まいこん',
  'まいしん',
  'まいすう',
  'まいせつ',
  'まいせん',
  'まいそう',
  'まいぞう',
  'まいたい',
  'まいたけ',
  'まいたつ',
  'まいだん',
  'まいちる',
  'まいっか',
  'まいつき',
  'まいった',
  'まいとし',
  'まいどの',
  'まいなー',
  'まいない',
  'まいなす',
  'まいなつ',
  'まいにち',
  'まいにん',
  'まいねん',
  'まいはぎ',
  'まいはし',
  'まいばし',
  'まいはだ',
  'まいばん',
  'まいびと',
  'まいひめ',
  'まいふく',
  'まいふゆ',
  'まいふん',
  'まいべん',
  'まいぼつ',
  'まいまい',
  'まいゆう',
  'まいらー',
  'まいるか',
  'まいるど',
  'まいわし',
  'まいんど',
  'まうしろ',
  'まうんと',
  'まうんど',
  'まえあき',
  'まえあし',
  'まえいた',
  'まえうで',
  'まえうり',
  'まえおき',
  'まえがき',
  'まえかけ',
  'まえかご',
  'まえがし',
  'まえかた',
  'まえかの',
  'まえかぶ',
  'まえがみ',
  'まえがり',
  'まえかれ',
  'まえがわ',
  'まえきん',
  'まえげり',
  'まえさく',
  'まえすれ',
  'まえせつ',
  'まえたて',
  'まえだて',
  'まえだま',
  'まえだれ',
  'まえづけ',
  'まえつぼ',
  'まえどり',
  'まえにわ',
  'まえのよ',
  'まえばし',
  'まえばり',
  'まえびろ',
  'まえぴん',
  'まえふり',
  'まえぶれ',
  'まえほど',
  'まえまえ',
  'まえみつ',
  'まえむき',
  'まえやく',
  'まえわれ',
  'まおとこ',
  'まおなが',
  'まおまお',
  'まおりご',
  'まかーに',
  'まがいい',
  'まがえる',
  'まがこと',
  'まがごと',
  'まがさす',
  'まかじき',
  'まがしら',
  'まがじん',
  'まかせる',
  'まがたま',
  'まかだむ',
  'まがった',
  'まかない',
  'まがない',
  'まかなう',
  'まかべう',
  'まかべお',
  'まがよい',
  'まがりめ',
  'まがれい',
  'まかろに',
  'まかろん',
  'まきあみ',
  'まきえい',
  'まきおび',
  'まきがい',
  'まきかえ',
  'まきがみ',
  'まきがり',
  'まきくせ',
  'まきぐそ',
  'まきぐも',
  'まきこみ',
  'まきこむ',
  'まきごや',
  'まきじく',
  'まきじた',
  'まきしむ',
  'まきずし',
  'まきせん',
  'まきぞい',
  'まきぞえ',
  'まきたて',
  'まきつく',
  'まきつけ',
  'まきづめ',
  'まきとり',
  'まきとる',
  'まきばい',
  'まきはだ',
  'まきひげ',
  'まきびし',
  'まきみず',
  'まきもの',
  'まぎゃく',
  'まきゅう',
  'まきょう',
  'まぎょう',
  'まぎらす',
  'まぎれる',
  'まきわら',
  'まきわり',
  'まくあい',
  'まくあき',
  'まくあけ',
  'まくあつ',
  'まくいた',
  'まくうち',
  'まくぎれ',
  'まくこつ',
  'まくした',
  'まくしつ',
  'まくしむ',
  'まくじり',
  'まくせい',
  'まくでん',
  'まぐなむ',
  'まぐねと',
  'まくひき',
  'まくへき',
  'まくらえ',
  'まくらぎ',
  'まくらべ',
  'まくらめ',
  'まくれる',
  'まくろび',
  'まくろん',
  'まぐわい',
  'まぐわう',
  'まけいぬ',
  'まけいろ',
  'まけぐみ',
  'まけこし',
  'まけこす',
  'まけじと',
  'まけどく',
  'まけぶり',
  'まけぼし',
  'まけまけ',
  'まげもの',
  'まげゆい',
  'まけんき',
  'まけんし',
  'まごいも',
  'まごうけ',
  'まこころ',
  'まごころ',
  'まごさん',
  'まごつく',
  'まこっさ',
  'まごでし',
  'まことに',
  'まごのて',
  'まごびき',
  'まごまご',
  'まごやし',
  'まごらが',
  'まころん',
  'まこんぶ',
  'まざーず',
  'まさかき',
  'まさかり',
  'まさぐる',
  'まざこん',
  'まさしく',
  'まさつち',
  'まざまざ',
  'まさむね',
  'まさゆめ',
  'まさらー',
  'ましーん',
  'まじえる',
  'ましかく',
  'まじかる',
  'まじきり',
  'まじぎれ',
  'ましくら',
  'ましぐら',
  'まじこう',
  'まじこる',
  'まじこん',
  'ましじみ',
  'ましじめ',
  'ましずり',
  'まじっく',
  'まじつゆ',
  'ましてや',
  'まじない',
  'まじなう',
  'まじなき',
  'まじなも',
  'ましにん',
  'まじばな',
  'まじぱん',
  'まじぼけ',
  'まじまじ',
  'まします',
  'ましまろ',
  'ましみず',
  'まじもの',
  'ましゃく',
  'まじゅう',
  'まじゅつ',
  'ましょう',
  'まじょこ',
  'まじりか',
  'まじりけ',
  'まじれす',
  'まじろぐ',
  'まじわり',
  'まじわる',
  'ましんご',
  'ましんゆ',
  'ますいい',
  'ますうり',
  'ますがた',
  'ますから',
  'ますぐみ',
  'ますこみ',
  'ますごみ',
  'ますこん',
  'ますざけ',
  'まずしい',
  'ますじど',
  'ますせき',
  'ますたー',
  'ますたば',
  'ますちふ',
  'まずない',
  'ますひと',
  'ますぷろ',
  'ますます',
  'まずまず',
  'ますらお',
  'まずるか',
  'ますわり',
  'まぜおり',
  'ませがき',
  'まぜがき',
  'まぜこぜ',
  'まぜこむ',
  'まぜもの',
  'まぜらん',
  'ませんか',
  'まぜんた',
  'またうけ',
  'またおい',
  'またがい',
  'またかし',
  'またがし',
  'またがみ',
  'またがり',
  'またがる',
  'またぎき',
  'またくぎ',
  'またぐら',
  'またした',
  'まだしも',
  'またずれ',
  'またせる',
  'またぞろ',
  'またたき',
  'まだたき',
  'またたく',
  'まだたく',
  'またたび',
  'またでし',
  'またどん',
  'またない',
  'またなわ',
  'またぬき',
  'またぬの',
  'またのな',
  'またのひ',
  'またはら',
  'またまた',
  'まだまだ',
  'まためい',
  'またもや',
  'まだるい',
  'またろー',
  'またわり',
  'まちあい',
  'まちうけ',
  'まちぇて',
  'まちがい',
  'まぢかい',
  'まちがう',
  'まちがえ',
  'まちかご',
  'まちかた',
  'まちかど',
  'まちかね',
  'まちきん',
  'まちごま',
  'まちこん',
  'まちすじ',
  'まちすも',
  'まちずも',
  'まちだい',
  'まちっく',
  'まちなか',
  'まちなみ',
  'まちにん',
  'まちねー',
  'まちばり',
  'まちばる',
  'まちびと',
  'まちぶせ',
  'まちふれ',
  'まちぼけ',
  'まちまち',
  'まちゅあ',
  'まつえい',
  'まつえく',
  'まつかえ',
  'まっかく',
  'まつかさ',
  'まつかぜ',
  'まっかつ',
  'まつかつ',
  'まっかり',
  'まつかわ',
  'まっくす',
  'まっくら',
  'まっくる',
  'まっくろ',
  'まっこう',
  'まっこり',
  'まっさお',
  'まっさき',
  'まっさつ',
  'まっさら',
  'まつじつ',
  'まっしぶ',
  'まっしゃ',
  'まっしゅ',
  'まつじょ',
  'まっしろ',
  'まっしん',
  'まつすぎ',
  'まっすぐ',
  'まっする',
  'まっせい',
  'まっせき',
  'まっせつ',
  'まつぜみ',
  'まつぞく',
  'まっそん',
  'まったい',
  'まつだい',
  'まったき',
  'まったく',
  'まったけ',
  'まつたけ',
  'まったり',
  'まったん',
  'まつだん',
  'まっちゃ',
  'まっちょ',
  'まっつぉ',
  'まってい',
  'まつてん',
  'まっとう',
  'まっとし',
  'まつねん',
  'まつのき',
  'まつのは',
  'まつのみ',
  'まつばい',
  'まっぱい',
  'まつばゆ',
  'まつばら',
  'まっぴつ',
  'まっぴら',
  'まつぶん',
  'まっぽう',
  'まつほど',
  'まつまい',
  'まつむし',
  'まつもく',
  'まつやに',
  'まつやま',
  'まつよい',
  'まつよう',
  'まつりか',
  'まつわる',
  'までいら',
  'まてがい',
  'まてちゃ',
  'までなら',
  'まてばら',
  'まてはん',
  'まどうし',
  'まどがい',
  'まどかけ',
  'まどがわ',
  'まどぎわ',
  'まとぐし',
  'まどぐち',
  'まどごし',
  'まどころ',
  'まどだい',
  'まどつき',
  'まとなり',
  'まどはん',
  'まどふき',
  'まどぷろ',
  'まとまり',
  'まとまる',
  'まとめて',
  'まとめる',
  'まどらー',
  'まどらさ',
  'まどらす',
  'まどりず',
  'まどろす',
  'まどろみ',
  'まどろむ',
  'まどわく',
  'まどわす',
  'まどんな',
  'まなーま',
  'まないた',
  'まなうら',
  'まなかい',
  'まながき',
  'まなぐあ',
  'まなざし',
  'まなしき',
  'まなじり',
  'まなつび',
  'まなづる',
  'まなでし',
  'まなばし',
  'まなばん',
  'まなびや',
  'まなぶた',
  'まなぶみ',
  'まなぼん',
  'まにあい',
  'まにあう',
  'まにある',
  'まにおく',
  'まにしゅ',
  'まにじゅ',
  'まにとば',
  'まにまに',
  'まにゅう',
  'まにらし',
  'まぬかん',
  'まねーじ',
  'まねきん',
  'まねごと',
  'まねっこ',
  'まねろん',
  'まのいい',
  'まのがる',
  'まのよい',
  'まばしら',
  'まばたき',
  'まばたく',
  'まはとま',
  'まばゆい',
  'まひがし',
  'まびきな',
  'まびさし',
  'まひまひ',
  'まふぃあ',
  'まふぃん',
  'まぶしい',
  'まぶだち',
  'まふゆび',
  'まふらー',
  'まぶれる',
  'まべがい',
  'まぺっと',
  'まぼしい',
  'まほらま',
  'まぼろし',
  'まほろば',
  'ままいも',
  'ままおや',
  'ままかつ',
  'ままかり',
  'ままごと',
  'ままさん',
  'ままちち',
  'ままっこ',
  'ままてつ',
  'ままとも',
  'ままねえ',
  'ままはは',
  'まみえる',
  'まみじろ',
  'まみなみ',
  'まみれる',
  'まむかい',
  'まむこう',
  'まめいた',
  'まめがき',
  'まめかす',
  'まめがら',
  'まめじか',
  'まめぞう',
  'まめたん',
  'まめづた',
  'まめつぶ',
  'まめなし',
  'まめへん',
  'まめほん',
  'まめまき',
  'まめみそ',
  'まめもく',
  'まめやか',
  'まめるい',
  'まもない',
  'まもなく',
  'まやかし',
  'まやかす',
  'まやだし',
  'まやらん',
  'まゆかき',
  'まゆじり',
  'まゆずみ',
  'まゆだま',
  'まゆづき',
  'まゆつば',
  'まゆやま',
  'まよいご',
  'まよなか',
  'まよらー',
  'まよわす',
  'まらーた',
  'まらうい',
  'まらかす',
  'まらそん',
  'まらりあ',
  'まらんた',
  'まりあな',
  'まりーな',
  'まりーん',
  'まりおん',
  'まりがん',
  'まりっじ',
  'まりなげ',
  'まりなら',
  'まりょく',
  'まりわな',
  'まりんば',
  'まるあな',
  'まるいし',
  'まるいす',
  'まるいち',
  'まるーん',
  'まるえり',
  'まるおび',
  'まるがお',
  'まるがた',
  'まるがち',
  'まるがま',
  'まるがり',
  'まるきり',
  'まるぎり',
  'まるくび',
  'まるけい',
  'まるこう',
  'まるごし',
  'まるごと',
  'まるざい',
  'まるさば',
  'まるさら',
  'まるざら',
  'まるしー',
  'まるしぇ',
  'まるすげ',
  'まるそう',
  'まるぞこ',
  'まるぞん',
  'まるたい',
  'まるだい',
  'まるたけ',
  'まるたご',
  'まるだし',
  'まるたて',
  'まるっか',
  'まるづか',
  'まるっと',
  'まるどり',
  'まるなげ',
  'まるのこ',
  'まるのみ',
  'まるはげ',
  'まるはち',
  'まるばつ',
  'まるぺん',
  'まるぼう',
  'まるぼし',
  'まるぼり',
  'まるほん',
  'まるぼん',
  'まるまけ',
  'まるまげ',
  'まるまど',
  'まるまま',
  'まるまる',
  'まるみえ',
  'まるめる',
  'まるめろ',
  'まるもじ',
  'まるもち',
  'まるやき',
  'まるやけ',
  'まるやね',
  'まるゆう',
  'まるわげ',
  'まれーご',
  'まれっと',
  'まれびと',
  'まろうと',
  'まろうど',
  'まろにえ',
  'まろやか',
  'まをおく',
  'まをもつ',
  'まんいち',
  'まんいつ',
  'まんいん',
  'まんえい',
  'まんえつ',
  'まんえん',
  'まんかい',
  'まんがか',
  'まんがく',
  'まんがじ',
  'まんかす',
  'まんかぶ',
  'まんかん',
  'まんがん',
  'まんきつ',
  'まんきび',
  'まんきん',
  'まんくう',
  'まんげつ',
  'まんけん',
  'まんげん',
  'まんこう',
  'まんごう',
  'まんごー',
  'まんさい',
  'まんざい',
  'まんさく',
  'まんさつ',
  'まんざら',
  'まんさん',
  'まんざん',
  'まんしつ',
  'まんしゃ',
  'まんじゅ',
  'まんじり',
  'まんじる',
  'まんしん',
  'まんすい',
  'まんずり',
  'まんずる',
  'まんせい',
  'まんせー',
  'まんせき',
  'まんぜん',
  'まんぞく',
  'まんだい',
  'まんたく',
  'まんだら',
  'まんたん',
  'まんだん',
  'まんでー',
  'まんてる',
  'まんてん',
  'まんとう',
  'まんどう',
  'まんとー',
  'まんどく',
  'まんとら',
  'まんとる',
  'まんなか',
  'まんなん',
  'まんにん',
  'まんねり',
  'まんねん',
  'まんのう',
  'まんぱい',
  'まんびき',
  'まんぴつ',
  'まんふぁ',
  'まんぷく',
  'まんぶん',
  'まんべん',
  'まんぼう',
  'まんまえ',
  'まんまく',
  'まんまと',
  'まんまる',
  'まんまん',
  'まんめん',
  'まんもう',
  'まんもく',
  'まんもす',
  'まんもん',
  'まんゆう',
  'まんよう',
  'まんらん',
  'まんりき',
  'まんるい',
  'まんろく',
  'みあかし',
  'みあがり',
  'みあきす',
  'みあきる',
  'みあげる',
  'みあたる',
  'みありー',
  'みあわす',
  'みあわせ',
  'みいだす',
  'みーっけ',
  'みいとこ',
  'みいはあ',
  'みーはー',
  'みいらか',
  'みうける',
  'みうごき',
  'みえけん',
  'みえすく',
  'みえばる',
  'みえぼう',
  'みえみえ',
  'みえりん',
  'みえるか',
  'みおえる',
  'みおくり',
  'みおくる',
  'みおさめ',
  'みおしん',
  'みおとし',
  'みおとす',
  'みおとり',
  'みおどり',
  'みおぼえ',
  'みおろす',
  'みおんぼ',
  'みかいち',
  'みかえし',
  'みかえす',
  'みかえり',
  'みかえる',
  'みがきこ',
  'みかぎる',
  'みかぐら',
  'みかける',
  'みかこう',
  'みかじめ',
  'みかしょ',
  'みかずき',
  'みかたき',
  'みかづき',
  'みがって',
  'みがなる',
  'みかねる',
  'みがまえ',
  'みかまぎ',
  'みがるい',
  'みかわす',
  'みがわり',
  'みかんか',
  'みかんが',
  'みぎあし',
  'みぎうえ',
  'みぎうち',
  'みぎうで',
  'みぎおく',
  'みぎがき',
  'みぎかた',
  'みぎがわ',
  'みぎきき',
  'みきさー',
  'みぎした',
  'みぎづめ',
  'みきてい',
  'みぎはし',
  'みぎひじ',
  'みぎまえ',
  'みぎまき',
  'みぎむき',
  'みぎよこ',
  'みぎよせ',
  'みぎよつ',
  'みぎより',
  'みぎれい',
  'みきれる',
  'みぎわき',
  'みきわめ',
  'みくゔぁ',
  'みくうぇ',
  'みくゔぇ',
  'みくさー',
  'みくすと',
  'みくだす',
  'みくびる',
  'みぐるみ',
  'みくろん',
  'みくわー',
  'みけいか',
  'みけねこ',
  'みこうち',
  'みこころ',
  'みごたえ',
  'みことば',
  'みごなし',
  'みこまい',
  'みごもる',
  'みこよせ',
  'みごろし',
  'みこんか',
  'みこんち',
  'みさいえ',
  'みさいる',
  'みさかい',
  'みざくら',
  'みさげる',
  'みささぎ',
  'みさらし',
  'みざらし',
  'みさんが',
  'みじかい',
  'みじかさ',
  'みじかめ',
  'みじかよ',
  'みしがん',
  'みじたく',
  'みじまい',
  'みしみし',
  'みしゅう',
  'みじゅく',
  'みしょう',
  'みしよう',
  'みしょち',
  'みしょり',
  'みしらず',
  'みしらぬ',
  'みじろぎ',
  'みじろぐ',
  'みじんこ',
  'みしんめ',
  'みずあか',
  'みずあげ',
  'みずあび',
  'みずあぶ',
  'みずあめ',
  'みずいか',
  'みずいぼ',
  'みずいり',
  'みずいれ',
  'みずいろ',
  'みずうお',
  'みずうす',
  'みずうみ',
  'みずーり',
  'みすえる',
  'みずおけ',
  'みずおち',
  'みずおと',
  'みずがい',
  'みずかえ',
  'みずかき',
  'みずかさ',
  'みずがし',
  'みすかす',
  'みずがめ',
  'みずから',
  'みずきか',
  'みずきき',
  'みずきり',
  'みずぎわ',
  'みずきん',
  'みずくき',
  'みずぐき',
  'みすくさ',
  'みずくさ',
  'みずぐち',
  'みずくみ',
  'みずぐも',
  'みずげい',
  'みずごけ',
  'みずこし',
  'みすごす',
  'みずごり',
  'みすこん',
  'みずさき',
  'みずさし',
  'みずしめ',
  'みずじめ',
  'みずしも',
  'みずじも',
  'みずぜめ',
  'みずそこ',
  'みずぞこ',
  'みすたー',
  'みずたき',
  'みずだき',
  'みずだこ',
  'みずだし',
  'みずたで',
  'みずたま',
  'みずだめ',
  'みずつぎ',
  'みずつく',
  'みずづく',
  'みすてり',
  'みすてる',
  'みずてん',
  'みずとり',
  'みずどり',
  'みずなす',
  'みずなら',
  'みずぬき',
  'みずぬれ',
  'みずのえ',
  'みずのと',
  'みずのみ',
  'みずはけ',
  'みずばな',
  'みずばら',
  'みずばり',
  'みずひき',
  'みずぶか',
  'みずぶき',
  'みずぶち',
  'みずぶね',
  'みすぷり',
  'みずぶろ',
  'みずまき',
  'みずまし',
  'みすます',
  'みすみす',
  'みずむし',
  'みずめし',
  'みずもち',
  'みずもの',
  'みずもり',
  'みずもれ',
  'みずやり',
  'みずろう',
  'みずろん',
  'みずわに',
  'みずわり',
  'みせあう',
  'みせいた',
  'みせいり',
  'みぜーる',
  'みせかけ',
  'みせかた',
  'みせがね',
  'みせけち',
  'みせさき',
  'みせしめ',
  'みせだし',
  'みせだな',
  'みぜっと',
  'みせはい',
  'みせぱい',
  'みせばや',
  'みせばん',
  'みせぱん',
  'みせぶら',
  'みせもの',
  'みそあえ',
  'みそあん',
  'みぞおち',
  'みそくそ',
  'みぞごい',
  'みそこし',
  'みそしき',
  'みそしる',
  'みそすり',
  'みそたき',
  'みそだま',
  'みそだる',
  'みそたれ',
  'みそだれ',
  'みそづけ',
  'みそっぱ',
  'みそはぎ',
  'みぞはぎ',
  'みそまめ',
  'みそめる',
  'みそれる',
  'みたいだ',
  'みたいな',
  'みたざる',
  'みだしご',
  'みたてる',
  'みたない',
  'みたまや',
  'みたらし',
  'みだりに',
  'みだれる',
  'みちいた',
  'みちいと',
  'みちがい',
  'みぢかい',
  'みちがう',
  'みちがく',
  'みちかけ',
  'みちくさ',
  'みちしお',
  'みちしば',
  'みちすう',
  'みちすじ',
  'みちぞい',
  'みちづれ',
  'みちなか',
  'みちのく',
  'みちのし',
  'みちのり',
  'みちばた',
  'みちばち',
  'みちはば',
  'みちひき',
  'みちびき',
  'みちびく',
  'みちみち',
  'みちゃく',
  'みちゆき',
  'みちゆく',
  'みつあみ',
  'みついろ',
  'みつうん',
  'みつえい',
  'みつおり',
  'みっかい',
  'みつかい',
  'みつがい',
  'みっかじ',
  'みつかど',
  'みつかる',
  'みっくす',
  'みつくす',
  'みつくち',
  'みつぐま',
  'みつぐみ',
  'みっけい',
  'みつげつ',
  'みっける',
  'みつける',
  'みっこう',
  'みっこく',
  'みっさつ',
  'みっしー',
  'みっしつ',
  'みっしょ',
  'みっしり',
  'みつすい',
  'みっせい',
  'みっせつ',
  'みっせん',
  'みつせん',
  'みっそう',
  'みつぞう',
  'みつだえ',
  'みつだん',
  'みっちり',
  'みっつう',
  'みつづけ',
  'みつつぼ',
  'みってい',
  'みつばい',
  'みつばち',
  'みつばん',
  'みっぷう',
  'みっぷす',
  'みっぺい',
  'みつぼう',
  'みつぼし',
  'みつまた',
  'みつまめ',
  'みつみつ',
  'みつめる',
  'みつもり',
  'みつもる',
  'みつもん',
  'みつやく',
  'みつゆび',
  'みづらい',
  'みつりん',
  'みつれい',
  'みつろう',
  'みつわー',
  'みでぃー',
  'みていぎ',
  'みてくれ',
  'みてとる',
  'みてろよ',
  'みとうき',
  'みとうさ',
  'みとおし',
  'みとおす',
  'みどころ',
  'みとどけ',
  'みとめる',
  'みどりご',
  'みとりず',
  'みどりふ',
  'みとれる',
  'みなおし',
  'みなおす',
  'みなかみ',
  'みなぎる',
  'みなくち',
  'みなさま',
  'みなさん',
  'みなしご',
  'みなして',
  'みなそこ',
  'みなつき',
  'みなづき',
  'みなとく',
  'みなぬか',
  'みなのか',
  'みなみあ',
  'みなみく',
  'みなみな',
  'みなもと',
  'みならい',
  'みならう',
  'みならす',
  'みなれる',
  'みにいく',
  'みにおん',
  'みにかー',
  'みにくい',
  'みにくる',
  'みにこみ',
  'みにこん',
  'みにすか',
  'みにつく',
  'みにっつ',
  'みになる',
  'みにばー',
  'みにばす',
  'みにぱと',
  'みにばん',
  'みにぴる',
  'みにまむ',
  'みにまる',
  'みにらぼ',
  'みぬける',
  'みぬふり',
  'みねうち',
  'みねそた',
  'みねみね',
  'みねらる',
  'みねるば',
  'みのある',
  'みのうえ',
  'みのかさ',
  'みのがし',
  'みのがす',
  'みのがみ',
  'みのがめ',
  'みのこく',
  'みのこし',
  'みのこす',
  'みのたけ',
  'みのため',
  'みのない',
  'みのばと',
  'みのばん',
  'みのほど',
  'みのむし',
  'みのるか',
  'みのわた',
  'みはじめ',
  'みはしら',
  'みはてぬ',
  'みはてる',
  'みはなす',
  'みはらい',
  'みばらい',
  'みはらし',
  'みはらす',
  'みびいき',
  'みひとつ',
  'みびょう',
  'みひらき',
  'みひらく',
  'みぶるい',
  'みぶんか',
  'みほそう',
  'みほれる',
  'みまがう',
  'みまかる',
  'みまごう',
  'みまさか',
  'みまさり',
  'みまもる',
  'みまわす',
  'みまわり',
  'みまわる',
  'みみあか',
  'みみあて',
  'みみうち',
  'みみおち',
  'みみがー',
  'みみがい',
  'みみかき',
  'みみかす',
  'みみがね',
  'みみぐけ',
  'みみくそ',
  'みみくり',
  'みみこぴ',
  'みみしい',
  'みみずく',
  'みみせん',
  'みみたけ',
  'みみたこ',
  'みみたぶ',
  'みみだれ',
  'みみづか',
  'みみつき',
  'みみっく',
  'みみづく',
  'みみつり',
  'みみなり',
  'みみぬき',
  'みみのひ',
  'みみへん',
  'みみもと',
  'みみょう',
  'みみより',
  'みめしす',
  'みめよい',
  'みもだえ',
  'みもない',
  'みゃおご',
  'みゃくり',
  'みやげや',
  'みやごう',
  'みやざき',
  'みやさま',
  'みやすい',
  'みやつき',
  'みやつこ',
  'みやづこ',
  'みやてら',
  'みやでら',
  'みやびお',
  'みやびた',
  'みやびと',
  'みやぶる',
  'みやもり',
  'みゅーず',
  'みゅーと',
  'みゅーる',
  'みゅおん',
  'みゅとす',
  'みょうか',
  'みょうが',
  'みょうぎ',
  'みょうご',
  'みょうじ',
  'みょうと',
  'みょうぶ',
  'みょうみ',
  'みょうや',
  'みょうり',
  'みらいき',
  'みらいは',
  'みらくる',
  'みられる',
  'みりおた',
  'みりおん',
  'みりねじ',
  'みりめし',
  'みりゅー',
  'みりょう',
  'みりょく',
  'みりょん',
  'みりれむ',
  'みるいろ',
  'みるかー',
  'みるがい',
  'みるから',
  'みるくい',
  'みるちゃ',
  'みるべき',
  'みるぽわ',
  'みるまに',
  'みるみる',
  'みろんが',
  'みわける',
  'みわたし',
  'みわたす',
  'みをおく',
  'みをひく',
  'みをやく',
  'みんえい',
  'みんおく',
  'みんがく',
  'みんかん',
  'みんげい',
  'みんけん',
  'みんこう',
  'みんこー',
  'みんこく',
  'みんさー',
  'みんざい',
  'みんしゅ',
  'みんじゅ',
  'みんしん',
  'みんじん',
  'みんすく',
  'みんせい',
  'みんせん',
  'みんぞく',
  'みんだい',
  'みんだん',
  'みんてつ',
  'みんとく',
  'みんぱく',
  'みんぷう',
  'みんぷく',
  'みんぺい',
  'みんぼう',
  'みんぽう',
  'みんぼー',
  'みんみん',
  'みんゆう',
  'みんよう',
  'みんろん',
  'むあんだ',
  'むいしき',
  'むいそん',
  'むいんし',
  'むうじゅ',
  'むーすり',
  'むーちょ',
  'むうっと',
  'むーっと',
  'むーでぃ',
  'むーとん',
  'むーばー',
  'むーびー',
  'むーむー',
  'むーらん',
  'むえたい',
  'むがーる',
  'むかいび',
  'むかえび',
  'むかえる',
  'むかきん',
  'むかしつ',
  'むかつき',
  'むかつく',
  'むかっと',
  'むかばら',
  'むかひか',
  'むかむか',
  'むかんさ',
  'むかんし',
  'むきあう',
  'むぎあき',
  'むぎいい',
  'むぎうち',
  'むきえび',
  'むきえん',
  'むきおん',
  'むぎかり',
  'むきけい',
  'むきげん',
  'むぎこう',
  'むぎこき',
  'むぎさく',
  'むきさん',
  'むきしつ',
  'むきだし',
  'むきだす',
  'むぎたば',
  'むぎちゃ',
  'むぎつき',
  'むぎつく',
  'むぎつぶ',
  'むきてき',
  'むきどう',
  'むきはい',
  'むぎぶえ',
  'むきぶつ',
  'むぎふみ',
  'むぎまき',
  'むきまめ',
  'むぎみそ',
  'むきむき',
  'むきめい',
  'むぎめし',
  'むきもの',
  'むきゃく',
  'むきゅう',
  'むぎゅう',
  'むぎょう',
  'むきょか',
  'むきょく',
  'むぎらん',
  'むきりつ',
  'むぎるい',
  'むぎわら',
  'むくいぬ',
  'むくいる',
  'むくざい',
  'むくっと',
  'むくどり',
  'むくのき',
  'むくむく',
  'むくれる',
  'むくろじ',
  'むこいり',
  'むこうか',
  'むこうき',
  'むこうこ',
  'むこせき',
  'むことり',
  'むさくい',
  'むささび',
  'むざさび',
  'むさべつ',
  'むさぼる',
  'むざむざ',
  'むさんし',
  'むさんそ',
  'むしあみ',
  'むしうり',
  'むしかく',
  'むじかく',
  'むしかご',
  'むしがし',
  'むしかり',
  'むしくい',
  'むしけら',
  'むしけん',
  'むしごけ',
  'むしこぶ',
  'むしごむ',
  'むしだし',
  'むしとり',
  'むしどり',
  'むしなべ',
  'むじなも',
  'むしのね',
  'むしばむ',
  'むしばら',
  'むしぱん',
  'むしぴん',
  'むしふだ',
  'むしぶろ',
  'むしへん',
  'むしぼう',
  'むしぼし',
  'むしむし',
  'むしめし',
  'むしもち',
  'むしもの',
  'むしゃえ',
  'むしやき',
  'むじゃき',
  'むしゅう',
  'むじゅう',
  'むしゅく',
  'むしゅみ',
  'むじゅん',
  'むしょう',
  'むじょう',
  'むしょく',
  'むしよけ',
  'むしりょ',
  'むしるい',
  'むじるし',
  'むしれる',
  'むじんか',
  'むじんき',
  'むしんさ',
  'むすかり',
  'むずかる',
  'むずがる',
  'むすこん',
  'むずつく',
  'むすっと',
  'むすびめ',
  'むずむず',
  'むすめご',
  'むすりむ',
  'むすろう',
  'むせいか',
  'むせいが',
  'むせいご',
  'むせいふ',
  'むせんか',
  'むせんき',
  'むそうか',
  'むぞうさ',
  'むだあし',
  'むだがね',
  'むだぐい',
  'むだぐち',
  'むだごと',
  'むだじに',
  'むだばな',
  'むだぼえ',
  'むだぼね',
  'むだめし',
  'むだんで',
  'むたんぽ',
  'むちいれ',
  'むちうち',
  'むちうつ',
  'むちこく',
  'むちのち',
  'むちむち',
  'むちゅう',
  'むつぎり',
  'むっくと',
  'むっくり',
  'むつごと',
  'むっしゅ',
  'むっちゃ',
  'むっちり',
  'むっつり',
  'むつどき',
  'むてんか',
  'むとうか',
  'むとうは',
  'むとどけ',
  'むなあて',
  'むないた',
  'むながい',
  'むなかき',
  'むなくそ',
  'むなぐら',
  'むなぐろ',
  'むなこと',
  'むなさき',
  'むなしい',
  'むなしく',
  'むなだか',
  'むなひぼ',
  'むなひも',
  'むなびれ',
  'むなふだ',
  'むなもと',
  'むなやけ',
  'むなわき',
  'むにえる',
  'むにする',
  'むにゅう',
  'むにょう',
  'むにんか',
  'むねあげ',
  'むねあつ',
  'むねあて',
  'むねうち',
  'むねくそ',
  'むねしゃ',
  'むねにく',
  'むねはば',
  'むねひも',
  'むねふだ',
  'むねぽけ',
  'むねぽち',
  'むねやけ',
  'むねわる',
  'むはばつ',
  'むばばね',
  'むひはん',
  'むびもく',
  'むびゅう',
  'むひょう',
  'むびょう',
  'むびるい',
  'むふうく',
  'むべんが',
  'むぼうび',
  'むみょう',
  'むめいし',
  'むもれぎ',
  'むやみに',
  'むらーと',
  'むらいと',
  'むらおさ',
  'むらがり',
  'むらがる',
  'むらぎえ',
  'むらきも',
  'むらぎも',
  'むらぎり',
  'むらくも',
  'むらさき',
  'むらざと',
  'むらさめ',
  'むらそい',
  'むらたけ',
  'むらだち',
  'むらっけ',
  'むらなく',
  'むらびと',
  'むらむら',
  'むらやま',
  'むりおし',
  'むりおん',
  'むりかい',
  'むりくり',
  'むりげー',
  'むりじい',
  'むりしき',
  'むりすう',
  'むりすじ',
  'むりそく',
  'むりない',
  'むりなく',
  'むりやり',
  'むりょう',
  'むりょく',
  'むれいる',
  'むれたつ',
  'むれだつ',
  'むれとぶ',
  'むれにく',
  'むろあじ',
  'むろざき',
  'むろつみ',
  'むろまち',
  'むわっと',
  'むんてら',
  'むんばい',
  'むんぷす',
  'むんむん',
  'めあかし',
  'めいあん',
  'めいいり',
  'めいうつ',
  'めいうん',
  'めいえん',
  'めいおう',
  'めいかい',
  'めいかく',
  'めいがざ',
  'めいがら',
  'めいかん',
  'めいぎで',
  'めいきょ',
  'めいきん',
  'めいぎん',
  'めいくん',
  'めいけい',
  'めいげつ',
  'めいけん',
  'めいげん',
  'めいこう',
  'めいごう',
  'めいこん',
  'めいさい',
  'めいさく',
  'めいさつ',
  'めいさま',
  'めいさん',
  'めいざん',
  'めいしか',
  'めいじき',
  'めいしく',
  'めいじつ',
  'めいしゃ',
  'めいしゅ',
  'めいしょ',
  'めいじる',
  'めいしん',
  'めいじん',
  'めいすい',
  'めいすう',
  'めいする',
  'めいずる',
  'めいせい',
  'めいせき',
  'めいせつ',
  'めいせん',
  'めいそう',
  'めいだい',
  'めいたつ',
  'めいたん',
  'めいだん',
  'めいちゃ',
  'めいちょ',
  'めいっこ',
  'めいてい',
  'めいでい',
  'めいでー',
  'めいてつ',
  'めいてん',
  'めいとう',
  'めいどう',
  'めいとく',
  'めいにち',
  'めいのう',
  'めいはく',
  'めいばく',
  'めいばつ',
  'めいばん',
  'めいひつ',
  'めいひん',
  'めいびん',
  'めいふく',
  'めいぶつ',
  'めいぷる',
  'めいふん',
  'めいぶん',
  'めいべん',
  'めいほう',
  'めいぼう',
  'めいぼく',
  'めいめい',
  'めいめつ',
  'めいもう',
  'めいもく',
  'めいもん',
  'めいやー',
  'めいやく',
  'めいゆう',
  'めいらー',
  'めいらん',
  'めいれい',
  'めいれき',
  'めいろう',
  'めいろん',
  'めいわく',
  'めうつり',
  'めーかー',
  'めーざー',
  'めーたー',
  'めーたく',
  'めーでー',
  'めーとる',
  'めーぷる',
  'めえめえ',
  'めーめー',
  'めーらー',
  'めがあう',
  'めがあく',
  'めがいい',
  'めがいく',
  'めがきく',
  'めかくし',
  'めがける',
  'めかじき',
  'めかしや',
  'めがしら',
  'めかずら',
  'めがでも',
  'めがでる',
  'めがとん',
  'めがない',
  'めがねや',
  'めかぶら',
  'めがほん',
  'めがまう',
  'めがもり',
  'めがゆく',
  'めがよい',
  'めがろぱ',
  'めがわら',
  'めきしこ',
  'めぎつね',
  'めきめき',
  'めくされ',
  'めくじら',
  'めぐすり',
  'めくばせ',
  'めくばり',
  'めぐらす',
  'めくれる',
  'めくわせ',
  'めぐわせ',
  'めこすじ',
  'めこぼし',
  'めこぼれ',
  'めさいあ',
  'めさいや',
  'めざとい',
  'めざまし',
  'めざます',
  'めざめる',
  'めされる',
  'めざわり',
  'めじあん',
  'めしいる',
  'めしうど',
  'めしうま',
  'めじうむ',
  'めしおち',
  'めしかえ',
  'めじから',
  'めしくん',
  'めしたき',
  'めしだす',
  'めしつぶ',
  'めしてろ',
  'めしどき',
  'めしとる',
  'めしびつ',
  'めしもの',
  'めしもり',
  'めじゃー',
  'めじるし',
  'めしわん',
  'めすいき',
  'めすいぬ',
  'めすかる',
  'めすちぞ',
  'めすねこ',
  'めすねじ',
  'めすぶた',
  'めせーじ',
  'めそーど',
  'めそっど',
  'めそめそ',
  'めたたく',
  'めたたぐ',
  'めたどん',
  'めたふぁ',
  'めたふぉ',
  'めためた',
  'めたもじ',
  'めちーる',
  'めちがい',
  'めぢから',
  'めちにす',
  'めちるか',
  'めちるき',
  'めちれん',
  'めっかち',
  'めっかる',
  'めっきり',
  'めっきん',
  'めっける',
  'めつざい',
  'めっさつ',
  'めっしつ',
  'めっしゅ',
  'めっする',
  'めっそう',
  'めったい',
  'めったに',
  'めっちゃ',
  'めつどう',
  'めつぶし',
  'めつぼう',
  'めっぽう',
  'めづまり',
  'めつれつ',
  'めでぃあ',
  'めてぃす',
  'めでぅさ',
  'めでおう',
  'めでたい',
  'めでたし',
  'めどぅさ',
  'めどおし',
  'めどおり',
  'めとせく',
  'めどっく',
  'めどはぎ',
  'めどれー',
  'めにあう',
  'めにする',
  'めにたつ',
  'めにつく',
  'めにゅー',
  'めのいい',
  'めのいろ',
  'めのくま',
  'めのした',
  'めのたま',
  'めのどく',
  'めのまえ',
  'めのよい',
  'めのらー',
  'めばえる',
  'めばたき',
  'めばたく',
  'めばちこ',
  'めはちぶ',
  'めばやい',
  'めびうす',
  'めひしば',
  'めひょう',
  'めひるぎ',
  'めぼうき',
  'めぼしい',
  'めめしい',
  'めもあや',
  'めもりー',
  'めらにん',
  'めらみん',
  'めらめら',
  'めりあす',
  'めりくり',
  'めりけん',
  'めりこむ',
  'めりすま',
  'めりっさ',
  'めりっと',
  'めりのー',
  'めりはり',
  'めりめり',
  'めりやす',
  'めりんす',
  'めるあど',
  'めるしー',
  'めるとも',
  'めるとん',
  'めるへん',
  'めるまが',
  'めるろー',
  'めれーな',
  'めれんげ',
  'めれんす',
  'めろこあ',
  'めろでぃ',
  'めろでー',
  'めろめろ',
  'めをだす',
  'めをつむ',
  'めをひく',
  'めをみる',
  'めをむく',
  'めをやる',
  'めんあつ',
  'めんえき',
  'めんえつ',
  'めんかい',
  'めんかく',
  'めんがね',
  'めんかん',
  'めんきつ',
  'めんきょ',
  'めんくい',
  'めんこい',
  'めんごい',
  'めんこん',
  'めんざい',
  'めんさく',
  'めんしあ',
  'めんしき',
  'めんじつ',
  'めんじて',
  'めんじょ',
  'めんじる',
  'めんしん',
  'めんする',
  'めんずる',
  'めんぜい',
  'めんせき',
  'めんせつ',
  'めんぜん',
  'めんそう',
  'めんそち',
  'めんたー',
  'めんたい',
  'めんだこ',
  'めんだし',
  'めんたま',
  'めんたる',
  'めんだん',
  'めんちん',
  'めんつう',
  'めんつけ',
  'めんつゆ',
  'めんてい',
  'めんてき',
  'めんでん',
  'めんどい',
  'めんどう',
  'めんとり',
  'めんどり',
  'めんねる',
  'めんばー',
  'めんぱお',
  'めんばん',
  'めんぱん',
  'めんひる',
  'めんぷく',
  'めんぶれ',
  'めんぺき',
  'めんへら',
  'めんへる',
  'めんぼう',
  'めんぽう',
  'めんぽお',
  'めんぼく',
  'めんみつ',
  'めんめん',
  'めんもう',
  'めんもく',
  'めんよう',
  'めんるい',
  'もいすと',
  'もいらい',
  'もうあい',
  'もうあく',
  'もういい',
  'もううい',
  'もううり',
  'もうえん',
  'もうかる',
  'もうかん',
  'もうきん',
  'もうげき',
  'もうける',
  'もうけん',
  'もうげん',
  'もうこう',
  'もうこご',
  'もうこん',
  'もうじき',
  'もうしご',
  'もうしで',
  'もうしゃ',
  'もうじゃ',
  'もうしょ',
  'もうじょ',
  'もうしん',
  'もうじん',
  'もうすぐ',
  'もうせい',
  'もうぜい',
  'もうせつ',
  'もうせん',
  'もうぜん',
  'もうそう',
  'もうたい',
  'もうだん',
  'もうつい',
  'もうでる',
  'もうてん',
  'もうとう',
  'もうどう',
  'もうどく',
  'もうねん',
  'もうのう',
  'もうばく',
  'もうぱす',
  'もうはつ',
  'もうはん',
  'もうひつ',
  'もうべん',
  'もうほう',
  'もうまい',
  'もうまく',
  'もうもう',
  'もうもく',
  'もうゆう',
  'もうれつ',
  'もうろう',
  'もうろく',
  'もえかす',
  'もえがら',
  'もえくさ',
  'もえさし',
  'もえしゃ',
  'もえそで',
  'もえだす',
  'もえたつ',
  'もえだん',
  'もえつく',
  'もえでる',
  'もえぶた',
  'もーうい',
  'もーぐる',
  'もーぜる',
  'もーたー',
  'もーだる',
  'もーてる',
  'もおとこ',
  'もーとる',
  'もーはい',
  'もーぱい',
  'もーびる',
  'もーほー',
  'もーもー',
  'もーるど',
  'もおんな',
  'もかしん',
  'もぎせん',
  'もぎたて',
  'もぎてん',
  'もぎとう',
  'もぎどう',
  'もぎとる',
  'もくいた',
  'もくいん',
  'もくかん',
  'もくぎょ',
  'もくきん',
  'もくげき',
  'もくけん',
  'もくざい',
  'もくさく',
  'もくさつ',
  'もくさん',
  'もくしつ',
  'もくする',
  'もくせい',
  'もくせん',
  'もくぜん',
  'もくそう',
  'もくぞう',
  'もくそく',
  'もくだく',
  'もくたん',
  'もくてき',
  'もくとう',
  'もくどう',
  'もくどく',
  'もくにん',
  'もくねじ',
  'もくねん',
  'もくはい',
  'もくはん',
  'もくばん',
  'もくぱん',
  'もくぶつ',
  'もくへん',
  'もくほん',
  'もくもう',
  'もくもく',
  'もぐもぐ',
  'もくやく',
  'もくよう',
  'もくよく',
  'もぐらか',
  'もくれい',
  'もくれん',
  'もくろう',
  'もくろく',
  'もくろみ',
  'もくろむ',
  'もけいか',
  'もけっと',
  'もこもこ',
  'もごもご',
  'もざいく',
  'もさっと',
  'もさもさ',
  'もざれら',
  'もじいち',
  'もじおち',
  'もしかし',
  'もじかず',
  'もじかん',
  'もしきず',
  'もしくは',
  'もじこら',
  'もじしき',
  'もじすう',
  'もじずり',
  'もじぞう',
  'もじてん',
  'もじばけ',
  'もじはば',
  'もじばん',
  'もしもし',
  'もじもじ',
  'もじゅら',
  'もじゅろ',
  'もしょう',
  'もじよみ',
  'もじれつ',
  'もじわく',
  'もすくわ',
  'もすりむ',
  'もすりん',
  'もすれむ',
  'もぞうし',
  'もそっと',
  'もそもそ',
  'もぞもぞ',
  'もだーん',
  'もだえる',
  'もたげる',
  'もたざる',
  'もたせる',
  'もたつく',
  'もたもた',
  'もたらす',
  'もたれる',
  'もちあい',
  'もちあう',
  'もちあじ',
  'もちあみ',
  'もちあわ',
  'もちいえ',
  'もちーふ',
  'もちいる',
  'もちうた',
  'もちうま',
  'もちうる',
  'もちおい',
  'もちがし',
  'もちかた',
  'もちがね',
  'もちかぶ',
  'もちがゆ',
  'もちきび',
  'もちきり',
  'もちきる',
  'もちきん',
  'もちぐさ',
  'もちげい',
  'もちこし',
  'もちこす',
  'もちごま',
  'もちこみ',
  'もちこむ',
  'もちごめ',
  'もちごや',
  'もちざお',
  'もちさる',
  'もちだい',
  'もちだか',
  'もちだし',
  'もちだす',
  'もちだま',
  'もちつき',
  'もちづき',
  'もちてん',
  'もちなげ',
  'もちなめ',
  'もちにげ',
  'もちぬし',
  'もちねた',
  'もちのき',
  'もちはだ',
  'もちばな',
  'もちふだ',
  'もちぶね',
  'もちふみ',
  'もちぶん',
  'もちまえ',
  'もちまき',
  'もちもち',
  'もちもの',
  'もちゅう',
  'もちより',
  'もちよる',
  'もちろん',
  'もっかい',
  'もっかん',
  'もっきつ',
  'もっきょ',
  'もっきん',
  'もっけい',
  'もっけん',
  'もっこう',
  'もっこく',
  'もっこつ',
  'もっこり',
  'もっこん',
  'もっさい',
  'もっさり',
  'もっそう',
  'もっそり',
  'もったい',
  'もっちり',
  'もってけ',
  'もっとい',
  'もっとー',
  'もっとも',
  'もつなべ',
  'もっぱら',
  'もっぱん',
  'もっぺん',
  'もつやき',
  'もつやく',
  'もつれる',
  'もてがみ',
  'もてっと',
  'もてない',
  'もてなし',
  'もてなす',
  'もてもて',
  'もでらー',
  'もでるか',
  'もとうけ',
  'もとうし',
  'もとうた',
  'もとうり',
  'もとおる',
  'もとかた',
  'もとかの',
  'もとかれ',
  'もときん',
  'もとごえ',
  'もとごめ',
  'もとこん',
  'もとさや',
  'もとじめ',
  'もとせん',
  'もとだか',
  'もとだち',
  'もとづく',
  'もとつま',
  'もとどり',
  'もとなり',
  'もとねた',
  'もとまる',
  'もとみや',
  'もとむる',
  'もとめる',
  'もともと',
  'もとやん',
  'もとゆい',
  'もとよめ',
  'もとより',
  'もどりち',
  'もなみー',
  'もなりざ',
  'もにたー',
  'ものいい',
  'ものいう',
  'ものいみ',
  'ものいり',
  'ものいれ',
  'ものうい',
  'ものうげ',
  'ものうり',
  'ものおき',
  'ものおじ',
  'ものおと',
  'ものかき',
  'ものかげ',
  'ものかは',
  'ものきに',
  'ものぐさ',
  'ものくる',
  'ものくろ',
  'ものごい',
  'ものごし',
  'ものごと',
  'ものさし',
  'ものしり',
  'ものずき',
  'ものたち',
  'ものだち',
  'ものだね',
  'ものちす',
  'ものつき',
  'ものでぃ',
  'ものども',
  'ものとり',
  'ものなら',
  'もののぐ',
  'もののけ',
  'もののな',
  'もののふ',
  'ものぼけ',
  'ものほし',
  'ものほん',
  'ものまー',
  'ものまえ',
  'ものまね',
  'ものもう',
  'ものもち',
  'ものらる',
  'ものりす',
  'ものるび',
  'もばいる',
  'もひーと',
  'もびーる',
  'もひかん',
  'もひとつ',
  'もびんぐ',
  'もふもふ',
  'もぶろぐ',
  'もぺっと',
  'もぺっど',
  'もほーく',
  'もほめん',
  'もまれる',
  'もみあい',
  'もみあう',
  'もみあげ',
  'もみがみ',
  'もみがら',
  'もみかわ',
  'もみくた',
  'もみけし',
  'もみけす',
  'もみこむ',
  'もみずむ',
  'もみすり',
  'もみずり',
  'もみだす',
  'もみのき',
  'もみのり',
  'もみもみ',
  'もめごと',
  'もめんと',
  'ももあげ',
  'ももいろ',
  'ももかん',
  'ももじり',
  'ももぞの',
  'ももだち',
  'ももたび',
  'ももとせ',
  'ももにく',
  'ももひき',
  'ももわれ',
  'ももんが',
  'ももんじ',
  'もやくや',
  'もやげた',
  'もやもや',
  'もよおし',
  'もよおす',
  'もらーる',
  'もらいご',
  'もらいぢ',
  'もらいて',
  'もらいび',
  'もらえる',
  'もらはら',
  'もりおか',
  'もりがし',
  'もりきり',
  'もりこむ',
  'もりしお',
  'もりじお',
  'もりずな',
  'もりそば',
  'もりだぐ',
  'もりつけ',
  'もりつち',
  'もりばな',
  'もりもり',
  'もりやく',
  'もるじぶ',
  'もるだー',
  'もるたる',
  'もるどば',
  'もるねつ',
  'もるひね',
  'もるふぉ',
  'もるもん',
  'もれーん',
  'もれきく',
  'もれだす',
  'もれなく',
  'もれんど',
  'もろあし',
  'もろうで',
  'もろおや',
  'もろがみ',
  'もろくも',
  'もろこし',
  'もろごし',
  'もろざし',
  'もろっこ',
  'もろとも',
  'もろはだ',
  'もろばれ',
  'もろひざ',
  'もろひと',
  'もろびと',
  'もろもろ',
  'もわっと',
  'もわもわ',
  'もんいん',
  'もんえい',
  'もんおり',
  'もんがい',
  'もんかん',
  'もんきー',
  'もんけん',
  'もんげん',
  'もんこう',
  'もんごる',
  'もんごん',
  'もんざい',
  'もんさつ',
  'もんじゃ',
  'もんしゅ',
  'もんじゅ',
  'もんじょ',
  'もんしん',
  'もんじん',
  'もんせい',
  'もんせき',
  'もんぜき',
  'もんぜつ',
  'もんぜん',
  'もんぞう',
  'もんだい',
  'もんたな',
  'もんつき',
  'もんてい',
  'もんとう',
  'もんどう',
  'もんどり',
  'もんない',
  'もんなし',
  'もんなら',
  'もんばつ',
  'もんぱり',
  'もんばん',
  'もんぷく',
  'もんぺあ',
  'もんぼう',
  'もんぽう',
  'もんほん',
  'もんぽん',
  'もんもう',
  'もんもん',
  'もんよう',
  'もんろう',
  'やーうぇ',
  'やーゔぇ',
  'やーこう',
  'やーこん',
  'やーさん',
  'やーぬす',
  'やーぱん',
  'やあやあ',
  'やーやー',
  'やーるど',
  'やーんぴ',
  'やいなや',
  'やいばた',
  'やいやい',
  'やうんで',
  'やえいち',
  'やえがき',
  'やえくも',
  'やえぐも',
  'やえざき',
  'やえなり',
  'やえやえ',
  'やおぞく',
  'やおもて',
  'やがすり',
  'やかんぶ',
  'やぎあか',
  'やきあみ',
  'やきいし',
  'やきいも',
  'やきいれ',
  'やきいろ',
  'やきいん',
  'やきうち',
  'やきがき',
  'やきがし',
  'やきがた',
  'やきがね',
  'やきがま',
  'やききる',
  'やきぐし',
  'やきぐり',
  'やきごて',
  'やきごめ',
  'やきさけ',
  'やきしお',
  'やきしめ',
  'やきじめ',
  'やきそば',
  'やきたて',
  'やきつき',
  'やきつぎ',
  'やきつく',
  'やきつけ',
  'やきとり',
  'やきとん',
  'やきなす',
  'やきなべ',
  'やきにく',
  'やきのり',
  'やきはた',
  'やきばた',
  'やぎひげ',
  'やきぶた',
  'やきふで',
  'やきまし',
  'やきみそ',
  'やきめし',
  'やぎもう',
  'やきもき',
  'やぎもく',
  'やきもち',
  'やきもの',
  'やきゅう',
  'やぎゅう',
  'やぎょう',
  'やきょく',
  'やくいん',
  'やくうん',
  'やくえき',
  'やくえん',
  'やくおん',
  'やくがい',
  'やくがえ',
  'やくがく',
  'やくがら',
  'やくげん',
  'やくさい',
  'やくざい',
  'やくさつ',
  'やくざる',
  'やくしか',
  'やくしく',
  'やくしつ',
  'やくしゃ',
  'やくしゅ',
  'やくしょ',
  'やくじょ',
  'やくしん',
  'やくじん',
  'やくすう',
  'やくすぎ',
  'やくする',
  'やくせき',
  'やくせん',
  'やくぜん',
  'やくそう',
  'やくそく',
  'やくたい',
  'やくだい',
  'やくたく',
  'やくだく',
  'やくだつ',
  'やくだな',
  'やくつき',
  'やくづき',
  'やくてん',
  'やくとう',
  'やくどう',
  'やくとく',
  'やくどく',
  'やくどし',
  'やくなん',
  'やくにげ',
  'やくにん',
  'やくぬけ',
  'やくはい',
  'やくぱぷ',
  'やくひつ',
  'やくひん',
  'やくふだ',
  'やくぶつ',
  'やくぶん',
  'やくほう',
  'やくほん',
  'やくまえ',
  'やくまけ',
  'やくまん',
  'やくむき',
  'やくめい',
  'やくもの',
  'やくよう',
  'やくよく',
  'やくよけ',
  'やぐるま',
  'やくれい',
  'やくろう',
  'やくわり',
  'やけあと',
  'やけあな',
  'やけいし',
  'やけぎみ',
  'やけぐい',
  'やけくそ',
  'やけこげ',
  'やけざけ',
  'やけしぬ',
  'やけつく',
  'やけのみ',
  'やけばら',
  'やけやま',
  'やこぜん',
  'やざいく',
  'やさいこ',
  'やさがし',
  'やさがた',
  'やさかに',
  'やさきに',
  'やさぐれ',
  'やさけび',
  'やさしい',
  'やさしげ',
  'やさんす',
  'やじうま',
  'やしおじ',
  'やしかく',
  'やしがに',
  'やじきた',
  'やしっこ',
  'やじでぃ',
  'やしとう',
  'やしどり',
  'やしない',
  'やしなう',
  'やしのき',
  'やしのみ',
  'やじぶか',
  'やしゃご',
  'やしゅう',
  'やじゅう',
  'やじょう',
  'やしょく',
  'やじるし',
  'やしんか',
  'やすうり',
  'やすかわ',
  'やすくに',
  'やすざけ',
  'やずでぃ',
  'やすぴか',
  'やすびん',
  'やすまる',
  'やすみば',
  'やすめる',
  'やすもの',
  'やすやす',
  'やすやど',
  'やすらい',
  'やすらう',
  'やすらか',
  'やすらぎ',
  'やすらぐ',
  'やすりめ',
  'やせいか',
  'やせいじ',
  'やせうで',
  'やせうま',
  'やせがた',
  'やせぎす',
  'やせざる',
  'やせじし',
  'やせすぎ',
  'やせつち',
  'やせむら',
  'やせやま',
  'やそかい',
  'やそがみ',
  'やそしま',
  'やたけに',
  'やたけび',
  'やちくさ',
  'やちぐさ',
  'やちだも',
  'やちとせ',
  'やちゅう',
  'やちょう',
  'やちょく',
  'やっかい',
  'やっかみ',
  'やっかむ',
  'やつがれ',
  'やっかん',
  'やつぎり',
  'やつくち',
  'やづくり',
  'やっこい',
  'やっこう',
  'やつざき',
  'やったあ',
  'やったー',
  'やったら',
  'やつどき',
  'やっとこ',
  'やつはし',
  'やっぱし',
  'やっぱぷ',
  'やつばら',
  'やっぱり',
  'やっぴー',
  'やっほー',
  'やつれる',
  'やどがえ',
  'やどかり',
  'やどせん',
  'やどだい',
  'やどちん',
  'やどなし',
  'やどぬし',
  'やどひき',
  'やとらに',
  'やどりぎ',
  'やどろく',
  'やとわれ',
  'やないば',
  'やなぎか',
  'やなぎば',
  'やなぐい',
  'やにある',
  'やにとり',
  'やにわに',
  'やねいた',
  'やねうら',
  'やねがえ',
  'やねまど',
  'やはうぇ',
  'やぶいぬ',
  'やぶいり',
  'やぶかげ',
  'やぶける',
  'やぶさか',
  'やぶさめ',
  'やぶそば',
  'やぶへび',
  'やぶまき',
  'やぶらん',
  'やぶれめ',
  'やぶれる',
  'やぼてん',
  'やぼよう',
  'やまあい',
  'やまあり',
  'やまいけ',
  'やまいぬ',
  'やまいも',
  'やまうば',
  'やまおく',
  'やまおり',
  'やまかい',
  'やまかけ',
  'やまかげ',
  'やまかじ',
  'やまかぜ',
  'やまがた',
  'やまがら',
  'やまがり',
  'やまかわ',
  'やまがわ',
  'やまかん',
  'やまぎり',
  'やまぎわ',
  'やまくさ',
  'やまぐさ',
  'やまぐち',
  'やまぐに',
  'やまぐも',
  'やまくら',
  'やまぐわ',
  'やまげた',
  'やまごえ',
  'やまごし',
  'やまごや',
  'やまさち',
  'やまさつ',
  'やまざと',
  'やまざる',
  'やましい',
  'やまじお',
  'やましぎ',
  'やました',
  'やましろ',
  'やまじろ',
  'やますそ',
  'やまずみ',
  'やませみ',
  'やまぞい',
  'やまそわ',
  'やまだし',
  'やまだち',
  'やまっけ',
  'やまづと',
  'やまづみ',
  'やまでら',
  'やまてん',
  'やまとえ',
  'やまとに',
  'やまどり',
  'やまない',
  'やまなか',
  'やまなし',
  'やまなす',
  'やまなみ',
  'やまなり',
  'やまにれ',
  'やまぬし',
  'やまねこ',
  'やまのい',
  'やまのき',
  'やまのせ',
  'やまのて',
  'やまのは',
  'やまのひ',
  'やまはい',
  'やまはぎ',
  'やまばく',
  'やまはぜ',
  'やまはた',
  'やまはだ',
  'やまばた',
  'やまばと',
  'やまばん',
  'やまびこ',
  'やまひだ',
  'やまびと',
  'やまひめ',
  'やまびる',
  'やまびわ',
  'やまぶき',
  'やまふじ',
  'やまぶし',
  'やまふだ',
  'やまへん',
  'やまぼこ',
  'やまほど',
  'やままゆ',
  'やまみず',
  'やまみち',
  'やまもと',
  'やまもも',
  'やまもり',
  'やまやき',
  'やまやけ',
  'やまやま',
  'やまゆき',
  'やまゆり',
  'やまわけ',
  'やまわろ',
  'やまんば',
  'やみあか',
  'やみいち',
  'やみうち',
  'やみおち',
  'やみきん',
  'やみくも',
  'やみごめ',
  'やみじる',
  'やみつき',
  'やみつく',
  'やみてん',
  'やみなべ',
  'やみやみ',
  'やむいも',
  'やむえず',
  'やむちゃ',
  'やむなく',
  'やめけん',
  'やめとき',
  'ややおも',
  'ややこい',
  'やよろず',
  'やらかい',
  'やらかす',
  'やらしい',
  'やらせる',
  'やらっぱ',
  'やらはた',
  'やらやら',
  'やられる',
  'やりあう',
  'やりいか',
  'やりぃっ',
  'やりがい',
  'やりかけ',
  'やりかた',
  'やりきる',
  'やりくち',
  'やりくり',
  'やりこい',
  'やりこみ',
  'やりこん',
  'やりさー',
  'やりさき',
  'やりすぎ',
  'やりだし',
  'やりだす',
  'やりだま',
  'やりちん',
  'やりっぱ',
  'やりとも',
  'やりとり',
  'やりなげ',
  'やりにげ',
  'やりぬく',
  'やりまん',
  'やりみず',
  'やりもく',
  'やりもち',
  'やりょう',
  'やりよう',
  'やれやれ',
  'やわにく',
  'やわはだ',
  'やわらか',
  'やわらぎ',
  'やわらぐ',
  'やんえぐ',
  'やんきー',
  'やんごん',
  'やんしゃ',
  'やんちゃ',
  'やんちょ',
  'やんでれ',
  'やんぱぱ',
  'やんばる',
  'やんばん',
  'やんまま',
  'やんわり',
  'ゆあがり',
  'ゆあたり',
  'ゆあつき',
  'ゆいいつ',
  'ゆいがい',
  'ゆいかた',
  'ゆいがみ',
  'ゆいごう',
  'ゆいごん',
  'ゆいしき',
  'ゆいしょ',
  'ゆいしん',
  'ゆいちー',
  'ゆいのう',
  'ゆいぶつ',
  'ゆいわた',
  'ゆうあい',
  'ゆーあい',
  'ゆうあく',
  'ゆうあん',
  'ゆういぎ',
  'ゆういさ',
  'ゆういつ',
  'ゆういん',
  'ゆううつ',
  'ゆうえい',
  'ゆうえき',
  'ゆうえつ',
  'ゆうえん',
  'ゆーえん',
  'ゆうおう',
  'ゆーかー',
  'ゆうかい',
  'ゆうがい',
  'ゆうがお',
  'ゆうかく',
  'ゆうがく',
  'ゆうかげ',
  'ゆうがし',
  'ゆうかぜ',
  'ゆうがた',
  'ゆーから',
  'ゆーかり',
  'ゆうかん',
  'ゆうきょ',
  'ゆうぎょ',
  'ゆうぎり',
  'ゆうきん',
  'ゆうぎん',
  'ゆうぐう',
  'ゆうぐも',
  'ゆうぐれ',
  'ゆうくん',
  'ゆうぐん',
  'ゆうけい',
  'ゆうげい',
  'ゆうげき',
  'ゆうけつ',
  'ゆうけん',
  'ゆうげん',
  'ゆうこう',
  'ゆうごう',
  'ゆうこく',
  'ゆうこん',
  'ゆーざー',
  'ゆうさい',
  'ゆうざい',
  'ゆうさつ',
  'ゆーざぶ',
  'ゆうさん',
  'ゆうしお',
  'ゆうしき',
  'ゆうしつ',
  'ゆうしゃ',
  'ゆうじゃ',
  'ゆうしゅ',
  'ゆうじょ',
  'ゆうしん',
  'ゆうじん',
  'ゆうすい',
  'ゆうずい',
  'ゆうすう',
  'ゆうずう',
  'ゆうすげ',
  'ゆーずど',
  'ゆうする',
  'ゆうせい',
  'ゆうぜい',
  'ゆうせき',
  'ゆうせつ',
  'ゆうぜみ',
  'ゆうせん',
  'ゆうぜん',
  'ゆうそう',
  'ゆうそく',
  'ゆうそこ',
  'ゆうぞら',
  'ゆうたい',
  'ゆうだい',
  'ゆうだち',
  'ゆうたん',
  'ゆうだん',
  'ゆうちょ',
  'ゆうづう',
  'ゆうづき',
  'ゆうてい',
  'ゆうてん',
  'ゆうでん',
  'ゆうとう',
  'ゆうどう',
  'ゆうとく',
  'ゆうどく',
  'ゆうどひ',
  'ゆーどら',
  'ゆうなぎ',
  'ゆうなる',
  'ゆうにじ',
  'ゆうのう',
  'ゆうはい',
  'ゆうばえ',
  'ゆうばく',
  'ゆうはつ',
  'ゆうばれ',
  'ゆうはん',
  'ゆーびー',
  'ゆーぴー',
  'ゆうびえ',
  'ゆうひつ',
  'ゆうびん',
  'ゆうふう',
  'ゆうふく',
  'ゆうぶつ',
  'ゆうふん',
  'ゆうぶん',
  'ゆうへい',
  'ゆうへん',
  'ゆうべん',
  'ゆうほう',
  'ゆうぼう',
  'ゆうぼく',
  'ゆうまい',
  'ゆうみん',
  'ゆうめい',
  'ゆうめし',
  'ゆーもあ',
  'ゆうもう',
  'ゆうもや',
  'ゆうもん',
  'ゆうやく',
  'ゆうやけ',
  'ゆうやみ',
  'ゆうゆう',
  'ゆうよう',
  'ゆうよく',
  'ゆうらく',
  'ゆうらん',
  'ゆうりか',
  'ゆうりき',
  'ゆうりご',
  'ゆうりょ',
  'ゆうりん',
  'ゆうれい',
  'ゆーれか',
  'ゆうれき',
  'ゆうれつ',
  'ゆうろう',
  'ゆうわく',
  'ゆえない',
  'ゆかいた',
  'ゆかうえ',
  'ゆかげん',
  'ゆかざい',
  'ゆかしい',
  'ゆかした',
  'ゆかたじ',
  'ゆかだん',
  'ゆかどん',
  'ゆがめる',
  'ゆかめん',
  'ゆきあう',
  'ゆきうち',
  'ゆきうら',
  'ゆきおれ',
  'ゆきかい',
  'ゆきかう',
  'ゆきかき',
  'ゆきがけ',
  'ゆきかぜ',
  'ゆきかた',
  'ゆきがた',
  'ゆきがら',
  'ゆきぎえ',
  'ゆきぐつ',
  'ゆきぐに',
  'ゆきぐも',
  'ゆきさき',
  'ゆきざさ',
  'ゆきしつ',
  'ゆきしな',
  'ゆきしる',
  'ゆきじる',
  'ゆきしろ',
  'ゆきじろ',
  'ゆきすき',
  'ゆきすぎ',
  'ゆきずり',
  'ゆきぞら',
  'ゆきだま',
  'ゆきちゃ',
  'ゆきつく',
  'ゆきつけ',
  'ゆきつり',
  'ゆきづり',
  'ゆきどけ',
  'ゆきどめ',
  'ゆきなげ',
  'ゆきなし',
  'ゆきなり',
  'ゆきはだ',
  'ゆきばな',
  'ゆきばら',
  'ゆきばれ',
  'ゆきふみ',
  'ゆきふり',
  'ゆきみず',
  'ゆきみち',
  'ゆきむし',
  'ゆきむろ',
  'ゆきもち',
  'ゆきやけ',
  'ゆきやま',
  'ゆぎょう',
  'ゆきよけ',
  'ゆきわり',
  'ゆきんこ',
  'ゆくかた',
  'ゆくさき',
  'ゆくすえ',
  'ゆくとし',
  'ゆくはる',
  'ゆくゆく',
  'ゆけむり',
  'ゆさぶり',
  'ゆさぶる',
  'ゆざまし',
  'ゆさゆさ',
  'ゆしのき',
  'ゆしゃん',
  'ゆしゅつ',
  'ゆしょう',
  'ゆじょう',
  'ゆしょく',
  'ゆずしゅ',
  'ゆずちゃ',
  'ゆすのき',
  'ゆすぶる',
  'ゆずぶろ',
  'ゆずぼう',
  'ゆずみそ',
  'ゆすりか',
  'ゆずりは',
  'ゆすれる',
  'ゆそうか',
  'ゆそうき',
  'ゆそうひ',
  'ゆそでん',
  'ゆだこう',
  'ゆだねる',
  'ゆたんぽ',
  'ゆちゃく',
  'ゆづかれ',
  'ゆっくり',
  'ゆったり',
  'ゆでえび',
  'ゆでじる',
  'ゆでたこ',
  'ゆでだこ',
  'ゆでめん',
  'ゆどうふ',
  'ゆどおし',
  'ゆなぶろ',
  'ゆにーく',
  'ゆにおん',
  'ゆにせふ',
  'ゆにぞん',
  'ゆにっと',
  'ゆにばれ',
  'ゆにゅう',
  'ゆねすこ',
  'ゆねっぷ',
  'ゆのはな',
  'ゆばたけ',
  'ゆびあな',
  'ゆびいた',
  'ゆびいれ',
  'ゆびおり',
  'ゆびがね',
  'ゆびきり',
  'ゆびげい',
  'ゆびさき',
  'ゆびさし',
  'ゆびざし',
  'ゆびさす',
  'ゆびざる',
  'ゆびつめ',
  'ゆぴてる',
  'ゆびぬき',
  'ゆびぶえ',
  'ゆびまん',
  'ゆびもじ',
  'ゆみがた',
  'ゆみづる',
  'ゆみとり',
  'ゆみなり',
  'ゆみのこ',
  'ゆみはず',
  'ゆみはり',
  'ゆみひく',
  'ゆみへん',
  'ゆめおち',
  'ゆめぐり',
  'ゆめとき',
  'ゆめにも',
  'ゆめみる',
  'ゆめゆめ',
  'ゆゆしい',
  'ゆゆしき',
  'ゆらめき',
  'ゆらめく',
  'ゆらゆら',
  'ゆりいか',
  'ゆりいす',
  'ゆりかご',
  'ゆりのき',
  'ゆりょう',
  'ゆるがす',
  'ゆるがせ',
  'ゆるふわ',
  'ゆるまる',
  'ゆるめる',
  'ゆるやか',
  'ゆるゆる',
  'ゆわえる',
  'ゆわかし',
  'ゆんぜい',
  'よあかし',
  'よあがり',
  'よあそび',
  'よあらい',
  'よあらし',
  'よあるき',
  'よいごし',
  'よいこと',
  'よいころ',
  'よいざめ',
  'よいしょ',
  'よいづき',
  'よいづみ',
  'よいどめ',
  'よいどれ',
  'よいやさ',
  'よいやま',
  'よいやみ',
  'よいよい',
  'よいんし',
  'ようあつ',
  'ようあん',
  'よういく',
  'よういん',
  'よううん',
  'ようえい',
  'ようえき',
  'ようえん',
  'ようおん',
  'ようかい',
  'ようがい',
  'ようがか',
  'ようかく',
  'ようがく',
  'ようがさ',
  'ようがし',
  'ようかた',
  'ようかん',
  'ようがん',
  'ようきが',
  'ようきゃ',
  'ようぎょ',
  'ようきん',
  'ようぎん',
  'ようくん',
  'ようぐん',
  'ようけい',
  'ようげー',
  'ようげき',
  'ようけつ',
  'ようけん',
  'ようげん',
  'ようこう',
  'ようこく',
  'ようこそ',
  'ようこん',
  'ようさい',
  'ようざい',
  'ようさん',
  'ようざん',
  'ようしき',
  'ようじき',
  'ようじご',
  'ようしし',
  'ようしつ',
  'ようしゃ',
  'ようじゃ',
  'ようしゅ',
  'ようじゅ',
  'ようしょ',
  'ようじょ',
  'ようしん',
  'ようじん',
  'ようすい',
  'ようすみ',
  'ようずみ',
  'ようする',
  'ようせい',
  'ようせき',
  'ようせつ',
  'ようせん',
  'ようそう',
  'ようそか',
  'ようそつ',
  'ようそろ',
  'ようそん',
  'ようぞん',
  'ようたい',
  'ようだい',
  'ようたし',
  'ようたつ',
  'ようだん',
  'ようちく',
  'ようつい',
  'ようつう',
  'ようつべ',
  'ようてい',
  'ようてき',
  'ようです',
  'ようてん',
  'ようとう',
  'ようどう',
  'ようとじ',
  'ようとん',
  'ようなし',
  'ようにく',
  'ようにん',
  'ようねん',
  'ようはい',
  'ようばい',
  'ようはく',
  'ようはつ',
  'ようぱん',
  'ようひし',
  'ようひつ',
  'ようひん',
  'ようふう',
  'ようふく',
  'ようぶつ',
  'ようふぼ',
  'ようふん',
  'ようぶん',
  'ようへい',
  'ようへき',
  'ようへん',
  'ようべん',
  'ようほう',
  'ようぼう',
  'ようぼく',
  'ようほん',
  'ようまく',
  'ようまん',
  'ようむき',
  'ようめい',
  'ようもう',
  'ようもく',
  'ようもの',
  'ようやく',
  'ようゆう',
  'ようよう',
  'ようらく',
  'ようらん',
  'ようりき',
  'ようりく',
  'ようりつ',
  'ようれい',
  'ようれき',
  'ようれつ',
  'ようろう',
  'よーしん',
  'よーちん',
  'よーでる',
  'よーまん',
  'よーよー',
  'よかせい',
  'よかせぎ',
  'よがたり',
  'よがらす',
  'よからぬ',
  'よかろう',
  'よぎしゃ',
  'よきせぬ',
  'よぎない',
  'よぎなく',
  'よきひと',
  'よきほど',
  'よきょう',
  'よぎょう',
  'よくあさ',
  'よくあつ',
  'よくある',
  'よくいう',
  'よくうつ',
  'よくかい',
  'よくがた',
  'よくげつ',
  'よくさん',
  'よくしつ',
  'よくじつ',
  'よくしゃ',
  'よくしん',
  'よくじん',
  'よくする',
  'よくせい',
  'よくそう',
  'よくでん',
  'よくとう',
  'よくとく',
  'よくとし',
  'よくなる',
  'よくねん',
  'よくはば',
  'よくばり',
  'よくばる',
  'よくばん',
  'よくふか',
  'よくぶか',
  'よくふく',
  'よくぼう',
  'よくまあ',
  'よくやき',
  'よくよう',
  'よくよく',
  'よくろう',
  'よければ',
  'よこあい',
  'よこあし',
  'よこあな',
  'よこいた',
  'よこいと',
  'よこいり',
  'よこえび',
  'よこがお',
  'よこがき',
  'よこかぜ',
  'よこから',
  'よこぎる',
  'よこくし',
  'よこぐみ',
  'よこぐも',
  'よここう',
  'よこざい',
  'よこさま',
  'よこざま',
  'よこじく',
  'よこしま',
  'よこじま',
  'よこずき',
  'よこすじ',
  'よこずれ',
  'よこせん',
  'よこだき',
  'よこちち',
  'よこちょ',
  'よこづけ',
  'よこづち',
  'よこづな',
  'よこつら',
  'よことじ',
  'よことび',
  'よこどり',
  'よこなが',
  'よこなぎ',
  'よこなげ',
  'よこなみ',
  'よこばい',
  'よこぱい',
  'よこばし',
  'よこぱす',
  'よこはば',
  'よこはま',
  'よこばら',
  'よこばり',
  'よこぶえ',
  'よこぶり',
  'よこぼう',
  'よこぼり',
  'よこみち',
  'よこみつ',
  'よこむき',
  'よこむく',
  'よこめし',
  'よこもじ',
  'よこもち',
  'よこもの',
  'よごもり',
  'よこやり',
  'よこゆれ',
  'よこれす',
  'よごれる',
  'よざくら',
  'よさこい',
  'よさそう',
  'よざらし',
  'よさんい',
  'よさんか',
  'よしあし',
  'よしある',
  'よじうむ',
  'よしがも',
  'よしきた',
  'よしきり',
  'よじげん',
  'よしごい',
  'よしごと',
  'よしなき',
  'よしなに',
  'よしぶえ',
  'よしゅう',
  'よじゅう',
  'よしゅく',
  'よじょう',
  'よしょく',
  'よしよし',
  'よじれる',
  'よしわら',
  'よしんば',
  'よすいろ',
  'よすすぎ',
  'よせあう',
  'よせうえ',
  'よせがき',
  'よせぎれ',
  'よせくる',
  'よせざん',
  'よせせき',
  'よせなべ',
  'よせなみ',
  'よせばし',
  'よせむね',
  'よせやい',
  'よそいき',
  'よそうび',
  'よそうや',
  'よそえる',
  'よそおい',
  'よそおう',
  'よそぎき',
  'よそごと',
  'よそもの',
  'よそゆき',
  'よだきい',
  'よたもの',
  'よたもん',
  'よたよた',
  'よたろう',
  'よちょう',
  'よちよち',
  'よつあし',
  'よつうち',
  'よつおり',
  'よっかい',
  'よっかく',
  'よつかど',
  'よつがな',
  'よつぎり',
  'よっしゃ',
  'よったり',
  'よつつじ',
  'よってる',
  'よつのお',
  'よつばい',
  'よっぴて',
  'よっぽど',
  'よていし',
  'よていび',
  'よとうが',
  'よどおし',
  'よどぼけ',
  'よどまり',
  'よなおし',
  'よなげる',
  'よなしょ',
  'よなぬき',
  'よなのか',
  'よなよな',
  'よなれる',
  'よにいう',
  'よにげや',
  'よにたつ',
  'よにでる',
  'よにとく',
  'よにゅう',
  'よのぜん',
  'よのつね',
  'よのなか',
  'よばなし',
  'よばれる',
  'よばわり',
  'よばわる',
  'よびあう',
  'よびいん',
  'よびうり',
  'よびえき',
  'よびかけ',
  'よびかた',
  'よびきん',
  'よびぐん',
  'よびこう',
  'よびごえ',
  'よびこみ',
  'よびこむ',
  'よびざい',
  'よびじお',
  'よびしつ',
  'よびすて',
  'よびたい',
  'よびだし',
  'よびだす',
  'よびてき',
  'よびどい',
  'よびひん',
  'よびへい',
  'よびみず',
  'よびもの',
  'よひょう',
  'よびょう',
  'よびりん',
  'よひんべ',
  'よぶかい',
  'よふかし',
  'よふけて',
  'よぼよぼ',
  'よまつり',
  'よまわり',
  'よみあげ',
  'よみいい',
  'よみうり',
  'よみがえ',
  'よみかき',
  'よみかけ',
  'よみかた',
  'よみがな',
  'よみきり',
  'よみきる',
  'よみくせ',
  'よみこみ',
  'よみこむ',
  'よみさし',
  'よみさす',
  'よみする',
  'よみだし',
  'よみだす',
  'よみつぐ',
  'よみとく',
  'よみとり',
  'よみとる',
  'よみびと',
  'よみふだ',
  'よみぶり',
  'よみほん',
  'よみもの',
  'よみよい',
  'よめいり',
  'よめいる',
  'よめさん',
  'よめとり',
  'よめはん',
  'よもぎう',
  'よもじご',
  'よもすえ',
  'よやくご',
  'よやとう',
  'よりあい',
  'よりあう',
  'よりいと',
  'よりうえ',
  'よりきり',
  'よりきる',
  'よりくず',
  'よりけり',
  'よりしろ',
  'よりせん',
  'よりそう',
  'よりだす',
  'よりつき',
  'よりつく',
  'よりどり',
  'よりぬき',
  'よりぬく',
  'よりまし',
  'よりみち',
  'よりよい',
  'よりょく',
  'よりより',
  'よるがお',
  'よるがた',
  'よるだん',
  'よるばご',
  'よるひる',
  'よるよう',
  'よれよれ',
  'よろいど',
  'よろける',
  'よろこび',
  'よろこぶ',
  'よろしい',
  'よろしく',
  'よろずや',
  'よろずよ',
  'よろつく',
  'よろぴく',
  'よろめく',
  'よろよろ',
  'よわあめ',
  'よわごし',
  'よわせる',
  'よわたり',
  'よわまり',
  'よわまる',
  'よわみそ',
  'よわむし',
  'よわめる',
  'よわりめ',
  'よをさる',
  'よんけー',
  'よんこま',
  'よんじょ',
  'よんせい',
  'よんせん',
  'よんだい',
  'よんとう',
  'よんなん',
  'よんばい',
  'よんほん',
  'よんもじ',
  'よんりん',
  'らーおご',
  'らーかー',
  'らーげり',
  'らーげる',
  'らーじゃ',
  'らーてる',
  'らーばん',
  'らーふら',
  'らーまん',
  'らあめん',
  'らーめん',
  'らーんち',
  'らいあー',
  'らいいん',
  'らいうん',
  'らいえつ',
  'らいえん',
  'らいおき',
  'らいおん',
  'らいがー',
  'らいかい',
  'らいかく',
  'らいがく',
  'らいかん',
  'らいがん',
  'らいぎょ',
  'らいきん',
  'らいげき',
  'らいげつ',
  'らいけん',
  'らいこう',
  'らいごう',
  'らいこす',
  'らいさつ',
  'らいさん',
  'らいじつ',
  'らいしゃ',
  'らいしょ',
  'らいしん',
  'らいじん',
  'らいすき',
  'らいせい',
  'らいせん',
  'らいそん',
  'らいたー',
  'らいだー',
  'らいたく',
  'らいだん',
  'らいちー',
  'らいてい',
  'らいてん',
  'らいでん',
  'らいとう',
  'らいどう',
  'らいなー',
  'らいにち',
  'らいにん',
  'らいねん',
  'らいのべ',
  'らいばー',
  'らいはい',
  'らいはく',
  'らいはつ',
  'らいはる',
  'らいばる',
  'らいはん',
  'らいばん',
  'らいひい',
  'らいひー',
  'らいひん',
  'らいふく',
  'らいふる',
  'らいほう',
  'らいぼん',
  'らいまめ',
  'らいむぎ',
  'らいめい',
  'らいゆう',
  'らいよけ',
  'らいらい',
  'らいらく',
  'らいりん',
  'らいれき',
  'らゔこめ',
  'らうたー',
  'らうほあ',
  'らうりる',
  'らうんじ',
  'らうんち',
  'らうんど',
  'らおすご',
  'らかんか',
  'らぎっど',
  'らぎょう',
  'らくいん',
  'らくーん',
  'らぐーん',
  'らくえき',
  'らくえん',
  'らくがい',
  'らくがき',
  'らくがく',
  'らくがみ',
  'らくがん',
  'らくげつ',
  'らくごか',
  'らくさつ',
  'らくさん',
  'らくじつ',
  'らくしゃ',
  'らぐしゃ',
  'らくしゅ',
  'らくしょ',
  'らくじん',
  'らくすい',
  'らくせい',
  'らくせき',
  'らくせつ',
  'らくせん',
  'らくそう',
  'らくたい',
  'らくだい',
  'らくだか',
  'らくだつ',
  'らくたむ',
  'らくたん',
  'らくちん',
  'らくてつ',
  'らくてん',
  'らくとん',
  'らくない',
  'らくなん',
  'らくのう',
  'らくばい',
  'らくはく',
  'らくばく',
  'らくはつ',
  'らくばん',
  'らぐびー',
  'らくひつ',
  'らくほく',
  'らくぼく',
  'らくめい',
  'らくめん',
  'らくやき',
  'らくよう',
  'らくらい',
  'らくらく',
  'らぐらん',
  'らくるい',
  'らくろす',
  'らげーじ',
  'らげっじ',
  'らけっと',
  'らごーら',
  'らこりす',
  'らざにあ',
  'らざにえ',
  'らさにや',
  'らじある',
  'らじあん',
  'らじうす',
  'らじうむ',
  'らじえた',
  'らじかせ',
  'らじかる',
  'らじこん',
  'らじゃー',
  'らしゅつ',
  'らしんぎ',
  'らすおや',
  'らすたー',
  'らすたか',
  'らすぼす',
  'らすぼら',
  'らせみか',
  'らたいが',
  'らちがい',
  'らちない',
  'らちゅう',
  'らっかー',
  'らっかん',
  'らっきぃ',
  'らっきー',
  'らっきょ',
  'らっけい',
  'らっけん',
  'らっしー',
  'らっしゅ',
  'らっせる',
  'らったる',
  'らっぱー',
  'らっふる',
  'らつわん',
  'らてぃす',
  'らてっく',
  'らてらん',
  'らてるね',
  'らてんご',
  'らとびあ',
  'らのりん',
  'らばーぶ',
  'らはーる',
  'らばうる',
  'らぴあー',
  'らびおり',
  'らびっと',
  'らふあん',
  'らふぃあ',
  'らぶいん',
  'らぶかか',
  'らぶこめ',
  'らぷこん',
  'らふてえ',
  'らふてー',
  'らぶばな',
  'らぶらぶ',
  'らぶりー',
  'らべいか',
  'らほうい',
  'らぽーる',
  'らまだん',
  'らみにん',
  'らむしゅ',
  'らむばす',
  'らめきん',
  'ららばい',
  'らりった',
  'らんいち',
  'らんいん',
  'らんうん',
  'らんえき',
  'らんえん',
  'らんおう',
  'らんかー',
  'らんかい',
  'らんがい',
  'らんかく',
  'らんがく',
  'らんかつ',
  'らんかん',
  'らんぎく',
  'らんぎり',
  'らんきん',
  'らんぐい',
  'らんくつ',
  'らんぐん',
  'らんけい',
  'らんげき',
  'らんげつ',
  'らんこう',
  'らんこく',
  'らんこん',
  'らんさー',
  'らんさく',
  'らんざつ',
  'らんしゃ',
  'らんしゅ',
  'らんしん',
  'らんじん',
  'らんすい',
  'らんすう',
  'らんする',
  'らんせい',
  'らんせん',
  'らんそう',
  'らんぞう',
  'らんたな',
  'らんだむ',
  'らんたん',
  'らんちえ',
  'らんづみ',
  'らんてん',
  'らんとう',
  'らんどく',
  'らんどり',
  'らんなー',
  'らんのう',
  'らんばい',
  'らんぱく',
  'らんばだ',
  'らんばつ',
  'らんぱつ',
  'らんぱぶ',
  'らんぱん',
  'らんぴつ',
  'らんびん',
  'らんぶん',
  'らんぷん',
  'らんほう',
  'らんぼう',
  'らんぽう',
  'らんまー',
  'らんまく',
  'らんまん',
  'らんよう',
  'らんらん',
  'らんりつ',
  'らんりん',
  'りあーぜ',
  'りあーる',
  'りあかー',
  'りあこい',
  'りあさす',
  'りあたい',
  'りあとも',
  'りーゔる',
  'りーおう',
  'りーがー',
  'りーがる',
  'りーきー',
  'りーさす',
  'りーしゅ',
  'りーずん',
  'りーぞく',
  'りーだー',
  'りーづも',
  'りーぱー',
  'りーぱい',
  'りーぶる',
  'りーまー',
  'りーまん',
  'りうまち',
  'りえぞん',
  'りえっと',
  'りがーぜ',
  'りかいど',
  'りかおん',
  'りかがく',
  'りがくし',
  'りがくぶ',
  'りかけい',
  'りかばー',
  'りかばり',
  'りがんど',
  'りきえい',
  'りきえき',
  'りきえん',
  'りきがく',
  'りきかん',
  'りきさく',
  'りきしょ',
  'りきせき',
  'りきせつ',
  'りきせん',
  'りきそう',
  'りきっど',
  'りきてん',
  'りきとう',
  'りきへん',
  'りきやく',
  'りきゅう',
  'りきょう',
  'りぎょう',
  'りきりつ',
  'りぎんぐ',
  'りくあげ',
  'りくーど',
  'りくうん',
  'りくおう',
  'りくかい',
  'りくがい',
  'りくかぜ',
  'りくがめ',
  'りくかん',
  'りくがん',
  'りくぐん',
  'りくけい',
  'りくこう',
  'りくごう',
  'りくこく',
  'りくさん',
  'りくしょ',
  'りくすい',
  'りくすー',
  'りくする',
  'りくせい',
  'りくせん',
  'りくぜん',
  'りくそう',
  'りくぞく',
  'りくたい',
  'りくだい',
  'りくだな',
  'りくつや',
  'りくでん',
  'りくとう',
  'りくとれ',
  'りぐなん',
  'りぐにん',
  'りくふう',
  'りくへい',
  'りくほう',
  'りくらぶ',
  'りくれん',
  'りけじょ',
  'りけんや',
  'りこいる',
  'りこうか',
  'りこーだ',
  'りこーる',
  'りこしん',
  'りこった',
  'りこてき',
  'りこぴん',
  'りこぺん',
  'りこりす',
  'りさーち',
  'りざーど',
  'りざーぶ',
  'りざいか',
  'りさいず',
  'りざりあ',
  'りざると',
  'りじかい',
  'りじこく',
  'りしゅう',
  'りじゅん',
  'りしょう',
  'りしょく',
  'りじょん',
  'りしりつ',
  'りすきー',
  'りすざる',
  'りすとあ',
  'りすとら',
  'りすなー',
  'りすぼあ',
  'りすぼん',
  'りせーる',
  'りせっと',
  'りせまら',
  'りせらー',
  'りそうか',
  'りそーす',
  'りぞーと',
  'りぞーる',
  'りぞっと',
  'りぞらば',
  'りぞるば',
  'りたーん',
  'りたいあ',
  'りたいや',
  'りたっち',
  'りたりん',
  'りちうむ',
  'りちてき',
  'りちょう',
  'りつあん',
  'りっかん',
  'りつがん',
  'りっけい',
  'りっけん',
  'りつげん',
  'りっこう',
  'りっこく',
  'りっしん',
  'りっすい',
  'りっする',
  'りっすん',
  'りっせん',
  'りつせん',
  'りつぜん',
  'りつぞう',
  'りっそく',
  'りったー',
  'りったい',
  'りつだい',
  'りつだん',
  'りっちも',
  'りっとう',
  'りつどう',
  'りっとる',
  'りっぱー',
  'りっぱい',
  'りっぷく',
  'りっぷそ',
  'りっぷる',
  'りつぶん',
  'りっぽう',
  'りつみん',
  'りつめい',
  'りつめん',
  'りつりょ',
  'りつれい',
  'りつれつ',
  'りつろん',
  'りでぃあ',
  'りていく',
  'りてーく',
  'りてーる',
  'りてなー',
  'りてらし',
  'りてらる',
  'りどぅー',
  'りとます',
  'りとらい',
  'りどれす',
  'りにくす',
  'りにゅー',
  'りにゅう',
  'りにょう',
  'りぬくす',
  'りねーじ',
  'りねーむ',
  'りのある',
  'りのーる',
  'りばーし',
  'りばーす',
  'りぱーぜ',
  'りばーぶ',
  'りはつし',
  'りはびり',
  'りばらい',
  'りばりー',
  'りぴーた',
  'りぴーと',
  'りびどー',
  'りひむい',
  'りびょう',
  'りびんぐ',
  'りふぃる',
  'りぶーと',
  'りふじん',
  'りぷらい',
  'りぷらん',
  'りぷれい',
  'りぷれー',
  'りべーと',
  'りべった',
  'りべっと',
  'りべらる',
  'りべりあ',
  'りべんか',
  'りべんじ',
  'りぽいど',
  'りぼーく',
  'りぼーす',
  'りぽーと',
  'りほーむ',
  'りぽさん',
  'りぽすと',
  'りまーく',
  'りまわり',
  'りみった',
  'りみっと',
  'りむーぶ',
  'りむじん',
  'りめいく',
  'りめーく',
  'りめんし',
  'りもーと',
  'りもこん',
  'りもねん',
  'りやーる',
  'りやかー',
  'りゃくが',
  'りゃくぎ',
  'りゃくご',
  'りゃくし',
  'りゃくじ',
  'りゃくす',
  'りゃくず',
  'りゃくふ',
  'りゃっき',
  'りゃんこ',
  'りゅうい',
  'りゅうか',
  'りゅうが',
  'りゅうき',
  'りゅうぎ',
  'りゅうこ',
  'りゅうご',
  'りゅうさ',
  'りゅうざ',
  'りゅうし',
  'りゆーす',
  'りゅーず',
  'りゅうず',
  'りゅうち',
  'りゅーと',
  'りゅうど',
  'りゅうは',
  'りゅうび',
  'りゅうほ',
  'りゅうめ',
  'りゅうり',
  'りゅうろ',
  'りゅくす',
  'りゅっく',
  'りゅらー',
  'りょうい',
  'りょうう',
  'りょうか',
  'りょうが',
  'りょうき',
  'りょうぎ',
  'りょうぐ',
  'りょうけ',
  'りょうこ',
  'りょうご',
  'りょうし',
  'りようし',
  'りょうじ',
  'りょうち',
  'りょうて',
  'りょうど',
  'りょうは',
  'りょうば',
  'りょうひ',
  'りょうふ',
  'りょうぶ',
  'りょうほ',
  'りょうぼ',
  'りょうみ',
  'りょうめ',
  'りょうや',
  'りょうら',
  'りょうり',
  'りょうる',
  'りょがい',
  'りょかく',
  'りょかん',
  'りょくう',
  'りょくか',
  'りょくさ',
  'りょくち',
  'りょくど',
  'りょくば',
  'りょくひ',
  'りょくや',
  'りょけん',
  'りょこう',
  'りょしゃ',
  'りょしん',
  'りょじん',
  'りよせる',
  'りょせん',
  'りょそう',
  'りょだん',
  'りょっか',
  'りょてい',
  'りょてん',
  'りょはん',
  'りょもん',
  'りらいと',
  'りりあん',
  'りりーす',
  'りりーふ',
  'りりいべ',
  'りりかる',
  'りりこい',
  'りりしい',
  'りりっく',
  'りりやん',
  'りりゅう',
  'りりょう',
  'りりょく',
  'りるーと',
  'りれいず',
  'りろーど',
  'りろんか',
  'りろんち',
  'りわーど',
  'りんかー',
  'りんがー',
  'りんかい',
  'りんかく',
  'りんがく',
  'りんがら',
  'りんかん',
  'りんきょ',
  'りんぎょ',
  'りんきん',
  'りんくう',
  'りんくす',
  'りんけい',
  'りんげつ',
  'りんげる',
  'りんけん',
  'りんげん',
  'りんこう',
  'りんこく',
  'りんごく',
  'りんごす',
  'りんさい',
  'りんざい',
  'りんさく',
  'りんさん',
  'りんじく',
  'りんしつ',
  'りんじひ',
  'りんしゃ',
  'りんしょ',
  'りんじん',
  'りんせい',
  'りんせき',
  'りんせつ',
  'りんせん',
  'りんぜん',
  'りんぞう',
  'りんそん',
  'りんたー',
  'りんたく',
  'りんてん',
  'りんでん',
  'りんどう',
  'りんどく',
  'りんない',
  'りんねる',
  'りんばつ',
  'りんばん',
  'りんぷん',
  'りんぺん',
  'りんぼう',
  'りんぽう',
  'りんぼー',
  'りんぼく',
  'りんめい',
  'りんもう',
  'りんよう',
  'りんらく',
  'りんりつ',
  'りんりん',
  'りんれつ',
  'るあんだ',
  'るいいん',
  'るいえき',
  'るいえん',
  'るいおん',
  'るいかつ',
  'るいかん',
  'るいぎご',
  'るいぐん',
  'るいけい',
  'るいげつ',
  'るいげん',
  'るいこつ',
  'るいさん',
  'るいじつ',
  'るいじど',
  'るいじゅ',
  'るいしょ',
  'るいしん',
  'るいすい',
  'るいする',
  'るいせい',
  'るいせき',
  'るいせつ',
  'るいせん',
  'るいそう',
  'るいぞう',
  'るいそん',
  'るいだい',
  'るいてん',
  'るいどう',
  'るいとも',
  'るいねん',
  'るいのう',
  'るいはん',
  'るいぶん',
  'るいへき',
  'るいべつ',
  'るいぼす',
  'るいほん',
  'るいらん',
  'るいるい',
  'るいれい',
  'るいれき',
  'るゔぁん',
  'るゔぃご',
  'るーゔる',
  'るーきー',
  'るーこら',
  'るーざー',
  'るーさん',
  'るーじゅ',
  'るーたー',
  'るーちん',
  'るーばー',
  'るーぴん',
  'るーぶり',
  'るーぶる',
  'るーめん',
  'るーらー',
  'るーらる',
  'るかでん',
  'るごーる',
  'るじゅつ',
  'るすたく',
  'るすでん',
  'るすのま',
  'るすばん',
  'るすろく',
  'るたばが',
  'るっくす',
  'るっこら',
  'るっさい',
  'るていん',
  'るばーと',
  'るばーぶ',
  'るばしか',
  'るぱしか',
  'るぴなす',
  'るびふり',
  'るふぼん',
  'るふらん',
  'るりいろ',
  'るりがい',
  'るりはた',
  'るれっと',
  'るわんだ',
  'るんぎー',
  'るんぺん',
  'るんるん',
  'れあひん',
  'れあもの',
  'れいあー',
  'れいいき',
  'れいえん',
  'れいおふ',
  'れいおん',
  'れいかい',
  'れいがい',
  'れいかく',
  'れいがく',
  'れいかん',
  'れいがん',
  'れいきん',
  'れいぐう',
  'れいけい',
  'れいけつ',
  'れいげつ',
  'れいけん',
  'れいげん',
  'れいこう',
  'れいごう',
  'れいこー',
  'れいこく',
  'れいこん',
  'れいさい',
  'れいざん',
  'れいしき',
  'れいじき',
  'れいしつ',
  'れいじつ',
  'れいじぼ',
  'れいしゅ',
  'れいしょ',
  'れいしん',
  'れいじん',
  'れいすい',
  'れいすう',
  'れいする',
  'れいせい',
  'れいせき',
  'れいせつ',
  'れいせん',
  'れいぜん',
  'れいそう',
  'れいぞう',
  'れいそく',
  'れいぞく',
  'れいそん',
  'れいだい',
  'れいたつ',
  'れいたん',
  'れいてい',
  'れいてき',
  'れいてつ',
  'れいてん',
  'れいでん',
  'れいとう',
  'れいどう',
  'れいとく',
  'れいにー',
  'れいにく',
  'れいねつ',
  'れいねん',
  'れいのう',
  'れいばー',
  'れいぱー',
  'れいはい',
  'れいばい',
  'れいはん',
  'れいぴあ',
  'れいひつ',
  'れいふう',
  'れいふく',
  'れいふん',
  'れいぶん',
  'れいほう',
  'れいぼう',
  'れいぼく',
  'れいほん',
  'れいまい',
  'れいまん',
  'れいみん',
  'れいめい',
  'れいめん',
  'れいもつ',
  'れいやー',
  'れいやく',
  'れいゆう',
  'れいよう',
  'れいよし',
  'れいよん',
  'れいらく',
  'れいれい',
  'れいろう',
  'れいんじ',
  'れゔぇる',
  'れゔゅー',
  'れーえん',
  'れーこん',
  'れーさー',
  'れーざー',
  'れーしー',
  'れーずん',
  'れーだー',
  'れーどる',
  'れーにん',
  'れーぱん',
  'れーぴあ',
  'れーべる',
  'れーやー',
  'れーよん',
  'れおぽん',
  'れがーす',
  'れがーず',
  'れがーと',
  'れがしー',
  'れがった',
  'れきおう',
  'れぎおん',
  'れきがく',
  'れきがん',
  'れきげつ',
  'れきさつ',
  'れきしか',
  'れきしが',
  'れきじつ',
  'れきじょ',
  'れきすう',
  'れきせい',
  'れきせん',
  'れきぜん',
  'れきだい',
  'れきだん',
  'れきてい',
  'れきでん',
  'れきどう',
  'れきにん',
  'れきねん',
  'れぎぱん',
  'れきほう',
  'れきほん',
  'れきゆう',
  'れきらん',
  'れきれき',
  'れぎんす',
  'れくちゃ',
  'れくちん',
  'れぐほん',
  'れぐるす',
  'れこーだ',
  'れこーど',
  'れこだい',
  'れごりす',
  'れざーぶ',
  'れざぺぱ',
  'れしーと',
  'れしーば',
  'れしーぶ',
  'れじーむ',
  'れじうち',
  'れじぇろ',
  'れじすた',
  'れじすと',
  'れしちん',
  'れしぴー',
  'れしぷろ',
  'れじゃー',
  'れじゅめ',
  'れじるし',
  'れずっけ',
  'れすてる',
  'れすとあ',
  'れすらー',
  'れせぷと',
  'れぞるば',
  'れたっち',
  'れつあく',
  'れっかー',
  'れっかい',
  'れっかく',
  'れっきょ',
  'れっくす',
  'れっこう',
  'れっこく',
  'れっさい',
  'れつじつ',
  'れっしゃ',
  'れつじょ',
  'れっしん',
  'れっする',
  'れっすん',
  'れっせい',
  'れっせき',
  'れっそう',
  'れってる',
  'れつでん',
  'れっとう',
  'れっぱい',
  'れっぱく',
  'れっぱん',
  'れっぷう',
  'れっぷく',
  'れつりつ',
  'れつれつ',
  'れでぃー',
  'れでぃす',
  'れでぃず',
  'れとると',
  'れとろげ',
  'れなんば',
  'れにうむ',
  'ればーす',
  'ればさし',
  'ればにら',
  'ればのん',
  'れはびり',
  'れぴーと',
  'れびじん',
  'れびびと',
  'れびゅー',
  'れびらと',
  'れふぃる',
  'れふてぃ',
  'れぷとん',
  'れふばん',
  'れふりー',
  'れぷりか',
  'れぶりん',
  'れべっく',
  'れぽーと',
  'れぼどぱ',
  'れぼると',
  'れみんぐ',
  'れりーず',
  'れりーふ',
  'れりっく',
  'れんあい',
  'れんおん',
  'れんかく',
  'れんがし',
  'れんかつ',
  'れんかん',
  'れんぎょ',
  'れんきん',
  'れんぎん',
  'れんぐす',
  'れんけい',
  'れんげざ',
  'れんけつ',
  'れんげん',
  'れんこう',
  'れんごう',
  'れんごく',
  'れんこん',
  'れんさい',
  'れんさく',
  'れんさつ',
  'れんざん',
  'れんじつ',
  'れんしゃ',
  'れんしゅ',
  'れんじゅ',
  'れんしょ',
  'れんせい',
  'れんせつ',
  'れんせん',
  'れんそう',
  'れんぞく',
  'れんたい',
  'れんだい',
  'れんだく',
  'れんたつ',
  'れんだら',
  'れんたる',
  'れんたん',
  'れんだん',
  'れんちる',
  'れんちん',
  'れんつう',
  'れんてつ',
  'れんとう',
  'れんどう',
  'れんどら',
  'れんにん',
  'れんねん',
  'れんばい',
  'れんぱい',
  'れんぱく',
  'れんぱつ',
  'れんばん',
  'れんぱん',
  'れんぴら',
  'れんびん',
  'れんぷく',
  'れんべい',
  'れんぺい',
  'れんぽう',
  'れんほー',
  'れんめい',
  'れんめん',
  'れんもち',
  'れんよう',
  'れんらく',
  'れんりつ',
  'れんるい',
  'れんれん',
  'ろいしん',
  'ろいやる',
  'ろうえい',
  'ろうえき',
  'ろうえん',
  'ろうおう',
  'ろうおく',
  'ろうかい',
  'ろうがい',
  'ろうかく',
  'ろうかつ',
  'ろうがみ',
  'ろうかん',
  'ろうがん',
  'ろうぎし',
  'ろうきょ',
  'ろうきん',
  'ろうぎん',
  'ろうくみ',
  'ろうくん',
  'ろうげつ',
  'ろうけん',
  'ろうこう',
  'ろうこく',
  'ろうごく',
  'ろうこつ',
  'ろうさい',
  'ろうさく',
  'ろうさん',
  'ろうじつ',
  'ろうしゃ',
  'ろうしゅ',
  'ろうじゅ',
  'ろうじょ',
  'ろうしん',
  'ろうじん',
  'ろうすい',
  'ろうする',
  'ろうせい',
  'ろうせき',
  'ろうぜき',
  'ろうせつ',
  'ろうそう',
  'ろうそく',
  'ろうぞめ',
  'ろうたい',
  'ろうだい',
  'ろうたし',
  'ろうだん',
  'ろうちん',
  'ろうづけ',
  'ろうてい',
  'ろうでん',
  'ろうとう',
  'ろうどう',
  'ろうどく',
  'ろうにん',
  'ろうねん',
  'ろうのう',
  'ろうはい',
  'ろうばい',
  'ろうばん',
  'ろうひか',
  'ろうびき',
  'ろうへい',
  'ろうほう',
  'ろうぼく',
  'ろうまく',
  'ろうまん',
  'ろうむか',
  'ろうもう',
  'ろうもん',
  'ろうゆう',
  'ろうよう',
  'ろうらい',
  'ろうらく',
  'ろうりゅ',
  'ろうれい',
  'ろうれつ',
  'ろうれん',
  'ろうろう',
  'ろーかる',
  'ろーぎあ',
  'ろーきー',
  'ろーじん',
  'ろーすと',
  'ろーぜる',
  'ろーそく',
  'ろーたー',
  'ろーだー',
  'ろーたす',
  'ろーづけ',
  'ろーてく',
  'ろーとゆ',
  'ろーとる',
  'ろーふぁ',
  'ろーぷれ',
  'ろーまじ',
  'ろーまん',
  'ろーやる',
  'ろーらー',
  'ろーりえ',
  'ろーるし',
  'ろーれる',
  'ろーんち',
  'ろかーる',
  'ろくいん',
  'ろぐいん',
  'ろくおう',
  'ろぐおふ',
  'ろくおん',
  'ろぐおん',
  'ろくがつ',
  'ろくさい',
  'ろくざい',
  'ろくしき',
  'ろくしゅ',
  'ろくしょ',
  'ろくしん',
  'ろくする',
  'ろくたい',
  'ろくだい',
  'ろくだか',
  'ろくちじ',
  'ろくどう',
  'ろくぼく',
  'ろくまく',
  'ろくやね',
  'ろくよう',
  'ろくろく',
  'ろくろし',
  'ろけーた',
  'ろけーと',
  'ろけーる',
  'ろけさき',
  'ろけっと',
  'ろけばす',
  'ろけはら',
  'ろけはん',
  'ろけらん',
  'ろこもこ',
  'ろざりお',
  'ろしあご',
  'ろじあな',
  'ろじうむ',
  'ろじうら',
  'ろじかる',
  'ろじぐち',
  'ろじっく',
  'ろじっと',
  'ろじばん',
  'ろじもの',
  'ろじもん',
  'ろじゅう',
  'ろしゅく',
  'ろしゅつ',
  'ろしょう',
  'ろじょう',
  'ろすいき',
  'ろすたー',
  'ろすとる',
  'ろすばけ',
  'ろすばげ',
  'ろすれす',
  'ろぜっと',
  'ろせんか',
  'ろせんず',
  'ろたんだ',
  'ろちゅー',
  'ろちゅう',
  'ろちょう',
  'ろっかー',
  'ろっかく',
  'ろっかん',
  'ろっきん',
  'ろっくす',
  'ろっこく',
  'ろっこつ',
  'ろっこん',
  'ろっじあ',
  'ろっとー',
  'ろっぱく',
  'ろっぷん',
  'ろっぽう',
  'ろっぽん',
  'ろてのん',
  'ろとんだ',
  'ろはーす',
  'ろはだい',
  'ろひょう',
  'ろびらき',
  'ろびんぐ',
  'ろふさぎ',
  'ろぶすた',
  'ろべりあ',
  'ろぼあど',
  'ろぼっと',
  'ろまにー',
  'ろまんす',
  'ろまんは',
  'ろみろみ',
  'ろむせん',
  'ろりーた',
  'ろりこん',
  'ろれろれ',
  'ろんがい',
  'ろんかく',
  'ろんきつ',
  'ろんきょ',
  'ろんけつ',
  'ろんこう',
  'ろんこく',
  'ろんさく',
  'ろんさん',
  'ろんじー',
  'ろんしゃ',
  'ろんじゃ',
  'ろんしょ',
  'ろんじる',
  'ろんじん',
  'ろんずる',
  'ろんせつ',
  'ろんせん',
  'ろんそう',
  'ろんだい',
  'ろんだん',
  'ろんてい',
  'ろんてき',
  'ろんてん',
  'ろんどん',
  'ろんなん',
  'ろんばく',
  'ろんぱり',
  'ろんぱん',
  'ろんぶん',
  'ろんべん',
  'ろんぽう',
  'ろんほー',
  'ろんもう',
  'ろんりー',
  'ろんりず',
  'ろんりち',
  'ろんりわ',
  'わーかー',
  'わーくす',
  'わーすと',
  'わーでん',
  'わーぷろ',
  'わーほり',
  'わーまま',
  'わーるど',
  'わあわあ',
  'わいげん',
  'わいざつ',
  'わいじゅ',
  'わいじろ',
  'わいじん',
  'わいせい',
  'わいせつ',
  'わいだん',
  'わいのう',
  'わいぱー',
  'わいはい',
  'わいぴー',
  'わいほん',
  'わいやー',
  'わいりつ',
  'わいるど',
  'わいわい',
  'わかあゆ',
  'わがいえ',
  'わかいこ',
  'わかうお',
  'わかうど',
  'わかえだ',
  'わかがき',
  'わかきひ',
  'わかぎみ',
  'わがきみ',
  'わかぎり',
  'わかくさ',
  'わがくに',
  'わがこう',
  'わがこと',
  'わかさぎ',
  'わかさま',
  'わかしお',
  'わかじに',
  'わがしゃ',
  'わがしや',
  'わかしゅ',
  'わかしゆ',
  'わかぞう',
  'わがっき',
  'わかづま',
  'わがつま',
  'わかとう',
  'わがとう',
  'わかとの',
  'わかどり',
  'わかなご',
  'わがねる',
  'わがはい',
  'わかはげ',
  'わかばん',
  'わかびと',
  'わがほう',
  'わかまつ',
  'わがまま',
  'わかみず',
  'わかみや',
  'わかむき',
  'わかむし',
  'わかもの',
  'わがもの',
  'わかもれ',
  'わかやか',
  'わかやぐ',
  'わかやま',
  'わからん',
  'わかれじ',
  'わかれめ',
  'わかれる',
  'わきあけ',
  'わきくさ',
  'わきくそ',
  'わきざし',
  'わきだす',
  'わきたつ',
  'わきづけ',
  'わきでら',
  'わきでる',
  'わきのう',
  'わきばら',
  'わきまえ',
  'わきみず',
  'わきみち',
  'わぎもこ',
  'わきやく',
  'わきゅう',
  'わぎゅう',
  'わきょう',
  'わぎょう',
  'わきわき',
  'わくがい',
  'わくぐみ',
  'わくせい',
  'わくせん',
  'わくちん',
  'わくてか',
  'わくでき',
  'わくない',
  'わくらば',
  'わくらん',
  'わくれん',
  'わくわく',
  'わけあい',
  'わけあう',
  'わけあり',
  'わけいい',
  'わけいる',
  'わけうり',
  'わけがら',
  'わけしり',
  'わけどり',
  'わけとる',
  'わけない',
  'わけなく',
  'わけまえ',
  'わけもつ',
  'わげもの',
  'わけよい',
  'わこうど',
  'わこもの',
  'わごりょ',
  'わざあり',
  'わさいし',
  'わさづの',
  'わさびな',
  'わざもの',
  'わざわい',
  'わさわさ',
  'わざわざ',
  'わさんか',
  'わしばな',
  'わしゅう',
  'わじゅつ',
  'わじょう',
  'わしょく',
  'わじるし',
  'わしわし',
  'わじんち',
  'わずかに',
  'わずらい',
  'わずらう',
  'わすれお',
  'わすれる',
  'わせいご',
  'わせじょ',
  'わせりん',
  'わたあめ',
  'わだいか',
  'わたいこ',
  'わだいこ',
  'わたいれ',
  'わたうち',
  'わたがし',
  'わたぎぬ',
  'わたくし',
  'わたくず',
  'わたぐも',
  'わたくり',
  'わたさく',
  'わたしば',
  'わたすげ',
  'わたつみ',
  'わだつみ',
  'わたどの',
  'わたぬき',
  'わたのみ',
  'わたばね',
  'わたまし',
  'わたゆき',
  'わたゆみ',
  'わたりま',
  'わたるな',
  'わたわた',
  'わづくえ',
  'わっくす',
  'わっさー',
  'わっしゃ',
  'わっしょ',
  'わっとじ',
  'わっふる',
  'わっぺん',
  'わとうし',
  'わどけい',
  'わななく',
  'わなびー',
  'わなわな',
  'わにあし',
  'わにえそ',
  'わにがめ',
  'わにがわ',
  'わにぐち',
  'わにざめ',
  'わになし',
  'わになる',
  'わにもく',
  'わにりん',
  'わばさみ',
  'わびいる',
  'わびうた',
  'わびごえ',
  'わびこと',
  'わびごと',
  'わびさび',
  'わびしい',
  'わびびと',
  'わまわし',
  'わみょう',
  'わもだん',
  'わらーち',
  'わらいえ',
  'わらいご',
  'わらえる',
  'わらかす',
  'わらがみ',
  'わらぐつ',
  'わらける',
  'わらしべ',
  'わらすぼ',
  'わらたば',
  'わらづか',
  'わらづと',
  'わらばい',
  'わらびー',
  'わらびこ',
  'わらぶき',
  'わらやね',
  'わらるー',
  'わらわべ',
  'わらわめ',
  'わらわら',
  'わらんと',
  'わらんべ',
  'わりあい',
  'わりあて',
  'わりいし',
  'わりいん',
  'わりがき',
  'わりかし',
  'わりかた',
  'わりかん',
  'わりきり',
  'わりきる',
  'わりぐり',
  'わりこう',
  'わりこみ',
  'わりこむ',
  'わりざい',
  'わりざん',
  'わりした',
  'わりだか',
  'わりたけ',
  'わりだけ',
  'わりだし',
  'わりだす',
  'わりつぎ',
  'わりつけ',
  'わりばし',
  'わりはん',
  'わりばん',
  'わりびき',
  'わりびく',
  'わりふり',
  'わりふる',
  'わりぼし',
  'わりまえ',
  'わりまし',
  'わりむぎ',
  'わりやす',
  'わりんご',
  'わるがき',
  'わるぐせ',
  'わるくち',
  'わるぐち',
  'わるざれ',
  'わるじえ',
  'わるずれ',
  'わるそー',
  'わるぢえ',
  'わるのり',
  'わるぶる',
  'わるもの',
  'わるよい',
  'われがち',
  'われがね',
  'われから',
  'われっと',
  'われなべ',
  'われひと',
  'われぼめ',
  'われもの',
  'われらが',
  'われわれ',
  'わろんご',
  'わわさい',
  'わをかく',
  'わんおぺ',
  'わんがい',
  'わんがた',
  'わんがん',
  'わんぎり',
  'わんけー',
  'わんげつ',
  'わんげる',
  'わんこう',
  'わんこつ',
  'わんさか',
  'わんじー',
  'わんせぐ',
  'わんだー',
  'わんだね',
  'わんたん',
  'わんだん',
  'わんつー',
  'わんでい',
  'わんでー',
  'わんとう',
  'わんない',
  'わんぱい',
  'わんぱく',
  'わんぱす',
  'わんぺあ',
  'わんぺな',
  'わんぽう',
  'わんまん',
  'わんもり',
  'わんれん',
  'わんわん',
  'をおいて',
  'をたげい',
  'をたしゃ',
  'をもって',
  'んがため',
  'んちわー',
  'んとする',
]
